/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const mythbound = $root.mythbound = (() => {

    /**
     * Namespace mythbound.
     * @exports mythbound
     * @namespace
     */
    const mythbound = {};

    mythbound.websocket = (function() {

        /**
         * Namespace websocket.
         * @memberof mythbound
         * @namespace
         */
        const websocket = {};

        websocket.v1 = (function() {

            /**
             * Namespace v1.
             * @memberof mythbound.websocket
             * @namespace
             */
            const v1 = {};

            /**
             * ErrorCategory enum.
             * @name mythbound.websocket.v1.ErrorCategory
             * @enum {number}
             * @property {number} ERROR_CATEGORY_UNSPECIFIED=0 ERROR_CATEGORY_UNSPECIFIED value
             * @property {number} ERROR_CATEGORY_AUTHENTICATION=1000 ERROR_CATEGORY_AUTHENTICATION value
             * @property {number} ERROR_CATEGORY_STATE_MANAGEMENT=2000 ERROR_CATEGORY_STATE_MANAGEMENT value
             * @property {number} ERROR_CATEGORY_CONNECTION=3000 ERROR_CATEGORY_CONNECTION value
             * @property {number} ERROR_CATEGORY_VOICE_PROCESSING=4000 ERROR_CATEGORY_VOICE_PROCESSING value
             * @property {number} ERROR_CATEGORY_API=5000 ERROR_CATEGORY_API value
             * @property {number} ERROR_CATEGORY_VALIDATION=6000 ERROR_CATEGORY_VALIDATION value
             */
            v1.ErrorCategory = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "ERROR_CATEGORY_UNSPECIFIED"] = 0;
                values[valuesById[1000] = "ERROR_CATEGORY_AUTHENTICATION"] = 1000;
                values[valuesById[2000] = "ERROR_CATEGORY_STATE_MANAGEMENT"] = 2000;
                values[valuesById[3000] = "ERROR_CATEGORY_CONNECTION"] = 3000;
                values[valuesById[4000] = "ERROR_CATEGORY_VOICE_PROCESSING"] = 4000;
                values[valuesById[5000] = "ERROR_CATEGORY_API"] = 5000;
                values[valuesById[6000] = "ERROR_CATEGORY_VALIDATION"] = 6000;
                return values;
            })();

            /**
             * ErrorCode enum.
             * @name mythbound.websocket.v1.ErrorCode
             * @enum {number}
             * @property {number} ERROR_CODE_UNSPECIFIED=0 ERROR_CODE_UNSPECIFIED value
             * @property {number} ERROR_CODE_INVALID_TOKEN=1001 ERROR_CODE_INVALID_TOKEN value
             * @property {number} ERROR_CODE_EXPIRED_SESSION=1002 ERROR_CODE_EXPIRED_SESSION value
             * @property {number} ERROR_CODE_INSUFFICIENT_PERMISSIONS=1003 ERROR_CODE_INSUFFICIENT_PERMISSIONS value
             * @property {number} ERROR_CODE_OAUTH_PROVIDER_ERROR=1004 ERROR_CODE_OAUTH_PROVIDER_ERROR value
             * @property {number} ERROR_CODE_SESSION_NOT_FOUND=1005 ERROR_CODE_SESSION_NOT_FOUND value
             * @property {number} ERROR_CODE_ROLE_VALIDATION_FAILED=1006 ERROR_CODE_ROLE_VALIDATION_FAILED value
             * @property {number} ERROR_CODE_STATE_SYNC_CONFLICT=2001 ERROR_CODE_STATE_SYNC_CONFLICT value
             * @property {number} ERROR_CODE_VERSION_MISMATCH=2002 ERROR_CODE_VERSION_MISMATCH value
             * @property {number} ERROR_CODE_STATE_CORRUPTION=2003 ERROR_CODE_STATE_CORRUPTION value
             * @property {number} ERROR_CODE_HLC_TIMESTAMP_ERROR=2004 ERROR_CODE_HLC_TIMESTAMP_ERROR value
             * @property {number} ERROR_CODE_REDIS_CONNECTION_FAILED=2005 ERROR_CODE_REDIS_CONNECTION_FAILED value
             * @property {number} ERROR_CODE_STATE_VALIDATION_FAILED=2006 ERROR_CODE_STATE_VALIDATION_FAILED value
             * @property {number} ERROR_CODE_WEBSOCKET_TIMEOUT=3001 ERROR_CODE_WEBSOCKET_TIMEOUT value
             * @property {number} ERROR_CODE_NETWORK_FAILURE=3002 ERROR_CODE_NETWORK_FAILURE value
             * @property {number} ERROR_CODE_CONNECTION_REFUSED=3003 ERROR_CODE_CONNECTION_REFUSED value
             * @property {number} ERROR_CODE_HEARTBEAT_FAILED=3004 ERROR_CODE_HEARTBEAT_FAILED value
             * @property {number} ERROR_CODE_ROOM_NOT_FOUND=3005 ERROR_CODE_ROOM_NOT_FOUND value
             * @property {number} ERROR_CODE_CLIENT_DISCONNECTED=3006 ERROR_CODE_CLIENT_DISCONNECTED value
             * @property {number} ERROR_CODE_INVALID_AUDIO_FORMAT=4001 ERROR_CODE_INVALID_AUDIO_FORMAT value
             * @property {number} ERROR_CODE_STT_PROVIDER_FAILURE=4002 ERROR_CODE_STT_PROVIDER_FAILURE value
             * @property {number} ERROR_CODE_TTS_PROVIDER_FAILURE=4003 ERROR_CODE_TTS_PROVIDER_FAILURE value
             * @property {number} ERROR_CODE_AUDIO_PROCESSING_ERROR=4004 ERROR_CODE_AUDIO_PROCESSING_ERROR value
             * @property {number} ERROR_CODE_VOICE_ACTIVITY_DETECTION_FAILED=4005 ERROR_CODE_VOICE_ACTIVITY_DETECTION_FAILED value
             * @property {number} ERROR_CODE_AUDIO_CODEC_ERROR=4006 ERROR_CODE_AUDIO_CODEC_ERROR value
             * @property {number} ERROR_CODE_RATE_LIMIT_EXCEEDED=5001 ERROR_CODE_RATE_LIMIT_EXCEEDED value
             * @property {number} ERROR_CODE_EXTERNAL_SERVICE_DOWN=5002 ERROR_CODE_EXTERNAL_SERVICE_DOWN value
             * @property {number} ERROR_CODE_API_KEY_INVALID=5003 ERROR_CODE_API_KEY_INVALID value
             * @property {number} ERROR_CODE_REQUEST_TIMEOUT=5004 ERROR_CODE_REQUEST_TIMEOUT value
             * @property {number} ERROR_CODE_SERVICE_UNAVAILABLE=5005 ERROR_CODE_SERVICE_UNAVAILABLE value
             * @property {number} ERROR_CODE_QUOTA_EXCEEDED=5006 ERROR_CODE_QUOTA_EXCEEDED value
             * @property {number} ERROR_CODE_INVALID_INPUT_FORMAT=6001 ERROR_CODE_INVALID_INPUT_FORMAT value
             * @property {number} ERROR_CODE_MISSING_REQUIRED_FIELD=6002 ERROR_CODE_MISSING_REQUIRED_FIELD value
             * @property {number} ERROR_CODE_FIELD_VALUE_OUT_OF_RANGE=6003 ERROR_CODE_FIELD_VALUE_OUT_OF_RANGE value
             * @property {number} ERROR_CODE_INVALID_ENUM_VALUE=6004 ERROR_CODE_INVALID_ENUM_VALUE value
             * @property {number} ERROR_CODE_DATA_TYPE_MISMATCH=6005 ERROR_CODE_DATA_TYPE_MISMATCH value
             * @property {number} ERROR_CODE_SCHEMA_VALIDATION_FAILED=6006 ERROR_CODE_SCHEMA_VALIDATION_FAILED value
             */
            v1.ErrorCode = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "ERROR_CODE_UNSPECIFIED"] = 0;
                values[valuesById[1001] = "ERROR_CODE_INVALID_TOKEN"] = 1001;
                values[valuesById[1002] = "ERROR_CODE_EXPIRED_SESSION"] = 1002;
                values[valuesById[1003] = "ERROR_CODE_INSUFFICIENT_PERMISSIONS"] = 1003;
                values[valuesById[1004] = "ERROR_CODE_OAUTH_PROVIDER_ERROR"] = 1004;
                values[valuesById[1005] = "ERROR_CODE_SESSION_NOT_FOUND"] = 1005;
                values[valuesById[1006] = "ERROR_CODE_ROLE_VALIDATION_FAILED"] = 1006;
                values[valuesById[2001] = "ERROR_CODE_STATE_SYNC_CONFLICT"] = 2001;
                values[valuesById[2002] = "ERROR_CODE_VERSION_MISMATCH"] = 2002;
                values[valuesById[2003] = "ERROR_CODE_STATE_CORRUPTION"] = 2003;
                values[valuesById[2004] = "ERROR_CODE_HLC_TIMESTAMP_ERROR"] = 2004;
                values[valuesById[2005] = "ERROR_CODE_REDIS_CONNECTION_FAILED"] = 2005;
                values[valuesById[2006] = "ERROR_CODE_STATE_VALIDATION_FAILED"] = 2006;
                values[valuesById[3001] = "ERROR_CODE_WEBSOCKET_TIMEOUT"] = 3001;
                values[valuesById[3002] = "ERROR_CODE_NETWORK_FAILURE"] = 3002;
                values[valuesById[3003] = "ERROR_CODE_CONNECTION_REFUSED"] = 3003;
                values[valuesById[3004] = "ERROR_CODE_HEARTBEAT_FAILED"] = 3004;
                values[valuesById[3005] = "ERROR_CODE_ROOM_NOT_FOUND"] = 3005;
                values[valuesById[3006] = "ERROR_CODE_CLIENT_DISCONNECTED"] = 3006;
                values[valuesById[4001] = "ERROR_CODE_INVALID_AUDIO_FORMAT"] = 4001;
                values[valuesById[4002] = "ERROR_CODE_STT_PROVIDER_FAILURE"] = 4002;
                values[valuesById[4003] = "ERROR_CODE_TTS_PROVIDER_FAILURE"] = 4003;
                values[valuesById[4004] = "ERROR_CODE_AUDIO_PROCESSING_ERROR"] = 4004;
                values[valuesById[4005] = "ERROR_CODE_VOICE_ACTIVITY_DETECTION_FAILED"] = 4005;
                values[valuesById[4006] = "ERROR_CODE_AUDIO_CODEC_ERROR"] = 4006;
                values[valuesById[5001] = "ERROR_CODE_RATE_LIMIT_EXCEEDED"] = 5001;
                values[valuesById[5002] = "ERROR_CODE_EXTERNAL_SERVICE_DOWN"] = 5002;
                values[valuesById[5003] = "ERROR_CODE_API_KEY_INVALID"] = 5003;
                values[valuesById[5004] = "ERROR_CODE_REQUEST_TIMEOUT"] = 5004;
                values[valuesById[5005] = "ERROR_CODE_SERVICE_UNAVAILABLE"] = 5005;
                values[valuesById[5006] = "ERROR_CODE_QUOTA_EXCEEDED"] = 5006;
                values[valuesById[6001] = "ERROR_CODE_INVALID_INPUT_FORMAT"] = 6001;
                values[valuesById[6002] = "ERROR_CODE_MISSING_REQUIRED_FIELD"] = 6002;
                values[valuesById[6003] = "ERROR_CODE_FIELD_VALUE_OUT_OF_RANGE"] = 6003;
                values[valuesById[6004] = "ERROR_CODE_INVALID_ENUM_VALUE"] = 6004;
                values[valuesById[6005] = "ERROR_CODE_DATA_TYPE_MISMATCH"] = 6005;
                values[valuesById[6006] = "ERROR_CODE_SCHEMA_VALIDATION_FAILED"] = 6006;
                return values;
            })();

            /**
             * GMErrorSeverity enum.
             * @name mythbound.websocket.v1.GMErrorSeverity
             * @enum {number}
             * @property {number} GM_ERROR_SEVERITY_UNSPECIFIED=0 GM_ERROR_SEVERITY_UNSPECIFIED value
             * @property {number} GM_ERROR_SEVERITY_TRANSPARENT=1 GM_ERROR_SEVERITY_TRANSPARENT value
             * @property {number} GM_ERROR_SEVERITY_BACKGROUND=2 GM_ERROR_SEVERITY_BACKGROUND value
             * @property {number} GM_ERROR_SEVERITY_GRACEFUL=3 GM_ERROR_SEVERITY_GRACEFUL value
             * @property {number} GM_ERROR_SEVERITY_NOTICEABLE=4 GM_ERROR_SEVERITY_NOTICEABLE value
             * @property {number} GM_ERROR_SEVERITY_CRITICAL=5 GM_ERROR_SEVERITY_CRITICAL value
             */
            v1.GMErrorSeverity = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "GM_ERROR_SEVERITY_UNSPECIFIED"] = 0;
                values[valuesById[1] = "GM_ERROR_SEVERITY_TRANSPARENT"] = 1;
                values[valuesById[2] = "GM_ERROR_SEVERITY_BACKGROUND"] = 2;
                values[valuesById[3] = "GM_ERROR_SEVERITY_GRACEFUL"] = 3;
                values[valuesById[4] = "GM_ERROR_SEVERITY_NOTICEABLE"] = 4;
                values[valuesById[5] = "GM_ERROR_SEVERITY_CRITICAL"] = 5;
                return values;
            })();

            v1.RetryPolicy = (function() {

                /**
                 * Properties of a RetryPolicy.
                 * @memberof mythbound.websocket.v1
                 * @interface IRetryPolicy
                 * @property {number|null} [maxAttempts] RetryPolicy maxAttempts
                 * @property {number|null} [baseDelay] RetryPolicy baseDelay
                 * @property {number|null} [maxDelay] RetryPolicy maxDelay
                 * @property {boolean|null} [exponentialBackoff] RetryPolicy exponentialBackoff
                 * @property {boolean|null} [jitter] RetryPolicy jitter
                 * @property {boolean|null} [retryable] RetryPolicy retryable
                 */

                /**
                 * Constructs a new RetryPolicy.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a RetryPolicy.
                 * @implements IRetryPolicy
                 * @constructor
                 * @param {mythbound.websocket.v1.IRetryPolicy=} [properties] Properties to set
                 */
                function RetryPolicy(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RetryPolicy maxAttempts.
                 * @member {number} maxAttempts
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @instance
                 */
                RetryPolicy.prototype.maxAttempts = 0;

                /**
                 * RetryPolicy baseDelay.
                 * @member {number} baseDelay
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @instance
                 */
                RetryPolicy.prototype.baseDelay = 0;

                /**
                 * RetryPolicy maxDelay.
                 * @member {number} maxDelay
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @instance
                 */
                RetryPolicy.prototype.maxDelay = 0;

                /**
                 * RetryPolicy exponentialBackoff.
                 * @member {boolean} exponentialBackoff
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @instance
                 */
                RetryPolicy.prototype.exponentialBackoff = false;

                /**
                 * RetryPolicy jitter.
                 * @member {boolean} jitter
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @instance
                 */
                RetryPolicy.prototype.jitter = false;

                /**
                 * RetryPolicy retryable.
                 * @member {boolean} retryable
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @instance
                 */
                RetryPolicy.prototype.retryable = false;

                /**
                 * Creates a new RetryPolicy instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @static
                 * @param {mythbound.websocket.v1.IRetryPolicy=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.RetryPolicy} RetryPolicy instance
                 */
                RetryPolicy.create = function create(properties) {
                    return new RetryPolicy(properties);
                };

                /**
                 * Encodes the specified RetryPolicy message. Does not implicitly {@link mythbound.websocket.v1.RetryPolicy.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @static
                 * @param {mythbound.websocket.v1.IRetryPolicy} message RetryPolicy message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RetryPolicy.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.maxAttempts != null && Object.hasOwnProperty.call(message, "maxAttempts"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.maxAttempts);
                    if (message.baseDelay != null && Object.hasOwnProperty.call(message, "baseDelay"))
                        writer.uint32(/* id 2, wireType 5 =*/21).float(message.baseDelay);
                    if (message.maxDelay != null && Object.hasOwnProperty.call(message, "maxDelay"))
                        writer.uint32(/* id 3, wireType 5 =*/29).float(message.maxDelay);
                    if (message.exponentialBackoff != null && Object.hasOwnProperty.call(message, "exponentialBackoff"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.exponentialBackoff);
                    if (message.jitter != null && Object.hasOwnProperty.call(message, "jitter"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.jitter);
                    if (message.retryable != null && Object.hasOwnProperty.call(message, "retryable"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.retryable);
                    return writer;
                };

                /**
                 * Encodes the specified RetryPolicy message, length delimited. Does not implicitly {@link mythbound.websocket.v1.RetryPolicy.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @static
                 * @param {mythbound.websocket.v1.IRetryPolicy} message RetryPolicy message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RetryPolicy.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a RetryPolicy message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.RetryPolicy} RetryPolicy
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RetryPolicy.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.RetryPolicy();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.maxAttempts = reader.int32();
                                break;
                            }
                        case 2: {
                                message.baseDelay = reader.float();
                                break;
                            }
                        case 3: {
                                message.maxDelay = reader.float();
                                break;
                            }
                        case 4: {
                                message.exponentialBackoff = reader.bool();
                                break;
                            }
                        case 5: {
                                message.jitter = reader.bool();
                                break;
                            }
                        case 6: {
                                message.retryable = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a RetryPolicy message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.RetryPolicy} RetryPolicy
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RetryPolicy.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RetryPolicy message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RetryPolicy.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.maxAttempts != null && Object.hasOwnProperty.call(message, "maxAttempts"))
                        if (!$util.isInteger(message.maxAttempts))
                            return "maxAttempts: integer expected";
                    if (message.baseDelay != null && Object.hasOwnProperty.call(message, "baseDelay"))
                        if (typeof message.baseDelay !== "number")
                            return "baseDelay: number expected";
                    if (message.maxDelay != null && Object.hasOwnProperty.call(message, "maxDelay"))
                        if (typeof message.maxDelay !== "number")
                            return "maxDelay: number expected";
                    if (message.exponentialBackoff != null && Object.hasOwnProperty.call(message, "exponentialBackoff"))
                        if (typeof message.exponentialBackoff !== "boolean")
                            return "exponentialBackoff: boolean expected";
                    if (message.jitter != null && Object.hasOwnProperty.call(message, "jitter"))
                        if (typeof message.jitter !== "boolean")
                            return "jitter: boolean expected";
                    if (message.retryable != null && Object.hasOwnProperty.call(message, "retryable"))
                        if (typeof message.retryable !== "boolean")
                            return "retryable: boolean expected";
                    return null;
                };

                /**
                 * Creates a RetryPolicy message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.RetryPolicy} RetryPolicy
                 */
                RetryPolicy.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.RetryPolicy)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.RetryPolicy: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.RetryPolicy();
                    if (object.maxAttempts != null)
                        message.maxAttempts = object.maxAttempts | 0;
                    if (object.baseDelay != null)
                        message.baseDelay = Number(object.baseDelay);
                    if (object.maxDelay != null)
                        message.maxDelay = Number(object.maxDelay);
                    if (object.exponentialBackoff != null)
                        message.exponentialBackoff = Boolean(object.exponentialBackoff);
                    if (object.jitter != null)
                        message.jitter = Boolean(object.jitter);
                    if (object.retryable != null)
                        message.retryable = Boolean(object.retryable);
                    return message;
                };

                /**
                 * Creates a plain object from a RetryPolicy message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @static
                 * @param {mythbound.websocket.v1.RetryPolicy} message RetryPolicy
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RetryPolicy.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.maxAttempts = 0;
                        object.baseDelay = 0;
                        object.maxDelay = 0;
                        object.exponentialBackoff = false;
                        object.jitter = false;
                        object.retryable = false;
                    }
                    if (message.maxAttempts != null && Object.hasOwnProperty.call(message, "maxAttempts"))
                        object.maxAttempts = message.maxAttempts;
                    if (message.baseDelay != null && Object.hasOwnProperty.call(message, "baseDelay"))
                        object.baseDelay = options.json && !isFinite(message.baseDelay) ? String(message.baseDelay) : message.baseDelay;
                    if (message.maxDelay != null && Object.hasOwnProperty.call(message, "maxDelay"))
                        object.maxDelay = options.json && !isFinite(message.maxDelay) ? String(message.maxDelay) : message.maxDelay;
                    if (message.exponentialBackoff != null && Object.hasOwnProperty.call(message, "exponentialBackoff"))
                        object.exponentialBackoff = message.exponentialBackoff;
                    if (message.jitter != null && Object.hasOwnProperty.call(message, "jitter"))
                        object.jitter = message.jitter;
                    if (message.retryable != null && Object.hasOwnProperty.call(message, "retryable"))
                        object.retryable = message.retryable;
                    return object;
                };

                /**
                 * Converts this RetryPolicy to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RetryPolicy.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RetryPolicy
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.RetryPolicy
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RetryPolicy.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.RetryPolicy";
                };

                return RetryPolicy;
            })();

            v1.StandardizedError = (function() {

                /**
                 * Properties of a StandardizedError.
                 * @memberof mythbound.websocket.v1
                 * @interface IStandardizedError
                 * @property {mythbound.websocket.v1.ErrorCode|null} [errorCode] StandardizedError errorCode
                 * @property {string|null} [errorName] StandardizedError errorName
                 * @property {mythbound.websocket.v1.ErrorCategory|null} [category] StandardizedError category
                 * @property {string|null} [message] StandardizedError message
                 * @property {Object.<string,string>|null} [details] StandardizedError details
                 * @property {string|null} [timestamp] StandardizedError timestamp
                 * @property {string|null} [correlationId] StandardizedError correlationId
                 * @property {string|null} [userId] StandardizedError userId
                 * @property {string|null} [sessionId] StandardizedError sessionId
                 * @property {string|null} [component] StandardizedError component
                 * @property {mythbound.websocket.v1.IRetryPolicy|null} [retryPolicy] StandardizedError retryPolicy
                 * @property {boolean|null} [isRetryable] StandardizedError isRetryable
                 * @property {mythbound.websocket.v1.GMErrorSeverity|null} [gmSeverity] StandardizedError gmSeverity
                 * @property {string|null} [userVisibleMessage] StandardizedError userVisibleMessage
                 * @property {string|null} [fallbackResponse] StandardizedError fallbackResponse
                 */

                /**
                 * Constructs a new StandardizedError.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a StandardizedError.
                 * @implements IStandardizedError
                 * @constructor
                 * @param {mythbound.websocket.v1.IStandardizedError=} [properties] Properties to set
                 */
                function StandardizedError(properties) {
                    this.details = {};
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StandardizedError errorCode.
                 * @member {mythbound.websocket.v1.ErrorCode} errorCode
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.errorCode = 0;

                /**
                 * StandardizedError errorName.
                 * @member {string} errorName
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.errorName = "";

                /**
                 * StandardizedError category.
                 * @member {mythbound.websocket.v1.ErrorCategory} category
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.category = 0;

                /**
                 * StandardizedError message.
                 * @member {string} message
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.message = "";

                /**
                 * StandardizedError details.
                 * @member {Object.<string,string>} details
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.details = $util.emptyObject;

                /**
                 * StandardizedError timestamp.
                 * @member {string} timestamp
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.timestamp = "";

                /**
                 * StandardizedError correlationId.
                 * @member {string} correlationId
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.correlationId = "";

                /**
                 * StandardizedError userId.
                 * @member {string} userId
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.userId = "";

                /**
                 * StandardizedError sessionId.
                 * @member {string} sessionId
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.sessionId = "";

                /**
                 * StandardizedError component.
                 * @member {string} component
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.component = "";

                /**
                 * StandardizedError retryPolicy.
                 * @member {mythbound.websocket.v1.IRetryPolicy|null|undefined} retryPolicy
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.retryPolicy = null;

                /**
                 * StandardizedError isRetryable.
                 * @member {boolean} isRetryable
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.isRetryable = false;

                /**
                 * StandardizedError gmSeverity.
                 * @member {mythbound.websocket.v1.GMErrorSeverity} gmSeverity
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.gmSeverity = 0;

                /**
                 * StandardizedError userVisibleMessage.
                 * @member {string} userVisibleMessage
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.userVisibleMessage = "";

                /**
                 * StandardizedError fallbackResponse.
                 * @member {string} fallbackResponse
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 */
                StandardizedError.prototype.fallbackResponse = "";

                /**
                 * Creates a new StandardizedError instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @static
                 * @param {mythbound.websocket.v1.IStandardizedError=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.StandardizedError} StandardizedError instance
                 */
                StandardizedError.create = function create(properties) {
                    return new StandardizedError(properties);
                };

                /**
                 * Encodes the specified StandardizedError message. Does not implicitly {@link mythbound.websocket.v1.StandardizedError.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @static
                 * @param {mythbound.websocket.v1.IStandardizedError} message StandardizedError message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StandardizedError.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errorCode);
                    if (message.errorName != null && Object.hasOwnProperty.call(message, "errorName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.errorName);
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.category);
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
                    if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                        for (let keys = Object.keys(message.details), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 5, wireType 2 =*/42).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.details[keys[i]]).ldelim();
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.timestamp);
                    if (message.correlationId != null && Object.hasOwnProperty.call(message, "correlationId"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.correlationId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.userId);
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.sessionId);
                    if (message.component != null && Object.hasOwnProperty.call(message, "component"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.component);
                    if (message.retryPolicy != null && Object.hasOwnProperty.call(message, "retryPolicy"))
                        $root.mythbound.websocket.v1.RetryPolicy.encode(message.retryPolicy, writer.uint32(/* id 11, wireType 2 =*/90).fork(), q + 1).ldelim();
                    if (message.isRetryable != null && Object.hasOwnProperty.call(message, "isRetryable"))
                        writer.uint32(/* id 12, wireType 0 =*/96).bool(message.isRetryable);
                    if (message.gmSeverity != null && Object.hasOwnProperty.call(message, "gmSeverity"))
                        writer.uint32(/* id 13, wireType 0 =*/104).int32(message.gmSeverity);
                    if (message.userVisibleMessage != null && Object.hasOwnProperty.call(message, "userVisibleMessage"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.userVisibleMessage);
                    if (message.fallbackResponse != null && Object.hasOwnProperty.call(message, "fallbackResponse"))
                        writer.uint32(/* id 15, wireType 2 =*/122).string(message.fallbackResponse);
                    return writer;
                };

                /**
                 * Encodes the specified StandardizedError message, length delimited. Does not implicitly {@link mythbound.websocket.v1.StandardizedError.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @static
                 * @param {mythbound.websocket.v1.IStandardizedError} message StandardizedError message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StandardizedError.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a StandardizedError message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.StandardizedError} StandardizedError
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StandardizedError.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message, key, value;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.StandardizedError();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.errorCode = reader.int32();
                                break;
                            }
                        case 2: {
                                message.errorName = reader.string();
                                break;
                            }
                        case 3: {
                                message.category = reader.int32();
                                break;
                            }
                        case 4: {
                                message.message = reader.string();
                                break;
                            }
                        case 5: {
                                if (message.details === $util.emptyObject)
                                    message.details = {};
                                let end2 = reader.uint32() + reader.pos;
                                if (end2 > reader.len)
                                    throw RangeError("index out of range");
                                reader.len = end2;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7, long);
                                        break;
                                    }
                                }
                                if (reader.pos !== end2)
                                    throw RangeError("index out of range");
                                reader.len = end;
                                if (key === "__proto__")
                                    $util.makeProp(message.details, key);
                                message.details[key] = value;
                                break;
                            }
                        case 6: {
                                message.timestamp = reader.string();
                                break;
                            }
                        case 7: {
                                message.correlationId = reader.string();
                                break;
                            }
                        case 8: {
                                message.userId = reader.string();
                                break;
                            }
                        case 9: {
                                message.sessionId = reader.string();
                                break;
                            }
                        case 10: {
                                message.component = reader.string();
                                break;
                            }
                        case 11: {
                                message.retryPolicy = $root.mythbound.websocket.v1.RetryPolicy.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 12: {
                                message.isRetryable = reader.bool();
                                break;
                            }
                        case 13: {
                                message.gmSeverity = reader.int32();
                                break;
                            }
                        case 14: {
                                message.userVisibleMessage = reader.string();
                                break;
                            }
                        case 15: {
                                message.fallbackResponse = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a StandardizedError message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.StandardizedError} StandardizedError
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StandardizedError.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StandardizedError message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StandardizedError.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                        switch (message.errorCode) {
                        default:
                            return "errorCode: enum value expected";
                        case 0:
                        case 1001:
                        case 1002:
                        case 1003:
                        case 1004:
                        case 1005:
                        case 1006:
                        case 2001:
                        case 2002:
                        case 2003:
                        case 2004:
                        case 2005:
                        case 2006:
                        case 3001:
                        case 3002:
                        case 3003:
                        case 3004:
                        case 3005:
                        case 3006:
                        case 4001:
                        case 4002:
                        case 4003:
                        case 4004:
                        case 4005:
                        case 4006:
                        case 5001:
                        case 5002:
                        case 5003:
                        case 5004:
                        case 5005:
                        case 5006:
                        case 6001:
                        case 6002:
                        case 6003:
                        case 6004:
                        case 6005:
                        case 6006:
                            break;
                        }
                    if (message.errorName != null && Object.hasOwnProperty.call(message, "errorName"))
                        if (!$util.isString(message.errorName))
                            return "errorName: string expected";
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        switch (message.category) {
                        default:
                            return "category: enum value expected";
                        case 0:
                        case 1000:
                        case 2000:
                        case 3000:
                        case 4000:
                        case 5000:
                        case 6000:
                            break;
                        }
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        if (!$util.isString(message.message))
                            return "message: string expected";
                    if (message.details != null && Object.hasOwnProperty.call(message, "details")) {
                        if (!$util.isObject(message.details))
                            return "details: object expected";
                        let key = Object.keys(message.details);
                        for (let i = 0; i < key.length; ++i)
                            if (!$util.isString(message.details[key[i]]))
                                return "details: string{k:string} expected";
                    }
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        if (!$util.isString(message.timestamp))
                            return "timestamp: string expected";
                    if (message.correlationId != null && Object.hasOwnProperty.call(message, "correlationId"))
                        if (!$util.isString(message.correlationId))
                            return "correlationId: string expected";
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        if (!$util.isString(message.sessionId))
                            return "sessionId: string expected";
                    if (message.component != null && Object.hasOwnProperty.call(message, "component"))
                        if (!$util.isString(message.component))
                            return "component: string expected";
                    if (message.retryPolicy != null && Object.hasOwnProperty.call(message, "retryPolicy")) {
                        let error = $root.mythbound.websocket.v1.RetryPolicy.verify(message.retryPolicy, long + 1);
                        if (error)
                            return "retryPolicy." + error;
                    }
                    if (message.isRetryable != null && Object.hasOwnProperty.call(message, "isRetryable"))
                        if (typeof message.isRetryable !== "boolean")
                            return "isRetryable: boolean expected";
                    if (message.gmSeverity != null && Object.hasOwnProperty.call(message, "gmSeverity"))
                        switch (message.gmSeverity) {
                        default:
                            return "gmSeverity: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    if (message.userVisibleMessage != null && Object.hasOwnProperty.call(message, "userVisibleMessage"))
                        if (!$util.isString(message.userVisibleMessage))
                            return "userVisibleMessage: string expected";
                    if (message.fallbackResponse != null && Object.hasOwnProperty.call(message, "fallbackResponse"))
                        if (!$util.isString(message.fallbackResponse))
                            return "fallbackResponse: string expected";
                    return null;
                };

                /**
                 * Creates a StandardizedError message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.StandardizedError} StandardizedError
                 */
                StandardizedError.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.StandardizedError)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.StandardizedError: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.StandardizedError();
                    switch (object.errorCode) {
                    default:
                        if (typeof object.errorCode === "number") {
                            message.errorCode = object.errorCode;
                            break;
                        }
                        break;
                    case "ERROR_CODE_UNSPECIFIED":
                    case 0:
                        message.errorCode = 0;
                        break;
                    case "ERROR_CODE_INVALID_TOKEN":
                    case 1001:
                        message.errorCode = 1001;
                        break;
                    case "ERROR_CODE_EXPIRED_SESSION":
                    case 1002:
                        message.errorCode = 1002;
                        break;
                    case "ERROR_CODE_INSUFFICIENT_PERMISSIONS":
                    case 1003:
                        message.errorCode = 1003;
                        break;
                    case "ERROR_CODE_OAUTH_PROVIDER_ERROR":
                    case 1004:
                        message.errorCode = 1004;
                        break;
                    case "ERROR_CODE_SESSION_NOT_FOUND":
                    case 1005:
                        message.errorCode = 1005;
                        break;
                    case "ERROR_CODE_ROLE_VALIDATION_FAILED":
                    case 1006:
                        message.errorCode = 1006;
                        break;
                    case "ERROR_CODE_STATE_SYNC_CONFLICT":
                    case 2001:
                        message.errorCode = 2001;
                        break;
                    case "ERROR_CODE_VERSION_MISMATCH":
                    case 2002:
                        message.errorCode = 2002;
                        break;
                    case "ERROR_CODE_STATE_CORRUPTION":
                    case 2003:
                        message.errorCode = 2003;
                        break;
                    case "ERROR_CODE_HLC_TIMESTAMP_ERROR":
                    case 2004:
                        message.errorCode = 2004;
                        break;
                    case "ERROR_CODE_REDIS_CONNECTION_FAILED":
                    case 2005:
                        message.errorCode = 2005;
                        break;
                    case "ERROR_CODE_STATE_VALIDATION_FAILED":
                    case 2006:
                        message.errorCode = 2006;
                        break;
                    case "ERROR_CODE_WEBSOCKET_TIMEOUT":
                    case 3001:
                        message.errorCode = 3001;
                        break;
                    case "ERROR_CODE_NETWORK_FAILURE":
                    case 3002:
                        message.errorCode = 3002;
                        break;
                    case "ERROR_CODE_CONNECTION_REFUSED":
                    case 3003:
                        message.errorCode = 3003;
                        break;
                    case "ERROR_CODE_HEARTBEAT_FAILED":
                    case 3004:
                        message.errorCode = 3004;
                        break;
                    case "ERROR_CODE_ROOM_NOT_FOUND":
                    case 3005:
                        message.errorCode = 3005;
                        break;
                    case "ERROR_CODE_CLIENT_DISCONNECTED":
                    case 3006:
                        message.errorCode = 3006;
                        break;
                    case "ERROR_CODE_INVALID_AUDIO_FORMAT":
                    case 4001:
                        message.errorCode = 4001;
                        break;
                    case "ERROR_CODE_STT_PROVIDER_FAILURE":
                    case 4002:
                        message.errorCode = 4002;
                        break;
                    case "ERROR_CODE_TTS_PROVIDER_FAILURE":
                    case 4003:
                        message.errorCode = 4003;
                        break;
                    case "ERROR_CODE_AUDIO_PROCESSING_ERROR":
                    case 4004:
                        message.errorCode = 4004;
                        break;
                    case "ERROR_CODE_VOICE_ACTIVITY_DETECTION_FAILED":
                    case 4005:
                        message.errorCode = 4005;
                        break;
                    case "ERROR_CODE_AUDIO_CODEC_ERROR":
                    case 4006:
                        message.errorCode = 4006;
                        break;
                    case "ERROR_CODE_RATE_LIMIT_EXCEEDED":
                    case 5001:
                        message.errorCode = 5001;
                        break;
                    case "ERROR_CODE_EXTERNAL_SERVICE_DOWN":
                    case 5002:
                        message.errorCode = 5002;
                        break;
                    case "ERROR_CODE_API_KEY_INVALID":
                    case 5003:
                        message.errorCode = 5003;
                        break;
                    case "ERROR_CODE_REQUEST_TIMEOUT":
                    case 5004:
                        message.errorCode = 5004;
                        break;
                    case "ERROR_CODE_SERVICE_UNAVAILABLE":
                    case 5005:
                        message.errorCode = 5005;
                        break;
                    case "ERROR_CODE_QUOTA_EXCEEDED":
                    case 5006:
                        message.errorCode = 5006;
                        break;
                    case "ERROR_CODE_INVALID_INPUT_FORMAT":
                    case 6001:
                        message.errorCode = 6001;
                        break;
                    case "ERROR_CODE_MISSING_REQUIRED_FIELD":
                    case 6002:
                        message.errorCode = 6002;
                        break;
                    case "ERROR_CODE_FIELD_VALUE_OUT_OF_RANGE":
                    case 6003:
                        message.errorCode = 6003;
                        break;
                    case "ERROR_CODE_INVALID_ENUM_VALUE":
                    case 6004:
                        message.errorCode = 6004;
                        break;
                    case "ERROR_CODE_DATA_TYPE_MISMATCH":
                    case 6005:
                        message.errorCode = 6005;
                        break;
                    case "ERROR_CODE_SCHEMA_VALIDATION_FAILED":
                    case 6006:
                        message.errorCode = 6006;
                        break;
                    }
                    if (object.errorName != null)
                        message.errorName = String(object.errorName);
                    switch (object.category) {
                    default:
                        if (typeof object.category === "number") {
                            message.category = object.category;
                            break;
                        }
                        break;
                    case "ERROR_CATEGORY_UNSPECIFIED":
                    case 0:
                        message.category = 0;
                        break;
                    case "ERROR_CATEGORY_AUTHENTICATION":
                    case 1000:
                        message.category = 1000;
                        break;
                    case "ERROR_CATEGORY_STATE_MANAGEMENT":
                    case 2000:
                        message.category = 2000;
                        break;
                    case "ERROR_CATEGORY_CONNECTION":
                    case 3000:
                        message.category = 3000;
                        break;
                    case "ERROR_CATEGORY_VOICE_PROCESSING":
                    case 4000:
                        message.category = 4000;
                        break;
                    case "ERROR_CATEGORY_API":
                    case 5000:
                        message.category = 5000;
                        break;
                    case "ERROR_CATEGORY_VALIDATION":
                    case 6000:
                        message.category = 6000;
                        break;
                    }
                    if (object.message != null)
                        message.message = String(object.message);
                    if (object.details) {
                        if (!$util.isObject(object.details))
                            throw TypeError(".mythbound.websocket.v1.StandardizedError.details: object expected");
                        message.details = {};
                        for (let keys = Object.keys(object.details), i = 0; i < keys.length; ++i) {
                            if (keys[i] === "__proto__")
                                $util.makeProp(message.details, keys[i]);
                            message.details[keys[i]] = String(object.details[keys[i]]);
                        }
                    }
                    if (object.timestamp != null)
                        message.timestamp = String(object.timestamp);
                    if (object.correlationId != null)
                        message.correlationId = String(object.correlationId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.sessionId != null)
                        message.sessionId = String(object.sessionId);
                    if (object.component != null)
                        message.component = String(object.component);
                    if (object.retryPolicy != null) {
                        if (!$util.isObject(object.retryPolicy))
                            throw TypeError(".mythbound.websocket.v1.StandardizedError.retryPolicy: object expected");
                        message.retryPolicy = $root.mythbound.websocket.v1.RetryPolicy.fromObject(object.retryPolicy, long + 1);
                    }
                    if (object.isRetryable != null)
                        message.isRetryable = Boolean(object.isRetryable);
                    switch (object.gmSeverity) {
                    default:
                        if (typeof object.gmSeverity === "number") {
                            message.gmSeverity = object.gmSeverity;
                            break;
                        }
                        break;
                    case "GM_ERROR_SEVERITY_UNSPECIFIED":
                    case 0:
                        message.gmSeverity = 0;
                        break;
                    case "GM_ERROR_SEVERITY_TRANSPARENT":
                    case 1:
                        message.gmSeverity = 1;
                        break;
                    case "GM_ERROR_SEVERITY_BACKGROUND":
                    case 2:
                        message.gmSeverity = 2;
                        break;
                    case "GM_ERROR_SEVERITY_GRACEFUL":
                    case 3:
                        message.gmSeverity = 3;
                        break;
                    case "GM_ERROR_SEVERITY_NOTICEABLE":
                    case 4:
                        message.gmSeverity = 4;
                        break;
                    case "GM_ERROR_SEVERITY_CRITICAL":
                    case 5:
                        message.gmSeverity = 5;
                        break;
                    }
                    if (object.userVisibleMessage != null)
                        message.userVisibleMessage = String(object.userVisibleMessage);
                    if (object.fallbackResponse != null)
                        message.fallbackResponse = String(object.fallbackResponse);
                    return message;
                };

                /**
                 * Creates a plain object from a StandardizedError message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @static
                 * @param {mythbound.websocket.v1.StandardizedError} message StandardizedError
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StandardizedError.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.objects || options.defaults)
                        object.details = {};
                    if (options.defaults) {
                        object.errorCode = options.enums === String ? "ERROR_CODE_UNSPECIFIED" : 0;
                        object.errorName = "";
                        object.category = options.enums === String ? "ERROR_CATEGORY_UNSPECIFIED" : 0;
                        object.message = "";
                        object.timestamp = "";
                        object.correlationId = "";
                        object.userId = "";
                        object.sessionId = "";
                        object.component = "";
                        object.retryPolicy = null;
                        object.isRetryable = false;
                        object.gmSeverity = options.enums === String ? "GM_ERROR_SEVERITY_UNSPECIFIED" : 0;
                        object.userVisibleMessage = "";
                        object.fallbackResponse = "";
                    }
                    if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                        object.errorCode = options.enums === String ? $root.mythbound.websocket.v1.ErrorCode[message.errorCode] === undefined ? message.errorCode : $root.mythbound.websocket.v1.ErrorCode[message.errorCode] : message.errorCode;
                    if (message.errorName != null && Object.hasOwnProperty.call(message, "errorName"))
                        object.errorName = message.errorName;
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        object.category = options.enums === String ? $root.mythbound.websocket.v1.ErrorCategory[message.category] === undefined ? message.category : $root.mythbound.websocket.v1.ErrorCategory[message.category] : message.category;
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        object.message = message.message;
                    let keys2;
                    if (message.details && (keys2 = Object.keys(message.details)).length) {
                        object.details = {};
                        for (let j = 0; j < keys2.length; ++j) {
                            if (keys2[j] === "__proto__")
                                $util.makeProp(object.details, keys2[j]);
                            object.details[keys2[j]] = message.details[keys2[j]];
                        }
                    }
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        object.timestamp = message.timestamp;
                    if (message.correlationId != null && Object.hasOwnProperty.call(message, "correlationId"))
                        object.correlationId = message.correlationId;
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        object.userId = message.userId;
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        object.sessionId = message.sessionId;
                    if (message.component != null && Object.hasOwnProperty.call(message, "component"))
                        object.component = message.component;
                    if (message.retryPolicy != null && Object.hasOwnProperty.call(message, "retryPolicy"))
                        object.retryPolicy = $root.mythbound.websocket.v1.RetryPolicy.toObject(message.retryPolicy, options, q + 1);
                    if (message.isRetryable != null && Object.hasOwnProperty.call(message, "isRetryable"))
                        object.isRetryable = message.isRetryable;
                    if (message.gmSeverity != null && Object.hasOwnProperty.call(message, "gmSeverity"))
                        object.gmSeverity = options.enums === String ? $root.mythbound.websocket.v1.GMErrorSeverity[message.gmSeverity] === undefined ? message.gmSeverity : $root.mythbound.websocket.v1.GMErrorSeverity[message.gmSeverity] : message.gmSeverity;
                    if (message.userVisibleMessage != null && Object.hasOwnProperty.call(message, "userVisibleMessage"))
                        object.userVisibleMessage = message.userVisibleMessage;
                    if (message.fallbackResponse != null && Object.hasOwnProperty.call(message, "fallbackResponse"))
                        object.fallbackResponse = message.fallbackResponse;
                    return object;
                };

                /**
                 * Converts this StandardizedError to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StandardizedError.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StandardizedError
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.StandardizedError
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StandardizedError.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.StandardizedError";
                };

                return StandardizedError;
            })();

            v1.ErrorMessage = (function() {

                /**
                 * Properties of an ErrorMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IErrorMessage
                 * @property {string|null} [messageId] ErrorMessage messageId
                 * @property {string|null} [messageType] ErrorMessage messageType
                 * @property {string|null} [timestamp] ErrorMessage timestamp
                 * @property {string|null} [correlationId] ErrorMessage correlationId
                 * @property {number|null} [sequenceNumber] ErrorMessage sequenceNumber
                 * @property {mythbound.websocket.v1.IStandardizedError|null} [error] ErrorMessage error
                 * @property {string|null} [sourcePlatform] ErrorMessage sourcePlatform
                 * @property {string|null} [targetPlatform] ErrorMessage targetPlatform
                 * @property {string|null} [campaignId] ErrorMessage campaignId
                 * @property {string|null} [userId] ErrorMessage userId
                 * @property {string|null} [priority] ErrorMessage priority
                 */

                /**
                 * Constructs a new ErrorMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents an ErrorMessage.
                 * @implements IErrorMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IErrorMessage=} [properties] Properties to set
                 */
                function ErrorMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ErrorMessage messageId.
                 * @member {string} messageId
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 */
                ErrorMessage.prototype.messageId = "";

                /**
                 * ErrorMessage messageType.
                 * @member {string} messageType
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 */
                ErrorMessage.prototype.messageType = "";

                /**
                 * ErrorMessage timestamp.
                 * @member {string} timestamp
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 */
                ErrorMessage.prototype.timestamp = "";

                /**
                 * ErrorMessage correlationId.
                 * @member {string} correlationId
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 */
                ErrorMessage.prototype.correlationId = "";

                /**
                 * ErrorMessage sequenceNumber.
                 * @member {number} sequenceNumber
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 */
                ErrorMessage.prototype.sequenceNumber = 0;

                /**
                 * ErrorMessage error.
                 * @member {mythbound.websocket.v1.IStandardizedError|null|undefined} error
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 */
                ErrorMessage.prototype.error = null;

                /**
                 * ErrorMessage sourcePlatform.
                 * @member {string} sourcePlatform
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 */
                ErrorMessage.prototype.sourcePlatform = "";

                /**
                 * ErrorMessage targetPlatform.
                 * @member {string} targetPlatform
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 */
                ErrorMessage.prototype.targetPlatform = "";

                /**
                 * ErrorMessage campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 */
                ErrorMessage.prototype.campaignId = "";

                /**
                 * ErrorMessage userId.
                 * @member {string} userId
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 */
                ErrorMessage.prototype.userId = "";

                /**
                 * ErrorMessage priority.
                 * @member {string} priority
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 */
                ErrorMessage.prototype.priority = "";

                /**
                 * Creates a new ErrorMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @static
                 * @param {mythbound.websocket.v1.IErrorMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.ErrorMessage} ErrorMessage instance
                 */
                ErrorMessage.create = function create(properties) {
                    return new ErrorMessage(properties);
                };

                /**
                 * Encodes the specified ErrorMessage message. Does not implicitly {@link mythbound.websocket.v1.ErrorMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @static
                 * @param {mythbound.websocket.v1.IErrorMessage} message ErrorMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
                    if (message.messageType != null && Object.hasOwnProperty.call(message, "messageType"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageType);
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.timestamp);
                    if (message.correlationId != null && Object.hasOwnProperty.call(message, "correlationId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.correlationId);
                    if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.sequenceNumber);
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.mythbound.websocket.v1.StandardizedError.encode(message.error, writer.uint32(/* id 6, wireType 2 =*/50).fork(), q + 1).ldelim();
                    if (message.sourcePlatform != null && Object.hasOwnProperty.call(message, "sourcePlatform"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.sourcePlatform);
                    if (message.targetPlatform != null && Object.hasOwnProperty.call(message, "targetPlatform"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.targetPlatform);
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.campaignId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.userId);
                    if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.priority);
                    return writer;
                };

                /**
                 * Encodes the specified ErrorMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.ErrorMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @static
                 * @param {mythbound.websocket.v1.IErrorMessage} message ErrorMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes an ErrorMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.ErrorMessage} ErrorMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.ErrorMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.messageId = reader.string();
                                break;
                            }
                        case 2: {
                                message.messageType = reader.string();
                                break;
                            }
                        case 3: {
                                message.timestamp = reader.string();
                                break;
                            }
                        case 4: {
                                message.correlationId = reader.string();
                                break;
                            }
                        case 5: {
                                message.sequenceNumber = reader.int32();
                                break;
                            }
                        case 6: {
                                message.error = $root.mythbound.websocket.v1.StandardizedError.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 7: {
                                message.sourcePlatform = reader.string();
                                break;
                            }
                        case 8: {
                                message.targetPlatform = reader.string();
                                break;
                            }
                        case 9: {
                                message.campaignId = reader.string();
                                break;
                            }
                        case 10: {
                                message.userId = reader.string();
                                break;
                            }
                        case 11: {
                                message.priority = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes an ErrorMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.ErrorMessage} ErrorMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ErrorMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ErrorMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                        if (!$util.isString(message.messageId))
                            return "messageId: string expected";
                    if (message.messageType != null && Object.hasOwnProperty.call(message, "messageType"))
                        if (!$util.isString(message.messageType))
                            return "messageType: string expected";
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        if (!$util.isString(message.timestamp))
                            return "timestamp: string expected";
                    if (message.correlationId != null && Object.hasOwnProperty.call(message, "correlationId"))
                        if (!$util.isString(message.correlationId))
                            return "correlationId: string expected";
                    if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                        if (!$util.isInteger(message.sequenceNumber))
                            return "sequenceNumber: integer expected";
                    if (message.error != null && Object.hasOwnProperty.call(message, "error")) {
                        let error = $root.mythbound.websocket.v1.StandardizedError.verify(message.error, long + 1);
                        if (error)
                            return "error." + error;
                    }
                    if (message.sourcePlatform != null && Object.hasOwnProperty.call(message, "sourcePlatform"))
                        if (!$util.isString(message.sourcePlatform))
                            return "sourcePlatform: string expected";
                    if (message.targetPlatform != null && Object.hasOwnProperty.call(message, "targetPlatform"))
                        if (!$util.isString(message.targetPlatform))
                            return "targetPlatform: string expected";
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                        if (!$util.isString(message.priority))
                            return "priority: string expected";
                    return null;
                };

                /**
                 * Creates an ErrorMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.ErrorMessage} ErrorMessage
                 */
                ErrorMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.ErrorMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.ErrorMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.ErrorMessage();
                    if (object.messageId != null)
                        message.messageId = String(object.messageId);
                    if (object.messageType != null)
                        message.messageType = String(object.messageType);
                    if (object.timestamp != null)
                        message.timestamp = String(object.timestamp);
                    if (object.correlationId != null)
                        message.correlationId = String(object.correlationId);
                    if (object.sequenceNumber != null)
                        message.sequenceNumber = object.sequenceNumber | 0;
                    if (object.error != null) {
                        if (!$util.isObject(object.error))
                            throw TypeError(".mythbound.websocket.v1.ErrorMessage.error: object expected");
                        message.error = $root.mythbound.websocket.v1.StandardizedError.fromObject(object.error, long + 1);
                    }
                    if (object.sourcePlatform != null)
                        message.sourcePlatform = String(object.sourcePlatform);
                    if (object.targetPlatform != null)
                        message.targetPlatform = String(object.targetPlatform);
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.priority != null)
                        message.priority = String(object.priority);
                    return message;
                };

                /**
                 * Creates a plain object from an ErrorMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @static
                 * @param {mythbound.websocket.v1.ErrorMessage} message ErrorMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ErrorMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.messageId = "";
                        object.messageType = "";
                        object.timestamp = "";
                        object.correlationId = "";
                        object.sequenceNumber = 0;
                        object.error = null;
                        object.sourcePlatform = "";
                        object.targetPlatform = "";
                        object.campaignId = "";
                        object.userId = "";
                        object.priority = "";
                    }
                    if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                        object.messageId = message.messageId;
                    if (message.messageType != null && Object.hasOwnProperty.call(message, "messageType"))
                        object.messageType = message.messageType;
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        object.timestamp = message.timestamp;
                    if (message.correlationId != null && Object.hasOwnProperty.call(message, "correlationId"))
                        object.correlationId = message.correlationId;
                    if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                        object.sequenceNumber = message.sequenceNumber;
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        object.error = $root.mythbound.websocket.v1.StandardizedError.toObject(message.error, options, q + 1);
                    if (message.sourcePlatform != null && Object.hasOwnProperty.call(message, "sourcePlatform"))
                        object.sourcePlatform = message.sourcePlatform;
                    if (message.targetPlatform != null && Object.hasOwnProperty.call(message, "targetPlatform"))
                        object.targetPlatform = message.targetPlatform;
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        object.userId = message.userId;
                    if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                        object.priority = message.priority;
                    return object;
                };

                /**
                 * Converts this ErrorMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ErrorMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ErrorMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.ErrorMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ErrorMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.ErrorMessage";
                };

                return ErrorMessage;
            })();

            v1.ErrorBatch = (function() {

                /**
                 * Properties of an ErrorBatch.
                 * @memberof mythbound.websocket.v1
                 * @interface IErrorBatch
                 * @property {Array.<mythbound.websocket.v1.IStandardizedError>|null} [errors] ErrorBatch errors
                 * @property {string|null} [batchId] ErrorBatch batchId
                 * @property {string|null} [startTimestamp] ErrorBatch startTimestamp
                 * @property {string|null} [endTimestamp] ErrorBatch endTimestamp
                 * @property {number|null} [totalCount] ErrorBatch totalCount
                 * @property {Object.<string,number>|null} [errorsByCode] ErrorBatch errorsByCode
                 * @property {Object.<string,number>|null} [errorsByCategory] ErrorBatch errorsByCategory
                 */

                /**
                 * Constructs a new ErrorBatch.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents an ErrorBatch.
                 * @implements IErrorBatch
                 * @constructor
                 * @param {mythbound.websocket.v1.IErrorBatch=} [properties] Properties to set
                 */
                function ErrorBatch(properties) {
                    this.errors = [];
                    this.errorsByCode = {};
                    this.errorsByCategory = {};
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ErrorBatch errors.
                 * @member {Array.<mythbound.websocket.v1.IStandardizedError>} errors
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @instance
                 */
                ErrorBatch.prototype.errors = $util.emptyArray;

                /**
                 * ErrorBatch batchId.
                 * @member {string} batchId
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @instance
                 */
                ErrorBatch.prototype.batchId = "";

                /**
                 * ErrorBatch startTimestamp.
                 * @member {string} startTimestamp
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @instance
                 */
                ErrorBatch.prototype.startTimestamp = "";

                /**
                 * ErrorBatch endTimestamp.
                 * @member {string} endTimestamp
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @instance
                 */
                ErrorBatch.prototype.endTimestamp = "";

                /**
                 * ErrorBatch totalCount.
                 * @member {number} totalCount
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @instance
                 */
                ErrorBatch.prototype.totalCount = 0;

                /**
                 * ErrorBatch errorsByCode.
                 * @member {Object.<string,number>} errorsByCode
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @instance
                 */
                ErrorBatch.prototype.errorsByCode = $util.emptyObject;

                /**
                 * ErrorBatch errorsByCategory.
                 * @member {Object.<string,number>} errorsByCategory
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @instance
                 */
                ErrorBatch.prototype.errorsByCategory = $util.emptyObject;

                /**
                 * Creates a new ErrorBatch instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @static
                 * @param {mythbound.websocket.v1.IErrorBatch=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.ErrorBatch} ErrorBatch instance
                 */
                ErrorBatch.create = function create(properties) {
                    return new ErrorBatch(properties);
                };

                /**
                 * Encodes the specified ErrorBatch message. Does not implicitly {@link mythbound.websocket.v1.ErrorBatch.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @static
                 * @param {mythbound.websocket.v1.IErrorBatch} message ErrorBatch message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorBatch.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.errors != null && message.errors.length)
                        for (let i = 0; i < message.errors.length; ++i)
                            $root.mythbound.websocket.v1.StandardizedError.encode(message.errors[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.batchId != null && Object.hasOwnProperty.call(message, "batchId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.batchId);
                    if (message.startTimestamp != null && Object.hasOwnProperty.call(message, "startTimestamp"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.startTimestamp);
                    if (message.endTimestamp != null && Object.hasOwnProperty.call(message, "endTimestamp"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.endTimestamp);
                    if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.totalCount);
                    if (message.errorsByCode != null && Object.hasOwnProperty.call(message, "errorsByCode"))
                        for (let keys = Object.keys(message.errorsByCode), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.errorsByCode[keys[i]]).ldelim();
                    if (message.errorsByCategory != null && Object.hasOwnProperty.call(message, "errorsByCategory"))
                        for (let keys = Object.keys(message.errorsByCategory), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 7, wireType 2 =*/58).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.errorsByCategory[keys[i]]).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ErrorBatch message, length delimited. Does not implicitly {@link mythbound.websocket.v1.ErrorBatch.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @static
                 * @param {mythbound.websocket.v1.IErrorBatch} message ErrorBatch message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorBatch.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes an ErrorBatch message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.ErrorBatch} ErrorBatch
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorBatch.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message, key, value;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.ErrorBatch();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.errors && message.errors.length))
                                    message.errors = [];
                                message.errors.push($root.mythbound.websocket.v1.StandardizedError.decode(reader, reader.uint32(), undefined, long + 1));
                                break;
                            }
                        case 2: {
                                message.batchId = reader.string();
                                break;
                            }
                        case 3: {
                                message.startTimestamp = reader.string();
                                break;
                            }
                        case 4: {
                                message.endTimestamp = reader.string();
                                break;
                            }
                        case 5: {
                                message.totalCount = reader.int32();
                                break;
                            }
                        case 6: {
                                if (message.errorsByCode === $util.emptyObject)
                                    message.errorsByCode = {};
                                let end2 = reader.uint32() + reader.pos;
                                if (end2 > reader.len)
                                    throw RangeError("index out of range");
                                reader.len = end2;
                                key = "";
                                value = 0;
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.int32();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7, long);
                                        break;
                                    }
                                }
                                if (reader.pos !== end2)
                                    throw RangeError("index out of range");
                                reader.len = end;
                                if (key === "__proto__")
                                    $util.makeProp(message.errorsByCode, key);
                                message.errorsByCode[key] = value;
                                break;
                            }
                        case 7: {
                                if (message.errorsByCategory === $util.emptyObject)
                                    message.errorsByCategory = {};
                                let end2 = reader.uint32() + reader.pos;
                                if (end2 > reader.len)
                                    throw RangeError("index out of range");
                                reader.len = end2;
                                key = "";
                                value = 0;
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.int32();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7, long);
                                        break;
                                    }
                                }
                                if (reader.pos !== end2)
                                    throw RangeError("index out of range");
                                reader.len = end;
                                if (key === "__proto__")
                                    $util.makeProp(message.errorsByCategory, key);
                                message.errorsByCategory[key] = value;
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes an ErrorBatch message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.ErrorBatch} ErrorBatch
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorBatch.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ErrorBatch message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ErrorBatch.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.errors != null && Object.hasOwnProperty.call(message, "errors")) {
                        if (!Array.isArray(message.errors))
                            return "errors: array expected";
                        for (let i = 0; i < message.errors.length; ++i) {
                            let error = $root.mythbound.websocket.v1.StandardizedError.verify(message.errors[i], long + 1);
                            if (error)
                                return "errors." + error;
                        }
                    }
                    if (message.batchId != null && Object.hasOwnProperty.call(message, "batchId"))
                        if (!$util.isString(message.batchId))
                            return "batchId: string expected";
                    if (message.startTimestamp != null && Object.hasOwnProperty.call(message, "startTimestamp"))
                        if (!$util.isString(message.startTimestamp))
                            return "startTimestamp: string expected";
                    if (message.endTimestamp != null && Object.hasOwnProperty.call(message, "endTimestamp"))
                        if (!$util.isString(message.endTimestamp))
                            return "endTimestamp: string expected";
                    if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                        if (!$util.isInteger(message.totalCount))
                            return "totalCount: integer expected";
                    if (message.errorsByCode != null && Object.hasOwnProperty.call(message, "errorsByCode")) {
                        if (!$util.isObject(message.errorsByCode))
                            return "errorsByCode: object expected";
                        let key = Object.keys(message.errorsByCode);
                        for (let i = 0; i < key.length; ++i)
                            if (!$util.isInteger(message.errorsByCode[key[i]]))
                                return "errorsByCode: integer{k:string} expected";
                    }
                    if (message.errorsByCategory != null && Object.hasOwnProperty.call(message, "errorsByCategory")) {
                        if (!$util.isObject(message.errorsByCategory))
                            return "errorsByCategory: object expected";
                        let key = Object.keys(message.errorsByCategory);
                        for (let i = 0; i < key.length; ++i)
                            if (!$util.isInteger(message.errorsByCategory[key[i]]))
                                return "errorsByCategory: integer{k:string} expected";
                    }
                    return null;
                };

                /**
                 * Creates an ErrorBatch message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.ErrorBatch} ErrorBatch
                 */
                ErrorBatch.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.ErrorBatch)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.ErrorBatch: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.ErrorBatch();
                    if (object.errors) {
                        if (!Array.isArray(object.errors))
                            throw TypeError(".mythbound.websocket.v1.ErrorBatch.errors: array expected");
                        message.errors = [];
                        for (let i = 0; i < object.errors.length; ++i) {
                            if (!$util.isObject(object.errors[i]))
                                throw TypeError(".mythbound.websocket.v1.ErrorBatch.errors: object expected");
                            message.errors[i] = $root.mythbound.websocket.v1.StandardizedError.fromObject(object.errors[i], long + 1);
                        }
                    }
                    if (object.batchId != null)
                        message.batchId = String(object.batchId);
                    if (object.startTimestamp != null)
                        message.startTimestamp = String(object.startTimestamp);
                    if (object.endTimestamp != null)
                        message.endTimestamp = String(object.endTimestamp);
                    if (object.totalCount != null)
                        message.totalCount = object.totalCount | 0;
                    if (object.errorsByCode) {
                        if (!$util.isObject(object.errorsByCode))
                            throw TypeError(".mythbound.websocket.v1.ErrorBatch.errorsByCode: object expected");
                        message.errorsByCode = {};
                        for (let keys = Object.keys(object.errorsByCode), i = 0; i < keys.length; ++i) {
                            if (keys[i] === "__proto__")
                                $util.makeProp(message.errorsByCode, keys[i]);
                            message.errorsByCode[keys[i]] = object.errorsByCode[keys[i]] | 0;
                        }
                    }
                    if (object.errorsByCategory) {
                        if (!$util.isObject(object.errorsByCategory))
                            throw TypeError(".mythbound.websocket.v1.ErrorBatch.errorsByCategory: object expected");
                        message.errorsByCategory = {};
                        for (let keys = Object.keys(object.errorsByCategory), i = 0; i < keys.length; ++i) {
                            if (keys[i] === "__proto__")
                                $util.makeProp(message.errorsByCategory, keys[i]);
                            message.errorsByCategory[keys[i]] = object.errorsByCategory[keys[i]] | 0;
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ErrorBatch message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @static
                 * @param {mythbound.websocket.v1.ErrorBatch} message ErrorBatch
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ErrorBatch.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.errors = [];
                    if (options.objects || options.defaults) {
                        object.errorsByCode = {};
                        object.errorsByCategory = {};
                    }
                    if (options.defaults) {
                        object.batchId = "";
                        object.startTimestamp = "";
                        object.endTimestamp = "";
                        object.totalCount = 0;
                    }
                    if (message.errors && message.errors.length) {
                        object.errors = [];
                        for (let j = 0; j < message.errors.length; ++j)
                            object.errors[j] = $root.mythbound.websocket.v1.StandardizedError.toObject(message.errors[j], options, q + 1);
                    }
                    if (message.batchId != null && Object.hasOwnProperty.call(message, "batchId"))
                        object.batchId = message.batchId;
                    if (message.startTimestamp != null && Object.hasOwnProperty.call(message, "startTimestamp"))
                        object.startTimestamp = message.startTimestamp;
                    if (message.endTimestamp != null && Object.hasOwnProperty.call(message, "endTimestamp"))
                        object.endTimestamp = message.endTimestamp;
                    if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                        object.totalCount = message.totalCount;
                    let keys2;
                    if (message.errorsByCode && (keys2 = Object.keys(message.errorsByCode)).length) {
                        object.errorsByCode = {};
                        for (let j = 0; j < keys2.length; ++j) {
                            if (keys2[j] === "__proto__")
                                $util.makeProp(object.errorsByCode, keys2[j]);
                            object.errorsByCode[keys2[j]] = message.errorsByCode[keys2[j]];
                        }
                    }
                    if (message.errorsByCategory && (keys2 = Object.keys(message.errorsByCategory)).length) {
                        object.errorsByCategory = {};
                        for (let j = 0; j < keys2.length; ++j) {
                            if (keys2[j] === "__proto__")
                                $util.makeProp(object.errorsByCategory, keys2[j]);
                            object.errorsByCategory[keys2[j]] = message.errorsByCategory[keys2[j]];
                        }
                    }
                    return object;
                };

                /**
                 * Converts this ErrorBatch to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ErrorBatch.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ErrorBatch
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.ErrorBatch
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ErrorBatch.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.ErrorBatch";
                };

                return ErrorBatch;
            })();

            v1.RecoveryAction = (function() {

                /**
                 * Properties of a RecoveryAction.
                 * @memberof mythbound.websocket.v1
                 * @interface IRecoveryAction
                 * @property {string|null} [actionType] RecoveryAction actionType
                 * @property {string|null} [description] RecoveryAction description
                 * @property {Object.<string,string>|null} [parameters] RecoveryAction parameters
                 * @property {number|null} [delaySeconds] RecoveryAction delaySeconds
                 */

                /**
                 * Constructs a new RecoveryAction.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a RecoveryAction.
                 * @implements IRecoveryAction
                 * @constructor
                 * @param {mythbound.websocket.v1.IRecoveryAction=} [properties] Properties to set
                 */
                function RecoveryAction(properties) {
                    this.parameters = {};
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecoveryAction actionType.
                 * @member {string} actionType
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @instance
                 */
                RecoveryAction.prototype.actionType = "";

                /**
                 * RecoveryAction description.
                 * @member {string} description
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @instance
                 */
                RecoveryAction.prototype.description = "";

                /**
                 * RecoveryAction parameters.
                 * @member {Object.<string,string>} parameters
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @instance
                 */
                RecoveryAction.prototype.parameters = $util.emptyObject;

                /**
                 * RecoveryAction delaySeconds.
                 * @member {number} delaySeconds
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @instance
                 */
                RecoveryAction.prototype.delaySeconds = 0;

                /**
                 * Creates a new RecoveryAction instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @static
                 * @param {mythbound.websocket.v1.IRecoveryAction=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.RecoveryAction} RecoveryAction instance
                 */
                RecoveryAction.create = function create(properties) {
                    return new RecoveryAction(properties);
                };

                /**
                 * Encodes the specified RecoveryAction message. Does not implicitly {@link mythbound.websocket.v1.RecoveryAction.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @static
                 * @param {mythbound.websocket.v1.IRecoveryAction} message RecoveryAction message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecoveryAction.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.actionType);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
                    if (message.parameters != null && Object.hasOwnProperty.call(message, "parameters"))
                        for (let keys = Object.keys(message.parameters), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.parameters[keys[i]]).ldelim();
                    if (message.delaySeconds != null && Object.hasOwnProperty.call(message, "delaySeconds"))
                        writer.uint32(/* id 4, wireType 5 =*/37).float(message.delaySeconds);
                    return writer;
                };

                /**
                 * Encodes the specified RecoveryAction message, length delimited. Does not implicitly {@link mythbound.websocket.v1.RecoveryAction.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @static
                 * @param {mythbound.websocket.v1.IRecoveryAction} message RecoveryAction message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecoveryAction.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a RecoveryAction message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.RecoveryAction} RecoveryAction
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecoveryAction.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message, key, value;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.RecoveryAction();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.actionType = reader.string();
                                break;
                            }
                        case 2: {
                                message.description = reader.string();
                                break;
                            }
                        case 3: {
                                if (message.parameters === $util.emptyObject)
                                    message.parameters = {};
                                let end2 = reader.uint32() + reader.pos;
                                if (end2 > reader.len)
                                    throw RangeError("index out of range");
                                reader.len = end2;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7, long);
                                        break;
                                    }
                                }
                                if (reader.pos !== end2)
                                    throw RangeError("index out of range");
                                reader.len = end;
                                if (key === "__proto__")
                                    $util.makeProp(message.parameters, key);
                                message.parameters[key] = value;
                                break;
                            }
                        case 4: {
                                message.delaySeconds = reader.float();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a RecoveryAction message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.RecoveryAction} RecoveryAction
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecoveryAction.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecoveryAction message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecoveryAction.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                        if (!$util.isString(message.actionType))
                            return "actionType: string expected";
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.parameters != null && Object.hasOwnProperty.call(message, "parameters")) {
                        if (!$util.isObject(message.parameters))
                            return "parameters: object expected";
                        let key = Object.keys(message.parameters);
                        for (let i = 0; i < key.length; ++i)
                            if (!$util.isString(message.parameters[key[i]]))
                                return "parameters: string{k:string} expected";
                    }
                    if (message.delaySeconds != null && Object.hasOwnProperty.call(message, "delaySeconds"))
                        if (typeof message.delaySeconds !== "number")
                            return "delaySeconds: number expected";
                    return null;
                };

                /**
                 * Creates a RecoveryAction message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.RecoveryAction} RecoveryAction
                 */
                RecoveryAction.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.RecoveryAction)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.RecoveryAction: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.RecoveryAction();
                    if (object.actionType != null)
                        message.actionType = String(object.actionType);
                    if (object.description != null)
                        message.description = String(object.description);
                    if (object.parameters) {
                        if (!$util.isObject(object.parameters))
                            throw TypeError(".mythbound.websocket.v1.RecoveryAction.parameters: object expected");
                        message.parameters = {};
                        for (let keys = Object.keys(object.parameters), i = 0; i < keys.length; ++i) {
                            if (keys[i] === "__proto__")
                                $util.makeProp(message.parameters, keys[i]);
                            message.parameters[keys[i]] = String(object.parameters[keys[i]]);
                        }
                    }
                    if (object.delaySeconds != null)
                        message.delaySeconds = Number(object.delaySeconds);
                    return message;
                };

                /**
                 * Creates a plain object from a RecoveryAction message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @static
                 * @param {mythbound.websocket.v1.RecoveryAction} message RecoveryAction
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecoveryAction.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.objects || options.defaults)
                        object.parameters = {};
                    if (options.defaults) {
                        object.actionType = "";
                        object.description = "";
                        object.delaySeconds = 0;
                    }
                    if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                        object.actionType = message.actionType;
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        object.description = message.description;
                    let keys2;
                    if (message.parameters && (keys2 = Object.keys(message.parameters)).length) {
                        object.parameters = {};
                        for (let j = 0; j < keys2.length; ++j) {
                            if (keys2[j] === "__proto__")
                                $util.makeProp(object.parameters, keys2[j]);
                            object.parameters[keys2[j]] = message.parameters[keys2[j]];
                        }
                    }
                    if (message.delaySeconds != null && Object.hasOwnProperty.call(message, "delaySeconds"))
                        object.delaySeconds = options.json && !isFinite(message.delaySeconds) ? String(message.delaySeconds) : message.delaySeconds;
                    return object;
                };

                /**
                 * Converts this RecoveryAction to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecoveryAction.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RecoveryAction
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.RecoveryAction
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RecoveryAction.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.RecoveryAction";
                };

                return RecoveryAction;
            })();

            v1.ErrorContext = (function() {

                /**
                 * Properties of an ErrorContext.
                 * @memberof mythbound.websocket.v1
                 * @interface IErrorContext
                 * @property {string|null} [requestId] ErrorContext requestId
                 * @property {string|null} [endpoint] ErrorContext endpoint
                 * @property {string|null} [method] ErrorContext method
                 * @property {Object.<string,string>|null} [headers] ErrorContext headers
                 * @property {string|null} [bodySample] ErrorContext bodySample
                 * @property {string|null} [stackTrace] ErrorContext stackTrace
                 * @property {string|null} [originalException] ErrorContext originalException
                 */

                /**
                 * Constructs a new ErrorContext.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents an ErrorContext.
                 * @implements IErrorContext
                 * @constructor
                 * @param {mythbound.websocket.v1.IErrorContext=} [properties] Properties to set
                 */
                function ErrorContext(properties) {
                    this.headers = {};
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ErrorContext requestId.
                 * @member {string} requestId
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @instance
                 */
                ErrorContext.prototype.requestId = "";

                /**
                 * ErrorContext endpoint.
                 * @member {string} endpoint
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @instance
                 */
                ErrorContext.prototype.endpoint = "";

                /**
                 * ErrorContext method.
                 * @member {string} method
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @instance
                 */
                ErrorContext.prototype.method = "";

                /**
                 * ErrorContext headers.
                 * @member {Object.<string,string>} headers
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @instance
                 */
                ErrorContext.prototype.headers = $util.emptyObject;

                /**
                 * ErrorContext bodySample.
                 * @member {string} bodySample
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @instance
                 */
                ErrorContext.prototype.bodySample = "";

                /**
                 * ErrorContext stackTrace.
                 * @member {string} stackTrace
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @instance
                 */
                ErrorContext.prototype.stackTrace = "";

                /**
                 * ErrorContext originalException.
                 * @member {string} originalException
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @instance
                 */
                ErrorContext.prototype.originalException = "";

                /**
                 * Creates a new ErrorContext instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @static
                 * @param {mythbound.websocket.v1.IErrorContext=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.ErrorContext} ErrorContext instance
                 */
                ErrorContext.create = function create(properties) {
                    return new ErrorContext(properties);
                };

                /**
                 * Encodes the specified ErrorContext message. Does not implicitly {@link mythbound.websocket.v1.ErrorContext.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @static
                 * @param {mythbound.websocket.v1.IErrorContext} message ErrorContext message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorContext.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
                    if (message.endpoint != null && Object.hasOwnProperty.call(message, "endpoint"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.endpoint);
                    if (message.method != null && Object.hasOwnProperty.call(message, "method"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.method);
                    if (message.headers != null && Object.hasOwnProperty.call(message, "headers"))
                        for (let keys = Object.keys(message.headers), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 4, wireType 2 =*/34).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.headers[keys[i]]).ldelim();
                    if (message.bodySample != null && Object.hasOwnProperty.call(message, "bodySample"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.bodySample);
                    if (message.stackTrace != null && Object.hasOwnProperty.call(message, "stackTrace"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.stackTrace);
                    if (message.originalException != null && Object.hasOwnProperty.call(message, "originalException"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.originalException);
                    return writer;
                };

                /**
                 * Encodes the specified ErrorContext message, length delimited. Does not implicitly {@link mythbound.websocket.v1.ErrorContext.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @static
                 * @param {mythbound.websocket.v1.IErrorContext} message ErrorContext message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorContext.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes an ErrorContext message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.ErrorContext} ErrorContext
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorContext.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message, key, value;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.ErrorContext();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.requestId = reader.string();
                                break;
                            }
                        case 2: {
                                message.endpoint = reader.string();
                                break;
                            }
                        case 3: {
                                message.method = reader.string();
                                break;
                            }
                        case 4: {
                                if (message.headers === $util.emptyObject)
                                    message.headers = {};
                                let end2 = reader.uint32() + reader.pos;
                                if (end2 > reader.len)
                                    throw RangeError("index out of range");
                                reader.len = end2;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7, long);
                                        break;
                                    }
                                }
                                if (reader.pos !== end2)
                                    throw RangeError("index out of range");
                                reader.len = end;
                                if (key === "__proto__")
                                    $util.makeProp(message.headers, key);
                                message.headers[key] = value;
                                break;
                            }
                        case 5: {
                                message.bodySample = reader.string();
                                break;
                            }
                        case 6: {
                                message.stackTrace = reader.string();
                                break;
                            }
                        case 7: {
                                message.originalException = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes an ErrorContext message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.ErrorContext} ErrorContext
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorContext.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ErrorContext message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ErrorContext.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        if (!$util.isString(message.requestId))
                            return "requestId: string expected";
                    if (message.endpoint != null && Object.hasOwnProperty.call(message, "endpoint"))
                        if (!$util.isString(message.endpoint))
                            return "endpoint: string expected";
                    if (message.method != null && Object.hasOwnProperty.call(message, "method"))
                        if (!$util.isString(message.method))
                            return "method: string expected";
                    if (message.headers != null && Object.hasOwnProperty.call(message, "headers")) {
                        if (!$util.isObject(message.headers))
                            return "headers: object expected";
                        let key = Object.keys(message.headers);
                        for (let i = 0; i < key.length; ++i)
                            if (!$util.isString(message.headers[key[i]]))
                                return "headers: string{k:string} expected";
                    }
                    if (message.bodySample != null && Object.hasOwnProperty.call(message, "bodySample"))
                        if (!$util.isString(message.bodySample))
                            return "bodySample: string expected";
                    if (message.stackTrace != null && Object.hasOwnProperty.call(message, "stackTrace"))
                        if (!$util.isString(message.stackTrace))
                            return "stackTrace: string expected";
                    if (message.originalException != null && Object.hasOwnProperty.call(message, "originalException"))
                        if (!$util.isString(message.originalException))
                            return "originalException: string expected";
                    return null;
                };

                /**
                 * Creates an ErrorContext message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.ErrorContext} ErrorContext
                 */
                ErrorContext.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.ErrorContext)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.ErrorContext: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.ErrorContext();
                    if (object.requestId != null)
                        message.requestId = String(object.requestId);
                    if (object.endpoint != null)
                        message.endpoint = String(object.endpoint);
                    if (object.method != null)
                        message.method = String(object.method);
                    if (object.headers) {
                        if (!$util.isObject(object.headers))
                            throw TypeError(".mythbound.websocket.v1.ErrorContext.headers: object expected");
                        message.headers = {};
                        for (let keys = Object.keys(object.headers), i = 0; i < keys.length; ++i) {
                            if (keys[i] === "__proto__")
                                $util.makeProp(message.headers, keys[i]);
                            message.headers[keys[i]] = String(object.headers[keys[i]]);
                        }
                    }
                    if (object.bodySample != null)
                        message.bodySample = String(object.bodySample);
                    if (object.stackTrace != null)
                        message.stackTrace = String(object.stackTrace);
                    if (object.originalException != null)
                        message.originalException = String(object.originalException);
                    return message;
                };

                /**
                 * Creates a plain object from an ErrorContext message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @static
                 * @param {mythbound.websocket.v1.ErrorContext} message ErrorContext
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ErrorContext.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.objects || options.defaults)
                        object.headers = {};
                    if (options.defaults) {
                        object.requestId = "";
                        object.endpoint = "";
                        object.method = "";
                        object.bodySample = "";
                        object.stackTrace = "";
                        object.originalException = "";
                    }
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        object.requestId = message.requestId;
                    if (message.endpoint != null && Object.hasOwnProperty.call(message, "endpoint"))
                        object.endpoint = message.endpoint;
                    if (message.method != null && Object.hasOwnProperty.call(message, "method"))
                        object.method = message.method;
                    let keys2;
                    if (message.headers && (keys2 = Object.keys(message.headers)).length) {
                        object.headers = {};
                        for (let j = 0; j < keys2.length; ++j) {
                            if (keys2[j] === "__proto__")
                                $util.makeProp(object.headers, keys2[j]);
                            object.headers[keys2[j]] = message.headers[keys2[j]];
                        }
                    }
                    if (message.bodySample != null && Object.hasOwnProperty.call(message, "bodySample"))
                        object.bodySample = message.bodySample;
                    if (message.stackTrace != null && Object.hasOwnProperty.call(message, "stackTrace"))
                        object.stackTrace = message.stackTrace;
                    if (message.originalException != null && Object.hasOwnProperty.call(message, "originalException"))
                        object.originalException = message.originalException;
                    return object;
                };

                /**
                 * Converts this ErrorContext to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ErrorContext.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ErrorContext
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.ErrorContext
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ErrorContext.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.ErrorContext";
                };

                return ErrorContext;
            })();

            v1.ErrorStatistics = (function() {

                /**
                 * Properties of an ErrorStatistics.
                 * @memberof mythbound.websocket.v1
                 * @interface IErrorStatistics
                 * @property {string|null} [errorCode] ErrorStatistics errorCode
                 * @property {number|null} [totalOccurrences] ErrorStatistics totalOccurrences
                 * @property {number|null} [lastHourCount] ErrorStatistics lastHourCount
                 * @property {number|null} [lastDayCount] ErrorStatistics lastDayCount
                 * @property {string|null} [firstOccurrence] ErrorStatistics firstOccurrence
                 * @property {string|null} [lastOccurrence] ErrorStatistics lastOccurrence
                 * @property {number|null} [avgResolutionTimeMs] ErrorStatistics avgResolutionTimeMs
                 * @property {number|null} [successRatePercent] ErrorStatistics successRatePercent
                 */

                /**
                 * Constructs a new ErrorStatistics.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents an ErrorStatistics.
                 * @implements IErrorStatistics
                 * @constructor
                 * @param {mythbound.websocket.v1.IErrorStatistics=} [properties] Properties to set
                 */
                function ErrorStatistics(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ErrorStatistics errorCode.
                 * @member {string} errorCode
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @instance
                 */
                ErrorStatistics.prototype.errorCode = "";

                /**
                 * ErrorStatistics totalOccurrences.
                 * @member {number} totalOccurrences
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @instance
                 */
                ErrorStatistics.prototype.totalOccurrences = 0;

                /**
                 * ErrorStatistics lastHourCount.
                 * @member {number} lastHourCount
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @instance
                 */
                ErrorStatistics.prototype.lastHourCount = 0;

                /**
                 * ErrorStatistics lastDayCount.
                 * @member {number} lastDayCount
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @instance
                 */
                ErrorStatistics.prototype.lastDayCount = 0;

                /**
                 * ErrorStatistics firstOccurrence.
                 * @member {string} firstOccurrence
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @instance
                 */
                ErrorStatistics.prototype.firstOccurrence = "";

                /**
                 * ErrorStatistics lastOccurrence.
                 * @member {string} lastOccurrence
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @instance
                 */
                ErrorStatistics.prototype.lastOccurrence = "";

                /**
                 * ErrorStatistics avgResolutionTimeMs.
                 * @member {number} avgResolutionTimeMs
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @instance
                 */
                ErrorStatistics.prototype.avgResolutionTimeMs = 0;

                /**
                 * ErrorStatistics successRatePercent.
                 * @member {number} successRatePercent
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @instance
                 */
                ErrorStatistics.prototype.successRatePercent = 0;

                /**
                 * Creates a new ErrorStatistics instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @static
                 * @param {mythbound.websocket.v1.IErrorStatistics=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.ErrorStatistics} ErrorStatistics instance
                 */
                ErrorStatistics.create = function create(properties) {
                    return new ErrorStatistics(properties);
                };

                /**
                 * Encodes the specified ErrorStatistics message. Does not implicitly {@link mythbound.websocket.v1.ErrorStatistics.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @static
                 * @param {mythbound.websocket.v1.IErrorStatistics} message ErrorStatistics message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorStatistics.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.errorCode);
                    if (message.totalOccurrences != null && Object.hasOwnProperty.call(message, "totalOccurrences"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalOccurrences);
                    if (message.lastHourCount != null && Object.hasOwnProperty.call(message, "lastHourCount"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.lastHourCount);
                    if (message.lastDayCount != null && Object.hasOwnProperty.call(message, "lastDayCount"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.lastDayCount);
                    if (message.firstOccurrence != null && Object.hasOwnProperty.call(message, "firstOccurrence"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.firstOccurrence);
                    if (message.lastOccurrence != null && Object.hasOwnProperty.call(message, "lastOccurrence"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.lastOccurrence);
                    if (message.avgResolutionTimeMs != null && Object.hasOwnProperty.call(message, "avgResolutionTimeMs"))
                        writer.uint32(/* id 7, wireType 5 =*/61).float(message.avgResolutionTimeMs);
                    if (message.successRatePercent != null && Object.hasOwnProperty.call(message, "successRatePercent"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int32(message.successRatePercent);
                    return writer;
                };

                /**
                 * Encodes the specified ErrorStatistics message, length delimited. Does not implicitly {@link mythbound.websocket.v1.ErrorStatistics.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @static
                 * @param {mythbound.websocket.v1.IErrorStatistics} message ErrorStatistics message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorStatistics.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes an ErrorStatistics message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.ErrorStatistics} ErrorStatistics
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorStatistics.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.ErrorStatistics();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.errorCode = reader.string();
                                break;
                            }
                        case 2: {
                                message.totalOccurrences = reader.int32();
                                break;
                            }
                        case 3: {
                                message.lastHourCount = reader.int32();
                                break;
                            }
                        case 4: {
                                message.lastDayCount = reader.int32();
                                break;
                            }
                        case 5: {
                                message.firstOccurrence = reader.string();
                                break;
                            }
                        case 6: {
                                message.lastOccurrence = reader.string();
                                break;
                            }
                        case 7: {
                                message.avgResolutionTimeMs = reader.float();
                                break;
                            }
                        case 8: {
                                message.successRatePercent = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes an ErrorStatistics message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.ErrorStatistics} ErrorStatistics
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorStatistics.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ErrorStatistics message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ErrorStatistics.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                        if (!$util.isString(message.errorCode))
                            return "errorCode: string expected";
                    if (message.totalOccurrences != null && Object.hasOwnProperty.call(message, "totalOccurrences"))
                        if (!$util.isInteger(message.totalOccurrences))
                            return "totalOccurrences: integer expected";
                    if (message.lastHourCount != null && Object.hasOwnProperty.call(message, "lastHourCount"))
                        if (!$util.isInteger(message.lastHourCount))
                            return "lastHourCount: integer expected";
                    if (message.lastDayCount != null && Object.hasOwnProperty.call(message, "lastDayCount"))
                        if (!$util.isInteger(message.lastDayCount))
                            return "lastDayCount: integer expected";
                    if (message.firstOccurrence != null && Object.hasOwnProperty.call(message, "firstOccurrence"))
                        if (!$util.isString(message.firstOccurrence))
                            return "firstOccurrence: string expected";
                    if (message.lastOccurrence != null && Object.hasOwnProperty.call(message, "lastOccurrence"))
                        if (!$util.isString(message.lastOccurrence))
                            return "lastOccurrence: string expected";
                    if (message.avgResolutionTimeMs != null && Object.hasOwnProperty.call(message, "avgResolutionTimeMs"))
                        if (typeof message.avgResolutionTimeMs !== "number")
                            return "avgResolutionTimeMs: number expected";
                    if (message.successRatePercent != null && Object.hasOwnProperty.call(message, "successRatePercent"))
                        if (!$util.isInteger(message.successRatePercent))
                            return "successRatePercent: integer expected";
                    return null;
                };

                /**
                 * Creates an ErrorStatistics message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.ErrorStatistics} ErrorStatistics
                 */
                ErrorStatistics.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.ErrorStatistics)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.ErrorStatistics: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.ErrorStatistics();
                    if (object.errorCode != null)
                        message.errorCode = String(object.errorCode);
                    if (object.totalOccurrences != null)
                        message.totalOccurrences = object.totalOccurrences | 0;
                    if (object.lastHourCount != null)
                        message.lastHourCount = object.lastHourCount | 0;
                    if (object.lastDayCount != null)
                        message.lastDayCount = object.lastDayCount | 0;
                    if (object.firstOccurrence != null)
                        message.firstOccurrence = String(object.firstOccurrence);
                    if (object.lastOccurrence != null)
                        message.lastOccurrence = String(object.lastOccurrence);
                    if (object.avgResolutionTimeMs != null)
                        message.avgResolutionTimeMs = Number(object.avgResolutionTimeMs);
                    if (object.successRatePercent != null)
                        message.successRatePercent = object.successRatePercent | 0;
                    return message;
                };

                /**
                 * Creates a plain object from an ErrorStatistics message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @static
                 * @param {mythbound.websocket.v1.ErrorStatistics} message ErrorStatistics
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ErrorStatistics.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.errorCode = "";
                        object.totalOccurrences = 0;
                        object.lastHourCount = 0;
                        object.lastDayCount = 0;
                        object.firstOccurrence = "";
                        object.lastOccurrence = "";
                        object.avgResolutionTimeMs = 0;
                        object.successRatePercent = 0;
                    }
                    if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                        object.errorCode = message.errorCode;
                    if (message.totalOccurrences != null && Object.hasOwnProperty.call(message, "totalOccurrences"))
                        object.totalOccurrences = message.totalOccurrences;
                    if (message.lastHourCount != null && Object.hasOwnProperty.call(message, "lastHourCount"))
                        object.lastHourCount = message.lastHourCount;
                    if (message.lastDayCount != null && Object.hasOwnProperty.call(message, "lastDayCount"))
                        object.lastDayCount = message.lastDayCount;
                    if (message.firstOccurrence != null && Object.hasOwnProperty.call(message, "firstOccurrence"))
                        object.firstOccurrence = message.firstOccurrence;
                    if (message.lastOccurrence != null && Object.hasOwnProperty.call(message, "lastOccurrence"))
                        object.lastOccurrence = message.lastOccurrence;
                    if (message.avgResolutionTimeMs != null && Object.hasOwnProperty.call(message, "avgResolutionTimeMs"))
                        object.avgResolutionTimeMs = options.json && !isFinite(message.avgResolutionTimeMs) ? String(message.avgResolutionTimeMs) : message.avgResolutionTimeMs;
                    if (message.successRatePercent != null && Object.hasOwnProperty.call(message, "successRatePercent"))
                        object.successRatePercent = message.successRatePercent;
                    return object;
                };

                /**
                 * Converts this ErrorStatistics to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ErrorStatistics.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ErrorStatistics
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.ErrorStatistics
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ErrorStatistics.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.ErrorStatistics";
                };

                return ErrorStatistics;
            })();

            /**
             * MessagePriority enum.
             * @name mythbound.websocket.v1.MessagePriority
             * @enum {number}
             * @property {number} MESSAGE_PRIORITY_UNSPECIFIED=0 MESSAGE_PRIORITY_UNSPECIFIED value
             * @property {number} MESSAGE_PRIORITY_LOW=1 MESSAGE_PRIORITY_LOW value
             * @property {number} MESSAGE_PRIORITY_NORMAL=2 MESSAGE_PRIORITY_NORMAL value
             * @property {number} MESSAGE_PRIORITY_HIGH=3 MESSAGE_PRIORITY_HIGH value
             * @property {number} MESSAGE_PRIORITY_CRITICAL=4 MESSAGE_PRIORITY_CRITICAL value
             */
            v1.MessagePriority = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "MESSAGE_PRIORITY_UNSPECIFIED"] = 0;
                values[valuesById[1] = "MESSAGE_PRIORITY_LOW"] = 1;
                values[valuesById[2] = "MESSAGE_PRIORITY_NORMAL"] = 2;
                values[valuesById[3] = "MESSAGE_PRIORITY_HIGH"] = 3;
                values[valuesById[4] = "MESSAGE_PRIORITY_CRITICAL"] = 4;
                return values;
            })();

            /**
             * MessageCategory enum.
             * @name mythbound.websocket.v1.MessageCategory
             * @enum {number}
             * @property {number} MESSAGE_CATEGORY_UNSPECIFIED=0 MESSAGE_CATEGORY_UNSPECIFIED value
             * @property {number} MESSAGE_CATEGORY_VOICE=1 MESSAGE_CATEGORY_VOICE value
             * @property {number} MESSAGE_CATEGORY_CAMPAIGN=2 MESSAGE_CATEGORY_CAMPAIGN value
             * @property {number} MESSAGE_CATEGORY_CHARACTER=3 MESSAGE_CATEGORY_CHARACTER value
             * @property {number} MESSAGE_CATEGORY_CHAT=4 MESSAGE_CATEGORY_CHAT value
             * @property {number} MESSAGE_CATEGORY_SYSTEM=5 MESSAGE_CATEGORY_SYSTEM value
             * @property {number} MESSAGE_CATEGORY_AI_MYTHMASTER=6 MESSAGE_CATEGORY_AI_MYTHMASTER value
             * @property {number} MESSAGE_CATEGORY_DICE=7 MESSAGE_CATEGORY_DICE value
             * @property {number} MESSAGE_CATEGORY_ERROR=8 MESSAGE_CATEGORY_ERROR value
             */
            v1.MessageCategory = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "MESSAGE_CATEGORY_UNSPECIFIED"] = 0;
                values[valuesById[1] = "MESSAGE_CATEGORY_VOICE"] = 1;
                values[valuesById[2] = "MESSAGE_CATEGORY_CAMPAIGN"] = 2;
                values[valuesById[3] = "MESSAGE_CATEGORY_CHARACTER"] = 3;
                values[valuesById[4] = "MESSAGE_CATEGORY_CHAT"] = 4;
                values[valuesById[5] = "MESSAGE_CATEGORY_SYSTEM"] = 5;
                values[valuesById[6] = "MESSAGE_CATEGORY_AI_MYTHMASTER"] = 6;
                values[valuesById[7] = "MESSAGE_CATEGORY_DICE"] = 7;
                values[valuesById[8] = "MESSAGE_CATEGORY_ERROR"] = 8;
                return values;
            })();

            /**
             * PlatformType enum.
             * @name mythbound.websocket.v1.PlatformType
             * @enum {number}
             * @property {number} PLATFORM_TYPE_UNSPECIFIED=0 PLATFORM_TYPE_UNSPECIFIED value
             * @property {number} PLATFORM_TYPE_DISCORD_BOT=1 PLATFORM_TYPE_DISCORD_BOT value
             * @property {number} PLATFORM_TYPE_WEBAPP_FRONTEND=2 PLATFORM_TYPE_WEBAPP_FRONTEND value
             * @property {number} PLATFORM_TYPE_MOBILE_APP=3 PLATFORM_TYPE_MOBILE_APP value
             * @property {number} PLATFORM_TYPE_BACKEND_SERVER=4 PLATFORM_TYPE_BACKEND_SERVER value
             */
            v1.PlatformType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "PLATFORM_TYPE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "PLATFORM_TYPE_DISCORD_BOT"] = 1;
                values[valuesById[2] = "PLATFORM_TYPE_WEBAPP_FRONTEND"] = 2;
                values[valuesById[3] = "PLATFORM_TYPE_MOBILE_APP"] = 3;
                values[valuesById[4] = "PLATFORM_TYPE_BACKEND_SERVER"] = 4;
                return values;
            })();

            v1.BaseMessage = (function() {

                /**
                 * Properties of a BaseMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IBaseMessage
                 * @property {string|null} [messageId] BaseMessage messageId
                 * @property {string|null} [messageType] BaseMessage messageType
                 * @property {mythbound.websocket.v1.MessageCategory|null} [category] BaseMessage category
                 * @property {mythbound.websocket.v1.MessagePriority|null} [priority] BaseMessage priority
                 * @property {mythbound.websocket.v1.PlatformType|null} [sourcePlatform] BaseMessage sourcePlatform
                 * @property {mythbound.websocket.v1.PlatformType|null} [targetPlatform] BaseMessage targetPlatform
                 * @property {string|null} [campaignId] BaseMessage campaignId
                 * @property {string|null} [userId] BaseMessage userId
                 * @property {string|null} [timestamp] BaseMessage timestamp
                 * @property {string|null} [correlationId] BaseMessage correlationId
                 * @property {number|null} [sequenceNumber] BaseMessage sequenceNumber
                 * @property {Object.<string,string>|null} [data] BaseMessage data
                 */

                /**
                 * Constructs a new BaseMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a BaseMessage.
                 * @implements IBaseMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IBaseMessage=} [properties] Properties to set
                 */
                function BaseMessage(properties) {
                    this.data = {};
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BaseMessage messageId.
                 * @member {string} messageId
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.messageId = "";

                /**
                 * BaseMessage messageType.
                 * @member {string} messageType
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.messageType = "";

                /**
                 * BaseMessage category.
                 * @member {mythbound.websocket.v1.MessageCategory} category
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.category = 0;

                /**
                 * BaseMessage priority.
                 * @member {mythbound.websocket.v1.MessagePriority} priority
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.priority = 0;

                /**
                 * BaseMessage sourcePlatform.
                 * @member {mythbound.websocket.v1.PlatformType} sourcePlatform
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.sourcePlatform = 0;

                /**
                 * BaseMessage targetPlatform.
                 * @member {mythbound.websocket.v1.PlatformType} targetPlatform
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.targetPlatform = 0;

                /**
                 * BaseMessage campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.campaignId = "";

                /**
                 * BaseMessage userId.
                 * @member {string} userId
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.userId = "";

                /**
                 * BaseMessage timestamp.
                 * @member {string} timestamp
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.timestamp = "";

                /**
                 * BaseMessage correlationId.
                 * @member {string} correlationId
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.correlationId = "";

                /**
                 * BaseMessage sequenceNumber.
                 * @member {number} sequenceNumber
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.sequenceNumber = 0;

                /**
                 * BaseMessage data.
                 * @member {Object.<string,string>} data
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 */
                BaseMessage.prototype.data = $util.emptyObject;

                /**
                 * Creates a new BaseMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @static
                 * @param {mythbound.websocket.v1.IBaseMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.BaseMessage} BaseMessage instance
                 */
                BaseMessage.create = function create(properties) {
                    return new BaseMessage(properties);
                };

                /**
                 * Encodes the specified BaseMessage message. Does not implicitly {@link mythbound.websocket.v1.BaseMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @static
                 * @param {mythbound.websocket.v1.IBaseMessage} message BaseMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BaseMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
                    if (message.messageType != null && Object.hasOwnProperty.call(message, "messageType"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageType);
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.category);
                    if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.priority);
                    if (message.sourcePlatform != null && Object.hasOwnProperty.call(message, "sourcePlatform"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.sourcePlatform);
                    if (message.targetPlatform != null && Object.hasOwnProperty.call(message, "targetPlatform"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.targetPlatform);
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.campaignId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.userId);
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.timestamp);
                    if (message.correlationId != null && Object.hasOwnProperty.call(message, "correlationId"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.correlationId);
                    if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                        writer.uint32(/* id 11, wireType 0 =*/88).int32(message.sequenceNumber);
                    if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                        for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 12, wireType 2 =*/98).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.data[keys[i]]).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BaseMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.BaseMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @static
                 * @param {mythbound.websocket.v1.IBaseMessage} message BaseMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BaseMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a BaseMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.BaseMessage} BaseMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BaseMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message, key, value;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.BaseMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.messageId = reader.string();
                                break;
                            }
                        case 2: {
                                message.messageType = reader.string();
                                break;
                            }
                        case 3: {
                                message.category = reader.int32();
                                break;
                            }
                        case 4: {
                                message.priority = reader.int32();
                                break;
                            }
                        case 5: {
                                message.sourcePlatform = reader.int32();
                                break;
                            }
                        case 6: {
                                message.targetPlatform = reader.int32();
                                break;
                            }
                        case 7: {
                                message.campaignId = reader.string();
                                break;
                            }
                        case 8: {
                                message.userId = reader.string();
                                break;
                            }
                        case 9: {
                                message.timestamp = reader.string();
                                break;
                            }
                        case 10: {
                                message.correlationId = reader.string();
                                break;
                            }
                        case 11: {
                                message.sequenceNumber = reader.int32();
                                break;
                            }
                        case 12: {
                                if (message.data === $util.emptyObject)
                                    message.data = {};
                                let end2 = reader.uint32() + reader.pos;
                                if (end2 > reader.len)
                                    throw RangeError("index out of range");
                                reader.len = end2;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7, long);
                                        break;
                                    }
                                }
                                if (reader.pos !== end2)
                                    throw RangeError("index out of range");
                                reader.len = end;
                                if (key === "__proto__")
                                    $util.makeProp(message.data, key);
                                message.data[key] = value;
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a BaseMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.BaseMessage} BaseMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BaseMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BaseMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BaseMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                        if (!$util.isString(message.messageId))
                            return "messageId: string expected";
                    if (message.messageType != null && Object.hasOwnProperty.call(message, "messageType"))
                        if (!$util.isString(message.messageType))
                            return "messageType: string expected";
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        switch (message.category) {
                        default:
                            return "category: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                            break;
                        }
                    if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                        switch (message.priority) {
                        default:
                            return "priority: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.sourcePlatform != null && Object.hasOwnProperty.call(message, "sourcePlatform"))
                        switch (message.sourcePlatform) {
                        default:
                            return "sourcePlatform: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.targetPlatform != null && Object.hasOwnProperty.call(message, "targetPlatform"))
                        switch (message.targetPlatform) {
                        default:
                            return "targetPlatform: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        if (!$util.isString(message.timestamp))
                            return "timestamp: string expected";
                    if (message.correlationId != null && Object.hasOwnProperty.call(message, "correlationId"))
                        if (!$util.isString(message.correlationId))
                            return "correlationId: string expected";
                    if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                        if (!$util.isInteger(message.sequenceNumber))
                            return "sequenceNumber: integer expected";
                    if (message.data != null && Object.hasOwnProperty.call(message, "data")) {
                        if (!$util.isObject(message.data))
                            return "data: object expected";
                        let key = Object.keys(message.data);
                        for (let i = 0; i < key.length; ++i)
                            if (!$util.isString(message.data[key[i]]))
                                return "data: string{k:string} expected";
                    }
                    return null;
                };

                /**
                 * Creates a BaseMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.BaseMessage} BaseMessage
                 */
                BaseMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.BaseMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.BaseMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.BaseMessage();
                    if (object.messageId != null)
                        message.messageId = String(object.messageId);
                    if (object.messageType != null)
                        message.messageType = String(object.messageType);
                    switch (object.category) {
                    default:
                        if (typeof object.category === "number") {
                            message.category = object.category;
                            break;
                        }
                        break;
                    case "MESSAGE_CATEGORY_UNSPECIFIED":
                    case 0:
                        message.category = 0;
                        break;
                    case "MESSAGE_CATEGORY_VOICE":
                    case 1:
                        message.category = 1;
                        break;
                    case "MESSAGE_CATEGORY_CAMPAIGN":
                    case 2:
                        message.category = 2;
                        break;
                    case "MESSAGE_CATEGORY_CHARACTER":
                    case 3:
                        message.category = 3;
                        break;
                    case "MESSAGE_CATEGORY_CHAT":
                    case 4:
                        message.category = 4;
                        break;
                    case "MESSAGE_CATEGORY_SYSTEM":
                    case 5:
                        message.category = 5;
                        break;
                    case "MESSAGE_CATEGORY_AI_MYTHMASTER":
                    case 6:
                        message.category = 6;
                        break;
                    case "MESSAGE_CATEGORY_DICE":
                    case 7:
                        message.category = 7;
                        break;
                    case "MESSAGE_CATEGORY_ERROR":
                    case 8:
                        message.category = 8;
                        break;
                    }
                    switch (object.priority) {
                    default:
                        if (typeof object.priority === "number") {
                            message.priority = object.priority;
                            break;
                        }
                        break;
                    case "MESSAGE_PRIORITY_UNSPECIFIED":
                    case 0:
                        message.priority = 0;
                        break;
                    case "MESSAGE_PRIORITY_LOW":
                    case 1:
                        message.priority = 1;
                        break;
                    case "MESSAGE_PRIORITY_NORMAL":
                    case 2:
                        message.priority = 2;
                        break;
                    case "MESSAGE_PRIORITY_HIGH":
                    case 3:
                        message.priority = 3;
                        break;
                    case "MESSAGE_PRIORITY_CRITICAL":
                    case 4:
                        message.priority = 4;
                        break;
                    }
                    switch (object.sourcePlatform) {
                    default:
                        if (typeof object.sourcePlatform === "number") {
                            message.sourcePlatform = object.sourcePlatform;
                            break;
                        }
                        break;
                    case "PLATFORM_TYPE_UNSPECIFIED":
                    case 0:
                        message.sourcePlatform = 0;
                        break;
                    case "PLATFORM_TYPE_DISCORD_BOT":
                    case 1:
                        message.sourcePlatform = 1;
                        break;
                    case "PLATFORM_TYPE_WEBAPP_FRONTEND":
                    case 2:
                        message.sourcePlatform = 2;
                        break;
                    case "PLATFORM_TYPE_MOBILE_APP":
                    case 3:
                        message.sourcePlatform = 3;
                        break;
                    case "PLATFORM_TYPE_BACKEND_SERVER":
                    case 4:
                        message.sourcePlatform = 4;
                        break;
                    }
                    switch (object.targetPlatform) {
                    default:
                        if (typeof object.targetPlatform === "number") {
                            message.targetPlatform = object.targetPlatform;
                            break;
                        }
                        break;
                    case "PLATFORM_TYPE_UNSPECIFIED":
                    case 0:
                        message.targetPlatform = 0;
                        break;
                    case "PLATFORM_TYPE_DISCORD_BOT":
                    case 1:
                        message.targetPlatform = 1;
                        break;
                    case "PLATFORM_TYPE_WEBAPP_FRONTEND":
                    case 2:
                        message.targetPlatform = 2;
                        break;
                    case "PLATFORM_TYPE_MOBILE_APP":
                    case 3:
                        message.targetPlatform = 3;
                        break;
                    case "PLATFORM_TYPE_BACKEND_SERVER":
                    case 4:
                        message.targetPlatform = 4;
                        break;
                    }
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.timestamp != null)
                        message.timestamp = String(object.timestamp);
                    if (object.correlationId != null)
                        message.correlationId = String(object.correlationId);
                    if (object.sequenceNumber != null)
                        message.sequenceNumber = object.sequenceNumber | 0;
                    if (object.data) {
                        if (!$util.isObject(object.data))
                            throw TypeError(".mythbound.websocket.v1.BaseMessage.data: object expected");
                        message.data = {};
                        for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i) {
                            if (keys[i] === "__proto__")
                                $util.makeProp(message.data, keys[i]);
                            message.data[keys[i]] = String(object.data[keys[i]]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BaseMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @static
                 * @param {mythbound.websocket.v1.BaseMessage} message BaseMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BaseMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.objects || options.defaults)
                        object.data = {};
                    if (options.defaults) {
                        object.messageId = "";
                        object.messageType = "";
                        object.category = options.enums === String ? "MESSAGE_CATEGORY_UNSPECIFIED" : 0;
                        object.priority = options.enums === String ? "MESSAGE_PRIORITY_UNSPECIFIED" : 0;
                        object.sourcePlatform = options.enums === String ? "PLATFORM_TYPE_UNSPECIFIED" : 0;
                        object.targetPlatform = options.enums === String ? "PLATFORM_TYPE_UNSPECIFIED" : 0;
                        object.campaignId = "";
                        object.userId = "";
                        object.timestamp = "";
                        object.correlationId = "";
                        object.sequenceNumber = 0;
                    }
                    if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                        object.messageId = message.messageId;
                    if (message.messageType != null && Object.hasOwnProperty.call(message, "messageType"))
                        object.messageType = message.messageType;
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        object.category = options.enums === String ? $root.mythbound.websocket.v1.MessageCategory[message.category] === undefined ? message.category : $root.mythbound.websocket.v1.MessageCategory[message.category] : message.category;
                    if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                        object.priority = options.enums === String ? $root.mythbound.websocket.v1.MessagePriority[message.priority] === undefined ? message.priority : $root.mythbound.websocket.v1.MessagePriority[message.priority] : message.priority;
                    if (message.sourcePlatform != null && Object.hasOwnProperty.call(message, "sourcePlatform"))
                        object.sourcePlatform = options.enums === String ? $root.mythbound.websocket.v1.PlatformType[message.sourcePlatform] === undefined ? message.sourcePlatform : $root.mythbound.websocket.v1.PlatformType[message.sourcePlatform] : message.sourcePlatform;
                    if (message.targetPlatform != null && Object.hasOwnProperty.call(message, "targetPlatform"))
                        object.targetPlatform = options.enums === String ? $root.mythbound.websocket.v1.PlatformType[message.targetPlatform] === undefined ? message.targetPlatform : $root.mythbound.websocket.v1.PlatformType[message.targetPlatform] : message.targetPlatform;
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        object.userId = message.userId;
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        object.timestamp = message.timestamp;
                    if (message.correlationId != null && Object.hasOwnProperty.call(message, "correlationId"))
                        object.correlationId = message.correlationId;
                    if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                        object.sequenceNumber = message.sequenceNumber;
                    let keys2;
                    if (message.data && (keys2 = Object.keys(message.data)).length) {
                        object.data = {};
                        for (let j = 0; j < keys2.length; ++j) {
                            if (keys2[j] === "__proto__")
                                $util.makeProp(object.data, keys2[j]);
                            object.data[keys2[j]] = message.data[keys2[j]];
                        }
                    }
                    return object;
                };

                /**
                 * Converts this BaseMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BaseMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BaseMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.BaseMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BaseMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.BaseMessage";
                };

                return BaseMessage;
            })();

            v1.VoiceJoinMessage = (function() {

                /**
                 * Properties of a VoiceJoinMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IVoiceJoinMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] VoiceJoinMessage base
                 * @property {string|null} [characterId] VoiceJoinMessage characterId
                 * @property {string|null} [characterName] VoiceJoinMessage characterName
                 * @property {mythbound.websocket.v1.IAudioConfig|null} [audioConfig] VoiceJoinMessage audioConfig
                 * @property {string|null} [discordUserId] VoiceJoinMessage discordUserId
                 * @property {string|null} [oauthProvider] VoiceJoinMessage oauthProvider
                 */

                /**
                 * Constructs a new VoiceJoinMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a VoiceJoinMessage.
                 * @implements IVoiceJoinMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IVoiceJoinMessage=} [properties] Properties to set
                 */
                function VoiceJoinMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VoiceJoinMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @instance
                 */
                VoiceJoinMessage.prototype.base = null;

                /**
                 * VoiceJoinMessage characterId.
                 * @member {string} characterId
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @instance
                 */
                VoiceJoinMessage.prototype.characterId = "";

                /**
                 * VoiceJoinMessage characterName.
                 * @member {string} characterName
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @instance
                 */
                VoiceJoinMessage.prototype.characterName = "";

                /**
                 * VoiceJoinMessage audioConfig.
                 * @member {mythbound.websocket.v1.IAudioConfig|null|undefined} audioConfig
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @instance
                 */
                VoiceJoinMessage.prototype.audioConfig = null;

                /**
                 * VoiceJoinMessage discordUserId.
                 * @member {string} discordUserId
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @instance
                 */
                VoiceJoinMessage.prototype.discordUserId = "";

                /**
                 * VoiceJoinMessage oauthProvider.
                 * @member {string} oauthProvider
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @instance
                 */
                VoiceJoinMessage.prototype.oauthProvider = "";

                /**
                 * Creates a new VoiceJoinMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceJoinMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.VoiceJoinMessage} VoiceJoinMessage instance
                 */
                VoiceJoinMessage.create = function create(properties) {
                    return new VoiceJoinMessage(properties);
                };

                /**
                 * Encodes the specified VoiceJoinMessage message. Does not implicitly {@link mythbound.websocket.v1.VoiceJoinMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceJoinMessage} message VoiceJoinMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceJoinMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.characterId);
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.characterName);
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig"))
                        $root.mythbound.websocket.v1.AudioConfig.encode(message.audioConfig, writer.uint32(/* id 4, wireType 2 =*/34).fork(), q + 1).ldelim();
                    if (message.discordUserId != null && Object.hasOwnProperty.call(message, "discordUserId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.discordUserId);
                    if (message.oauthProvider != null && Object.hasOwnProperty.call(message, "oauthProvider"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.oauthProvider);
                    return writer;
                };

                /**
                 * Encodes the specified VoiceJoinMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.VoiceJoinMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceJoinMessage} message VoiceJoinMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceJoinMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a VoiceJoinMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.VoiceJoinMessage} VoiceJoinMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceJoinMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.VoiceJoinMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.characterId = reader.string();
                                break;
                            }
                        case 3: {
                                message.characterName = reader.string();
                                break;
                            }
                        case 4: {
                                message.audioConfig = $root.mythbound.websocket.v1.AudioConfig.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 5: {
                                message.discordUserId = reader.string();
                                break;
                            }
                        case 6: {
                                message.oauthProvider = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a VoiceJoinMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.VoiceJoinMessage} VoiceJoinMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceJoinMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VoiceJoinMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VoiceJoinMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        if (!$util.isString(message.characterId))
                            return "characterId: string expected";
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        if (!$util.isString(message.characterName))
                            return "characterName: string expected";
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig")) {
                        let error = $root.mythbound.websocket.v1.AudioConfig.verify(message.audioConfig, long + 1);
                        if (error)
                            return "audioConfig." + error;
                    }
                    if (message.discordUserId != null && Object.hasOwnProperty.call(message, "discordUserId"))
                        if (!$util.isString(message.discordUserId))
                            return "discordUserId: string expected";
                    if (message.oauthProvider != null && Object.hasOwnProperty.call(message, "oauthProvider"))
                        if (!$util.isString(message.oauthProvider))
                            return "oauthProvider: string expected";
                    return null;
                };

                /**
                 * Creates a VoiceJoinMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.VoiceJoinMessage} VoiceJoinMessage
                 */
                VoiceJoinMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.VoiceJoinMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.VoiceJoinMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.VoiceJoinMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.VoiceJoinMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.characterId != null)
                        message.characterId = String(object.characterId);
                    if (object.characterName != null)
                        message.characterName = String(object.characterName);
                    if (object.audioConfig != null) {
                        if (!$util.isObject(object.audioConfig))
                            throw TypeError(".mythbound.websocket.v1.VoiceJoinMessage.audioConfig: object expected");
                        message.audioConfig = $root.mythbound.websocket.v1.AudioConfig.fromObject(object.audioConfig, long + 1);
                    }
                    if (object.discordUserId != null)
                        message.discordUserId = String(object.discordUserId);
                    if (object.oauthProvider != null)
                        message.oauthProvider = String(object.oauthProvider);
                    return message;
                };

                /**
                 * Creates a plain object from a VoiceJoinMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @static
                 * @param {mythbound.websocket.v1.VoiceJoinMessage} message VoiceJoinMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VoiceJoinMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.characterId = "";
                        object.characterName = "";
                        object.audioConfig = null;
                        object.discordUserId = "";
                        object.oauthProvider = "";
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        object.characterId = message.characterId;
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        object.characterName = message.characterName;
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig"))
                        object.audioConfig = $root.mythbound.websocket.v1.AudioConfig.toObject(message.audioConfig, options, q + 1);
                    if (message.discordUserId != null && Object.hasOwnProperty.call(message, "discordUserId"))
                        object.discordUserId = message.discordUserId;
                    if (message.oauthProvider != null && Object.hasOwnProperty.call(message, "oauthProvider"))
                        object.oauthProvider = message.oauthProvider;
                    return object;
                };

                /**
                 * Converts this VoiceJoinMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VoiceJoinMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VoiceJoinMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.VoiceJoinMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VoiceJoinMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.VoiceJoinMessage";
                };

                return VoiceJoinMessage;
            })();

            v1.VoiceLeaveMessage = (function() {

                /**
                 * Properties of a VoiceLeaveMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IVoiceLeaveMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] VoiceLeaveMessage base
                 * @property {string|null} [participantId] VoiceLeaveMessage participantId
                 * @property {string|null} [leaveReason] VoiceLeaveMessage leaveReason
                 */

                /**
                 * Constructs a new VoiceLeaveMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a VoiceLeaveMessage.
                 * @implements IVoiceLeaveMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IVoiceLeaveMessage=} [properties] Properties to set
                 */
                function VoiceLeaveMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VoiceLeaveMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @instance
                 */
                VoiceLeaveMessage.prototype.base = null;

                /**
                 * VoiceLeaveMessage participantId.
                 * @member {string} participantId
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @instance
                 */
                VoiceLeaveMessage.prototype.participantId = "";

                /**
                 * VoiceLeaveMessage leaveReason.
                 * @member {string} leaveReason
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @instance
                 */
                VoiceLeaveMessage.prototype.leaveReason = "";

                /**
                 * Creates a new VoiceLeaveMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceLeaveMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.VoiceLeaveMessage} VoiceLeaveMessage instance
                 */
                VoiceLeaveMessage.create = function create(properties) {
                    return new VoiceLeaveMessage(properties);
                };

                /**
                 * Encodes the specified VoiceLeaveMessage message. Does not implicitly {@link mythbound.websocket.v1.VoiceLeaveMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceLeaveMessage} message VoiceLeaveMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceLeaveMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.participantId);
                    if (message.leaveReason != null && Object.hasOwnProperty.call(message, "leaveReason"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.leaveReason);
                    return writer;
                };

                /**
                 * Encodes the specified VoiceLeaveMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.VoiceLeaveMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceLeaveMessage} message VoiceLeaveMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceLeaveMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a VoiceLeaveMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.VoiceLeaveMessage} VoiceLeaveMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceLeaveMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.VoiceLeaveMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.participantId = reader.string();
                                break;
                            }
                        case 3: {
                                message.leaveReason = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a VoiceLeaveMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.VoiceLeaveMessage} VoiceLeaveMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceLeaveMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VoiceLeaveMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VoiceLeaveMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        if (!$util.isString(message.participantId))
                            return "participantId: string expected";
                    if (message.leaveReason != null && Object.hasOwnProperty.call(message, "leaveReason"))
                        if (!$util.isString(message.leaveReason))
                            return "leaveReason: string expected";
                    return null;
                };

                /**
                 * Creates a VoiceLeaveMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.VoiceLeaveMessage} VoiceLeaveMessage
                 */
                VoiceLeaveMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.VoiceLeaveMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.VoiceLeaveMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.VoiceLeaveMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.VoiceLeaveMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.participantId != null)
                        message.participantId = String(object.participantId);
                    if (object.leaveReason != null)
                        message.leaveReason = String(object.leaveReason);
                    return message;
                };

                /**
                 * Creates a plain object from a VoiceLeaveMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @static
                 * @param {mythbound.websocket.v1.VoiceLeaveMessage} message VoiceLeaveMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VoiceLeaveMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.participantId = "";
                        object.leaveReason = "";
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        object.participantId = message.participantId;
                    if (message.leaveReason != null && Object.hasOwnProperty.call(message, "leaveReason"))
                        object.leaveReason = message.leaveReason;
                    return object;
                };

                /**
                 * Converts this VoiceLeaveMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VoiceLeaveMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VoiceLeaveMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.VoiceLeaveMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VoiceLeaveMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.VoiceLeaveMessage";
                };

                return VoiceLeaveMessage;
            })();

            v1.VoiceDataMessage = (function() {

                /**
                 * Properties of a VoiceDataMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IVoiceDataMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] VoiceDataMessage base
                 * @property {string|null} [sessionId] VoiceDataMessage sessionId
                 * @property {string|null} [participantId] VoiceDataMessage participantId
                 * @property {Uint8Array|null} [audioData] VoiceDataMessage audioData
                 * @property {string|null} [audioFormat] VoiceDataMessage audioFormat
                 * @property {mythbound.websocket.v1.IAudioConfig|null} [audioConfig] VoiceDataMessage audioConfig
                 * @property {number|null} [durationMs] VoiceDataMessage durationMs
                 */

                /**
                 * Constructs a new VoiceDataMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a VoiceDataMessage.
                 * @implements IVoiceDataMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IVoiceDataMessage=} [properties] Properties to set
                 */
                function VoiceDataMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VoiceDataMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @instance
                 */
                VoiceDataMessage.prototype.base = null;

                /**
                 * VoiceDataMessage sessionId.
                 * @member {string} sessionId
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @instance
                 */
                VoiceDataMessage.prototype.sessionId = "";

                /**
                 * VoiceDataMessage participantId.
                 * @member {string} participantId
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @instance
                 */
                VoiceDataMessage.prototype.participantId = "";

                /**
                 * VoiceDataMessage audioData.
                 * @member {Uint8Array} audioData
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @instance
                 */
                VoiceDataMessage.prototype.audioData = $util.newBuffer([]);

                /**
                 * VoiceDataMessage audioFormat.
                 * @member {string} audioFormat
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @instance
                 */
                VoiceDataMessage.prototype.audioFormat = "";

                /**
                 * VoiceDataMessage audioConfig.
                 * @member {mythbound.websocket.v1.IAudioConfig|null|undefined} audioConfig
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @instance
                 */
                VoiceDataMessage.prototype.audioConfig = null;

                /**
                 * VoiceDataMessage durationMs.
                 * @member {number} durationMs
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @instance
                 */
                VoiceDataMessage.prototype.durationMs = 0;

                /**
                 * Creates a new VoiceDataMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceDataMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.VoiceDataMessage} VoiceDataMessage instance
                 */
                VoiceDataMessage.create = function create(properties) {
                    return new VoiceDataMessage(properties);
                };

                /**
                 * Encodes the specified VoiceDataMessage message. Does not implicitly {@link mythbound.websocket.v1.VoiceDataMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceDataMessage} message VoiceDataMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceDataMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.sessionId);
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.participantId);
                    if (message.audioData != null && Object.hasOwnProperty.call(message, "audioData"))
                        writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.audioData);
                    if (message.audioFormat != null && Object.hasOwnProperty.call(message, "audioFormat"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.audioFormat);
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig"))
                        $root.mythbound.websocket.v1.AudioConfig.encode(message.audioConfig, writer.uint32(/* id 6, wireType 2 =*/50).fork(), q + 1).ldelim();
                    if (message.durationMs != null && Object.hasOwnProperty.call(message, "durationMs"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int32(message.durationMs);
                    return writer;
                };

                /**
                 * Encodes the specified VoiceDataMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.VoiceDataMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceDataMessage} message VoiceDataMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a VoiceDataMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.VoiceDataMessage} VoiceDataMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceDataMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.VoiceDataMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.sessionId = reader.string();
                                break;
                            }
                        case 3: {
                                message.participantId = reader.string();
                                break;
                            }
                        case 4: {
                                message.audioData = reader.bytes();
                                break;
                            }
                        case 5: {
                                message.audioFormat = reader.string();
                                break;
                            }
                        case 6: {
                                message.audioConfig = $root.mythbound.websocket.v1.AudioConfig.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 7: {
                                message.durationMs = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a VoiceDataMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.VoiceDataMessage} VoiceDataMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceDataMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VoiceDataMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VoiceDataMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        if (!$util.isString(message.sessionId))
                            return "sessionId: string expected";
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        if (!$util.isString(message.participantId))
                            return "participantId: string expected";
                    if (message.audioData != null && Object.hasOwnProperty.call(message, "audioData"))
                        if (!(message.audioData && typeof message.audioData.length === "number" || $util.isString(message.audioData)))
                            return "audioData: buffer expected";
                    if (message.audioFormat != null && Object.hasOwnProperty.call(message, "audioFormat"))
                        if (!$util.isString(message.audioFormat))
                            return "audioFormat: string expected";
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig")) {
                        let error = $root.mythbound.websocket.v1.AudioConfig.verify(message.audioConfig, long + 1);
                        if (error)
                            return "audioConfig." + error;
                    }
                    if (message.durationMs != null && Object.hasOwnProperty.call(message, "durationMs"))
                        if (!$util.isInteger(message.durationMs))
                            return "durationMs: integer expected";
                    return null;
                };

                /**
                 * Creates a VoiceDataMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.VoiceDataMessage} VoiceDataMessage
                 */
                VoiceDataMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.VoiceDataMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.VoiceDataMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.VoiceDataMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.VoiceDataMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.sessionId != null)
                        message.sessionId = String(object.sessionId);
                    if (object.participantId != null)
                        message.participantId = String(object.participantId);
                    if (object.audioData != null)
                        if (typeof object.audioData === "string")
                            $util.base64.decode(object.audioData, message.audioData = $util.newBuffer($util.base64.length(object.audioData)), 0);
                        else if (object.audioData.length >= 0)
                            message.audioData = object.audioData;
                    if (object.audioFormat != null)
                        message.audioFormat = String(object.audioFormat);
                    if (object.audioConfig != null) {
                        if (!$util.isObject(object.audioConfig))
                            throw TypeError(".mythbound.websocket.v1.VoiceDataMessage.audioConfig: object expected");
                        message.audioConfig = $root.mythbound.websocket.v1.AudioConfig.fromObject(object.audioConfig, long + 1);
                    }
                    if (object.durationMs != null)
                        message.durationMs = object.durationMs | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a VoiceDataMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @static
                 * @param {mythbound.websocket.v1.VoiceDataMessage} message VoiceDataMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VoiceDataMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.sessionId = "";
                        object.participantId = "";
                        if (options.bytes === String)
                            object.audioData = "";
                        else {
                            object.audioData = [];
                            if (options.bytes !== Array)
                                object.audioData = $util.newBuffer(object.audioData);
                        }
                        object.audioFormat = "";
                        object.audioConfig = null;
                        object.durationMs = 0;
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        object.sessionId = message.sessionId;
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        object.participantId = message.participantId;
                    if (message.audioData != null && Object.hasOwnProperty.call(message, "audioData"))
                        object.audioData = options.bytes === String ? $util.base64.encode(message.audioData, 0, message.audioData.length) : options.bytes === Array ? Array.prototype.slice.call(message.audioData) : message.audioData;
                    if (message.audioFormat != null && Object.hasOwnProperty.call(message, "audioFormat"))
                        object.audioFormat = message.audioFormat;
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig"))
                        object.audioConfig = $root.mythbound.websocket.v1.AudioConfig.toObject(message.audioConfig, options, q + 1);
                    if (message.durationMs != null && Object.hasOwnProperty.call(message, "durationMs"))
                        object.durationMs = message.durationMs;
                    return object;
                };

                /**
                 * Converts this VoiceDataMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VoiceDataMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VoiceDataMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.VoiceDataMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VoiceDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.VoiceDataMessage";
                };

                return VoiceDataMessage;
            })();

            v1.VoiceActivityMessage = (function() {

                /**
                 * Properties of a VoiceActivityMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IVoiceActivityMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] VoiceActivityMessage base
                 * @property {string|null} [sessionId] VoiceActivityMessage sessionId
                 * @property {string|null} [participantId] VoiceActivityMessage participantId
                 * @property {boolean|null} [isSpeaking] VoiceActivityMessage isSpeaking
                 * @property {number|null} [energyLevel] VoiceActivityMessage energyLevel
                 * @property {number|null} [durationMs] VoiceActivityMessage durationMs
                 */

                /**
                 * Constructs a new VoiceActivityMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a VoiceActivityMessage.
                 * @implements IVoiceActivityMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IVoiceActivityMessage=} [properties] Properties to set
                 */
                function VoiceActivityMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VoiceActivityMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @instance
                 */
                VoiceActivityMessage.prototype.base = null;

                /**
                 * VoiceActivityMessage sessionId.
                 * @member {string} sessionId
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @instance
                 */
                VoiceActivityMessage.prototype.sessionId = "";

                /**
                 * VoiceActivityMessage participantId.
                 * @member {string} participantId
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @instance
                 */
                VoiceActivityMessage.prototype.participantId = "";

                /**
                 * VoiceActivityMessage isSpeaking.
                 * @member {boolean} isSpeaking
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @instance
                 */
                VoiceActivityMessage.prototype.isSpeaking = false;

                /**
                 * VoiceActivityMessage energyLevel.
                 * @member {number} energyLevel
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @instance
                 */
                VoiceActivityMessage.prototype.energyLevel = 0;

                /**
                 * VoiceActivityMessage durationMs.
                 * @member {number} durationMs
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @instance
                 */
                VoiceActivityMessage.prototype.durationMs = 0;

                /**
                 * Creates a new VoiceActivityMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceActivityMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.VoiceActivityMessage} VoiceActivityMessage instance
                 */
                VoiceActivityMessage.create = function create(properties) {
                    return new VoiceActivityMessage(properties);
                };

                /**
                 * Encodes the specified VoiceActivityMessage message. Does not implicitly {@link mythbound.websocket.v1.VoiceActivityMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceActivityMessage} message VoiceActivityMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceActivityMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.sessionId);
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.participantId);
                    if (message.isSpeaking != null && Object.hasOwnProperty.call(message, "isSpeaking"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isSpeaking);
                    if (message.energyLevel != null && Object.hasOwnProperty.call(message, "energyLevel"))
                        writer.uint32(/* id 5, wireType 5 =*/45).float(message.energyLevel);
                    if (message.durationMs != null && Object.hasOwnProperty.call(message, "durationMs"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.durationMs);
                    return writer;
                };

                /**
                 * Encodes the specified VoiceActivityMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.VoiceActivityMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceActivityMessage} message VoiceActivityMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceActivityMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a VoiceActivityMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.VoiceActivityMessage} VoiceActivityMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceActivityMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.VoiceActivityMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.sessionId = reader.string();
                                break;
                            }
                        case 3: {
                                message.participantId = reader.string();
                                break;
                            }
                        case 4: {
                                message.isSpeaking = reader.bool();
                                break;
                            }
                        case 5: {
                                message.energyLevel = reader.float();
                                break;
                            }
                        case 6: {
                                message.durationMs = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a VoiceActivityMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.VoiceActivityMessage} VoiceActivityMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceActivityMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VoiceActivityMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VoiceActivityMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        if (!$util.isString(message.sessionId))
                            return "sessionId: string expected";
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        if (!$util.isString(message.participantId))
                            return "participantId: string expected";
                    if (message.isSpeaking != null && Object.hasOwnProperty.call(message, "isSpeaking"))
                        if (typeof message.isSpeaking !== "boolean")
                            return "isSpeaking: boolean expected";
                    if (message.energyLevel != null && Object.hasOwnProperty.call(message, "energyLevel"))
                        if (typeof message.energyLevel !== "number")
                            return "energyLevel: number expected";
                    if (message.durationMs != null && Object.hasOwnProperty.call(message, "durationMs"))
                        if (!$util.isInteger(message.durationMs))
                            return "durationMs: integer expected";
                    return null;
                };

                /**
                 * Creates a VoiceActivityMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.VoiceActivityMessage} VoiceActivityMessage
                 */
                VoiceActivityMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.VoiceActivityMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.VoiceActivityMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.VoiceActivityMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.VoiceActivityMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.sessionId != null)
                        message.sessionId = String(object.sessionId);
                    if (object.participantId != null)
                        message.participantId = String(object.participantId);
                    if (object.isSpeaking != null)
                        message.isSpeaking = Boolean(object.isSpeaking);
                    if (object.energyLevel != null)
                        message.energyLevel = Number(object.energyLevel);
                    if (object.durationMs != null)
                        message.durationMs = object.durationMs | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a VoiceActivityMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @static
                 * @param {mythbound.websocket.v1.VoiceActivityMessage} message VoiceActivityMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VoiceActivityMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.sessionId = "";
                        object.participantId = "";
                        object.isSpeaking = false;
                        object.energyLevel = 0;
                        object.durationMs = 0;
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        object.sessionId = message.sessionId;
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        object.participantId = message.participantId;
                    if (message.isSpeaking != null && Object.hasOwnProperty.call(message, "isSpeaking"))
                        object.isSpeaking = message.isSpeaking;
                    if (message.energyLevel != null && Object.hasOwnProperty.call(message, "energyLevel"))
                        object.energyLevel = options.json && !isFinite(message.energyLevel) ? String(message.energyLevel) : message.energyLevel;
                    if (message.durationMs != null && Object.hasOwnProperty.call(message, "durationMs"))
                        object.durationMs = message.durationMs;
                    return object;
                };

                /**
                 * Converts this VoiceActivityMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VoiceActivityMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VoiceActivityMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.VoiceActivityMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VoiceActivityMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.VoiceActivityMessage";
                };

                return VoiceActivityMessage;
            })();

            v1.VoiceModeChangeMessage = (function() {

                /**
                 * Properties of a VoiceModeChangeMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IVoiceModeChangeMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] VoiceModeChangeMessage base
                 * @property {string|null} [mode] VoiceModeChangeMessage mode
                 * @property {string|null} [previousMode] VoiceModeChangeMessage previousMode
                 * @property {boolean|null} [wakeWordEnabled] VoiceModeChangeMessage wakeWordEnabled
                 * @property {string|null} [wakePhrase] VoiceModeChangeMessage wakePhrase
                 * @property {boolean|null} [broadcast] VoiceModeChangeMessage broadcast
                 */

                /**
                 * Constructs a new VoiceModeChangeMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a VoiceModeChangeMessage.
                 * @implements IVoiceModeChangeMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IVoiceModeChangeMessage=} [properties] Properties to set
                 */
                function VoiceModeChangeMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VoiceModeChangeMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @instance
                 */
                VoiceModeChangeMessage.prototype.base = null;

                /**
                 * VoiceModeChangeMessage mode.
                 * @member {string} mode
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @instance
                 */
                VoiceModeChangeMessage.prototype.mode = "";

                /**
                 * VoiceModeChangeMessage previousMode.
                 * @member {string} previousMode
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @instance
                 */
                VoiceModeChangeMessage.prototype.previousMode = "";

                /**
                 * VoiceModeChangeMessage wakeWordEnabled.
                 * @member {boolean} wakeWordEnabled
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @instance
                 */
                VoiceModeChangeMessage.prototype.wakeWordEnabled = false;

                /**
                 * VoiceModeChangeMessage wakePhrase.
                 * @member {string} wakePhrase
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @instance
                 */
                VoiceModeChangeMessage.prototype.wakePhrase = "";

                /**
                 * VoiceModeChangeMessage broadcast.
                 * @member {boolean} broadcast
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @instance
                 */
                VoiceModeChangeMessage.prototype.broadcast = false;

                /**
                 * Creates a new VoiceModeChangeMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceModeChangeMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.VoiceModeChangeMessage} VoiceModeChangeMessage instance
                 */
                VoiceModeChangeMessage.create = function create(properties) {
                    return new VoiceModeChangeMessage(properties);
                };

                /**
                 * Encodes the specified VoiceModeChangeMessage message. Does not implicitly {@link mythbound.websocket.v1.VoiceModeChangeMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceModeChangeMessage} message VoiceModeChangeMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceModeChangeMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.mode);
                    if (message.previousMode != null && Object.hasOwnProperty.call(message, "previousMode"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.previousMode);
                    if (message.wakeWordEnabled != null && Object.hasOwnProperty.call(message, "wakeWordEnabled"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.wakeWordEnabled);
                    if (message.wakePhrase != null && Object.hasOwnProperty.call(message, "wakePhrase"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.wakePhrase);
                    if (message.broadcast != null && Object.hasOwnProperty.call(message, "broadcast"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.broadcast);
                    return writer;
                };

                /**
                 * Encodes the specified VoiceModeChangeMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.VoiceModeChangeMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceModeChangeMessage} message VoiceModeChangeMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceModeChangeMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a VoiceModeChangeMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.VoiceModeChangeMessage} VoiceModeChangeMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceModeChangeMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.VoiceModeChangeMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.mode = reader.string();
                                break;
                            }
                        case 3: {
                                message.previousMode = reader.string();
                                break;
                            }
                        case 4: {
                                message.wakeWordEnabled = reader.bool();
                                break;
                            }
                        case 5: {
                                message.wakePhrase = reader.string();
                                break;
                            }
                        case 6: {
                                message.broadcast = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a VoiceModeChangeMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.VoiceModeChangeMessage} VoiceModeChangeMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceModeChangeMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VoiceModeChangeMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VoiceModeChangeMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
                        if (!$util.isString(message.mode))
                            return "mode: string expected";
                    if (message.previousMode != null && Object.hasOwnProperty.call(message, "previousMode"))
                        if (!$util.isString(message.previousMode))
                            return "previousMode: string expected";
                    if (message.wakeWordEnabled != null && Object.hasOwnProperty.call(message, "wakeWordEnabled"))
                        if (typeof message.wakeWordEnabled !== "boolean")
                            return "wakeWordEnabled: boolean expected";
                    if (message.wakePhrase != null && Object.hasOwnProperty.call(message, "wakePhrase"))
                        if (!$util.isString(message.wakePhrase))
                            return "wakePhrase: string expected";
                    if (message.broadcast != null && Object.hasOwnProperty.call(message, "broadcast"))
                        if (typeof message.broadcast !== "boolean")
                            return "broadcast: boolean expected";
                    return null;
                };

                /**
                 * Creates a VoiceModeChangeMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.VoiceModeChangeMessage} VoiceModeChangeMessage
                 */
                VoiceModeChangeMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.VoiceModeChangeMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.VoiceModeChangeMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.VoiceModeChangeMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.VoiceModeChangeMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.mode != null)
                        message.mode = String(object.mode);
                    if (object.previousMode != null)
                        message.previousMode = String(object.previousMode);
                    if (object.wakeWordEnabled != null)
                        message.wakeWordEnabled = Boolean(object.wakeWordEnabled);
                    if (object.wakePhrase != null)
                        message.wakePhrase = String(object.wakePhrase);
                    if (object.broadcast != null)
                        message.broadcast = Boolean(object.broadcast);
                    return message;
                };

                /**
                 * Creates a plain object from a VoiceModeChangeMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @static
                 * @param {mythbound.websocket.v1.VoiceModeChangeMessage} message VoiceModeChangeMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VoiceModeChangeMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.mode = "";
                        object.previousMode = "";
                        object.wakeWordEnabled = false;
                        object.wakePhrase = "";
                        object.broadcast = false;
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
                        object.mode = message.mode;
                    if (message.previousMode != null && Object.hasOwnProperty.call(message, "previousMode"))
                        object.previousMode = message.previousMode;
                    if (message.wakeWordEnabled != null && Object.hasOwnProperty.call(message, "wakeWordEnabled"))
                        object.wakeWordEnabled = message.wakeWordEnabled;
                    if (message.wakePhrase != null && Object.hasOwnProperty.call(message, "wakePhrase"))
                        object.wakePhrase = message.wakePhrase;
                    if (message.broadcast != null && Object.hasOwnProperty.call(message, "broadcast"))
                        object.broadcast = message.broadcast;
                    return object;
                };

                /**
                 * Converts this VoiceModeChangeMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VoiceModeChangeMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VoiceModeChangeMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.VoiceModeChangeMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VoiceModeChangeMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.VoiceModeChangeMessage";
                };

                return VoiceModeChangeMessage;
            })();

            v1.VoiceFeedbackMessage = (function() {

                /**
                 * Properties of a VoiceFeedbackMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IVoiceFeedbackMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] VoiceFeedbackMessage base
                 * @property {string|null} [state] VoiceFeedbackMessage state
                 * @property {string|null} [emoji] VoiceFeedbackMessage emoji
                 * @property {string|null} [participantId] VoiceFeedbackMessage participantId
                 */

                /**
                 * Constructs a new VoiceFeedbackMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a VoiceFeedbackMessage.
                 * @implements IVoiceFeedbackMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IVoiceFeedbackMessage=} [properties] Properties to set
                 */
                function VoiceFeedbackMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VoiceFeedbackMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @instance
                 */
                VoiceFeedbackMessage.prototype.base = null;

                /**
                 * VoiceFeedbackMessage state.
                 * @member {string} state
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @instance
                 */
                VoiceFeedbackMessage.prototype.state = "";

                /**
                 * VoiceFeedbackMessage emoji.
                 * @member {string} emoji
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @instance
                 */
                VoiceFeedbackMessage.prototype.emoji = "";

                /**
                 * VoiceFeedbackMessage participantId.
                 * @member {string} participantId
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @instance
                 */
                VoiceFeedbackMessage.prototype.participantId = "";

                /**
                 * Creates a new VoiceFeedbackMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceFeedbackMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.VoiceFeedbackMessage} VoiceFeedbackMessage instance
                 */
                VoiceFeedbackMessage.create = function create(properties) {
                    return new VoiceFeedbackMessage(properties);
                };

                /**
                 * Encodes the specified VoiceFeedbackMessage message. Does not implicitly {@link mythbound.websocket.v1.VoiceFeedbackMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceFeedbackMessage} message VoiceFeedbackMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceFeedbackMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.state);
                    if (message.emoji != null && Object.hasOwnProperty.call(message, "emoji"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.emoji);
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.participantId);
                    return writer;
                };

                /**
                 * Encodes the specified VoiceFeedbackMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.VoiceFeedbackMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceFeedbackMessage} message VoiceFeedbackMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceFeedbackMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a VoiceFeedbackMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.VoiceFeedbackMessage} VoiceFeedbackMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceFeedbackMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.VoiceFeedbackMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.state = reader.string();
                                break;
                            }
                        case 3: {
                                message.emoji = reader.string();
                                break;
                            }
                        case 4: {
                                message.participantId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a VoiceFeedbackMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.VoiceFeedbackMessage} VoiceFeedbackMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceFeedbackMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VoiceFeedbackMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VoiceFeedbackMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        if (!$util.isString(message.state))
                            return "state: string expected";
                    if (message.emoji != null && Object.hasOwnProperty.call(message, "emoji"))
                        if (!$util.isString(message.emoji))
                            return "emoji: string expected";
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        if (!$util.isString(message.participantId))
                            return "participantId: string expected";
                    return null;
                };

                /**
                 * Creates a VoiceFeedbackMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.VoiceFeedbackMessage} VoiceFeedbackMessage
                 */
                VoiceFeedbackMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.VoiceFeedbackMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.VoiceFeedbackMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.VoiceFeedbackMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.VoiceFeedbackMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.state != null)
                        message.state = String(object.state);
                    if (object.emoji != null)
                        message.emoji = String(object.emoji);
                    if (object.participantId != null)
                        message.participantId = String(object.participantId);
                    return message;
                };

                /**
                 * Creates a plain object from a VoiceFeedbackMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @static
                 * @param {mythbound.websocket.v1.VoiceFeedbackMessage} message VoiceFeedbackMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VoiceFeedbackMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.state = "";
                        object.emoji = "";
                        object.participantId = "";
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        object.state = message.state;
                    if (message.emoji != null && Object.hasOwnProperty.call(message, "emoji"))
                        object.emoji = message.emoji;
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        object.participantId = message.participantId;
                    return object;
                };

                /**
                 * Converts this VoiceFeedbackMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VoiceFeedbackMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VoiceFeedbackMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.VoiceFeedbackMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VoiceFeedbackMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.VoiceFeedbackMessage";
                };

                return VoiceFeedbackMessage;
            })();

            v1.CampaignCreateMessage = (function() {

                /**
                 * Properties of a CampaignCreateMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface ICampaignCreateMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] CampaignCreateMessage base
                 * @property {string|null} [name] CampaignCreateMessage name
                 * @property {string|null} [description] CampaignCreateMessage description
                 * @property {number|null} [maxParticipants] CampaignCreateMessage maxParticipants
                 * @property {string|null} [discordGuildId] CampaignCreateMessage discordGuildId
                 */

                /**
                 * Constructs a new CampaignCreateMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a CampaignCreateMessage.
                 * @implements ICampaignCreateMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.ICampaignCreateMessage=} [properties] Properties to set
                 */
                function CampaignCreateMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CampaignCreateMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @instance
                 */
                CampaignCreateMessage.prototype.base = null;

                /**
                 * CampaignCreateMessage name.
                 * @member {string} name
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @instance
                 */
                CampaignCreateMessage.prototype.name = "";

                /**
                 * CampaignCreateMessage description.
                 * @member {string} description
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @instance
                 */
                CampaignCreateMessage.prototype.description = "";

                /**
                 * CampaignCreateMessage maxParticipants.
                 * @member {number} maxParticipants
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @instance
                 */
                CampaignCreateMessage.prototype.maxParticipants = 0;

                /**
                 * CampaignCreateMessage discordGuildId.
                 * @member {string} discordGuildId
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @instance
                 */
                CampaignCreateMessage.prototype.discordGuildId = "";

                /**
                 * Creates a new CampaignCreateMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignCreateMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.CampaignCreateMessage} CampaignCreateMessage instance
                 */
                CampaignCreateMessage.create = function create(properties) {
                    return new CampaignCreateMessage(properties);
                };

                /**
                 * Encodes the specified CampaignCreateMessage message. Does not implicitly {@link mythbound.websocket.v1.CampaignCreateMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignCreateMessage} message CampaignCreateMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CampaignCreateMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                    if (message.maxParticipants != null && Object.hasOwnProperty.call(message, "maxParticipants"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.maxParticipants);
                    if (message.discordGuildId != null && Object.hasOwnProperty.call(message, "discordGuildId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.discordGuildId);
                    return writer;
                };

                /**
                 * Encodes the specified CampaignCreateMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.CampaignCreateMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignCreateMessage} message CampaignCreateMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CampaignCreateMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a CampaignCreateMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.CampaignCreateMessage} CampaignCreateMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CampaignCreateMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.CampaignCreateMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.description = reader.string();
                                break;
                            }
                        case 4: {
                                message.maxParticipants = reader.int32();
                                break;
                            }
                        case 5: {
                                message.discordGuildId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a CampaignCreateMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.CampaignCreateMessage} CampaignCreateMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CampaignCreateMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CampaignCreateMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CampaignCreateMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.maxParticipants != null && Object.hasOwnProperty.call(message, "maxParticipants"))
                        if (!$util.isInteger(message.maxParticipants))
                            return "maxParticipants: integer expected";
                    if (message.discordGuildId != null && Object.hasOwnProperty.call(message, "discordGuildId"))
                        if (!$util.isString(message.discordGuildId))
                            return "discordGuildId: string expected";
                    return null;
                };

                /**
                 * Creates a CampaignCreateMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.CampaignCreateMessage} CampaignCreateMessage
                 */
                CampaignCreateMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.CampaignCreateMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.CampaignCreateMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.CampaignCreateMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.CampaignCreateMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.description != null)
                        message.description = String(object.description);
                    if (object.maxParticipants != null)
                        message.maxParticipants = object.maxParticipants | 0;
                    if (object.discordGuildId != null)
                        message.discordGuildId = String(object.discordGuildId);
                    return message;
                };

                /**
                 * Creates a plain object from a CampaignCreateMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @static
                 * @param {mythbound.websocket.v1.CampaignCreateMessage} message CampaignCreateMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CampaignCreateMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.name = "";
                        object.description = "";
                        object.maxParticipants = 0;
                        object.discordGuildId = "";
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        object.name = message.name;
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        object.description = message.description;
                    if (message.maxParticipants != null && Object.hasOwnProperty.call(message, "maxParticipants"))
                        object.maxParticipants = message.maxParticipants;
                    if (message.discordGuildId != null && Object.hasOwnProperty.call(message, "discordGuildId"))
                        object.discordGuildId = message.discordGuildId;
                    return object;
                };

                /**
                 * Converts this CampaignCreateMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CampaignCreateMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CampaignCreateMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.CampaignCreateMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CampaignCreateMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.CampaignCreateMessage";
                };

                return CampaignCreateMessage;
            })();

            v1.CampaignUpdateMessage = (function() {

                /**
                 * Properties of a CampaignUpdateMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface ICampaignUpdateMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] CampaignUpdateMessage base
                 * @property {mythbound.websocket.v1.ICampaignState|null} [campaignState] CampaignUpdateMessage campaignState
                 * @property {Array.<string>|null} [changedFields] CampaignUpdateMessage changedFields
                 */

                /**
                 * Constructs a new CampaignUpdateMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a CampaignUpdateMessage.
                 * @implements ICampaignUpdateMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.ICampaignUpdateMessage=} [properties] Properties to set
                 */
                function CampaignUpdateMessage(properties) {
                    this.changedFields = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CampaignUpdateMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @instance
                 */
                CampaignUpdateMessage.prototype.base = null;

                /**
                 * CampaignUpdateMessage campaignState.
                 * @member {mythbound.websocket.v1.ICampaignState|null|undefined} campaignState
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @instance
                 */
                CampaignUpdateMessage.prototype.campaignState = null;

                /**
                 * CampaignUpdateMessage changedFields.
                 * @member {Array.<string>} changedFields
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @instance
                 */
                CampaignUpdateMessage.prototype.changedFields = $util.emptyArray;

                /**
                 * Creates a new CampaignUpdateMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignUpdateMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.CampaignUpdateMessage} CampaignUpdateMessage instance
                 */
                CampaignUpdateMessage.create = function create(properties) {
                    return new CampaignUpdateMessage(properties);
                };

                /**
                 * Encodes the specified CampaignUpdateMessage message. Does not implicitly {@link mythbound.websocket.v1.CampaignUpdateMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignUpdateMessage} message CampaignUpdateMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CampaignUpdateMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.campaignState != null && Object.hasOwnProperty.call(message, "campaignState"))
                        $root.mythbound.websocket.v1.CampaignState.encode(message.campaignState, writer.uint32(/* id 2, wireType 2 =*/18).fork(), q + 1).ldelim();
                    if (message.changedFields != null && message.changedFields.length)
                        for (let i = 0; i < message.changedFields.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.changedFields[i]);
                    return writer;
                };

                /**
                 * Encodes the specified CampaignUpdateMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.CampaignUpdateMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignUpdateMessage} message CampaignUpdateMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CampaignUpdateMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a CampaignUpdateMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.CampaignUpdateMessage} CampaignUpdateMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CampaignUpdateMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.CampaignUpdateMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.campaignState = $root.mythbound.websocket.v1.CampaignState.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 3: {
                                if (!(message.changedFields && message.changedFields.length))
                                    message.changedFields = [];
                                message.changedFields.push(reader.string());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a CampaignUpdateMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.CampaignUpdateMessage} CampaignUpdateMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CampaignUpdateMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CampaignUpdateMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CampaignUpdateMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.campaignState != null && Object.hasOwnProperty.call(message, "campaignState")) {
                        let error = $root.mythbound.websocket.v1.CampaignState.verify(message.campaignState, long + 1);
                        if (error)
                            return "campaignState." + error;
                    }
                    if (message.changedFields != null && Object.hasOwnProperty.call(message, "changedFields")) {
                        if (!Array.isArray(message.changedFields))
                            return "changedFields: array expected";
                        for (let i = 0; i < message.changedFields.length; ++i)
                            if (!$util.isString(message.changedFields[i]))
                                return "changedFields: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a CampaignUpdateMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.CampaignUpdateMessage} CampaignUpdateMessage
                 */
                CampaignUpdateMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.CampaignUpdateMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.CampaignUpdateMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.CampaignUpdateMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.CampaignUpdateMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.campaignState != null) {
                        if (!$util.isObject(object.campaignState))
                            throw TypeError(".mythbound.websocket.v1.CampaignUpdateMessage.campaignState: object expected");
                        message.campaignState = $root.mythbound.websocket.v1.CampaignState.fromObject(object.campaignState, long + 1);
                    }
                    if (object.changedFields) {
                        if (!Array.isArray(object.changedFields))
                            throw TypeError(".mythbound.websocket.v1.CampaignUpdateMessage.changedFields: array expected");
                        message.changedFields = [];
                        for (let i = 0; i < object.changedFields.length; ++i)
                            message.changedFields[i] = String(object.changedFields[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CampaignUpdateMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @static
                 * @param {mythbound.websocket.v1.CampaignUpdateMessage} message CampaignUpdateMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CampaignUpdateMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.changedFields = [];
                    if (options.defaults) {
                        object.base = null;
                        object.campaignState = null;
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.campaignState != null && Object.hasOwnProperty.call(message, "campaignState"))
                        object.campaignState = $root.mythbound.websocket.v1.CampaignState.toObject(message.campaignState, options, q + 1);
                    if (message.changedFields && message.changedFields.length) {
                        object.changedFields = [];
                        for (let j = 0; j < message.changedFields.length; ++j)
                            object.changedFields[j] = message.changedFields[j];
                    }
                    return object;
                };

                /**
                 * Converts this CampaignUpdateMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CampaignUpdateMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CampaignUpdateMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.CampaignUpdateMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CampaignUpdateMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.CampaignUpdateMessage";
                };

                return CampaignUpdateMessage;
            })();

            v1.CampaignParticipantMessage = (function() {

                /**
                 * Properties of a CampaignParticipantMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface ICampaignParticipantMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] CampaignParticipantMessage base
                 * @property {string|null} [action] CampaignParticipantMessage action
                 * @property {mythbound.websocket.v1.ICampaignParticipant|null} [participant] CampaignParticipantMessage participant
                 * @property {number|null} [currentCount] CampaignParticipantMessage currentCount
                 * @property {number|null} [maxCount] CampaignParticipantMessage maxCount
                 */

                /**
                 * Constructs a new CampaignParticipantMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a CampaignParticipantMessage.
                 * @implements ICampaignParticipantMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.ICampaignParticipantMessage=} [properties] Properties to set
                 */
                function CampaignParticipantMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CampaignParticipantMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @instance
                 */
                CampaignParticipantMessage.prototype.base = null;

                /**
                 * CampaignParticipantMessage action.
                 * @member {string} action
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @instance
                 */
                CampaignParticipantMessage.prototype.action = "";

                /**
                 * CampaignParticipantMessage participant.
                 * @member {mythbound.websocket.v1.ICampaignParticipant|null|undefined} participant
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @instance
                 */
                CampaignParticipantMessage.prototype.participant = null;

                /**
                 * CampaignParticipantMessage currentCount.
                 * @member {number} currentCount
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @instance
                 */
                CampaignParticipantMessage.prototype.currentCount = 0;

                /**
                 * CampaignParticipantMessage maxCount.
                 * @member {number} maxCount
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @instance
                 */
                CampaignParticipantMessage.prototype.maxCount = 0;

                /**
                 * Creates a new CampaignParticipantMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignParticipantMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.CampaignParticipantMessage} CampaignParticipantMessage instance
                 */
                CampaignParticipantMessage.create = function create(properties) {
                    return new CampaignParticipantMessage(properties);
                };

                /**
                 * Encodes the specified CampaignParticipantMessage message. Does not implicitly {@link mythbound.websocket.v1.CampaignParticipantMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignParticipantMessage} message CampaignParticipantMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CampaignParticipantMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.action);
                    if (message.participant != null && Object.hasOwnProperty.call(message, "participant"))
                        $root.mythbound.websocket.v1.CampaignParticipant.encode(message.participant, writer.uint32(/* id 3, wireType 2 =*/26).fork(), q + 1).ldelim();
                    if (message.currentCount != null && Object.hasOwnProperty.call(message, "currentCount"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.currentCount);
                    if (message.maxCount != null && Object.hasOwnProperty.call(message, "maxCount"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.maxCount);
                    return writer;
                };

                /**
                 * Encodes the specified CampaignParticipantMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.CampaignParticipantMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignParticipantMessage} message CampaignParticipantMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CampaignParticipantMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a CampaignParticipantMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.CampaignParticipantMessage} CampaignParticipantMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CampaignParticipantMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.CampaignParticipantMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.action = reader.string();
                                break;
                            }
                        case 3: {
                                message.participant = $root.mythbound.websocket.v1.CampaignParticipant.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 4: {
                                message.currentCount = reader.int32();
                                break;
                            }
                        case 5: {
                                message.maxCount = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a CampaignParticipantMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.CampaignParticipantMessage} CampaignParticipantMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CampaignParticipantMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CampaignParticipantMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CampaignParticipantMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                        if (!$util.isString(message.action))
                            return "action: string expected";
                    if (message.participant != null && Object.hasOwnProperty.call(message, "participant")) {
                        let error = $root.mythbound.websocket.v1.CampaignParticipant.verify(message.participant, long + 1);
                        if (error)
                            return "participant." + error;
                    }
                    if (message.currentCount != null && Object.hasOwnProperty.call(message, "currentCount"))
                        if (!$util.isInteger(message.currentCount))
                            return "currentCount: integer expected";
                    if (message.maxCount != null && Object.hasOwnProperty.call(message, "maxCount"))
                        if (!$util.isInteger(message.maxCount))
                            return "maxCount: integer expected";
                    return null;
                };

                /**
                 * Creates a CampaignParticipantMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.CampaignParticipantMessage} CampaignParticipantMessage
                 */
                CampaignParticipantMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.CampaignParticipantMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.CampaignParticipantMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.CampaignParticipantMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.CampaignParticipantMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.action != null)
                        message.action = String(object.action);
                    if (object.participant != null) {
                        if (!$util.isObject(object.participant))
                            throw TypeError(".mythbound.websocket.v1.CampaignParticipantMessage.participant: object expected");
                        message.participant = $root.mythbound.websocket.v1.CampaignParticipant.fromObject(object.participant, long + 1);
                    }
                    if (object.currentCount != null)
                        message.currentCount = object.currentCount | 0;
                    if (object.maxCount != null)
                        message.maxCount = object.maxCount | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a CampaignParticipantMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @static
                 * @param {mythbound.websocket.v1.CampaignParticipantMessage} message CampaignParticipantMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CampaignParticipantMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.action = "";
                        object.participant = null;
                        object.currentCount = 0;
                        object.maxCount = 0;
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                        object.action = message.action;
                    if (message.participant != null && Object.hasOwnProperty.call(message, "participant"))
                        object.participant = $root.mythbound.websocket.v1.CampaignParticipant.toObject(message.participant, options, q + 1);
                    if (message.currentCount != null && Object.hasOwnProperty.call(message, "currentCount"))
                        object.currentCount = message.currentCount;
                    if (message.maxCount != null && Object.hasOwnProperty.call(message, "maxCount"))
                        object.maxCount = message.maxCount;
                    return object;
                };

                /**
                 * Converts this CampaignParticipantMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CampaignParticipantMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CampaignParticipantMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.CampaignParticipantMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CampaignParticipantMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.CampaignParticipantMessage";
                };

                return CampaignParticipantMessage;
            })();

            v1.CharacterActionMessage = (function() {

                /**
                 * Properties of a CharacterActionMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface ICharacterActionMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] CharacterActionMessage base
                 * @property {string|null} [characterId] CharacterActionMessage characterId
                 * @property {string|null} [characterName] CharacterActionMessage characterName
                 * @property {string|null} [actionType] CharacterActionMessage actionType
                 * @property {string|null} [actionDescription] CharacterActionMessage actionDescription
                 * @property {Object.<string,string>|null} [actionData] CharacterActionMessage actionData
                 */

                /**
                 * Constructs a new CharacterActionMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a CharacterActionMessage.
                 * @implements ICharacterActionMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.ICharacterActionMessage=} [properties] Properties to set
                 */
                function CharacterActionMessage(properties) {
                    this.actionData = {};
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CharacterActionMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @instance
                 */
                CharacterActionMessage.prototype.base = null;

                /**
                 * CharacterActionMessage characterId.
                 * @member {string} characterId
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @instance
                 */
                CharacterActionMessage.prototype.characterId = "";

                /**
                 * CharacterActionMessage characterName.
                 * @member {string} characterName
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @instance
                 */
                CharacterActionMessage.prototype.characterName = "";

                /**
                 * CharacterActionMessage actionType.
                 * @member {string} actionType
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @instance
                 */
                CharacterActionMessage.prototype.actionType = "";

                /**
                 * CharacterActionMessage actionDescription.
                 * @member {string} actionDescription
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @instance
                 */
                CharacterActionMessage.prototype.actionDescription = "";

                /**
                 * CharacterActionMessage actionData.
                 * @member {Object.<string,string>} actionData
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @instance
                 */
                CharacterActionMessage.prototype.actionData = $util.emptyObject;

                /**
                 * Creates a new CharacterActionMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICharacterActionMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.CharacterActionMessage} CharacterActionMessage instance
                 */
                CharacterActionMessage.create = function create(properties) {
                    return new CharacterActionMessage(properties);
                };

                /**
                 * Encodes the specified CharacterActionMessage message. Does not implicitly {@link mythbound.websocket.v1.CharacterActionMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICharacterActionMessage} message CharacterActionMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CharacterActionMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.characterId);
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.characterName);
                    if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.actionType);
                    if (message.actionDescription != null && Object.hasOwnProperty.call(message, "actionDescription"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.actionDescription);
                    if (message.actionData != null && Object.hasOwnProperty.call(message, "actionData"))
                        for (let keys = Object.keys(message.actionData), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.actionData[keys[i]]).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CharacterActionMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.CharacterActionMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICharacterActionMessage} message CharacterActionMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CharacterActionMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a CharacterActionMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.CharacterActionMessage} CharacterActionMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CharacterActionMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message, key, value;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.CharacterActionMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.characterId = reader.string();
                                break;
                            }
                        case 3: {
                                message.characterName = reader.string();
                                break;
                            }
                        case 4: {
                                message.actionType = reader.string();
                                break;
                            }
                        case 5: {
                                message.actionDescription = reader.string();
                                break;
                            }
                        case 6: {
                                if (message.actionData === $util.emptyObject)
                                    message.actionData = {};
                                let end2 = reader.uint32() + reader.pos;
                                if (end2 > reader.len)
                                    throw RangeError("index out of range");
                                reader.len = end2;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7, long);
                                        break;
                                    }
                                }
                                if (reader.pos !== end2)
                                    throw RangeError("index out of range");
                                reader.len = end;
                                if (key === "__proto__")
                                    $util.makeProp(message.actionData, key);
                                message.actionData[key] = value;
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a CharacterActionMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.CharacterActionMessage} CharacterActionMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CharacterActionMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CharacterActionMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CharacterActionMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        if (!$util.isString(message.characterId))
                            return "characterId: string expected";
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        if (!$util.isString(message.characterName))
                            return "characterName: string expected";
                    if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                        if (!$util.isString(message.actionType))
                            return "actionType: string expected";
                    if (message.actionDescription != null && Object.hasOwnProperty.call(message, "actionDescription"))
                        if (!$util.isString(message.actionDescription))
                            return "actionDescription: string expected";
                    if (message.actionData != null && Object.hasOwnProperty.call(message, "actionData")) {
                        if (!$util.isObject(message.actionData))
                            return "actionData: object expected";
                        let key = Object.keys(message.actionData);
                        for (let i = 0; i < key.length; ++i)
                            if (!$util.isString(message.actionData[key[i]]))
                                return "actionData: string{k:string} expected";
                    }
                    return null;
                };

                /**
                 * Creates a CharacterActionMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.CharacterActionMessage} CharacterActionMessage
                 */
                CharacterActionMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.CharacterActionMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.CharacterActionMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.CharacterActionMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.CharacterActionMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.characterId != null)
                        message.characterId = String(object.characterId);
                    if (object.characterName != null)
                        message.characterName = String(object.characterName);
                    if (object.actionType != null)
                        message.actionType = String(object.actionType);
                    if (object.actionDescription != null)
                        message.actionDescription = String(object.actionDescription);
                    if (object.actionData) {
                        if (!$util.isObject(object.actionData))
                            throw TypeError(".mythbound.websocket.v1.CharacterActionMessage.actionData: object expected");
                        message.actionData = {};
                        for (let keys = Object.keys(object.actionData), i = 0; i < keys.length; ++i) {
                            if (keys[i] === "__proto__")
                                $util.makeProp(message.actionData, keys[i]);
                            message.actionData[keys[i]] = String(object.actionData[keys[i]]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CharacterActionMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @static
                 * @param {mythbound.websocket.v1.CharacterActionMessage} message CharacterActionMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CharacterActionMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.objects || options.defaults)
                        object.actionData = {};
                    if (options.defaults) {
                        object.base = null;
                        object.characterId = "";
                        object.characterName = "";
                        object.actionType = "";
                        object.actionDescription = "";
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        object.characterId = message.characterId;
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        object.characterName = message.characterName;
                    if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                        object.actionType = message.actionType;
                    if (message.actionDescription != null && Object.hasOwnProperty.call(message, "actionDescription"))
                        object.actionDescription = message.actionDescription;
                    let keys2;
                    if (message.actionData && (keys2 = Object.keys(message.actionData)).length) {
                        object.actionData = {};
                        for (let j = 0; j < keys2.length; ++j) {
                            if (keys2[j] === "__proto__")
                                $util.makeProp(object.actionData, keys2[j]);
                            object.actionData[keys2[j]] = message.actionData[keys2[j]];
                        }
                    }
                    return object;
                };

                /**
                 * Converts this CharacterActionMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CharacterActionMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CharacterActionMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.CharacterActionMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CharacterActionMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.CharacterActionMessage";
                };

                return CharacterActionMessage;
            })();

            v1.CharacterUpdateMessage = (function() {

                /**
                 * Properties of a CharacterUpdateMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface ICharacterUpdateMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] CharacterUpdateMessage base
                 * @property {mythbound.websocket.v1.ICharacterState|null} [characterState] CharacterUpdateMessage characterState
                 * @property {Array.<string>|null} [changedFields] CharacterUpdateMessage changedFields
                 */

                /**
                 * Constructs a new CharacterUpdateMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a CharacterUpdateMessage.
                 * @implements ICharacterUpdateMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.ICharacterUpdateMessage=} [properties] Properties to set
                 */
                function CharacterUpdateMessage(properties) {
                    this.changedFields = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CharacterUpdateMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @instance
                 */
                CharacterUpdateMessage.prototype.base = null;

                /**
                 * CharacterUpdateMessage characterState.
                 * @member {mythbound.websocket.v1.ICharacterState|null|undefined} characterState
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @instance
                 */
                CharacterUpdateMessage.prototype.characterState = null;

                /**
                 * CharacterUpdateMessage changedFields.
                 * @member {Array.<string>} changedFields
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @instance
                 */
                CharacterUpdateMessage.prototype.changedFields = $util.emptyArray;

                /**
                 * Creates a new CharacterUpdateMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICharacterUpdateMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.CharacterUpdateMessage} CharacterUpdateMessage instance
                 */
                CharacterUpdateMessage.create = function create(properties) {
                    return new CharacterUpdateMessage(properties);
                };

                /**
                 * Encodes the specified CharacterUpdateMessage message. Does not implicitly {@link mythbound.websocket.v1.CharacterUpdateMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICharacterUpdateMessage} message CharacterUpdateMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CharacterUpdateMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.characterState != null && Object.hasOwnProperty.call(message, "characterState"))
                        $root.mythbound.websocket.v1.CharacterState.encode(message.characterState, writer.uint32(/* id 2, wireType 2 =*/18).fork(), q + 1).ldelim();
                    if (message.changedFields != null && message.changedFields.length)
                        for (let i = 0; i < message.changedFields.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.changedFields[i]);
                    return writer;
                };

                /**
                 * Encodes the specified CharacterUpdateMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.CharacterUpdateMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @static
                 * @param {mythbound.websocket.v1.ICharacterUpdateMessage} message CharacterUpdateMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CharacterUpdateMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a CharacterUpdateMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.CharacterUpdateMessage} CharacterUpdateMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CharacterUpdateMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.CharacterUpdateMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.characterState = $root.mythbound.websocket.v1.CharacterState.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 3: {
                                if (!(message.changedFields && message.changedFields.length))
                                    message.changedFields = [];
                                message.changedFields.push(reader.string());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a CharacterUpdateMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.CharacterUpdateMessage} CharacterUpdateMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CharacterUpdateMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CharacterUpdateMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CharacterUpdateMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.characterState != null && Object.hasOwnProperty.call(message, "characterState")) {
                        let error = $root.mythbound.websocket.v1.CharacterState.verify(message.characterState, long + 1);
                        if (error)
                            return "characterState." + error;
                    }
                    if (message.changedFields != null && Object.hasOwnProperty.call(message, "changedFields")) {
                        if (!Array.isArray(message.changedFields))
                            return "changedFields: array expected";
                        for (let i = 0; i < message.changedFields.length; ++i)
                            if (!$util.isString(message.changedFields[i]))
                                return "changedFields: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a CharacterUpdateMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.CharacterUpdateMessage} CharacterUpdateMessage
                 */
                CharacterUpdateMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.CharacterUpdateMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.CharacterUpdateMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.CharacterUpdateMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.CharacterUpdateMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.characterState != null) {
                        if (!$util.isObject(object.characterState))
                            throw TypeError(".mythbound.websocket.v1.CharacterUpdateMessage.characterState: object expected");
                        message.characterState = $root.mythbound.websocket.v1.CharacterState.fromObject(object.characterState, long + 1);
                    }
                    if (object.changedFields) {
                        if (!Array.isArray(object.changedFields))
                            throw TypeError(".mythbound.websocket.v1.CharacterUpdateMessage.changedFields: array expected");
                        message.changedFields = [];
                        for (let i = 0; i < object.changedFields.length; ++i)
                            message.changedFields[i] = String(object.changedFields[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CharacterUpdateMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @static
                 * @param {mythbound.websocket.v1.CharacterUpdateMessage} message CharacterUpdateMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CharacterUpdateMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.changedFields = [];
                    if (options.defaults) {
                        object.base = null;
                        object.characterState = null;
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.characterState != null && Object.hasOwnProperty.call(message, "characterState"))
                        object.characterState = $root.mythbound.websocket.v1.CharacterState.toObject(message.characterState, options, q + 1);
                    if (message.changedFields && message.changedFields.length) {
                        object.changedFields = [];
                        for (let j = 0; j < message.changedFields.length; ++j)
                            object.changedFields[j] = message.changedFields[j];
                    }
                    return object;
                };

                /**
                 * Converts this CharacterUpdateMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CharacterUpdateMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CharacterUpdateMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.CharacterUpdateMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CharacterUpdateMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.CharacterUpdateMessage";
                };

                return CharacterUpdateMessage;
            })();

            v1.ChatMessage = (function() {

                /**
                 * Properties of a ChatMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IChatMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] ChatMessage base
                 * @property {string|null} [senderId] ChatMessage senderId
                 * @property {string|null} [senderName] ChatMessage senderName
                 * @property {string|null} [content] ChatMessage content
                 * @property {string|null} [chatType] ChatMessage chatType
                 * @property {string|null} [recipientId] ChatMessage recipientId
                 */

                /**
                 * Constructs a new ChatMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a ChatMessage.
                 * @implements IChatMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IChatMessage=} [properties] Properties to set
                 */
                function ChatMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ChatMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @instance
                 */
                ChatMessage.prototype.base = null;

                /**
                 * ChatMessage senderId.
                 * @member {string} senderId
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @instance
                 */
                ChatMessage.prototype.senderId = "";

                /**
                 * ChatMessage senderName.
                 * @member {string} senderName
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @instance
                 */
                ChatMessage.prototype.senderName = "";

                /**
                 * ChatMessage content.
                 * @member {string} content
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @instance
                 */
                ChatMessage.prototype.content = "";

                /**
                 * ChatMessage chatType.
                 * @member {string} chatType
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @instance
                 */
                ChatMessage.prototype.chatType = "";

                /**
                 * ChatMessage recipientId.
                 * @member {string} recipientId
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @instance
                 */
                ChatMessage.prototype.recipientId = "";

                /**
                 * Creates a new ChatMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @static
                 * @param {mythbound.websocket.v1.IChatMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.ChatMessage} ChatMessage instance
                 */
                ChatMessage.create = function create(properties) {
                    return new ChatMessage(properties);
                };

                /**
                 * Encodes the specified ChatMessage message. Does not implicitly {@link mythbound.websocket.v1.ChatMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @static
                 * @param {mythbound.websocket.v1.IChatMessage} message ChatMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChatMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.senderId);
                    if (message.senderName != null && Object.hasOwnProperty.call(message, "senderName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.senderName);
                    if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.content);
                    if (message.chatType != null && Object.hasOwnProperty.call(message, "chatType"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.chatType);
                    if (message.recipientId != null && Object.hasOwnProperty.call(message, "recipientId"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.recipientId);
                    return writer;
                };

                /**
                 * Encodes the specified ChatMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.ChatMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @static
                 * @param {mythbound.websocket.v1.IChatMessage} message ChatMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ChatMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a ChatMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.ChatMessage} ChatMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChatMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.ChatMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.senderId = reader.string();
                                break;
                            }
                        case 3: {
                                message.senderName = reader.string();
                                break;
                            }
                        case 4: {
                                message.content = reader.string();
                                break;
                            }
                        case 5: {
                                message.chatType = reader.string();
                                break;
                            }
                        case 6: {
                                message.recipientId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a ChatMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.ChatMessage} ChatMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ChatMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ChatMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ChatMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
                        if (!$util.isString(message.senderId))
                            return "senderId: string expected";
                    if (message.senderName != null && Object.hasOwnProperty.call(message, "senderName"))
                        if (!$util.isString(message.senderName))
                            return "senderName: string expected";
                    if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                        if (!$util.isString(message.content))
                            return "content: string expected";
                    if (message.chatType != null && Object.hasOwnProperty.call(message, "chatType"))
                        if (!$util.isString(message.chatType))
                            return "chatType: string expected";
                    if (message.recipientId != null && Object.hasOwnProperty.call(message, "recipientId"))
                        if (!$util.isString(message.recipientId))
                            return "recipientId: string expected";
                    return null;
                };

                /**
                 * Creates a ChatMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.ChatMessage} ChatMessage
                 */
                ChatMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.ChatMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.ChatMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.ChatMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.ChatMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.senderId != null)
                        message.senderId = String(object.senderId);
                    if (object.senderName != null)
                        message.senderName = String(object.senderName);
                    if (object.content != null)
                        message.content = String(object.content);
                    if (object.chatType != null)
                        message.chatType = String(object.chatType);
                    if (object.recipientId != null)
                        message.recipientId = String(object.recipientId);
                    return message;
                };

                /**
                 * Creates a plain object from a ChatMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @static
                 * @param {mythbound.websocket.v1.ChatMessage} message ChatMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ChatMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.senderId = "";
                        object.senderName = "";
                        object.content = "";
                        object.chatType = "";
                        object.recipientId = "";
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.senderId != null && Object.hasOwnProperty.call(message, "senderId"))
                        object.senderId = message.senderId;
                    if (message.senderName != null && Object.hasOwnProperty.call(message, "senderName"))
                        object.senderName = message.senderName;
                    if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                        object.content = message.content;
                    if (message.chatType != null && Object.hasOwnProperty.call(message, "chatType"))
                        object.chatType = message.chatType;
                    if (message.recipientId != null && Object.hasOwnProperty.call(message, "recipientId"))
                        object.recipientId = message.recipientId;
                    return object;
                };

                /**
                 * Converts this ChatMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ChatMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ChatMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.ChatMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ChatMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.ChatMessage";
                };

                return ChatMessage;
            })();

            v1.MythMasterRequestMessage = (function() {

                /**
                 * Properties of a MythMasterRequestMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IMythMasterRequestMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] MythMasterRequestMessage base
                 * @property {string|null} [requestType] MythMasterRequestMessage requestType
                 * @property {string|null} [inputText] MythMasterRequestMessage inputText
                 * @property {string|null} [characterId] MythMasterRequestMessage characterId
                 * @property {string|null} [characterName] MythMasterRequestMessage characterName
                 * @property {Object.<string,string>|null} [context] MythMasterRequestMessage context
                 */

                /**
                 * Constructs a new MythMasterRequestMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a MythMasterRequestMessage.
                 * @implements IMythMasterRequestMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IMythMasterRequestMessage=} [properties] Properties to set
                 */
                function MythMasterRequestMessage(properties) {
                    this.context = {};
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MythMasterRequestMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @instance
                 */
                MythMasterRequestMessage.prototype.base = null;

                /**
                 * MythMasterRequestMessage requestType.
                 * @member {string} requestType
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @instance
                 */
                MythMasterRequestMessage.prototype.requestType = "";

                /**
                 * MythMasterRequestMessage inputText.
                 * @member {string} inputText
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @instance
                 */
                MythMasterRequestMessage.prototype.inputText = "";

                /**
                 * MythMasterRequestMessage characterId.
                 * @member {string} characterId
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @instance
                 */
                MythMasterRequestMessage.prototype.characterId = "";

                /**
                 * MythMasterRequestMessage characterName.
                 * @member {string} characterName
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @instance
                 */
                MythMasterRequestMessage.prototype.characterName = "";

                /**
                 * MythMasterRequestMessage context.
                 * @member {Object.<string,string>} context
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @instance
                 */
                MythMasterRequestMessage.prototype.context = $util.emptyObject;

                /**
                 * Creates a new MythMasterRequestMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @static
                 * @param {mythbound.websocket.v1.IMythMasterRequestMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.MythMasterRequestMessage} MythMasterRequestMessage instance
                 */
                MythMasterRequestMessage.create = function create(properties) {
                    return new MythMasterRequestMessage(properties);
                };

                /**
                 * Encodes the specified MythMasterRequestMessage message. Does not implicitly {@link mythbound.websocket.v1.MythMasterRequestMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @static
                 * @param {mythbound.websocket.v1.IMythMasterRequestMessage} message MythMasterRequestMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MythMasterRequestMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.requestType != null && Object.hasOwnProperty.call(message, "requestType"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.requestType);
                    if (message.inputText != null && Object.hasOwnProperty.call(message, "inputText"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.inputText);
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.characterId);
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.characterName);
                    if (message.context != null && Object.hasOwnProperty.call(message, "context"))
                        for (let keys = Object.keys(message.context), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.context[keys[i]]).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified MythMasterRequestMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.MythMasterRequestMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @static
                 * @param {mythbound.websocket.v1.IMythMasterRequestMessage} message MythMasterRequestMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MythMasterRequestMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a MythMasterRequestMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.MythMasterRequestMessage} MythMasterRequestMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MythMasterRequestMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message, key, value;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.MythMasterRequestMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.requestType = reader.string();
                                break;
                            }
                        case 3: {
                                message.inputText = reader.string();
                                break;
                            }
                        case 4: {
                                message.characterId = reader.string();
                                break;
                            }
                        case 5: {
                                message.characterName = reader.string();
                                break;
                            }
                        case 6: {
                                if (message.context === $util.emptyObject)
                                    message.context = {};
                                let end2 = reader.uint32() + reader.pos;
                                if (end2 > reader.len)
                                    throw RangeError("index out of range");
                                reader.len = end2;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7, long);
                                        break;
                                    }
                                }
                                if (reader.pos !== end2)
                                    throw RangeError("index out of range");
                                reader.len = end;
                                if (key === "__proto__")
                                    $util.makeProp(message.context, key);
                                message.context[key] = value;
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a MythMasterRequestMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.MythMasterRequestMessage} MythMasterRequestMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MythMasterRequestMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MythMasterRequestMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MythMasterRequestMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.requestType != null && Object.hasOwnProperty.call(message, "requestType"))
                        if (!$util.isString(message.requestType))
                            return "requestType: string expected";
                    if (message.inputText != null && Object.hasOwnProperty.call(message, "inputText"))
                        if (!$util.isString(message.inputText))
                            return "inputText: string expected";
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        if (!$util.isString(message.characterId))
                            return "characterId: string expected";
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        if (!$util.isString(message.characterName))
                            return "characterName: string expected";
                    if (message.context != null && Object.hasOwnProperty.call(message, "context")) {
                        if (!$util.isObject(message.context))
                            return "context: object expected";
                        let key = Object.keys(message.context);
                        for (let i = 0; i < key.length; ++i)
                            if (!$util.isString(message.context[key[i]]))
                                return "context: string{k:string} expected";
                    }
                    return null;
                };

                /**
                 * Creates a MythMasterRequestMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.MythMasterRequestMessage} MythMasterRequestMessage
                 */
                MythMasterRequestMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.MythMasterRequestMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.MythMasterRequestMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.MythMasterRequestMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.MythMasterRequestMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.requestType != null)
                        message.requestType = String(object.requestType);
                    if (object.inputText != null)
                        message.inputText = String(object.inputText);
                    if (object.characterId != null)
                        message.characterId = String(object.characterId);
                    if (object.characterName != null)
                        message.characterName = String(object.characterName);
                    if (object.context) {
                        if (!$util.isObject(object.context))
                            throw TypeError(".mythbound.websocket.v1.MythMasterRequestMessage.context: object expected");
                        message.context = {};
                        for (let keys = Object.keys(object.context), i = 0; i < keys.length; ++i) {
                            if (keys[i] === "__proto__")
                                $util.makeProp(message.context, keys[i]);
                            message.context[keys[i]] = String(object.context[keys[i]]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MythMasterRequestMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @static
                 * @param {mythbound.websocket.v1.MythMasterRequestMessage} message MythMasterRequestMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MythMasterRequestMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.objects || options.defaults)
                        object.context = {};
                    if (options.defaults) {
                        object.base = null;
                        object.requestType = "";
                        object.inputText = "";
                        object.characterId = "";
                        object.characterName = "";
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.requestType != null && Object.hasOwnProperty.call(message, "requestType"))
                        object.requestType = message.requestType;
                    if (message.inputText != null && Object.hasOwnProperty.call(message, "inputText"))
                        object.inputText = message.inputText;
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        object.characterId = message.characterId;
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        object.characterName = message.characterName;
                    let keys2;
                    if (message.context && (keys2 = Object.keys(message.context)).length) {
                        object.context = {};
                        for (let j = 0; j < keys2.length; ++j) {
                            if (keys2[j] === "__proto__")
                                $util.makeProp(object.context, keys2[j]);
                            object.context[keys2[j]] = message.context[keys2[j]];
                        }
                    }
                    return object;
                };

                /**
                 * Converts this MythMasterRequestMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MythMasterRequestMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MythMasterRequestMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.MythMasterRequestMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MythMasterRequestMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.MythMasterRequestMessage";
                };

                return MythMasterRequestMessage;
            })();

            v1.MythMasterResponseMessage = (function() {

                /**
                 * Properties of a MythMasterResponseMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IMythMasterResponseMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] MythMasterResponseMessage base
                 * @property {string|null} [responseText] MythMasterResponseMessage responseText
                 * @property {string|null} [responseType] MythMasterResponseMessage responseType
                 * @property {string|null} [engineUsed] MythMasterResponseMessage engineUsed
                 * @property {string|null} [model] MythMasterResponseMessage model
                 * @property {number|null} [processingTimeMs] MythMasterResponseMessage processingTimeMs
                 * @property {number|null} [confidence] MythMasterResponseMessage confidence
                 */

                /**
                 * Constructs a new MythMasterResponseMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a MythMasterResponseMessage.
                 * @implements IMythMasterResponseMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IMythMasterResponseMessage=} [properties] Properties to set
                 */
                function MythMasterResponseMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MythMasterResponseMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @instance
                 */
                MythMasterResponseMessage.prototype.base = null;

                /**
                 * MythMasterResponseMessage responseText.
                 * @member {string} responseText
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @instance
                 */
                MythMasterResponseMessage.prototype.responseText = "";

                /**
                 * MythMasterResponseMessage responseType.
                 * @member {string} responseType
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @instance
                 */
                MythMasterResponseMessage.prototype.responseType = "";

                /**
                 * MythMasterResponseMessage engineUsed.
                 * @member {string} engineUsed
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @instance
                 */
                MythMasterResponseMessage.prototype.engineUsed = "";

                /**
                 * MythMasterResponseMessage model.
                 * @member {string} model
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @instance
                 */
                MythMasterResponseMessage.prototype.model = "";

                /**
                 * MythMasterResponseMessage processingTimeMs.
                 * @member {number} processingTimeMs
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @instance
                 */
                MythMasterResponseMessage.prototype.processingTimeMs = 0;

                /**
                 * MythMasterResponseMessage confidence.
                 * @member {number} confidence
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @instance
                 */
                MythMasterResponseMessage.prototype.confidence = 0;

                /**
                 * Creates a new MythMasterResponseMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @static
                 * @param {mythbound.websocket.v1.IMythMasterResponseMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.MythMasterResponseMessage} MythMasterResponseMessage instance
                 */
                MythMasterResponseMessage.create = function create(properties) {
                    return new MythMasterResponseMessage(properties);
                };

                /**
                 * Encodes the specified MythMasterResponseMessage message. Does not implicitly {@link mythbound.websocket.v1.MythMasterResponseMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @static
                 * @param {mythbound.websocket.v1.IMythMasterResponseMessage} message MythMasterResponseMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MythMasterResponseMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.responseText != null && Object.hasOwnProperty.call(message, "responseText"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.responseText);
                    if (message.responseType != null && Object.hasOwnProperty.call(message, "responseType"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.responseType);
                    if (message.engineUsed != null && Object.hasOwnProperty.call(message, "engineUsed"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.engineUsed);
                    if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.model);
                    if (message.processingTimeMs != null && Object.hasOwnProperty.call(message, "processingTimeMs"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.processingTimeMs);
                    if (message.confidence != null && Object.hasOwnProperty.call(message, "confidence"))
                        writer.uint32(/* id 7, wireType 5 =*/61).float(message.confidence);
                    return writer;
                };

                /**
                 * Encodes the specified MythMasterResponseMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.MythMasterResponseMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @static
                 * @param {mythbound.websocket.v1.IMythMasterResponseMessage} message MythMasterResponseMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MythMasterResponseMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a MythMasterResponseMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.MythMasterResponseMessage} MythMasterResponseMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MythMasterResponseMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.MythMasterResponseMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.responseText = reader.string();
                                break;
                            }
                        case 3: {
                                message.responseType = reader.string();
                                break;
                            }
                        case 4: {
                                message.engineUsed = reader.string();
                                break;
                            }
                        case 5: {
                                message.model = reader.string();
                                break;
                            }
                        case 6: {
                                message.processingTimeMs = reader.int32();
                                break;
                            }
                        case 7: {
                                message.confidence = reader.float();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a MythMasterResponseMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.MythMasterResponseMessage} MythMasterResponseMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MythMasterResponseMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MythMasterResponseMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MythMasterResponseMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.responseText != null && Object.hasOwnProperty.call(message, "responseText"))
                        if (!$util.isString(message.responseText))
                            return "responseText: string expected";
                    if (message.responseType != null && Object.hasOwnProperty.call(message, "responseType"))
                        if (!$util.isString(message.responseType))
                            return "responseType: string expected";
                    if (message.engineUsed != null && Object.hasOwnProperty.call(message, "engineUsed"))
                        if (!$util.isString(message.engineUsed))
                            return "engineUsed: string expected";
                    if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                        if (!$util.isString(message.model))
                            return "model: string expected";
                    if (message.processingTimeMs != null && Object.hasOwnProperty.call(message, "processingTimeMs"))
                        if (!$util.isInteger(message.processingTimeMs))
                            return "processingTimeMs: integer expected";
                    if (message.confidence != null && Object.hasOwnProperty.call(message, "confidence"))
                        if (typeof message.confidence !== "number")
                            return "confidence: number expected";
                    return null;
                };

                /**
                 * Creates a MythMasterResponseMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.MythMasterResponseMessage} MythMasterResponseMessage
                 */
                MythMasterResponseMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.MythMasterResponseMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.MythMasterResponseMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.MythMasterResponseMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.MythMasterResponseMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.responseText != null)
                        message.responseText = String(object.responseText);
                    if (object.responseType != null)
                        message.responseType = String(object.responseType);
                    if (object.engineUsed != null)
                        message.engineUsed = String(object.engineUsed);
                    if (object.model != null)
                        message.model = String(object.model);
                    if (object.processingTimeMs != null)
                        message.processingTimeMs = object.processingTimeMs | 0;
                    if (object.confidence != null)
                        message.confidence = Number(object.confidence);
                    return message;
                };

                /**
                 * Creates a plain object from a MythMasterResponseMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @static
                 * @param {mythbound.websocket.v1.MythMasterResponseMessage} message MythMasterResponseMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MythMasterResponseMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.responseText = "";
                        object.responseType = "";
                        object.engineUsed = "";
                        object.model = "";
                        object.processingTimeMs = 0;
                        object.confidence = 0;
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.responseText != null && Object.hasOwnProperty.call(message, "responseText"))
                        object.responseText = message.responseText;
                    if (message.responseType != null && Object.hasOwnProperty.call(message, "responseType"))
                        object.responseType = message.responseType;
                    if (message.engineUsed != null && Object.hasOwnProperty.call(message, "engineUsed"))
                        object.engineUsed = message.engineUsed;
                    if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                        object.model = message.model;
                    if (message.processingTimeMs != null && Object.hasOwnProperty.call(message, "processingTimeMs"))
                        object.processingTimeMs = message.processingTimeMs;
                    if (message.confidence != null && Object.hasOwnProperty.call(message, "confidence"))
                        object.confidence = options.json && !isFinite(message.confidence) ? String(message.confidence) : message.confidence;
                    return object;
                };

                /**
                 * Converts this MythMasterResponseMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MythMasterResponseMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MythMasterResponseMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.MythMasterResponseMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MythMasterResponseMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.MythMasterResponseMessage";
                };

                return MythMasterResponseMessage;
            })();

            v1.MythMasterStatusMessage = (function() {

                /**
                 * Properties of a MythMasterStatusMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IMythMasterStatusMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] MythMasterStatusMessage base
                 * @property {string|null} [activeEngine] MythMasterStatusMessage activeEngine
                 * @property {string|null} [engineModel] MythMasterStatusMessage engineModel
                 * @property {boolean|null} [isHealthy] MythMasterStatusMessage isHealthy
                 * @property {boolean|null} [isProcessing] MythMasterStatusMessage isProcessing
                 * @property {string|null} [currentRequestId] MythMasterStatusMessage currentRequestId
                 */

                /**
                 * Constructs a new MythMasterStatusMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a MythMasterStatusMessage.
                 * @implements IMythMasterStatusMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IMythMasterStatusMessage=} [properties] Properties to set
                 */
                function MythMasterStatusMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MythMasterStatusMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @instance
                 */
                MythMasterStatusMessage.prototype.base = null;

                /**
                 * MythMasterStatusMessage activeEngine.
                 * @member {string} activeEngine
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @instance
                 */
                MythMasterStatusMessage.prototype.activeEngine = "";

                /**
                 * MythMasterStatusMessage engineModel.
                 * @member {string} engineModel
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @instance
                 */
                MythMasterStatusMessage.prototype.engineModel = "";

                /**
                 * MythMasterStatusMessage isHealthy.
                 * @member {boolean} isHealthy
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @instance
                 */
                MythMasterStatusMessage.prototype.isHealthy = false;

                /**
                 * MythMasterStatusMessage isProcessing.
                 * @member {boolean} isProcessing
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @instance
                 */
                MythMasterStatusMessage.prototype.isProcessing = false;

                /**
                 * MythMasterStatusMessage currentRequestId.
                 * @member {string} currentRequestId
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @instance
                 */
                MythMasterStatusMessage.prototype.currentRequestId = "";

                /**
                 * Creates a new MythMasterStatusMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @static
                 * @param {mythbound.websocket.v1.IMythMasterStatusMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.MythMasterStatusMessage} MythMasterStatusMessage instance
                 */
                MythMasterStatusMessage.create = function create(properties) {
                    return new MythMasterStatusMessage(properties);
                };

                /**
                 * Encodes the specified MythMasterStatusMessage message. Does not implicitly {@link mythbound.websocket.v1.MythMasterStatusMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @static
                 * @param {mythbound.websocket.v1.IMythMasterStatusMessage} message MythMasterStatusMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MythMasterStatusMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.activeEngine != null && Object.hasOwnProperty.call(message, "activeEngine"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.activeEngine);
                    if (message.engineModel != null && Object.hasOwnProperty.call(message, "engineModel"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.engineModel);
                    if (message.isHealthy != null && Object.hasOwnProperty.call(message, "isHealthy"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isHealthy);
                    if (message.isProcessing != null && Object.hasOwnProperty.call(message, "isProcessing"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isProcessing);
                    if (message.currentRequestId != null && Object.hasOwnProperty.call(message, "currentRequestId"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.currentRequestId);
                    return writer;
                };

                /**
                 * Encodes the specified MythMasterStatusMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.MythMasterStatusMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @static
                 * @param {mythbound.websocket.v1.IMythMasterStatusMessage} message MythMasterStatusMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MythMasterStatusMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a MythMasterStatusMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.MythMasterStatusMessage} MythMasterStatusMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MythMasterStatusMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.MythMasterStatusMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.activeEngine = reader.string();
                                break;
                            }
                        case 3: {
                                message.engineModel = reader.string();
                                break;
                            }
                        case 4: {
                                message.isHealthy = reader.bool();
                                break;
                            }
                        case 5: {
                                message.isProcessing = reader.bool();
                                break;
                            }
                        case 6: {
                                message.currentRequestId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a MythMasterStatusMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.MythMasterStatusMessage} MythMasterStatusMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MythMasterStatusMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MythMasterStatusMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MythMasterStatusMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.activeEngine != null && Object.hasOwnProperty.call(message, "activeEngine"))
                        if (!$util.isString(message.activeEngine))
                            return "activeEngine: string expected";
                    if (message.engineModel != null && Object.hasOwnProperty.call(message, "engineModel"))
                        if (!$util.isString(message.engineModel))
                            return "engineModel: string expected";
                    if (message.isHealthy != null && Object.hasOwnProperty.call(message, "isHealthy"))
                        if (typeof message.isHealthy !== "boolean")
                            return "isHealthy: boolean expected";
                    if (message.isProcessing != null && Object.hasOwnProperty.call(message, "isProcessing"))
                        if (typeof message.isProcessing !== "boolean")
                            return "isProcessing: boolean expected";
                    if (message.currentRequestId != null && Object.hasOwnProperty.call(message, "currentRequestId"))
                        if (!$util.isString(message.currentRequestId))
                            return "currentRequestId: string expected";
                    return null;
                };

                /**
                 * Creates a MythMasterStatusMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.MythMasterStatusMessage} MythMasterStatusMessage
                 */
                MythMasterStatusMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.MythMasterStatusMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.MythMasterStatusMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.MythMasterStatusMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.MythMasterStatusMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.activeEngine != null)
                        message.activeEngine = String(object.activeEngine);
                    if (object.engineModel != null)
                        message.engineModel = String(object.engineModel);
                    if (object.isHealthy != null)
                        message.isHealthy = Boolean(object.isHealthy);
                    if (object.isProcessing != null)
                        message.isProcessing = Boolean(object.isProcessing);
                    if (object.currentRequestId != null)
                        message.currentRequestId = String(object.currentRequestId);
                    return message;
                };

                /**
                 * Creates a plain object from a MythMasterStatusMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @static
                 * @param {mythbound.websocket.v1.MythMasterStatusMessage} message MythMasterStatusMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MythMasterStatusMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.activeEngine = "";
                        object.engineModel = "";
                        object.isHealthy = false;
                        object.isProcessing = false;
                        object.currentRequestId = "";
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.activeEngine != null && Object.hasOwnProperty.call(message, "activeEngine"))
                        object.activeEngine = message.activeEngine;
                    if (message.engineModel != null && Object.hasOwnProperty.call(message, "engineModel"))
                        object.engineModel = message.engineModel;
                    if (message.isHealthy != null && Object.hasOwnProperty.call(message, "isHealthy"))
                        object.isHealthy = message.isHealthy;
                    if (message.isProcessing != null && Object.hasOwnProperty.call(message, "isProcessing"))
                        object.isProcessing = message.isProcessing;
                    if (message.currentRequestId != null && Object.hasOwnProperty.call(message, "currentRequestId"))
                        object.currentRequestId = message.currentRequestId;
                    return object;
                };

                /**
                 * Converts this MythMasterStatusMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MythMasterStatusMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for MythMasterStatusMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.MythMasterStatusMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                MythMasterStatusMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.MythMasterStatusMessage";
                };

                return MythMasterStatusMessage;
            })();

            v1.DiceRollMessage = (function() {

                /**
                 * Properties of a DiceRollMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IDiceRollMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] DiceRollMessage base
                 * @property {string|null} [rollExpression] DiceRollMessage rollExpression
                 * @property {string|null} [characterId] DiceRollMessage characterId
                 * @property {string|null} [characterName] DiceRollMessage characterName
                 * @property {string|null} [rollReason] DiceRollMessage rollReason
                 */

                /**
                 * Constructs a new DiceRollMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a DiceRollMessage.
                 * @implements IDiceRollMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IDiceRollMessage=} [properties] Properties to set
                 */
                function DiceRollMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DiceRollMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @instance
                 */
                DiceRollMessage.prototype.base = null;

                /**
                 * DiceRollMessage rollExpression.
                 * @member {string} rollExpression
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @instance
                 */
                DiceRollMessage.prototype.rollExpression = "";

                /**
                 * DiceRollMessage characterId.
                 * @member {string} characterId
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @instance
                 */
                DiceRollMessage.prototype.characterId = "";

                /**
                 * DiceRollMessage characterName.
                 * @member {string} characterName
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @instance
                 */
                DiceRollMessage.prototype.characterName = "";

                /**
                 * DiceRollMessage rollReason.
                 * @member {string} rollReason
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @instance
                 */
                DiceRollMessage.prototype.rollReason = "";

                /**
                 * Creates a new DiceRollMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @static
                 * @param {mythbound.websocket.v1.IDiceRollMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.DiceRollMessage} DiceRollMessage instance
                 */
                DiceRollMessage.create = function create(properties) {
                    return new DiceRollMessage(properties);
                };

                /**
                 * Encodes the specified DiceRollMessage message. Does not implicitly {@link mythbound.websocket.v1.DiceRollMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @static
                 * @param {mythbound.websocket.v1.IDiceRollMessage} message DiceRollMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DiceRollMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.rollExpression != null && Object.hasOwnProperty.call(message, "rollExpression"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.rollExpression);
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.characterId);
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.characterName);
                    if (message.rollReason != null && Object.hasOwnProperty.call(message, "rollReason"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.rollReason);
                    return writer;
                };

                /**
                 * Encodes the specified DiceRollMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.DiceRollMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @static
                 * @param {mythbound.websocket.v1.IDiceRollMessage} message DiceRollMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DiceRollMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a DiceRollMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.DiceRollMessage} DiceRollMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DiceRollMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.DiceRollMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.rollExpression = reader.string();
                                break;
                            }
                        case 3: {
                                message.characterId = reader.string();
                                break;
                            }
                        case 4: {
                                message.characterName = reader.string();
                                break;
                            }
                        case 5: {
                                message.rollReason = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a DiceRollMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.DiceRollMessage} DiceRollMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DiceRollMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DiceRollMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DiceRollMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.rollExpression != null && Object.hasOwnProperty.call(message, "rollExpression"))
                        if (!$util.isString(message.rollExpression))
                            return "rollExpression: string expected";
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        if (!$util.isString(message.characterId))
                            return "characterId: string expected";
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        if (!$util.isString(message.characterName))
                            return "characterName: string expected";
                    if (message.rollReason != null && Object.hasOwnProperty.call(message, "rollReason"))
                        if (!$util.isString(message.rollReason))
                            return "rollReason: string expected";
                    return null;
                };

                /**
                 * Creates a DiceRollMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.DiceRollMessage} DiceRollMessage
                 */
                DiceRollMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.DiceRollMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.DiceRollMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.DiceRollMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.DiceRollMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.rollExpression != null)
                        message.rollExpression = String(object.rollExpression);
                    if (object.characterId != null)
                        message.characterId = String(object.characterId);
                    if (object.characterName != null)
                        message.characterName = String(object.characterName);
                    if (object.rollReason != null)
                        message.rollReason = String(object.rollReason);
                    return message;
                };

                /**
                 * Creates a plain object from a DiceRollMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @static
                 * @param {mythbound.websocket.v1.DiceRollMessage} message DiceRollMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DiceRollMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.rollExpression = "";
                        object.characterId = "";
                        object.characterName = "";
                        object.rollReason = "";
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.rollExpression != null && Object.hasOwnProperty.call(message, "rollExpression"))
                        object.rollExpression = message.rollExpression;
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        object.characterId = message.characterId;
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        object.characterName = message.characterName;
                    if (message.rollReason != null && Object.hasOwnProperty.call(message, "rollReason"))
                        object.rollReason = message.rollReason;
                    return object;
                };

                /**
                 * Converts this DiceRollMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DiceRollMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DiceRollMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.DiceRollMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DiceRollMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.DiceRollMessage";
                };

                return DiceRollMessage;
            })();

            v1.DiceRollResultMessage = (function() {

                /**
                 * Properties of a DiceRollResultMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IDiceRollResultMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] DiceRollResultMessage base
                 * @property {string|null} [rollExpression] DiceRollResultMessage rollExpression
                 * @property {Array.<number>|null} [individualRolls] DiceRollResultMessage individualRolls
                 * @property {number|null} [total] DiceRollResultMessage total
                 * @property {number|null} [modifier] DiceRollResultMessage modifier
                 * @property {string|null} [characterId] DiceRollResultMessage characterId
                 * @property {string|null} [characterName] DiceRollResultMessage characterName
                 * @property {boolean|null} [criticalSuccess] DiceRollResultMessage criticalSuccess
                 * @property {boolean|null} [criticalFailure] DiceRollResultMessage criticalFailure
                 */

                /**
                 * Constructs a new DiceRollResultMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a DiceRollResultMessage.
                 * @implements IDiceRollResultMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IDiceRollResultMessage=} [properties] Properties to set
                 */
                function DiceRollResultMessage(properties) {
                    this.individualRolls = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DiceRollResultMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @instance
                 */
                DiceRollResultMessage.prototype.base = null;

                /**
                 * DiceRollResultMessage rollExpression.
                 * @member {string} rollExpression
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @instance
                 */
                DiceRollResultMessage.prototype.rollExpression = "";

                /**
                 * DiceRollResultMessage individualRolls.
                 * @member {Array.<number>} individualRolls
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @instance
                 */
                DiceRollResultMessage.prototype.individualRolls = $util.emptyArray;

                /**
                 * DiceRollResultMessage total.
                 * @member {number} total
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @instance
                 */
                DiceRollResultMessage.prototype.total = 0;

                /**
                 * DiceRollResultMessage modifier.
                 * @member {number} modifier
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @instance
                 */
                DiceRollResultMessage.prototype.modifier = 0;

                /**
                 * DiceRollResultMessage characterId.
                 * @member {string} characterId
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @instance
                 */
                DiceRollResultMessage.prototype.characterId = "";

                /**
                 * DiceRollResultMessage characterName.
                 * @member {string} characterName
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @instance
                 */
                DiceRollResultMessage.prototype.characterName = "";

                /**
                 * DiceRollResultMessage criticalSuccess.
                 * @member {boolean} criticalSuccess
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @instance
                 */
                DiceRollResultMessage.prototype.criticalSuccess = false;

                /**
                 * DiceRollResultMessage criticalFailure.
                 * @member {boolean} criticalFailure
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @instance
                 */
                DiceRollResultMessage.prototype.criticalFailure = false;

                /**
                 * Creates a new DiceRollResultMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @static
                 * @param {mythbound.websocket.v1.IDiceRollResultMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.DiceRollResultMessage} DiceRollResultMessage instance
                 */
                DiceRollResultMessage.create = function create(properties) {
                    return new DiceRollResultMessage(properties);
                };

                /**
                 * Encodes the specified DiceRollResultMessage message. Does not implicitly {@link mythbound.websocket.v1.DiceRollResultMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @static
                 * @param {mythbound.websocket.v1.IDiceRollResultMessage} message DiceRollResultMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DiceRollResultMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.rollExpression != null && Object.hasOwnProperty.call(message, "rollExpression"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.rollExpression);
                    if (message.individualRolls != null && message.individualRolls.length) {
                        writer.uint32(/* id 3, wireType 2 =*/26).fork();
                        for (let i = 0; i < message.individualRolls.length; ++i)
                            writer.int32(message.individualRolls[i]);
                        writer.ldelim();
                    }
                    if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.total);
                    if (message.modifier != null && Object.hasOwnProperty.call(message, "modifier"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.modifier);
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.characterId);
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.characterName);
                    if (message.criticalSuccess != null && Object.hasOwnProperty.call(message, "criticalSuccess"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.criticalSuccess);
                    if (message.criticalFailure != null && Object.hasOwnProperty.call(message, "criticalFailure"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.criticalFailure);
                    return writer;
                };

                /**
                 * Encodes the specified DiceRollResultMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.DiceRollResultMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @static
                 * @param {mythbound.websocket.v1.IDiceRollResultMessage} message DiceRollResultMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DiceRollResultMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a DiceRollResultMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.DiceRollResultMessage} DiceRollResultMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DiceRollResultMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.DiceRollResultMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.rollExpression = reader.string();
                                break;
                            }
                        case 3: {
                                if (!(message.individualRolls && message.individualRolls.length))
                                    message.individualRolls = [];
                                if ((tag & 7) === 2) {
                                    let end2 = reader.uint32() + reader.pos;
                                    if (end2 > reader.len)
                                        throw RangeError("index out of range");
                                    reader.len = end2;
                                    while (reader.pos < end2)
                                        message.individualRolls.push(reader.int32());
                                    if (reader.pos !== end2)
                                        throw RangeError("index out of range");
                                    reader.len = end;
                                } else
                                    message.individualRolls.push(reader.int32());
                                break;
                            }
                        case 4: {
                                message.total = reader.int32();
                                break;
                            }
                        case 5: {
                                message.modifier = reader.int32();
                                break;
                            }
                        case 6: {
                                message.characterId = reader.string();
                                break;
                            }
                        case 7: {
                                message.characterName = reader.string();
                                break;
                            }
                        case 8: {
                                message.criticalSuccess = reader.bool();
                                break;
                            }
                        case 9: {
                                message.criticalFailure = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a DiceRollResultMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.DiceRollResultMessage} DiceRollResultMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DiceRollResultMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DiceRollResultMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DiceRollResultMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.rollExpression != null && Object.hasOwnProperty.call(message, "rollExpression"))
                        if (!$util.isString(message.rollExpression))
                            return "rollExpression: string expected";
                    if (message.individualRolls != null && Object.hasOwnProperty.call(message, "individualRolls")) {
                        if (!Array.isArray(message.individualRolls))
                            return "individualRolls: array expected";
                        for (let i = 0; i < message.individualRolls.length; ++i)
                            if (!$util.isInteger(message.individualRolls[i]))
                                return "individualRolls: integer[] expected";
                    }
                    if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                        if (!$util.isInteger(message.total))
                            return "total: integer expected";
                    if (message.modifier != null && Object.hasOwnProperty.call(message, "modifier"))
                        if (!$util.isInteger(message.modifier))
                            return "modifier: integer expected";
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        if (!$util.isString(message.characterId))
                            return "characterId: string expected";
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        if (!$util.isString(message.characterName))
                            return "characterName: string expected";
                    if (message.criticalSuccess != null && Object.hasOwnProperty.call(message, "criticalSuccess"))
                        if (typeof message.criticalSuccess !== "boolean")
                            return "criticalSuccess: boolean expected";
                    if (message.criticalFailure != null && Object.hasOwnProperty.call(message, "criticalFailure"))
                        if (typeof message.criticalFailure !== "boolean")
                            return "criticalFailure: boolean expected";
                    return null;
                };

                /**
                 * Creates a DiceRollResultMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.DiceRollResultMessage} DiceRollResultMessage
                 */
                DiceRollResultMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.DiceRollResultMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.DiceRollResultMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.DiceRollResultMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.DiceRollResultMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.rollExpression != null)
                        message.rollExpression = String(object.rollExpression);
                    if (object.individualRolls) {
                        if (!Array.isArray(object.individualRolls))
                            throw TypeError(".mythbound.websocket.v1.DiceRollResultMessage.individualRolls: array expected");
                        message.individualRolls = [];
                        for (let i = 0; i < object.individualRolls.length; ++i)
                            message.individualRolls[i] = object.individualRolls[i] | 0;
                    }
                    if (object.total != null)
                        message.total = object.total | 0;
                    if (object.modifier != null)
                        message.modifier = object.modifier | 0;
                    if (object.characterId != null)
                        message.characterId = String(object.characterId);
                    if (object.characterName != null)
                        message.characterName = String(object.characterName);
                    if (object.criticalSuccess != null)
                        message.criticalSuccess = Boolean(object.criticalSuccess);
                    if (object.criticalFailure != null)
                        message.criticalFailure = Boolean(object.criticalFailure);
                    return message;
                };

                /**
                 * Creates a plain object from a DiceRollResultMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @static
                 * @param {mythbound.websocket.v1.DiceRollResultMessage} message DiceRollResultMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DiceRollResultMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.individualRolls = [];
                    if (options.defaults) {
                        object.base = null;
                        object.rollExpression = "";
                        object.total = 0;
                        object.modifier = 0;
                        object.characterId = "";
                        object.characterName = "";
                        object.criticalSuccess = false;
                        object.criticalFailure = false;
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.rollExpression != null && Object.hasOwnProperty.call(message, "rollExpression"))
                        object.rollExpression = message.rollExpression;
                    if (message.individualRolls && message.individualRolls.length) {
                        object.individualRolls = [];
                        for (let j = 0; j < message.individualRolls.length; ++j)
                            object.individualRolls[j] = message.individualRolls[j];
                    }
                    if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                        object.total = message.total;
                    if (message.modifier != null && Object.hasOwnProperty.call(message, "modifier"))
                        object.modifier = message.modifier;
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        object.characterId = message.characterId;
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        object.characterName = message.characterName;
                    if (message.criticalSuccess != null && Object.hasOwnProperty.call(message, "criticalSuccess"))
                        object.criticalSuccess = message.criticalSuccess;
                    if (message.criticalFailure != null && Object.hasOwnProperty.call(message, "criticalFailure"))
                        object.criticalFailure = message.criticalFailure;
                    return object;
                };

                /**
                 * Converts this DiceRollResultMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DiceRollResultMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for DiceRollResultMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.DiceRollResultMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                DiceRollResultMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.DiceRollResultMessage";
                };

                return DiceRollResultMessage;
            })();

            v1.ConnectionEstablishedMessage = (function() {

                /**
                 * Properties of a ConnectionEstablishedMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IConnectionEstablishedMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] ConnectionEstablishedMessage base
                 * @property {string|null} [welcomeMessage] ConnectionEstablishedMessage welcomeMessage
                 * @property {string|null} [serverVersion] ConnectionEstablishedMessage serverVersion
                 * @property {mythbound.websocket.v1.IHLCTimestamp|null} [serverTimestamp] ConnectionEstablishedMessage serverTimestamp
                 */

                /**
                 * Constructs a new ConnectionEstablishedMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a ConnectionEstablishedMessage.
                 * @implements IConnectionEstablishedMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IConnectionEstablishedMessage=} [properties] Properties to set
                 */
                function ConnectionEstablishedMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ConnectionEstablishedMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @instance
                 */
                ConnectionEstablishedMessage.prototype.base = null;

                /**
                 * ConnectionEstablishedMessage welcomeMessage.
                 * @member {string} welcomeMessage
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @instance
                 */
                ConnectionEstablishedMessage.prototype.welcomeMessage = "";

                /**
                 * ConnectionEstablishedMessage serverVersion.
                 * @member {string} serverVersion
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @instance
                 */
                ConnectionEstablishedMessage.prototype.serverVersion = "";

                /**
                 * ConnectionEstablishedMessage serverTimestamp.
                 * @member {mythbound.websocket.v1.IHLCTimestamp|null|undefined} serverTimestamp
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @instance
                 */
                ConnectionEstablishedMessage.prototype.serverTimestamp = null;

                /**
                 * Creates a new ConnectionEstablishedMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @static
                 * @param {mythbound.websocket.v1.IConnectionEstablishedMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.ConnectionEstablishedMessage} ConnectionEstablishedMessage instance
                 */
                ConnectionEstablishedMessage.create = function create(properties) {
                    return new ConnectionEstablishedMessage(properties);
                };

                /**
                 * Encodes the specified ConnectionEstablishedMessage message. Does not implicitly {@link mythbound.websocket.v1.ConnectionEstablishedMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @static
                 * @param {mythbound.websocket.v1.IConnectionEstablishedMessage} message ConnectionEstablishedMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConnectionEstablishedMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.welcomeMessage != null && Object.hasOwnProperty.call(message, "welcomeMessage"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.welcomeMessage);
                    if (message.serverVersion != null && Object.hasOwnProperty.call(message, "serverVersion"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.serverVersion);
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp"))
                        $root.mythbound.websocket.v1.HLCTimestamp.encode(message.serverTimestamp, writer.uint32(/* id 4, wireType 2 =*/34).fork(), q + 1).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ConnectionEstablishedMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.ConnectionEstablishedMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @static
                 * @param {mythbound.websocket.v1.IConnectionEstablishedMessage} message ConnectionEstablishedMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConnectionEstablishedMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a ConnectionEstablishedMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.ConnectionEstablishedMessage} ConnectionEstablishedMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConnectionEstablishedMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.ConnectionEstablishedMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.welcomeMessage = reader.string();
                                break;
                            }
                        case 3: {
                                message.serverVersion = reader.string();
                                break;
                            }
                        case 4: {
                                message.serverTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a ConnectionEstablishedMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.ConnectionEstablishedMessage} ConnectionEstablishedMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConnectionEstablishedMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ConnectionEstablishedMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ConnectionEstablishedMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.welcomeMessage != null && Object.hasOwnProperty.call(message, "welcomeMessage"))
                        if (!$util.isString(message.welcomeMessage))
                            return "welcomeMessage: string expected";
                    if (message.serverVersion != null && Object.hasOwnProperty.call(message, "serverVersion"))
                        if (!$util.isString(message.serverVersion))
                            return "serverVersion: string expected";
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp")) {
                        let error = $root.mythbound.websocket.v1.HLCTimestamp.verify(message.serverTimestamp, long + 1);
                        if (error)
                            return "serverTimestamp." + error;
                    }
                    return null;
                };

                /**
                 * Creates a ConnectionEstablishedMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.ConnectionEstablishedMessage} ConnectionEstablishedMessage
                 */
                ConnectionEstablishedMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.ConnectionEstablishedMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.ConnectionEstablishedMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.ConnectionEstablishedMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.ConnectionEstablishedMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.welcomeMessage != null)
                        message.welcomeMessage = String(object.welcomeMessage);
                    if (object.serverVersion != null)
                        message.serverVersion = String(object.serverVersion);
                    if (object.serverTimestamp != null) {
                        if (!$util.isObject(object.serverTimestamp))
                            throw TypeError(".mythbound.websocket.v1.ConnectionEstablishedMessage.serverTimestamp: object expected");
                        message.serverTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.fromObject(object.serverTimestamp, long + 1);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ConnectionEstablishedMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @static
                 * @param {mythbound.websocket.v1.ConnectionEstablishedMessage} message ConnectionEstablishedMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ConnectionEstablishedMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.welcomeMessage = "";
                        object.serverVersion = "";
                        object.serverTimestamp = null;
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.welcomeMessage != null && Object.hasOwnProperty.call(message, "welcomeMessage"))
                        object.welcomeMessage = message.welcomeMessage;
                    if (message.serverVersion != null && Object.hasOwnProperty.call(message, "serverVersion"))
                        object.serverVersion = message.serverVersion;
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp"))
                        object.serverTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.toObject(message.serverTimestamp, options, q + 1);
                    return object;
                };

                /**
                 * Converts this ConnectionEstablishedMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ConnectionEstablishedMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ConnectionEstablishedMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.ConnectionEstablishedMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ConnectionEstablishedMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.ConnectionEstablishedMessage";
                };

                return ConnectionEstablishedMessage;
            })();

            v1.HeartbeatMessage = (function() {

                /**
                 * Properties of a HeartbeatMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IHeartbeatMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] HeartbeatMessage base
                 * @property {string|null} [pingId] HeartbeatMessage pingId
                 * @property {number|Long|null} [clientTimestamp] HeartbeatMessage clientTimestamp
                 * @property {number|Long|null} [serverTimestamp] HeartbeatMessage serverTimestamp
                 */

                /**
                 * Constructs a new HeartbeatMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a HeartbeatMessage.
                 * @implements IHeartbeatMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IHeartbeatMessage=} [properties] Properties to set
                 */
                function HeartbeatMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HeartbeatMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @instance
                 */
                HeartbeatMessage.prototype.base = null;

                /**
                 * HeartbeatMessage pingId.
                 * @member {string} pingId
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @instance
                 */
                HeartbeatMessage.prototype.pingId = "";

                /**
                 * HeartbeatMessage clientTimestamp.
                 * @member {number|Long} clientTimestamp
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @instance
                 */
                HeartbeatMessage.prototype.clientTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * HeartbeatMessage serverTimestamp.
                 * @member {number|Long} serverTimestamp
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @instance
                 */
                HeartbeatMessage.prototype.serverTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new HeartbeatMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @static
                 * @param {mythbound.websocket.v1.IHeartbeatMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.HeartbeatMessage} HeartbeatMessage instance
                 */
                HeartbeatMessage.create = function create(properties) {
                    return new HeartbeatMessage(properties);
                };

                /**
                 * Encodes the specified HeartbeatMessage message. Does not implicitly {@link mythbound.websocket.v1.HeartbeatMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @static
                 * @param {mythbound.websocket.v1.IHeartbeatMessage} message HeartbeatMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HeartbeatMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.pingId != null && Object.hasOwnProperty.call(message, "pingId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.pingId);
                    if (message.clientTimestamp != null && Object.hasOwnProperty.call(message, "clientTimestamp"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.clientTimestamp);
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.serverTimestamp);
                    return writer;
                };

                /**
                 * Encodes the specified HeartbeatMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.HeartbeatMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @static
                 * @param {mythbound.websocket.v1.IHeartbeatMessage} message HeartbeatMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HeartbeatMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a HeartbeatMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.HeartbeatMessage} HeartbeatMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HeartbeatMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.HeartbeatMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.pingId = reader.string();
                                break;
                            }
                        case 3: {
                                message.clientTimestamp = reader.int64();
                                break;
                            }
                        case 4: {
                                message.serverTimestamp = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a HeartbeatMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.HeartbeatMessage} HeartbeatMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HeartbeatMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HeartbeatMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HeartbeatMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.pingId != null && Object.hasOwnProperty.call(message, "pingId"))
                        if (!$util.isString(message.pingId))
                            return "pingId: string expected";
                    if (message.clientTimestamp != null && Object.hasOwnProperty.call(message, "clientTimestamp"))
                        if (!$util.isInteger(message.clientTimestamp) && !(message.clientTimestamp && $util.isInteger(message.clientTimestamp.low) && $util.isInteger(message.clientTimestamp.high)))
                            return "clientTimestamp: integer|Long expected";
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp"))
                        if (!$util.isInteger(message.serverTimestamp) && !(message.serverTimestamp && $util.isInteger(message.serverTimestamp.low) && $util.isInteger(message.serverTimestamp.high)))
                            return "serverTimestamp: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a HeartbeatMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.HeartbeatMessage} HeartbeatMessage
                 */
                HeartbeatMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.HeartbeatMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.HeartbeatMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.HeartbeatMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.HeartbeatMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.pingId != null)
                        message.pingId = String(object.pingId);
                    if (object.clientTimestamp != null)
                        if ($util.Long)
                            message.clientTimestamp = $util.Long.fromValue(object.clientTimestamp, false);
                        else if (typeof object.clientTimestamp === "string")
                            message.clientTimestamp = parseInt(object.clientTimestamp, 10);
                        else if (typeof object.clientTimestamp === "number")
                            message.clientTimestamp = object.clientTimestamp;
                        else if (typeof object.clientTimestamp === "object")
                            message.clientTimestamp = new $util.LongBits(object.clientTimestamp.low >>> 0, object.clientTimestamp.high >>> 0).toNumber();
                    if (object.serverTimestamp != null)
                        if ($util.Long)
                            message.serverTimestamp = $util.Long.fromValue(object.serverTimestamp, false);
                        else if (typeof object.serverTimestamp === "string")
                            message.serverTimestamp = parseInt(object.serverTimestamp, 10);
                        else if (typeof object.serverTimestamp === "number")
                            message.serverTimestamp = object.serverTimestamp;
                        else if (typeof object.serverTimestamp === "object")
                            message.serverTimestamp = new $util.LongBits(object.serverTimestamp.low >>> 0, object.serverTimestamp.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a HeartbeatMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @static
                 * @param {mythbound.websocket.v1.HeartbeatMessage} message HeartbeatMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HeartbeatMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.pingId = "";
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.clientTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                        } else
                            object.clientTimestamp = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.serverTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                        } else
                            object.serverTimestamp = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.pingId != null && Object.hasOwnProperty.call(message, "pingId"))
                        object.pingId = message.pingId;
                    if (message.clientTimestamp != null && Object.hasOwnProperty.call(message, "clientTimestamp"))
                        if (typeof BigInt !== "undefined" && options.longs === BigInt)
                            object.clientTimestamp = typeof message.clientTimestamp === "number" ? BigInt(message.clientTimestamp) : $util.Long.fromBits(message.clientTimestamp.low >>> 0, message.clientTimestamp.high >>> 0, false).toBigInt();
                        else if (typeof message.clientTimestamp === "number")
                            object.clientTimestamp = options.longs === String ? String(message.clientTimestamp) : message.clientTimestamp;
                        else
                            object.clientTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.clientTimestamp) : options.longs === Number ? new $util.LongBits(message.clientTimestamp.low >>> 0, message.clientTimestamp.high >>> 0).toNumber() : message.clientTimestamp;
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp"))
                        if (typeof BigInt !== "undefined" && options.longs === BigInt)
                            object.serverTimestamp = typeof message.serverTimestamp === "number" ? BigInt(message.serverTimestamp) : $util.Long.fromBits(message.serverTimestamp.low >>> 0, message.serverTimestamp.high >>> 0, false).toBigInt();
                        else if (typeof message.serverTimestamp === "number")
                            object.serverTimestamp = options.longs === String ? String(message.serverTimestamp) : message.serverTimestamp;
                        else
                            object.serverTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.serverTimestamp) : options.longs === Number ? new $util.LongBits(message.serverTimestamp.low >>> 0, message.serverTimestamp.high >>> 0).toNumber() : message.serverTimestamp;
                    return object;
                };

                /**
                 * Converts this HeartbeatMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HeartbeatMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for HeartbeatMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.HeartbeatMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                HeartbeatMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.HeartbeatMessage";
                };

                return HeartbeatMessage;
            })();

            v1.UniversalMessage = (function() {

                /**
                 * Properties of an UniversalMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IUniversalMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] UniversalMessage base
                 * @property {mythbound.websocket.v1.IVoiceJoinMessage|null} [voiceJoin] UniversalMessage voiceJoin
                 * @property {mythbound.websocket.v1.IVoiceLeaveMessage|null} [voiceLeave] UniversalMessage voiceLeave
                 * @property {mythbound.websocket.v1.IVoiceDataMessage|null} [voiceData] UniversalMessage voiceData
                 * @property {mythbound.websocket.v1.IVoiceActivityMessage|null} [voiceActivity] UniversalMessage voiceActivity
                 * @property {mythbound.websocket.v1.IVoiceModeChangeMessage|null} [voiceModeChange] UniversalMessage voiceModeChange
                 * @property {mythbound.websocket.v1.IVoiceFeedbackMessage|null} [voiceFeedback] UniversalMessage voiceFeedback
                 * @property {mythbound.websocket.v1.ICampaignCreateMessage|null} [campaignCreate] UniversalMessage campaignCreate
                 * @property {mythbound.websocket.v1.ICampaignUpdateMessage|null} [campaignUpdate] UniversalMessage campaignUpdate
                 * @property {mythbound.websocket.v1.ICampaignParticipantMessage|null} [campaignParticipant] UniversalMessage campaignParticipant
                 * @property {mythbound.websocket.v1.ICharacterActionMessage|null} [characterAction] UniversalMessage characterAction
                 * @property {mythbound.websocket.v1.ICharacterUpdateMessage|null} [characterUpdate] UniversalMessage characterUpdate
                 * @property {mythbound.websocket.v1.IChatMessage|null} [chat] UniversalMessage chat
                 * @property {mythbound.websocket.v1.IMythMasterRequestMessage|null} [mmRequest] UniversalMessage mmRequest
                 * @property {mythbound.websocket.v1.IMythMasterResponseMessage|null} [mmResponse] UniversalMessage mmResponse
                 * @property {mythbound.websocket.v1.IMythMasterStatusMessage|null} [mmStatus] UniversalMessage mmStatus
                 * @property {mythbound.websocket.v1.IDiceRollMessage|null} [diceRoll] UniversalMessage diceRoll
                 * @property {mythbound.websocket.v1.IDiceRollResultMessage|null} [diceRollResult] UniversalMessage diceRollResult
                 * @property {mythbound.websocket.v1.IConnectionEstablishedMessage|null} [connectionEstablished] UniversalMessage connectionEstablished
                 * @property {mythbound.websocket.v1.IHeartbeatMessage|null} [heartbeat] UniversalMessage heartbeat
                 * @property {mythbound.websocket.v1.IStateMessage|null} [state] UniversalMessage state
                 * @property {mythbound.websocket.v1.IErrorMessage|null} [error] UniversalMessage error
                 */

                /**
                 * Constructs a new UniversalMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents an UniversalMessage.
                 * @implements IUniversalMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IUniversalMessage=} [properties] Properties to set
                 */
                function UniversalMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UniversalMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.base = null;

                /**
                 * UniversalMessage voiceJoin.
                 * @member {mythbound.websocket.v1.IVoiceJoinMessage|null|undefined} voiceJoin
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.voiceJoin = null;

                /**
                 * UniversalMessage voiceLeave.
                 * @member {mythbound.websocket.v1.IVoiceLeaveMessage|null|undefined} voiceLeave
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.voiceLeave = null;

                /**
                 * UniversalMessage voiceData.
                 * @member {mythbound.websocket.v1.IVoiceDataMessage|null|undefined} voiceData
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.voiceData = null;

                /**
                 * UniversalMessage voiceActivity.
                 * @member {mythbound.websocket.v1.IVoiceActivityMessage|null|undefined} voiceActivity
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.voiceActivity = null;

                /**
                 * UniversalMessage voiceModeChange.
                 * @member {mythbound.websocket.v1.IVoiceModeChangeMessage|null|undefined} voiceModeChange
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.voiceModeChange = null;

                /**
                 * UniversalMessage voiceFeedback.
                 * @member {mythbound.websocket.v1.IVoiceFeedbackMessage|null|undefined} voiceFeedback
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.voiceFeedback = null;

                /**
                 * UniversalMessage campaignCreate.
                 * @member {mythbound.websocket.v1.ICampaignCreateMessage|null|undefined} campaignCreate
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.campaignCreate = null;

                /**
                 * UniversalMessage campaignUpdate.
                 * @member {mythbound.websocket.v1.ICampaignUpdateMessage|null|undefined} campaignUpdate
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.campaignUpdate = null;

                /**
                 * UniversalMessage campaignParticipant.
                 * @member {mythbound.websocket.v1.ICampaignParticipantMessage|null|undefined} campaignParticipant
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.campaignParticipant = null;

                /**
                 * UniversalMessage characterAction.
                 * @member {mythbound.websocket.v1.ICharacterActionMessage|null|undefined} characterAction
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.characterAction = null;

                /**
                 * UniversalMessage characterUpdate.
                 * @member {mythbound.websocket.v1.ICharacterUpdateMessage|null|undefined} characterUpdate
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.characterUpdate = null;

                /**
                 * UniversalMessage chat.
                 * @member {mythbound.websocket.v1.IChatMessage|null|undefined} chat
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.chat = null;

                /**
                 * UniversalMessage mmRequest.
                 * @member {mythbound.websocket.v1.IMythMasterRequestMessage|null|undefined} mmRequest
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.mmRequest = null;

                /**
                 * UniversalMessage mmResponse.
                 * @member {mythbound.websocket.v1.IMythMasterResponseMessage|null|undefined} mmResponse
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.mmResponse = null;

                /**
                 * UniversalMessage mmStatus.
                 * @member {mythbound.websocket.v1.IMythMasterStatusMessage|null|undefined} mmStatus
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.mmStatus = null;

                /**
                 * UniversalMessage diceRoll.
                 * @member {mythbound.websocket.v1.IDiceRollMessage|null|undefined} diceRoll
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.diceRoll = null;

                /**
                 * UniversalMessage diceRollResult.
                 * @member {mythbound.websocket.v1.IDiceRollResultMessage|null|undefined} diceRollResult
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.diceRollResult = null;

                /**
                 * UniversalMessage connectionEstablished.
                 * @member {mythbound.websocket.v1.IConnectionEstablishedMessage|null|undefined} connectionEstablished
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.connectionEstablished = null;

                /**
                 * UniversalMessage heartbeat.
                 * @member {mythbound.websocket.v1.IHeartbeatMessage|null|undefined} heartbeat
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.heartbeat = null;

                /**
                 * UniversalMessage state.
                 * @member {mythbound.websocket.v1.IStateMessage|null|undefined} state
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.state = null;

                /**
                 * UniversalMessage error.
                 * @member {mythbound.websocket.v1.IErrorMessage|null|undefined} error
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                UniversalMessage.prototype.error = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * UniversalMessage payload.
                 * @member {"voiceJoin"|"voiceLeave"|"voiceData"|"voiceActivity"|"voiceModeChange"|"voiceFeedback"|"campaignCreate"|"campaignUpdate"|"campaignParticipant"|"characterAction"|"characterUpdate"|"chat"|"mmRequest"|"mmResponse"|"mmStatus"|"diceRoll"|"diceRollResult"|"connectionEstablished"|"heartbeat"|"state"|"error"|undefined} payload
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 */
                Object.defineProperty(UniversalMessage.prototype, "payload", {
                    get: $util.oneOfGetter($oneOfFields = ["voiceJoin", "voiceLeave", "voiceData", "voiceActivity", "voiceModeChange", "voiceFeedback", "campaignCreate", "campaignUpdate", "campaignParticipant", "characterAction", "characterUpdate", "chat", "mmRequest", "mmResponse", "mmStatus", "diceRoll", "diceRollResult", "connectionEstablished", "heartbeat", "state", "error"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new UniversalMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @static
                 * @param {mythbound.websocket.v1.IUniversalMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.UniversalMessage} UniversalMessage instance
                 */
                UniversalMessage.create = function create(properties) {
                    return new UniversalMessage(properties);
                };

                /**
                 * Encodes the specified UniversalMessage message. Does not implicitly {@link mythbound.websocket.v1.UniversalMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @static
                 * @param {mythbound.websocket.v1.IUniversalMessage} message UniversalMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UniversalMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.voiceJoin != null && Object.hasOwnProperty.call(message, "voiceJoin"))
                        $root.mythbound.websocket.v1.VoiceJoinMessage.encode(message.voiceJoin, writer.uint32(/* id 10, wireType 2 =*/82).fork(), q + 1).ldelim();
                    if (message.voiceLeave != null && Object.hasOwnProperty.call(message, "voiceLeave"))
                        $root.mythbound.websocket.v1.VoiceLeaveMessage.encode(message.voiceLeave, writer.uint32(/* id 11, wireType 2 =*/90).fork(), q + 1).ldelim();
                    if (message.voiceData != null && Object.hasOwnProperty.call(message, "voiceData"))
                        $root.mythbound.websocket.v1.VoiceDataMessage.encode(message.voiceData, writer.uint32(/* id 12, wireType 2 =*/98).fork(), q + 1).ldelim();
                    if (message.voiceActivity != null && Object.hasOwnProperty.call(message, "voiceActivity"))
                        $root.mythbound.websocket.v1.VoiceActivityMessage.encode(message.voiceActivity, writer.uint32(/* id 13, wireType 2 =*/106).fork(), q + 1).ldelim();
                    if (message.voiceModeChange != null && Object.hasOwnProperty.call(message, "voiceModeChange"))
                        $root.mythbound.websocket.v1.VoiceModeChangeMessage.encode(message.voiceModeChange, writer.uint32(/* id 14, wireType 2 =*/114).fork(), q + 1).ldelim();
                    if (message.voiceFeedback != null && Object.hasOwnProperty.call(message, "voiceFeedback"))
                        $root.mythbound.websocket.v1.VoiceFeedbackMessage.encode(message.voiceFeedback, writer.uint32(/* id 15, wireType 2 =*/122).fork(), q + 1).ldelim();
                    if (message.campaignCreate != null && Object.hasOwnProperty.call(message, "campaignCreate"))
                        $root.mythbound.websocket.v1.CampaignCreateMessage.encode(message.campaignCreate, writer.uint32(/* id 20, wireType 2 =*/162).fork(), q + 1).ldelim();
                    if (message.campaignUpdate != null && Object.hasOwnProperty.call(message, "campaignUpdate"))
                        $root.mythbound.websocket.v1.CampaignUpdateMessage.encode(message.campaignUpdate, writer.uint32(/* id 21, wireType 2 =*/170).fork(), q + 1).ldelim();
                    if (message.campaignParticipant != null && Object.hasOwnProperty.call(message, "campaignParticipant"))
                        $root.mythbound.websocket.v1.CampaignParticipantMessage.encode(message.campaignParticipant, writer.uint32(/* id 22, wireType 2 =*/178).fork(), q + 1).ldelim();
                    if (message.characterAction != null && Object.hasOwnProperty.call(message, "characterAction"))
                        $root.mythbound.websocket.v1.CharacterActionMessage.encode(message.characterAction, writer.uint32(/* id 30, wireType 2 =*/242).fork(), q + 1).ldelim();
                    if (message.characterUpdate != null && Object.hasOwnProperty.call(message, "characterUpdate"))
                        $root.mythbound.websocket.v1.CharacterUpdateMessage.encode(message.characterUpdate, writer.uint32(/* id 31, wireType 2 =*/250).fork(), q + 1).ldelim();
                    if (message.chat != null && Object.hasOwnProperty.call(message, "chat"))
                        $root.mythbound.websocket.v1.ChatMessage.encode(message.chat, writer.uint32(/* id 40, wireType 2 =*/322).fork(), q + 1).ldelim();
                    if (message.mmRequest != null && Object.hasOwnProperty.call(message, "mmRequest"))
                        $root.mythbound.websocket.v1.MythMasterRequestMessage.encode(message.mmRequest, writer.uint32(/* id 50, wireType 2 =*/402).fork(), q + 1).ldelim();
                    if (message.mmResponse != null && Object.hasOwnProperty.call(message, "mmResponse"))
                        $root.mythbound.websocket.v1.MythMasterResponseMessage.encode(message.mmResponse, writer.uint32(/* id 51, wireType 2 =*/410).fork(), q + 1).ldelim();
                    if (message.mmStatus != null && Object.hasOwnProperty.call(message, "mmStatus"))
                        $root.mythbound.websocket.v1.MythMasterStatusMessage.encode(message.mmStatus, writer.uint32(/* id 52, wireType 2 =*/418).fork(), q + 1).ldelim();
                    if (message.diceRoll != null && Object.hasOwnProperty.call(message, "diceRoll"))
                        $root.mythbound.websocket.v1.DiceRollMessage.encode(message.diceRoll, writer.uint32(/* id 60, wireType 2 =*/482).fork(), q + 1).ldelim();
                    if (message.diceRollResult != null && Object.hasOwnProperty.call(message, "diceRollResult"))
                        $root.mythbound.websocket.v1.DiceRollResultMessage.encode(message.diceRollResult, writer.uint32(/* id 61, wireType 2 =*/490).fork(), q + 1).ldelim();
                    if (message.connectionEstablished != null && Object.hasOwnProperty.call(message, "connectionEstablished"))
                        $root.mythbound.websocket.v1.ConnectionEstablishedMessage.encode(message.connectionEstablished, writer.uint32(/* id 70, wireType 2 =*/562).fork(), q + 1).ldelim();
                    if (message.heartbeat != null && Object.hasOwnProperty.call(message, "heartbeat"))
                        $root.mythbound.websocket.v1.HeartbeatMessage.encode(message.heartbeat, writer.uint32(/* id 71, wireType 2 =*/570).fork(), q + 1).ldelim();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        $root.mythbound.websocket.v1.StateMessage.encode(message.state, writer.uint32(/* id 80, wireType 2 =*/642).fork(), q + 1).ldelim();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        $root.mythbound.websocket.v1.ErrorMessage.encode(message.error, writer.uint32(/* id 90, wireType 2 =*/722).fork(), q + 1).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UniversalMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.UniversalMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @static
                 * @param {mythbound.websocket.v1.IUniversalMessage} message UniversalMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UniversalMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes an UniversalMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.UniversalMessage} UniversalMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UniversalMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.UniversalMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 10: {
                                message.voiceJoin = $root.mythbound.websocket.v1.VoiceJoinMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 11: {
                                message.voiceLeave = $root.mythbound.websocket.v1.VoiceLeaveMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 12: {
                                message.voiceData = $root.mythbound.websocket.v1.VoiceDataMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 13: {
                                message.voiceActivity = $root.mythbound.websocket.v1.VoiceActivityMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 14: {
                                message.voiceModeChange = $root.mythbound.websocket.v1.VoiceModeChangeMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 15: {
                                message.voiceFeedback = $root.mythbound.websocket.v1.VoiceFeedbackMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 20: {
                                message.campaignCreate = $root.mythbound.websocket.v1.CampaignCreateMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 21: {
                                message.campaignUpdate = $root.mythbound.websocket.v1.CampaignUpdateMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 22: {
                                message.campaignParticipant = $root.mythbound.websocket.v1.CampaignParticipantMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 30: {
                                message.characterAction = $root.mythbound.websocket.v1.CharacterActionMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 31: {
                                message.characterUpdate = $root.mythbound.websocket.v1.CharacterUpdateMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 40: {
                                message.chat = $root.mythbound.websocket.v1.ChatMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 50: {
                                message.mmRequest = $root.mythbound.websocket.v1.MythMasterRequestMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 51: {
                                message.mmResponse = $root.mythbound.websocket.v1.MythMasterResponseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 52: {
                                message.mmStatus = $root.mythbound.websocket.v1.MythMasterStatusMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 60: {
                                message.diceRoll = $root.mythbound.websocket.v1.DiceRollMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 61: {
                                message.diceRollResult = $root.mythbound.websocket.v1.DiceRollResultMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 70: {
                                message.connectionEstablished = $root.mythbound.websocket.v1.ConnectionEstablishedMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 71: {
                                message.heartbeat = $root.mythbound.websocket.v1.HeartbeatMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 80: {
                                message.state = $root.mythbound.websocket.v1.StateMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 90: {
                                message.error = $root.mythbound.websocket.v1.ErrorMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes an UniversalMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.UniversalMessage} UniversalMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UniversalMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UniversalMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UniversalMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    let properties = {};
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.voiceJoin != null && Object.hasOwnProperty.call(message, "voiceJoin")) {
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.VoiceJoinMessage.verify(message.voiceJoin, long + 1);
                            if (error)
                                return "voiceJoin." + error;
                        }
                    }
                    if (message.voiceLeave != null && Object.hasOwnProperty.call(message, "voiceLeave")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.VoiceLeaveMessage.verify(message.voiceLeave, long + 1);
                            if (error)
                                return "voiceLeave." + error;
                        }
                    }
                    if (message.voiceData != null && Object.hasOwnProperty.call(message, "voiceData")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.VoiceDataMessage.verify(message.voiceData, long + 1);
                            if (error)
                                return "voiceData." + error;
                        }
                    }
                    if (message.voiceActivity != null && Object.hasOwnProperty.call(message, "voiceActivity")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.VoiceActivityMessage.verify(message.voiceActivity, long + 1);
                            if (error)
                                return "voiceActivity." + error;
                        }
                    }
                    if (message.voiceModeChange != null && Object.hasOwnProperty.call(message, "voiceModeChange")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.VoiceModeChangeMessage.verify(message.voiceModeChange, long + 1);
                            if (error)
                                return "voiceModeChange." + error;
                        }
                    }
                    if (message.voiceFeedback != null && Object.hasOwnProperty.call(message, "voiceFeedback")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.VoiceFeedbackMessage.verify(message.voiceFeedback, long + 1);
                            if (error)
                                return "voiceFeedback." + error;
                        }
                    }
                    if (message.campaignCreate != null && Object.hasOwnProperty.call(message, "campaignCreate")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.CampaignCreateMessage.verify(message.campaignCreate, long + 1);
                            if (error)
                                return "campaignCreate." + error;
                        }
                    }
                    if (message.campaignUpdate != null && Object.hasOwnProperty.call(message, "campaignUpdate")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.CampaignUpdateMessage.verify(message.campaignUpdate, long + 1);
                            if (error)
                                return "campaignUpdate." + error;
                        }
                    }
                    if (message.campaignParticipant != null && Object.hasOwnProperty.call(message, "campaignParticipant")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.CampaignParticipantMessage.verify(message.campaignParticipant, long + 1);
                            if (error)
                                return "campaignParticipant." + error;
                        }
                    }
                    if (message.characterAction != null && Object.hasOwnProperty.call(message, "characterAction")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.CharacterActionMessage.verify(message.characterAction, long + 1);
                            if (error)
                                return "characterAction." + error;
                        }
                    }
                    if (message.characterUpdate != null && Object.hasOwnProperty.call(message, "characterUpdate")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.CharacterUpdateMessage.verify(message.characterUpdate, long + 1);
                            if (error)
                                return "characterUpdate." + error;
                        }
                    }
                    if (message.chat != null && Object.hasOwnProperty.call(message, "chat")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.ChatMessage.verify(message.chat, long + 1);
                            if (error)
                                return "chat." + error;
                        }
                    }
                    if (message.mmRequest != null && Object.hasOwnProperty.call(message, "mmRequest")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.MythMasterRequestMessage.verify(message.mmRequest, long + 1);
                            if (error)
                                return "mmRequest." + error;
                        }
                    }
                    if (message.mmResponse != null && Object.hasOwnProperty.call(message, "mmResponse")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.MythMasterResponseMessage.verify(message.mmResponse, long + 1);
                            if (error)
                                return "mmResponse." + error;
                        }
                    }
                    if (message.mmStatus != null && Object.hasOwnProperty.call(message, "mmStatus")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.MythMasterStatusMessage.verify(message.mmStatus, long + 1);
                            if (error)
                                return "mmStatus." + error;
                        }
                    }
                    if (message.diceRoll != null && Object.hasOwnProperty.call(message, "diceRoll")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.DiceRollMessage.verify(message.diceRoll, long + 1);
                            if (error)
                                return "diceRoll." + error;
                        }
                    }
                    if (message.diceRollResult != null && Object.hasOwnProperty.call(message, "diceRollResult")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.DiceRollResultMessage.verify(message.diceRollResult, long + 1);
                            if (error)
                                return "diceRollResult." + error;
                        }
                    }
                    if (message.connectionEstablished != null && Object.hasOwnProperty.call(message, "connectionEstablished")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.ConnectionEstablishedMessage.verify(message.connectionEstablished, long + 1);
                            if (error)
                                return "connectionEstablished." + error;
                        }
                    }
                    if (message.heartbeat != null && Object.hasOwnProperty.call(message, "heartbeat")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.HeartbeatMessage.verify(message.heartbeat, long + 1);
                            if (error)
                                return "heartbeat." + error;
                        }
                    }
                    if (message.state != null && Object.hasOwnProperty.call(message, "state")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.StateMessage.verify(message.state, long + 1);
                            if (error)
                                return "state." + error;
                        }
                    }
                    if (message.error != null && Object.hasOwnProperty.call(message, "error")) {
                        if (properties.payload === 1)
                            return "payload: multiple values";
                        properties.payload = 1;
                        {
                            let error = $root.mythbound.websocket.v1.ErrorMessage.verify(message.error, long + 1);
                            if (error)
                                return "error." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an UniversalMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.UniversalMessage} UniversalMessage
                 */
                UniversalMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.UniversalMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.UniversalMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.UniversalMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.voiceJoin != null) {
                        if (!$util.isObject(object.voiceJoin))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.voiceJoin: object expected");
                        message.voiceJoin = $root.mythbound.websocket.v1.VoiceJoinMessage.fromObject(object.voiceJoin, long + 1);
                    }
                    if (object.voiceLeave != null) {
                        if (!$util.isObject(object.voiceLeave))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.voiceLeave: object expected");
                        message.voiceLeave = $root.mythbound.websocket.v1.VoiceLeaveMessage.fromObject(object.voiceLeave, long + 1);
                    }
                    if (object.voiceData != null) {
                        if (!$util.isObject(object.voiceData))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.voiceData: object expected");
                        message.voiceData = $root.mythbound.websocket.v1.VoiceDataMessage.fromObject(object.voiceData, long + 1);
                    }
                    if (object.voiceActivity != null) {
                        if (!$util.isObject(object.voiceActivity))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.voiceActivity: object expected");
                        message.voiceActivity = $root.mythbound.websocket.v1.VoiceActivityMessage.fromObject(object.voiceActivity, long + 1);
                    }
                    if (object.voiceModeChange != null) {
                        if (!$util.isObject(object.voiceModeChange))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.voiceModeChange: object expected");
                        message.voiceModeChange = $root.mythbound.websocket.v1.VoiceModeChangeMessage.fromObject(object.voiceModeChange, long + 1);
                    }
                    if (object.voiceFeedback != null) {
                        if (!$util.isObject(object.voiceFeedback))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.voiceFeedback: object expected");
                        message.voiceFeedback = $root.mythbound.websocket.v1.VoiceFeedbackMessage.fromObject(object.voiceFeedback, long + 1);
                    }
                    if (object.campaignCreate != null) {
                        if (!$util.isObject(object.campaignCreate))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.campaignCreate: object expected");
                        message.campaignCreate = $root.mythbound.websocket.v1.CampaignCreateMessage.fromObject(object.campaignCreate, long + 1);
                    }
                    if (object.campaignUpdate != null) {
                        if (!$util.isObject(object.campaignUpdate))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.campaignUpdate: object expected");
                        message.campaignUpdate = $root.mythbound.websocket.v1.CampaignUpdateMessage.fromObject(object.campaignUpdate, long + 1);
                    }
                    if (object.campaignParticipant != null) {
                        if (!$util.isObject(object.campaignParticipant))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.campaignParticipant: object expected");
                        message.campaignParticipant = $root.mythbound.websocket.v1.CampaignParticipantMessage.fromObject(object.campaignParticipant, long + 1);
                    }
                    if (object.characterAction != null) {
                        if (!$util.isObject(object.characterAction))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.characterAction: object expected");
                        message.characterAction = $root.mythbound.websocket.v1.CharacterActionMessage.fromObject(object.characterAction, long + 1);
                    }
                    if (object.characterUpdate != null) {
                        if (!$util.isObject(object.characterUpdate))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.characterUpdate: object expected");
                        message.characterUpdate = $root.mythbound.websocket.v1.CharacterUpdateMessage.fromObject(object.characterUpdate, long + 1);
                    }
                    if (object.chat != null) {
                        if (!$util.isObject(object.chat))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.chat: object expected");
                        message.chat = $root.mythbound.websocket.v1.ChatMessage.fromObject(object.chat, long + 1);
                    }
                    if (object.mmRequest != null) {
                        if (!$util.isObject(object.mmRequest))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.mmRequest: object expected");
                        message.mmRequest = $root.mythbound.websocket.v1.MythMasterRequestMessage.fromObject(object.mmRequest, long + 1);
                    }
                    if (object.mmResponse != null) {
                        if (!$util.isObject(object.mmResponse))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.mmResponse: object expected");
                        message.mmResponse = $root.mythbound.websocket.v1.MythMasterResponseMessage.fromObject(object.mmResponse, long + 1);
                    }
                    if (object.mmStatus != null) {
                        if (!$util.isObject(object.mmStatus))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.mmStatus: object expected");
                        message.mmStatus = $root.mythbound.websocket.v1.MythMasterStatusMessage.fromObject(object.mmStatus, long + 1);
                    }
                    if (object.diceRoll != null) {
                        if (!$util.isObject(object.diceRoll))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.diceRoll: object expected");
                        message.diceRoll = $root.mythbound.websocket.v1.DiceRollMessage.fromObject(object.diceRoll, long + 1);
                    }
                    if (object.diceRollResult != null) {
                        if (!$util.isObject(object.diceRollResult))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.diceRollResult: object expected");
                        message.diceRollResult = $root.mythbound.websocket.v1.DiceRollResultMessage.fromObject(object.diceRollResult, long + 1);
                    }
                    if (object.connectionEstablished != null) {
                        if (!$util.isObject(object.connectionEstablished))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.connectionEstablished: object expected");
                        message.connectionEstablished = $root.mythbound.websocket.v1.ConnectionEstablishedMessage.fromObject(object.connectionEstablished, long + 1);
                    }
                    if (object.heartbeat != null) {
                        if (!$util.isObject(object.heartbeat))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.heartbeat: object expected");
                        message.heartbeat = $root.mythbound.websocket.v1.HeartbeatMessage.fromObject(object.heartbeat, long + 1);
                    }
                    if (object.state != null) {
                        if (!$util.isObject(object.state))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.state: object expected");
                        message.state = $root.mythbound.websocket.v1.StateMessage.fromObject(object.state, long + 1);
                    }
                    if (object.error != null) {
                        if (!$util.isObject(object.error))
                            throw TypeError(".mythbound.websocket.v1.UniversalMessage.error: object expected");
                        message.error = $root.mythbound.websocket.v1.ErrorMessage.fromObject(object.error, long + 1);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UniversalMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @static
                 * @param {mythbound.websocket.v1.UniversalMessage} message UniversalMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UniversalMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults)
                        object.base = null;
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.voiceJoin != null && Object.hasOwnProperty.call(message, "voiceJoin")) {
                        object.voiceJoin = $root.mythbound.websocket.v1.VoiceJoinMessage.toObject(message.voiceJoin, options, q + 1);
                        if (options.oneofs)
                            object.payload = "voiceJoin";
                    }
                    if (message.voiceLeave != null && Object.hasOwnProperty.call(message, "voiceLeave")) {
                        object.voiceLeave = $root.mythbound.websocket.v1.VoiceLeaveMessage.toObject(message.voiceLeave, options, q + 1);
                        if (options.oneofs)
                            object.payload = "voiceLeave";
                    }
                    if (message.voiceData != null && Object.hasOwnProperty.call(message, "voiceData")) {
                        object.voiceData = $root.mythbound.websocket.v1.VoiceDataMessage.toObject(message.voiceData, options, q + 1);
                        if (options.oneofs)
                            object.payload = "voiceData";
                    }
                    if (message.voiceActivity != null && Object.hasOwnProperty.call(message, "voiceActivity")) {
                        object.voiceActivity = $root.mythbound.websocket.v1.VoiceActivityMessage.toObject(message.voiceActivity, options, q + 1);
                        if (options.oneofs)
                            object.payload = "voiceActivity";
                    }
                    if (message.voiceModeChange != null && Object.hasOwnProperty.call(message, "voiceModeChange")) {
                        object.voiceModeChange = $root.mythbound.websocket.v1.VoiceModeChangeMessage.toObject(message.voiceModeChange, options, q + 1);
                        if (options.oneofs)
                            object.payload = "voiceModeChange";
                    }
                    if (message.voiceFeedback != null && Object.hasOwnProperty.call(message, "voiceFeedback")) {
                        object.voiceFeedback = $root.mythbound.websocket.v1.VoiceFeedbackMessage.toObject(message.voiceFeedback, options, q + 1);
                        if (options.oneofs)
                            object.payload = "voiceFeedback";
                    }
                    if (message.campaignCreate != null && Object.hasOwnProperty.call(message, "campaignCreate")) {
                        object.campaignCreate = $root.mythbound.websocket.v1.CampaignCreateMessage.toObject(message.campaignCreate, options, q + 1);
                        if (options.oneofs)
                            object.payload = "campaignCreate";
                    }
                    if (message.campaignUpdate != null && Object.hasOwnProperty.call(message, "campaignUpdate")) {
                        object.campaignUpdate = $root.mythbound.websocket.v1.CampaignUpdateMessage.toObject(message.campaignUpdate, options, q + 1);
                        if (options.oneofs)
                            object.payload = "campaignUpdate";
                    }
                    if (message.campaignParticipant != null && Object.hasOwnProperty.call(message, "campaignParticipant")) {
                        object.campaignParticipant = $root.mythbound.websocket.v1.CampaignParticipantMessage.toObject(message.campaignParticipant, options, q + 1);
                        if (options.oneofs)
                            object.payload = "campaignParticipant";
                    }
                    if (message.characterAction != null && Object.hasOwnProperty.call(message, "characterAction")) {
                        object.characterAction = $root.mythbound.websocket.v1.CharacterActionMessage.toObject(message.characterAction, options, q + 1);
                        if (options.oneofs)
                            object.payload = "characterAction";
                    }
                    if (message.characterUpdate != null && Object.hasOwnProperty.call(message, "characterUpdate")) {
                        object.characterUpdate = $root.mythbound.websocket.v1.CharacterUpdateMessage.toObject(message.characterUpdate, options, q + 1);
                        if (options.oneofs)
                            object.payload = "characterUpdate";
                    }
                    if (message.chat != null && Object.hasOwnProperty.call(message, "chat")) {
                        object.chat = $root.mythbound.websocket.v1.ChatMessage.toObject(message.chat, options, q + 1);
                        if (options.oneofs)
                            object.payload = "chat";
                    }
                    if (message.mmRequest != null && Object.hasOwnProperty.call(message, "mmRequest")) {
                        object.mmRequest = $root.mythbound.websocket.v1.MythMasterRequestMessage.toObject(message.mmRequest, options, q + 1);
                        if (options.oneofs)
                            object.payload = "mmRequest";
                    }
                    if (message.mmResponse != null && Object.hasOwnProperty.call(message, "mmResponse")) {
                        object.mmResponse = $root.mythbound.websocket.v1.MythMasterResponseMessage.toObject(message.mmResponse, options, q + 1);
                        if (options.oneofs)
                            object.payload = "mmResponse";
                    }
                    if (message.mmStatus != null && Object.hasOwnProperty.call(message, "mmStatus")) {
                        object.mmStatus = $root.mythbound.websocket.v1.MythMasterStatusMessage.toObject(message.mmStatus, options, q + 1);
                        if (options.oneofs)
                            object.payload = "mmStatus";
                    }
                    if (message.diceRoll != null && Object.hasOwnProperty.call(message, "diceRoll")) {
                        object.diceRoll = $root.mythbound.websocket.v1.DiceRollMessage.toObject(message.diceRoll, options, q + 1);
                        if (options.oneofs)
                            object.payload = "diceRoll";
                    }
                    if (message.diceRollResult != null && Object.hasOwnProperty.call(message, "diceRollResult")) {
                        object.diceRollResult = $root.mythbound.websocket.v1.DiceRollResultMessage.toObject(message.diceRollResult, options, q + 1);
                        if (options.oneofs)
                            object.payload = "diceRollResult";
                    }
                    if (message.connectionEstablished != null && Object.hasOwnProperty.call(message, "connectionEstablished")) {
                        object.connectionEstablished = $root.mythbound.websocket.v1.ConnectionEstablishedMessage.toObject(message.connectionEstablished, options, q + 1);
                        if (options.oneofs)
                            object.payload = "connectionEstablished";
                    }
                    if (message.heartbeat != null && Object.hasOwnProperty.call(message, "heartbeat")) {
                        object.heartbeat = $root.mythbound.websocket.v1.HeartbeatMessage.toObject(message.heartbeat, options, q + 1);
                        if (options.oneofs)
                            object.payload = "heartbeat";
                    }
                    if (message.state != null && Object.hasOwnProperty.call(message, "state")) {
                        object.state = $root.mythbound.websocket.v1.StateMessage.toObject(message.state, options, q + 1);
                        if (options.oneofs)
                            object.payload = "state";
                    }
                    if (message.error != null && Object.hasOwnProperty.call(message, "error")) {
                        object.error = $root.mythbound.websocket.v1.ErrorMessage.toObject(message.error, options, q + 1);
                        if (options.oneofs)
                            object.payload = "error";
                    }
                    return object;
                };

                /**
                 * Converts this UniversalMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UniversalMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for UniversalMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.UniversalMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                UniversalMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.UniversalMessage";
                };

                return UniversalMessage;
            })();

            v1.SubscriptionFilter = (function() {

                /**
                 * Properties of a SubscriptionFilter.
                 * @memberof mythbound.websocket.v1
                 * @interface ISubscriptionFilter
                 * @property {Array.<mythbound.websocket.v1.MessageCategory>|null} [categories] SubscriptionFilter categories
                 * @property {Array.<string>|null} [messageTypes] SubscriptionFilter messageTypes
                 * @property {string|null} [campaignId] SubscriptionFilter campaignId
                 * @property {string|null} [userId] SubscriptionFilter userId
                 * @property {mythbound.websocket.v1.MessagePriority|null} [minPriority] SubscriptionFilter minPriority
                 */

                /**
                 * Constructs a new SubscriptionFilter.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a SubscriptionFilter.
                 * @implements ISubscriptionFilter
                 * @constructor
                 * @param {mythbound.websocket.v1.ISubscriptionFilter=} [properties] Properties to set
                 */
                function SubscriptionFilter(properties) {
                    this.categories = [];
                    this.messageTypes = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubscriptionFilter categories.
                 * @member {Array.<mythbound.websocket.v1.MessageCategory>} categories
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @instance
                 */
                SubscriptionFilter.prototype.categories = $util.emptyArray;

                /**
                 * SubscriptionFilter messageTypes.
                 * @member {Array.<string>} messageTypes
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @instance
                 */
                SubscriptionFilter.prototype.messageTypes = $util.emptyArray;

                /**
                 * SubscriptionFilter campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @instance
                 */
                SubscriptionFilter.prototype.campaignId = "";

                /**
                 * SubscriptionFilter userId.
                 * @member {string} userId
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @instance
                 */
                SubscriptionFilter.prototype.userId = "";

                /**
                 * SubscriptionFilter minPriority.
                 * @member {mythbound.websocket.v1.MessagePriority} minPriority
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @instance
                 */
                SubscriptionFilter.prototype.minPriority = 0;

                /**
                 * Creates a new SubscriptionFilter instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @static
                 * @param {mythbound.websocket.v1.ISubscriptionFilter=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.SubscriptionFilter} SubscriptionFilter instance
                 */
                SubscriptionFilter.create = function create(properties) {
                    return new SubscriptionFilter(properties);
                };

                /**
                 * Encodes the specified SubscriptionFilter message. Does not implicitly {@link mythbound.websocket.v1.SubscriptionFilter.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @static
                 * @param {mythbound.websocket.v1.ISubscriptionFilter} message SubscriptionFilter message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionFilter.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.categories != null && message.categories.length) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork();
                        for (let i = 0; i < message.categories.length; ++i)
                            writer.int32(message.categories[i]);
                        writer.ldelim();
                    }
                    if (message.messageTypes != null && message.messageTypes.length)
                        for (let i = 0; i < message.messageTypes.length; ++i)
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageTypes[i]);
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.campaignId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.userId);
                    if (message.minPriority != null && Object.hasOwnProperty.call(message, "minPriority"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.minPriority);
                    return writer;
                };

                /**
                 * Encodes the specified SubscriptionFilter message, length delimited. Does not implicitly {@link mythbound.websocket.v1.SubscriptionFilter.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @static
                 * @param {mythbound.websocket.v1.ISubscriptionFilter} message SubscriptionFilter message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionFilter.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a SubscriptionFilter message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.SubscriptionFilter} SubscriptionFilter
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionFilter.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.SubscriptionFilter();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.categories && message.categories.length))
                                    message.categories = [];
                                if ((tag & 7) === 2) {
                                    let end2 = reader.uint32() + reader.pos;
                                    if (end2 > reader.len)
                                        throw RangeError("index out of range");
                                    reader.len = end2;
                                    while (reader.pos < end2)
                                        message.categories.push(reader.int32());
                                    if (reader.pos !== end2)
                                        throw RangeError("index out of range");
                                    reader.len = end;
                                } else
                                    message.categories.push(reader.int32());
                                break;
                            }
                        case 2: {
                                if (!(message.messageTypes && message.messageTypes.length))
                                    message.messageTypes = [];
                                message.messageTypes.push(reader.string());
                                break;
                            }
                        case 3: {
                                message.campaignId = reader.string();
                                break;
                            }
                        case 4: {
                                message.userId = reader.string();
                                break;
                            }
                        case 5: {
                                message.minPriority = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a SubscriptionFilter message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.SubscriptionFilter} SubscriptionFilter
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionFilter.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubscriptionFilter message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubscriptionFilter.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.categories != null && Object.hasOwnProperty.call(message, "categories")) {
                        if (!Array.isArray(message.categories))
                            return "categories: array expected";
                        for (let i = 0; i < message.categories.length; ++i)
                            switch (message.categories[i]) {
                            default:
                                return "categories: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                                break;
                            }
                    }
                    if (message.messageTypes != null && Object.hasOwnProperty.call(message, "messageTypes")) {
                        if (!Array.isArray(message.messageTypes))
                            return "messageTypes: array expected";
                        for (let i = 0; i < message.messageTypes.length; ++i)
                            if (!$util.isString(message.messageTypes[i]))
                                return "messageTypes: string[] expected";
                    }
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.minPriority != null && Object.hasOwnProperty.call(message, "minPriority"))
                        switch (message.minPriority) {
                        default:
                            return "minPriority: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a SubscriptionFilter message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.SubscriptionFilter} SubscriptionFilter
                 */
                SubscriptionFilter.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.SubscriptionFilter)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.SubscriptionFilter: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.SubscriptionFilter();
                    if (object.categories) {
                        if (!Array.isArray(object.categories))
                            throw TypeError(".mythbound.websocket.v1.SubscriptionFilter.categories: array expected");
                        message.categories = [];
                        for (let i = 0; i < object.categories.length; ++i)
                            switch (object.categories[i]) {
                            default:
                                if (typeof object.categories[i] === "number") {
                                    message.categories[i] = object.categories[i];
                                    break;
                                }
                            case "MESSAGE_CATEGORY_UNSPECIFIED":
                            case 0:
                                message.categories[i] = 0;
                                break;
                            case "MESSAGE_CATEGORY_VOICE":
                            case 1:
                                message.categories[i] = 1;
                                break;
                            case "MESSAGE_CATEGORY_CAMPAIGN":
                            case 2:
                                message.categories[i] = 2;
                                break;
                            case "MESSAGE_CATEGORY_CHARACTER":
                            case 3:
                                message.categories[i] = 3;
                                break;
                            case "MESSAGE_CATEGORY_CHAT":
                            case 4:
                                message.categories[i] = 4;
                                break;
                            case "MESSAGE_CATEGORY_SYSTEM":
                            case 5:
                                message.categories[i] = 5;
                                break;
                            case "MESSAGE_CATEGORY_AI_MYTHMASTER":
                            case 6:
                                message.categories[i] = 6;
                                break;
                            case "MESSAGE_CATEGORY_DICE":
                            case 7:
                                message.categories[i] = 7;
                                break;
                            case "MESSAGE_CATEGORY_ERROR":
                            case 8:
                                message.categories[i] = 8;
                                break;
                            }
                    }
                    if (object.messageTypes) {
                        if (!Array.isArray(object.messageTypes))
                            throw TypeError(".mythbound.websocket.v1.SubscriptionFilter.messageTypes: array expected");
                        message.messageTypes = [];
                        for (let i = 0; i < object.messageTypes.length; ++i)
                            message.messageTypes[i] = String(object.messageTypes[i]);
                    }
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    switch (object.minPriority) {
                    default:
                        if (typeof object.minPriority === "number") {
                            message.minPriority = object.minPriority;
                            break;
                        }
                        break;
                    case "MESSAGE_PRIORITY_UNSPECIFIED":
                    case 0:
                        message.minPriority = 0;
                        break;
                    case "MESSAGE_PRIORITY_LOW":
                    case 1:
                        message.minPriority = 1;
                        break;
                    case "MESSAGE_PRIORITY_NORMAL":
                    case 2:
                        message.minPriority = 2;
                        break;
                    case "MESSAGE_PRIORITY_HIGH":
                    case 3:
                        message.minPriority = 3;
                        break;
                    case "MESSAGE_PRIORITY_CRITICAL":
                    case 4:
                        message.minPriority = 4;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SubscriptionFilter message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @static
                 * @param {mythbound.websocket.v1.SubscriptionFilter} message SubscriptionFilter
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubscriptionFilter.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults) {
                        object.categories = [];
                        object.messageTypes = [];
                    }
                    if (options.defaults) {
                        object.campaignId = "";
                        object.userId = "";
                        object.minPriority = options.enums === String ? "MESSAGE_PRIORITY_UNSPECIFIED" : 0;
                    }
                    if (message.categories && message.categories.length) {
                        object.categories = [];
                        for (let j = 0; j < message.categories.length; ++j)
                            object.categories[j] = options.enums === String ? $root.mythbound.websocket.v1.MessageCategory[message.categories[j]] === undefined ? message.categories[j] : $root.mythbound.websocket.v1.MessageCategory[message.categories[j]] : message.categories[j];
                    }
                    if (message.messageTypes && message.messageTypes.length) {
                        object.messageTypes = [];
                        for (let j = 0; j < message.messageTypes.length; ++j)
                            object.messageTypes[j] = message.messageTypes[j];
                    }
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        object.userId = message.userId;
                    if (message.minPriority != null && Object.hasOwnProperty.call(message, "minPriority"))
                        object.minPriority = options.enums === String ? $root.mythbound.websocket.v1.MessagePriority[message.minPriority] === undefined ? message.minPriority : $root.mythbound.websocket.v1.MessagePriority[message.minPriority] : message.minPriority;
                    return object;
                };

                /**
                 * Converts this SubscriptionFilter to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubscriptionFilter.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SubscriptionFilter
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.SubscriptionFilter
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SubscriptionFilter.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.SubscriptionFilter";
                };

                return SubscriptionFilter;
            })();

            v1.SubscriptionRequestMessage = (function() {

                /**
                 * Properties of a SubscriptionRequestMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface ISubscriptionRequestMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] SubscriptionRequestMessage base
                 * @property {mythbound.websocket.v1.ISubscriptionFilter|null} [filter] SubscriptionRequestMessage filter
                 * @property {string|null} [subscriptionId] SubscriptionRequestMessage subscriptionId
                 */

                /**
                 * Constructs a new SubscriptionRequestMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a SubscriptionRequestMessage.
                 * @implements ISubscriptionRequestMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.ISubscriptionRequestMessage=} [properties] Properties to set
                 */
                function SubscriptionRequestMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubscriptionRequestMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @instance
                 */
                SubscriptionRequestMessage.prototype.base = null;

                /**
                 * SubscriptionRequestMessage filter.
                 * @member {mythbound.websocket.v1.ISubscriptionFilter|null|undefined} filter
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @instance
                 */
                SubscriptionRequestMessage.prototype.filter = null;

                /**
                 * SubscriptionRequestMessage subscriptionId.
                 * @member {string} subscriptionId
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @instance
                 */
                SubscriptionRequestMessage.prototype.subscriptionId = "";

                /**
                 * Creates a new SubscriptionRequestMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @static
                 * @param {mythbound.websocket.v1.ISubscriptionRequestMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.SubscriptionRequestMessage} SubscriptionRequestMessage instance
                 */
                SubscriptionRequestMessage.create = function create(properties) {
                    return new SubscriptionRequestMessage(properties);
                };

                /**
                 * Encodes the specified SubscriptionRequestMessage message. Does not implicitly {@link mythbound.websocket.v1.SubscriptionRequestMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @static
                 * @param {mythbound.websocket.v1.ISubscriptionRequestMessage} message SubscriptionRequestMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionRequestMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                        $root.mythbound.websocket.v1.SubscriptionFilter.encode(message.filter, writer.uint32(/* id 2, wireType 2 =*/18).fork(), q + 1).ldelim();
                    if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.subscriptionId);
                    return writer;
                };

                /**
                 * Encodes the specified SubscriptionRequestMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.SubscriptionRequestMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @static
                 * @param {mythbound.websocket.v1.ISubscriptionRequestMessage} message SubscriptionRequestMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionRequestMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a SubscriptionRequestMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.SubscriptionRequestMessage} SubscriptionRequestMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionRequestMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.SubscriptionRequestMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.filter = $root.mythbound.websocket.v1.SubscriptionFilter.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 3: {
                                message.subscriptionId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a SubscriptionRequestMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.SubscriptionRequestMessage} SubscriptionRequestMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionRequestMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubscriptionRequestMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubscriptionRequestMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.filter != null && Object.hasOwnProperty.call(message, "filter")) {
                        let error = $root.mythbound.websocket.v1.SubscriptionFilter.verify(message.filter, long + 1);
                        if (error)
                            return "filter." + error;
                    }
                    if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
                        if (!$util.isString(message.subscriptionId))
                            return "subscriptionId: string expected";
                    return null;
                };

                /**
                 * Creates a SubscriptionRequestMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.SubscriptionRequestMessage} SubscriptionRequestMessage
                 */
                SubscriptionRequestMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.SubscriptionRequestMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.SubscriptionRequestMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.SubscriptionRequestMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.SubscriptionRequestMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.filter != null) {
                        if (!$util.isObject(object.filter))
                            throw TypeError(".mythbound.websocket.v1.SubscriptionRequestMessage.filter: object expected");
                        message.filter = $root.mythbound.websocket.v1.SubscriptionFilter.fromObject(object.filter, long + 1);
                    }
                    if (object.subscriptionId != null)
                        message.subscriptionId = String(object.subscriptionId);
                    return message;
                };

                /**
                 * Creates a plain object from a SubscriptionRequestMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @static
                 * @param {mythbound.websocket.v1.SubscriptionRequestMessage} message SubscriptionRequestMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubscriptionRequestMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.filter = null;
                        object.subscriptionId = "";
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                        object.filter = $root.mythbound.websocket.v1.SubscriptionFilter.toObject(message.filter, options, q + 1);
                    if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
                        object.subscriptionId = message.subscriptionId;
                    return object;
                };

                /**
                 * Converts this SubscriptionRequestMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubscriptionRequestMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SubscriptionRequestMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.SubscriptionRequestMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SubscriptionRequestMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.SubscriptionRequestMessage";
                };

                return SubscriptionRequestMessage;
            })();

            v1.SubscriptionAckMessage = (function() {

                /**
                 * Properties of a SubscriptionAckMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface ISubscriptionAckMessage
                 * @property {mythbound.websocket.v1.IBaseMessage|null} [base] SubscriptionAckMessage base
                 * @property {string|null} [subscriptionId] SubscriptionAckMessage subscriptionId
                 * @property {boolean|null} [success] SubscriptionAckMessage success
                 * @property {string|null} [errorMessage] SubscriptionAckMessage errorMessage
                 */

                /**
                 * Constructs a new SubscriptionAckMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a SubscriptionAckMessage.
                 * @implements ISubscriptionAckMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.ISubscriptionAckMessage=} [properties] Properties to set
                 */
                function SubscriptionAckMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubscriptionAckMessage base.
                 * @member {mythbound.websocket.v1.IBaseMessage|null|undefined} base
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @instance
                 */
                SubscriptionAckMessage.prototype.base = null;

                /**
                 * SubscriptionAckMessage subscriptionId.
                 * @member {string} subscriptionId
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @instance
                 */
                SubscriptionAckMessage.prototype.subscriptionId = "";

                /**
                 * SubscriptionAckMessage success.
                 * @member {boolean} success
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @instance
                 */
                SubscriptionAckMessage.prototype.success = false;

                /**
                 * SubscriptionAckMessage errorMessage.
                 * @member {string} errorMessage
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @instance
                 */
                SubscriptionAckMessage.prototype.errorMessage = "";

                /**
                 * Creates a new SubscriptionAckMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @static
                 * @param {mythbound.websocket.v1.ISubscriptionAckMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.SubscriptionAckMessage} SubscriptionAckMessage instance
                 */
                SubscriptionAckMessage.create = function create(properties) {
                    return new SubscriptionAckMessage(properties);
                };

                /**
                 * Encodes the specified SubscriptionAckMessage message. Does not implicitly {@link mythbound.websocket.v1.SubscriptionAckMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @static
                 * @param {mythbound.websocket.v1.ISubscriptionAckMessage} message SubscriptionAckMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionAckMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        $root.mythbound.websocket.v1.BaseMessage.encode(message.base, writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.subscriptionId);
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.success);
                    if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.errorMessage);
                    return writer;
                };

                /**
                 * Encodes the specified SubscriptionAckMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.SubscriptionAckMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @static
                 * @param {mythbound.websocket.v1.ISubscriptionAckMessage} message SubscriptionAckMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionAckMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a SubscriptionAckMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.SubscriptionAckMessage} SubscriptionAckMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionAckMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.SubscriptionAckMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.base = $root.mythbound.websocket.v1.BaseMessage.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 2: {
                                message.subscriptionId = reader.string();
                                break;
                            }
                        case 3: {
                                message.success = reader.bool();
                                break;
                            }
                        case 4: {
                                message.errorMessage = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a SubscriptionAckMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.SubscriptionAckMessage} SubscriptionAckMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionAckMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubscriptionAckMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubscriptionAckMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.base != null && Object.hasOwnProperty.call(message, "base")) {
                        let error = $root.mythbound.websocket.v1.BaseMessage.verify(message.base, long + 1);
                        if (error)
                            return "base." + error;
                    }
                    if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
                        if (!$util.isString(message.subscriptionId))
                            return "subscriptionId: string expected";
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        if (typeof message.success !== "boolean")
                            return "success: boolean expected";
                    if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                        if (!$util.isString(message.errorMessage))
                            return "errorMessage: string expected";
                    return null;
                };

                /**
                 * Creates a SubscriptionAckMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.SubscriptionAckMessage} SubscriptionAckMessage
                 */
                SubscriptionAckMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.SubscriptionAckMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.SubscriptionAckMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.SubscriptionAckMessage();
                    if (object.base != null) {
                        if (!$util.isObject(object.base))
                            throw TypeError(".mythbound.websocket.v1.SubscriptionAckMessage.base: object expected");
                        message.base = $root.mythbound.websocket.v1.BaseMessage.fromObject(object.base, long + 1);
                    }
                    if (object.subscriptionId != null)
                        message.subscriptionId = String(object.subscriptionId);
                    if (object.success != null)
                        message.success = Boolean(object.success);
                    if (object.errorMessage != null)
                        message.errorMessage = String(object.errorMessage);
                    return message;
                };

                /**
                 * Creates a plain object from a SubscriptionAckMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @static
                 * @param {mythbound.websocket.v1.SubscriptionAckMessage} message SubscriptionAckMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubscriptionAckMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.base = null;
                        object.subscriptionId = "";
                        object.success = false;
                        object.errorMessage = "";
                    }
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        object.base = $root.mythbound.websocket.v1.BaseMessage.toObject(message.base, options, q + 1);
                    if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
                        object.subscriptionId = message.subscriptionId;
                    if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                        object.success = message.success;
                    if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                        object.errorMessage = message.errorMessage;
                    return object;
                };

                /**
                 * Converts this SubscriptionAckMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubscriptionAckMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SubscriptionAckMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.SubscriptionAckMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SubscriptionAckMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.SubscriptionAckMessage";
                };

                return SubscriptionAckMessage;
            })();

            v1.HLCTimestamp = (function() {

                /**
                 * Properties of a HLCTimestamp.
                 * @memberof mythbound.websocket.v1
                 * @interface IHLCTimestamp
                 * @property {number|Long|null} [physicalTime] HLCTimestamp physicalTime
                 * @property {number|null} [logicalCounter] HLCTimestamp logicalCounter
                 * @property {string|null} [nodeId] HLCTimestamp nodeId
                 */

                /**
                 * Constructs a new HLCTimestamp.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a HLCTimestamp.
                 * @implements IHLCTimestamp
                 * @constructor
                 * @param {mythbound.websocket.v1.IHLCTimestamp=} [properties] Properties to set
                 */
                function HLCTimestamp(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HLCTimestamp physicalTime.
                 * @member {number|Long} physicalTime
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @instance
                 */
                HLCTimestamp.prototype.physicalTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * HLCTimestamp logicalCounter.
                 * @member {number} logicalCounter
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @instance
                 */
                HLCTimestamp.prototype.logicalCounter = 0;

                /**
                 * HLCTimestamp nodeId.
                 * @member {string} nodeId
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @instance
                 */
                HLCTimestamp.prototype.nodeId = "";

                /**
                 * Creates a new HLCTimestamp instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @static
                 * @param {mythbound.websocket.v1.IHLCTimestamp=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.HLCTimestamp} HLCTimestamp instance
                 */
                HLCTimestamp.create = function create(properties) {
                    return new HLCTimestamp(properties);
                };

                /**
                 * Encodes the specified HLCTimestamp message. Does not implicitly {@link mythbound.websocket.v1.HLCTimestamp.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @static
                 * @param {mythbound.websocket.v1.IHLCTimestamp} message HLCTimestamp message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HLCTimestamp.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.physicalTime != null && Object.hasOwnProperty.call(message, "physicalTime"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.physicalTime);
                    if (message.logicalCounter != null && Object.hasOwnProperty.call(message, "logicalCounter"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.logicalCounter);
                    if (message.nodeId != null && Object.hasOwnProperty.call(message, "nodeId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.nodeId);
                    return writer;
                };

                /**
                 * Encodes the specified HLCTimestamp message, length delimited. Does not implicitly {@link mythbound.websocket.v1.HLCTimestamp.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @static
                 * @param {mythbound.websocket.v1.IHLCTimestamp} message HLCTimestamp message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HLCTimestamp.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a HLCTimestamp message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.HLCTimestamp} HLCTimestamp
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HLCTimestamp.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.HLCTimestamp();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.physicalTime = reader.int64();
                                break;
                            }
                        case 2: {
                                message.logicalCounter = reader.int32();
                                break;
                            }
                        case 3: {
                                message.nodeId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a HLCTimestamp message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.HLCTimestamp} HLCTimestamp
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HLCTimestamp.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HLCTimestamp message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HLCTimestamp.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.physicalTime != null && Object.hasOwnProperty.call(message, "physicalTime"))
                        if (!$util.isInteger(message.physicalTime) && !(message.physicalTime && $util.isInteger(message.physicalTime.low) && $util.isInteger(message.physicalTime.high)))
                            return "physicalTime: integer|Long expected";
                    if (message.logicalCounter != null && Object.hasOwnProperty.call(message, "logicalCounter"))
                        if (!$util.isInteger(message.logicalCounter))
                            return "logicalCounter: integer expected";
                    if (message.nodeId != null && Object.hasOwnProperty.call(message, "nodeId"))
                        if (!$util.isString(message.nodeId))
                            return "nodeId: string expected";
                    return null;
                };

                /**
                 * Creates a HLCTimestamp message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.HLCTimestamp} HLCTimestamp
                 */
                HLCTimestamp.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.HLCTimestamp)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.HLCTimestamp: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.HLCTimestamp();
                    if (object.physicalTime != null)
                        if ($util.Long)
                            message.physicalTime = $util.Long.fromValue(object.physicalTime, false);
                        else if (typeof object.physicalTime === "string")
                            message.physicalTime = parseInt(object.physicalTime, 10);
                        else if (typeof object.physicalTime === "number")
                            message.physicalTime = object.physicalTime;
                        else if (typeof object.physicalTime === "object")
                            message.physicalTime = new $util.LongBits(object.physicalTime.low >>> 0, object.physicalTime.high >>> 0).toNumber();
                    if (object.logicalCounter != null)
                        message.logicalCounter = object.logicalCounter | 0;
                    if (object.nodeId != null)
                        message.nodeId = String(object.nodeId);
                    return message;
                };

                /**
                 * Creates a plain object from a HLCTimestamp message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @static
                 * @param {mythbound.websocket.v1.HLCTimestamp} message HLCTimestamp
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HLCTimestamp.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.physicalTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                        } else
                            object.physicalTime = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                        object.logicalCounter = 0;
                        object.nodeId = "";
                    }
                    if (message.physicalTime != null && Object.hasOwnProperty.call(message, "physicalTime"))
                        if (typeof BigInt !== "undefined" && options.longs === BigInt)
                            object.physicalTime = typeof message.physicalTime === "number" ? BigInt(message.physicalTime) : $util.Long.fromBits(message.physicalTime.low >>> 0, message.physicalTime.high >>> 0, false).toBigInt();
                        else if (typeof message.physicalTime === "number")
                            object.physicalTime = options.longs === String ? String(message.physicalTime) : message.physicalTime;
                        else
                            object.physicalTime = options.longs === String ? $util.Long.prototype.toString.call(message.physicalTime) : options.longs === Number ? new $util.LongBits(message.physicalTime.low >>> 0, message.physicalTime.high >>> 0).toNumber() : message.physicalTime;
                    if (message.logicalCounter != null && Object.hasOwnProperty.call(message, "logicalCounter"))
                        object.logicalCounter = message.logicalCounter;
                    if (message.nodeId != null && Object.hasOwnProperty.call(message, "nodeId"))
                        object.nodeId = message.nodeId;
                    return object;
                };

                /**
                 * Converts this HLCTimestamp to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HLCTimestamp.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for HLCTimestamp
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.HLCTimestamp
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                HLCTimestamp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.HLCTimestamp";
                };

                return HLCTimestamp;
            })();

            /**
             * StateOperationType enum.
             * @name mythbound.websocket.v1.StateOperationType
             * @enum {number}
             * @property {number} STATE_OPERATION_UNSPECIFIED=0 STATE_OPERATION_UNSPECIFIED value
             * @property {number} STATE_OPERATION_SET=1 STATE_OPERATION_SET value
             * @property {number} STATE_OPERATION_DELETE=2 STATE_OPERATION_DELETE value
             * @property {number} STATE_OPERATION_MERGE=3 STATE_OPERATION_MERGE value
             * @property {number} STATE_OPERATION_APPEND=4 STATE_OPERATION_APPEND value
             * @property {number} STATE_OPERATION_INCREMENT=5 STATE_OPERATION_INCREMENT value
             */
            v1.StateOperationType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "STATE_OPERATION_UNSPECIFIED"] = 0;
                values[valuesById[1] = "STATE_OPERATION_SET"] = 1;
                values[valuesById[2] = "STATE_OPERATION_DELETE"] = 2;
                values[valuesById[3] = "STATE_OPERATION_MERGE"] = 3;
                values[valuesById[4] = "STATE_OPERATION_APPEND"] = 4;
                values[valuesById[5] = "STATE_OPERATION_INCREMENT"] = 5;
                return values;
            })();

            /**
             * ConflictResolutionStrategy enum.
             * @name mythbound.websocket.v1.ConflictResolutionStrategy
             * @enum {number}
             * @property {number} CONFLICT_RESOLUTION_UNSPECIFIED=0 CONFLICT_RESOLUTION_UNSPECIFIED value
             * @property {number} CONFLICT_RESOLUTION_LAST_WRITE_WINS=1 CONFLICT_RESOLUTION_LAST_WRITE_WINS value
             * @property {number} CONFLICT_RESOLUTION_MERGE_DEEP=2 CONFLICT_RESOLUTION_MERGE_DEEP value
             * @property {number} CONFLICT_RESOLUTION_MERGE_UNION=3 CONFLICT_RESOLUTION_MERGE_UNION value
             * @property {number} CONFLICT_RESOLUTION_CUSTOM=4 CONFLICT_RESOLUTION_CUSTOM value
             */
            v1.ConflictResolutionStrategy = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "CONFLICT_RESOLUTION_UNSPECIFIED"] = 0;
                values[valuesById[1] = "CONFLICT_RESOLUTION_LAST_WRITE_WINS"] = 1;
                values[valuesById[2] = "CONFLICT_RESOLUTION_MERGE_DEEP"] = 2;
                values[valuesById[3] = "CONFLICT_RESOLUTION_MERGE_UNION"] = 3;
                values[valuesById[4] = "CONFLICT_RESOLUTION_CUSTOM"] = 4;
                return values;
            })();

            v1.StateUpdate = (function() {

                /**
                 * Properties of a StateUpdate.
                 * @memberof mythbound.websocket.v1
                 * @interface IStateUpdate
                 * @property {string|null} [updateId] StateUpdate updateId
                 * @property {mythbound.websocket.v1.IHLCTimestamp|null} [timestamp] StateUpdate timestamp
                 * @property {mythbound.websocket.v1.StateOperationType|null} [operation] StateUpdate operation
                 * @property {string|null} [keyPath] StateUpdate keyPath
                 * @property {string|null} [value] StateUpdate value
                 * @property {string|null} [previousValue] StateUpdate previousValue
                 * @property {mythbound.websocket.v1.ConflictResolutionStrategy|null} [resolutionStrategy] StateUpdate resolutionStrategy
                 * @property {string|null} [mergePolicy] StateUpdate mergePolicy
                 * @property {string|null} [sourceNode] StateUpdate sourceNode
                 * @property {string|null} [userId] StateUpdate userId
                 * @property {string|null} [sessionId] StateUpdate sessionId
                 * @property {string|null} [campaignId] StateUpdate campaignId
                 */

                /**
                 * Constructs a new StateUpdate.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a StateUpdate.
                 * @implements IStateUpdate
                 * @constructor
                 * @param {mythbound.websocket.v1.IStateUpdate=} [properties] Properties to set
                 */
                function StateUpdate(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StateUpdate updateId.
                 * @member {string} updateId
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.updateId = "";

                /**
                 * StateUpdate timestamp.
                 * @member {mythbound.websocket.v1.IHLCTimestamp|null|undefined} timestamp
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.timestamp = null;

                /**
                 * StateUpdate operation.
                 * @member {mythbound.websocket.v1.StateOperationType} operation
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.operation = 0;

                /**
                 * StateUpdate keyPath.
                 * @member {string} keyPath
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.keyPath = "";

                /**
                 * StateUpdate value.
                 * @member {string} value
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.value = "";

                /**
                 * StateUpdate previousValue.
                 * @member {string} previousValue
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.previousValue = "";

                /**
                 * StateUpdate resolutionStrategy.
                 * @member {mythbound.websocket.v1.ConflictResolutionStrategy} resolutionStrategy
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.resolutionStrategy = 0;

                /**
                 * StateUpdate mergePolicy.
                 * @member {string} mergePolicy
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.mergePolicy = "";

                /**
                 * StateUpdate sourceNode.
                 * @member {string} sourceNode
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.sourceNode = "";

                /**
                 * StateUpdate userId.
                 * @member {string} userId
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.userId = "";

                /**
                 * StateUpdate sessionId.
                 * @member {string} sessionId
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.sessionId = "";

                /**
                 * StateUpdate campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 */
                StateUpdate.prototype.campaignId = "";

                /**
                 * Creates a new StateUpdate instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @static
                 * @param {mythbound.websocket.v1.IStateUpdate=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.StateUpdate} StateUpdate instance
                 */
                StateUpdate.create = function create(properties) {
                    return new StateUpdate(properties);
                };

                /**
                 * Encodes the specified StateUpdate message. Does not implicitly {@link mythbound.websocket.v1.StateUpdate.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @static
                 * @param {mythbound.websocket.v1.IStateUpdate} message StateUpdate message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateUpdate.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.updateId != null && Object.hasOwnProperty.call(message, "updateId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.updateId);
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        $root.mythbound.websocket.v1.HLCTimestamp.encode(message.timestamp, writer.uint32(/* id 2, wireType 2 =*/18).fork(), q + 1).ldelim();
                    if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.operation);
                    if (message.keyPath != null && Object.hasOwnProperty.call(message, "keyPath"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.keyPath);
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.value);
                    if (message.previousValue != null && Object.hasOwnProperty.call(message, "previousValue"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.previousValue);
                    if (message.resolutionStrategy != null && Object.hasOwnProperty.call(message, "resolutionStrategy"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int32(message.resolutionStrategy);
                    if (message.mergePolicy != null && Object.hasOwnProperty.call(message, "mergePolicy"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.mergePolicy);
                    if (message.sourceNode != null && Object.hasOwnProperty.call(message, "sourceNode"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.sourceNode);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.userId);
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.sessionId);
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 12, wireType 2 =*/98).string(message.campaignId);
                    return writer;
                };

                /**
                 * Encodes the specified StateUpdate message, length delimited. Does not implicitly {@link mythbound.websocket.v1.StateUpdate.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @static
                 * @param {mythbound.websocket.v1.IStateUpdate} message StateUpdate message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateUpdate.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a StateUpdate message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.StateUpdate} StateUpdate
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateUpdate.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.StateUpdate();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.updateId = reader.string();
                                break;
                            }
                        case 2: {
                                message.timestamp = $root.mythbound.websocket.v1.HLCTimestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 3: {
                                message.operation = reader.int32();
                                break;
                            }
                        case 4: {
                                message.keyPath = reader.string();
                                break;
                            }
                        case 5: {
                                message.value = reader.string();
                                break;
                            }
                        case 6: {
                                message.previousValue = reader.string();
                                break;
                            }
                        case 7: {
                                message.resolutionStrategy = reader.int32();
                                break;
                            }
                        case 8: {
                                message.mergePolicy = reader.string();
                                break;
                            }
                        case 9: {
                                message.sourceNode = reader.string();
                                break;
                            }
                        case 10: {
                                message.userId = reader.string();
                                break;
                            }
                        case 11: {
                                message.sessionId = reader.string();
                                break;
                            }
                        case 12: {
                                message.campaignId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a StateUpdate message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.StateUpdate} StateUpdate
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateUpdate.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StateUpdate message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StateUpdate.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.updateId != null && Object.hasOwnProperty.call(message, "updateId"))
                        if (!$util.isString(message.updateId))
                            return "updateId: string expected";
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp")) {
                        let error = $root.mythbound.websocket.v1.HLCTimestamp.verify(message.timestamp, long + 1);
                        if (error)
                            return "timestamp." + error;
                    }
                    if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                        switch (message.operation) {
                        default:
                            return "operation: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    if (message.keyPath != null && Object.hasOwnProperty.call(message, "keyPath"))
                        if (!$util.isString(message.keyPath))
                            return "keyPath: string expected";
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        if (!$util.isString(message.value))
                            return "value: string expected";
                    if (message.previousValue != null && Object.hasOwnProperty.call(message, "previousValue"))
                        if (!$util.isString(message.previousValue))
                            return "previousValue: string expected";
                    if (message.resolutionStrategy != null && Object.hasOwnProperty.call(message, "resolutionStrategy"))
                        switch (message.resolutionStrategy) {
                        default:
                            return "resolutionStrategy: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.mergePolicy != null && Object.hasOwnProperty.call(message, "mergePolicy"))
                        if (!$util.isString(message.mergePolicy))
                            return "mergePolicy: string expected";
                    if (message.sourceNode != null && Object.hasOwnProperty.call(message, "sourceNode"))
                        if (!$util.isString(message.sourceNode))
                            return "sourceNode: string expected";
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        if (!$util.isString(message.sessionId))
                            return "sessionId: string expected";
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    return null;
                };

                /**
                 * Creates a StateUpdate message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.StateUpdate} StateUpdate
                 */
                StateUpdate.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.StateUpdate)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.StateUpdate: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.StateUpdate();
                    if (object.updateId != null)
                        message.updateId = String(object.updateId);
                    if (object.timestamp != null) {
                        if (!$util.isObject(object.timestamp))
                            throw TypeError(".mythbound.websocket.v1.StateUpdate.timestamp: object expected");
                        message.timestamp = $root.mythbound.websocket.v1.HLCTimestamp.fromObject(object.timestamp, long + 1);
                    }
                    switch (object.operation) {
                    default:
                        if (typeof object.operation === "number") {
                            message.operation = object.operation;
                            break;
                        }
                        break;
                    case "STATE_OPERATION_UNSPECIFIED":
                    case 0:
                        message.operation = 0;
                        break;
                    case "STATE_OPERATION_SET":
                    case 1:
                        message.operation = 1;
                        break;
                    case "STATE_OPERATION_DELETE":
                    case 2:
                        message.operation = 2;
                        break;
                    case "STATE_OPERATION_MERGE":
                    case 3:
                        message.operation = 3;
                        break;
                    case "STATE_OPERATION_APPEND":
                    case 4:
                        message.operation = 4;
                        break;
                    case "STATE_OPERATION_INCREMENT":
                    case 5:
                        message.operation = 5;
                        break;
                    }
                    if (object.keyPath != null)
                        message.keyPath = String(object.keyPath);
                    if (object.value != null)
                        message.value = String(object.value);
                    if (object.previousValue != null)
                        message.previousValue = String(object.previousValue);
                    switch (object.resolutionStrategy) {
                    default:
                        if (typeof object.resolutionStrategy === "number") {
                            message.resolutionStrategy = object.resolutionStrategy;
                            break;
                        }
                        break;
                    case "CONFLICT_RESOLUTION_UNSPECIFIED":
                    case 0:
                        message.resolutionStrategy = 0;
                        break;
                    case "CONFLICT_RESOLUTION_LAST_WRITE_WINS":
                    case 1:
                        message.resolutionStrategy = 1;
                        break;
                    case "CONFLICT_RESOLUTION_MERGE_DEEP":
                    case 2:
                        message.resolutionStrategy = 2;
                        break;
                    case "CONFLICT_RESOLUTION_MERGE_UNION":
                    case 3:
                        message.resolutionStrategy = 3;
                        break;
                    case "CONFLICT_RESOLUTION_CUSTOM":
                    case 4:
                        message.resolutionStrategy = 4;
                        break;
                    }
                    if (object.mergePolicy != null)
                        message.mergePolicy = String(object.mergePolicy);
                    if (object.sourceNode != null)
                        message.sourceNode = String(object.sourceNode);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.sessionId != null)
                        message.sessionId = String(object.sessionId);
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    return message;
                };

                /**
                 * Creates a plain object from a StateUpdate message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @static
                 * @param {mythbound.websocket.v1.StateUpdate} message StateUpdate
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StateUpdate.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.updateId = "";
                        object.timestamp = null;
                        object.operation = options.enums === String ? "STATE_OPERATION_UNSPECIFIED" : 0;
                        object.keyPath = "";
                        object.value = "";
                        object.previousValue = "";
                        object.resolutionStrategy = options.enums === String ? "CONFLICT_RESOLUTION_UNSPECIFIED" : 0;
                        object.mergePolicy = "";
                        object.sourceNode = "";
                        object.userId = "";
                        object.sessionId = "";
                        object.campaignId = "";
                    }
                    if (message.updateId != null && Object.hasOwnProperty.call(message, "updateId"))
                        object.updateId = message.updateId;
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        object.timestamp = $root.mythbound.websocket.v1.HLCTimestamp.toObject(message.timestamp, options, q + 1);
                    if (message.operation != null && Object.hasOwnProperty.call(message, "operation"))
                        object.operation = options.enums === String ? $root.mythbound.websocket.v1.StateOperationType[message.operation] === undefined ? message.operation : $root.mythbound.websocket.v1.StateOperationType[message.operation] : message.operation;
                    if (message.keyPath != null && Object.hasOwnProperty.call(message, "keyPath"))
                        object.keyPath = message.keyPath;
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        object.value = message.value;
                    if (message.previousValue != null && Object.hasOwnProperty.call(message, "previousValue"))
                        object.previousValue = message.previousValue;
                    if (message.resolutionStrategy != null && Object.hasOwnProperty.call(message, "resolutionStrategy"))
                        object.resolutionStrategy = options.enums === String ? $root.mythbound.websocket.v1.ConflictResolutionStrategy[message.resolutionStrategy] === undefined ? message.resolutionStrategy : $root.mythbound.websocket.v1.ConflictResolutionStrategy[message.resolutionStrategy] : message.resolutionStrategy;
                    if (message.mergePolicy != null && Object.hasOwnProperty.call(message, "mergePolicy"))
                        object.mergePolicy = message.mergePolicy;
                    if (message.sourceNode != null && Object.hasOwnProperty.call(message, "sourceNode"))
                        object.sourceNode = message.sourceNode;
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        object.userId = message.userId;
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        object.sessionId = message.sessionId;
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    return object;
                };

                /**
                 * Converts this StateUpdate to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StateUpdate.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StateUpdate
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.StateUpdate
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StateUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.StateUpdate";
                };

                return StateUpdate;
            })();

            v1.StateBatch = (function() {

                /**
                 * Properties of a StateBatch.
                 * @memberof mythbound.websocket.v1
                 * @interface IStateBatch
                 * @property {Array.<mythbound.websocket.v1.IStateUpdate>|null} [updates] StateBatch updates
                 * @property {string|null} [batchId] StateBatch batchId
                 * @property {mythbound.websocket.v1.IHLCTimestamp|null} [batchTimestamp] StateBatch batchTimestamp
                 * @property {boolean|null} [atomic] StateBatch atomic
                 */

                /**
                 * Constructs a new StateBatch.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a StateBatch.
                 * @implements IStateBatch
                 * @constructor
                 * @param {mythbound.websocket.v1.IStateBatch=} [properties] Properties to set
                 */
                function StateBatch(properties) {
                    this.updates = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StateBatch updates.
                 * @member {Array.<mythbound.websocket.v1.IStateUpdate>} updates
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @instance
                 */
                StateBatch.prototype.updates = $util.emptyArray;

                /**
                 * StateBatch batchId.
                 * @member {string} batchId
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @instance
                 */
                StateBatch.prototype.batchId = "";

                /**
                 * StateBatch batchTimestamp.
                 * @member {mythbound.websocket.v1.IHLCTimestamp|null|undefined} batchTimestamp
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @instance
                 */
                StateBatch.prototype.batchTimestamp = null;

                /**
                 * StateBatch atomic.
                 * @member {boolean} atomic
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @instance
                 */
                StateBatch.prototype.atomic = false;

                /**
                 * Creates a new StateBatch instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @static
                 * @param {mythbound.websocket.v1.IStateBatch=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.StateBatch} StateBatch instance
                 */
                StateBatch.create = function create(properties) {
                    return new StateBatch(properties);
                };

                /**
                 * Encodes the specified StateBatch message. Does not implicitly {@link mythbound.websocket.v1.StateBatch.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @static
                 * @param {mythbound.websocket.v1.IStateBatch} message StateBatch message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateBatch.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.updates != null && message.updates.length)
                        for (let i = 0; i < message.updates.length; ++i)
                            $root.mythbound.websocket.v1.StateUpdate.encode(message.updates[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), q + 1).ldelim();
                    if (message.batchId != null && Object.hasOwnProperty.call(message, "batchId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.batchId);
                    if (message.batchTimestamp != null && Object.hasOwnProperty.call(message, "batchTimestamp"))
                        $root.mythbound.websocket.v1.HLCTimestamp.encode(message.batchTimestamp, writer.uint32(/* id 3, wireType 2 =*/26).fork(), q + 1).ldelim();
                    if (message.atomic != null && Object.hasOwnProperty.call(message, "atomic"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.atomic);
                    return writer;
                };

                /**
                 * Encodes the specified StateBatch message, length delimited. Does not implicitly {@link mythbound.websocket.v1.StateBatch.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @static
                 * @param {mythbound.websocket.v1.IStateBatch} message StateBatch message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateBatch.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a StateBatch message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.StateBatch} StateBatch
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateBatch.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.StateBatch();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.updates && message.updates.length))
                                    message.updates = [];
                                message.updates.push($root.mythbound.websocket.v1.StateUpdate.decode(reader, reader.uint32(), undefined, long + 1));
                                break;
                            }
                        case 2: {
                                message.batchId = reader.string();
                                break;
                            }
                        case 3: {
                                message.batchTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 4: {
                                message.atomic = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a StateBatch message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.StateBatch} StateBatch
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateBatch.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StateBatch message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StateBatch.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.updates != null && Object.hasOwnProperty.call(message, "updates")) {
                        if (!Array.isArray(message.updates))
                            return "updates: array expected";
                        for (let i = 0; i < message.updates.length; ++i) {
                            let error = $root.mythbound.websocket.v1.StateUpdate.verify(message.updates[i], long + 1);
                            if (error)
                                return "updates." + error;
                        }
                    }
                    if (message.batchId != null && Object.hasOwnProperty.call(message, "batchId"))
                        if (!$util.isString(message.batchId))
                            return "batchId: string expected";
                    if (message.batchTimestamp != null && Object.hasOwnProperty.call(message, "batchTimestamp")) {
                        let error = $root.mythbound.websocket.v1.HLCTimestamp.verify(message.batchTimestamp, long + 1);
                        if (error)
                            return "batchTimestamp." + error;
                    }
                    if (message.atomic != null && Object.hasOwnProperty.call(message, "atomic"))
                        if (typeof message.atomic !== "boolean")
                            return "atomic: boolean expected";
                    return null;
                };

                /**
                 * Creates a StateBatch message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.StateBatch} StateBatch
                 */
                StateBatch.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.StateBatch)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.StateBatch: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.StateBatch();
                    if (object.updates) {
                        if (!Array.isArray(object.updates))
                            throw TypeError(".mythbound.websocket.v1.StateBatch.updates: array expected");
                        message.updates = [];
                        for (let i = 0; i < object.updates.length; ++i) {
                            if (!$util.isObject(object.updates[i]))
                                throw TypeError(".mythbound.websocket.v1.StateBatch.updates: object expected");
                            message.updates[i] = $root.mythbound.websocket.v1.StateUpdate.fromObject(object.updates[i], long + 1);
                        }
                    }
                    if (object.batchId != null)
                        message.batchId = String(object.batchId);
                    if (object.batchTimestamp != null) {
                        if (!$util.isObject(object.batchTimestamp))
                            throw TypeError(".mythbound.websocket.v1.StateBatch.batchTimestamp: object expected");
                        message.batchTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.fromObject(object.batchTimestamp, long + 1);
                    }
                    if (object.atomic != null)
                        message.atomic = Boolean(object.atomic);
                    return message;
                };

                /**
                 * Creates a plain object from a StateBatch message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @static
                 * @param {mythbound.websocket.v1.StateBatch} message StateBatch
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StateBatch.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.updates = [];
                    if (options.defaults) {
                        object.batchId = "";
                        object.batchTimestamp = null;
                        object.atomic = false;
                    }
                    if (message.updates && message.updates.length) {
                        object.updates = [];
                        for (let j = 0; j < message.updates.length; ++j)
                            object.updates[j] = $root.mythbound.websocket.v1.StateUpdate.toObject(message.updates[j], options, q + 1);
                    }
                    if (message.batchId != null && Object.hasOwnProperty.call(message, "batchId"))
                        object.batchId = message.batchId;
                    if (message.batchTimestamp != null && Object.hasOwnProperty.call(message, "batchTimestamp"))
                        object.batchTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.toObject(message.batchTimestamp, options, q + 1);
                    if (message.atomic != null && Object.hasOwnProperty.call(message, "atomic"))
                        object.atomic = message.atomic;
                    return object;
                };

                /**
                 * Converts this StateBatch to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StateBatch.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StateBatch
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.StateBatch
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StateBatch.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.StateBatch";
                };

                return StateBatch;
            })();

            v1.StateSyncRequest = (function() {

                /**
                 * Properties of a StateSyncRequest.
                 * @memberof mythbound.websocket.v1
                 * @interface IStateSyncRequest
                 * @property {string|null} [requestId] StateSyncRequest requestId
                 * @property {mythbound.websocket.v1.IHLCTimestamp|null} [clientTimestamp] StateSyncRequest clientTimestamp
                 * @property {Array.<string>|null} [keyPaths] StateSyncRequest keyPaths
                 * @property {string|null} [campaignId] StateSyncRequest campaignId
                 * @property {string|null} [sessionId] StateSyncRequest sessionId
                 */

                /**
                 * Constructs a new StateSyncRequest.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a StateSyncRequest.
                 * @implements IStateSyncRequest
                 * @constructor
                 * @param {mythbound.websocket.v1.IStateSyncRequest=} [properties] Properties to set
                 */
                function StateSyncRequest(properties) {
                    this.keyPaths = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StateSyncRequest requestId.
                 * @member {string} requestId
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @instance
                 */
                StateSyncRequest.prototype.requestId = "";

                /**
                 * StateSyncRequest clientTimestamp.
                 * @member {mythbound.websocket.v1.IHLCTimestamp|null|undefined} clientTimestamp
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @instance
                 */
                StateSyncRequest.prototype.clientTimestamp = null;

                /**
                 * StateSyncRequest keyPaths.
                 * @member {Array.<string>} keyPaths
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @instance
                 */
                StateSyncRequest.prototype.keyPaths = $util.emptyArray;

                /**
                 * StateSyncRequest campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @instance
                 */
                StateSyncRequest.prototype.campaignId = "";

                /**
                 * StateSyncRequest sessionId.
                 * @member {string} sessionId
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @instance
                 */
                StateSyncRequest.prototype.sessionId = "";

                /**
                 * Creates a new StateSyncRequest instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @static
                 * @param {mythbound.websocket.v1.IStateSyncRequest=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.StateSyncRequest} StateSyncRequest instance
                 */
                StateSyncRequest.create = function create(properties) {
                    return new StateSyncRequest(properties);
                };

                /**
                 * Encodes the specified StateSyncRequest message. Does not implicitly {@link mythbound.websocket.v1.StateSyncRequest.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @static
                 * @param {mythbound.websocket.v1.IStateSyncRequest} message StateSyncRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateSyncRequest.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
                    if (message.clientTimestamp != null && Object.hasOwnProperty.call(message, "clientTimestamp"))
                        $root.mythbound.websocket.v1.HLCTimestamp.encode(message.clientTimestamp, writer.uint32(/* id 2, wireType 2 =*/18).fork(), q + 1).ldelim();
                    if (message.keyPaths != null && message.keyPaths.length)
                        for (let i = 0; i < message.keyPaths.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.keyPaths[i]);
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.campaignId);
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.sessionId);
                    return writer;
                };

                /**
                 * Encodes the specified StateSyncRequest message, length delimited. Does not implicitly {@link mythbound.websocket.v1.StateSyncRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @static
                 * @param {mythbound.websocket.v1.IStateSyncRequest} message StateSyncRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateSyncRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a StateSyncRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.StateSyncRequest} StateSyncRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateSyncRequest.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.StateSyncRequest();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.requestId = reader.string();
                                break;
                            }
                        case 2: {
                                message.clientTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 3: {
                                if (!(message.keyPaths && message.keyPaths.length))
                                    message.keyPaths = [];
                                message.keyPaths.push(reader.string());
                                break;
                            }
                        case 4: {
                                message.campaignId = reader.string();
                                break;
                            }
                        case 5: {
                                message.sessionId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a StateSyncRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.StateSyncRequest} StateSyncRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateSyncRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StateSyncRequest message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StateSyncRequest.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        if (!$util.isString(message.requestId))
                            return "requestId: string expected";
                    if (message.clientTimestamp != null && Object.hasOwnProperty.call(message, "clientTimestamp")) {
                        let error = $root.mythbound.websocket.v1.HLCTimestamp.verify(message.clientTimestamp, long + 1);
                        if (error)
                            return "clientTimestamp." + error;
                    }
                    if (message.keyPaths != null && Object.hasOwnProperty.call(message, "keyPaths")) {
                        if (!Array.isArray(message.keyPaths))
                            return "keyPaths: array expected";
                        for (let i = 0; i < message.keyPaths.length; ++i)
                            if (!$util.isString(message.keyPaths[i]))
                                return "keyPaths: string[] expected";
                    }
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        if (!$util.isString(message.sessionId))
                            return "sessionId: string expected";
                    return null;
                };

                /**
                 * Creates a StateSyncRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.StateSyncRequest} StateSyncRequest
                 */
                StateSyncRequest.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.StateSyncRequest)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.StateSyncRequest: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.StateSyncRequest();
                    if (object.requestId != null)
                        message.requestId = String(object.requestId);
                    if (object.clientTimestamp != null) {
                        if (!$util.isObject(object.clientTimestamp))
                            throw TypeError(".mythbound.websocket.v1.StateSyncRequest.clientTimestamp: object expected");
                        message.clientTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.fromObject(object.clientTimestamp, long + 1);
                    }
                    if (object.keyPaths) {
                        if (!Array.isArray(object.keyPaths))
                            throw TypeError(".mythbound.websocket.v1.StateSyncRequest.keyPaths: array expected");
                        message.keyPaths = [];
                        for (let i = 0; i < object.keyPaths.length; ++i)
                            message.keyPaths[i] = String(object.keyPaths[i]);
                    }
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    if (object.sessionId != null)
                        message.sessionId = String(object.sessionId);
                    return message;
                };

                /**
                 * Creates a plain object from a StateSyncRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @static
                 * @param {mythbound.websocket.v1.StateSyncRequest} message StateSyncRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StateSyncRequest.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.keyPaths = [];
                    if (options.defaults) {
                        object.requestId = "";
                        object.clientTimestamp = null;
                        object.campaignId = "";
                        object.sessionId = "";
                    }
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        object.requestId = message.requestId;
                    if (message.clientTimestamp != null && Object.hasOwnProperty.call(message, "clientTimestamp"))
                        object.clientTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.toObject(message.clientTimestamp, options, q + 1);
                    if (message.keyPaths && message.keyPaths.length) {
                        object.keyPaths = [];
                        for (let j = 0; j < message.keyPaths.length; ++j)
                            object.keyPaths[j] = message.keyPaths[j];
                    }
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        object.sessionId = message.sessionId;
                    return object;
                };

                /**
                 * Converts this StateSyncRequest to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StateSyncRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StateSyncRequest
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.StateSyncRequest
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StateSyncRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.StateSyncRequest";
                };

                return StateSyncRequest;
            })();

            v1.StateSyncResponse = (function() {

                /**
                 * Properties of a StateSyncResponse.
                 * @memberof mythbound.websocket.v1
                 * @interface IStateSyncResponse
                 * @property {string|null} [requestId] StateSyncResponse requestId
                 * @property {mythbound.websocket.v1.IHLCTimestamp|null} [serverTimestamp] StateSyncResponse serverTimestamp
                 * @property {Object.<string,string>|null} [state] StateSyncResponse state
                 * @property {Array.<mythbound.websocket.v1.IStateUpdate>|null} [pendingUpdates] StateSyncResponse pendingUpdates
                 * @property {boolean|null} [complete] StateSyncResponse complete
                 */

                /**
                 * Constructs a new StateSyncResponse.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a StateSyncResponse.
                 * @implements IStateSyncResponse
                 * @constructor
                 * @param {mythbound.websocket.v1.IStateSyncResponse=} [properties] Properties to set
                 */
                function StateSyncResponse(properties) {
                    this.state = {};
                    this.pendingUpdates = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StateSyncResponse requestId.
                 * @member {string} requestId
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @instance
                 */
                StateSyncResponse.prototype.requestId = "";

                /**
                 * StateSyncResponse serverTimestamp.
                 * @member {mythbound.websocket.v1.IHLCTimestamp|null|undefined} serverTimestamp
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @instance
                 */
                StateSyncResponse.prototype.serverTimestamp = null;

                /**
                 * StateSyncResponse state.
                 * @member {Object.<string,string>} state
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @instance
                 */
                StateSyncResponse.prototype.state = $util.emptyObject;

                /**
                 * StateSyncResponse pendingUpdates.
                 * @member {Array.<mythbound.websocket.v1.IStateUpdate>} pendingUpdates
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @instance
                 */
                StateSyncResponse.prototype.pendingUpdates = $util.emptyArray;

                /**
                 * StateSyncResponse complete.
                 * @member {boolean} complete
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @instance
                 */
                StateSyncResponse.prototype.complete = false;

                /**
                 * Creates a new StateSyncResponse instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @static
                 * @param {mythbound.websocket.v1.IStateSyncResponse=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.StateSyncResponse} StateSyncResponse instance
                 */
                StateSyncResponse.create = function create(properties) {
                    return new StateSyncResponse(properties);
                };

                /**
                 * Encodes the specified StateSyncResponse message. Does not implicitly {@link mythbound.websocket.v1.StateSyncResponse.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @static
                 * @param {mythbound.websocket.v1.IStateSyncResponse} message StateSyncResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateSyncResponse.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp"))
                        $root.mythbound.websocket.v1.HLCTimestamp.encode(message.serverTimestamp, writer.uint32(/* id 2, wireType 2 =*/18).fork(), q + 1).ldelim();
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        for (let keys = Object.keys(message.state), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.state[keys[i]]).ldelim();
                    if (message.pendingUpdates != null && message.pendingUpdates.length)
                        for (let i = 0; i < message.pendingUpdates.length; ++i)
                            $root.mythbound.websocket.v1.StateUpdate.encode(message.pendingUpdates[i], writer.uint32(/* id 4, wireType 2 =*/34).fork(), q + 1).ldelim();
                    if (message.complete != null && Object.hasOwnProperty.call(message, "complete"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.complete);
                    return writer;
                };

                /**
                 * Encodes the specified StateSyncResponse message, length delimited. Does not implicitly {@link mythbound.websocket.v1.StateSyncResponse.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @static
                 * @param {mythbound.websocket.v1.IStateSyncResponse} message StateSyncResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateSyncResponse.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a StateSyncResponse message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.StateSyncResponse} StateSyncResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateSyncResponse.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message, key, value;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.StateSyncResponse();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.requestId = reader.string();
                                break;
                            }
                        case 2: {
                                message.serverTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 3: {
                                if (message.state === $util.emptyObject)
                                    message.state = {};
                                let end2 = reader.uint32() + reader.pos;
                                if (end2 > reader.len)
                                    throw RangeError("index out of range");
                                reader.len = end2;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7, long);
                                        break;
                                    }
                                }
                                if (reader.pos !== end2)
                                    throw RangeError("index out of range");
                                reader.len = end;
                                if (key === "__proto__")
                                    $util.makeProp(message.state, key);
                                message.state[key] = value;
                                break;
                            }
                        case 4: {
                                if (!(message.pendingUpdates && message.pendingUpdates.length))
                                    message.pendingUpdates = [];
                                message.pendingUpdates.push($root.mythbound.websocket.v1.StateUpdate.decode(reader, reader.uint32(), undefined, long + 1));
                                break;
                            }
                        case 5: {
                                message.complete = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a StateSyncResponse message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.StateSyncResponse} StateSyncResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateSyncResponse.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StateSyncResponse message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StateSyncResponse.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        if (!$util.isString(message.requestId))
                            return "requestId: string expected";
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp")) {
                        let error = $root.mythbound.websocket.v1.HLCTimestamp.verify(message.serverTimestamp, long + 1);
                        if (error)
                            return "serverTimestamp." + error;
                    }
                    if (message.state != null && Object.hasOwnProperty.call(message, "state")) {
                        if (!$util.isObject(message.state))
                            return "state: object expected";
                        let key = Object.keys(message.state);
                        for (let i = 0; i < key.length; ++i)
                            if (!$util.isString(message.state[key[i]]))
                                return "state: string{k:string} expected";
                    }
                    if (message.pendingUpdates != null && Object.hasOwnProperty.call(message, "pendingUpdates")) {
                        if (!Array.isArray(message.pendingUpdates))
                            return "pendingUpdates: array expected";
                        for (let i = 0; i < message.pendingUpdates.length; ++i) {
                            let error = $root.mythbound.websocket.v1.StateUpdate.verify(message.pendingUpdates[i], long + 1);
                            if (error)
                                return "pendingUpdates." + error;
                        }
                    }
                    if (message.complete != null && Object.hasOwnProperty.call(message, "complete"))
                        if (typeof message.complete !== "boolean")
                            return "complete: boolean expected";
                    return null;
                };

                /**
                 * Creates a StateSyncResponse message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.StateSyncResponse} StateSyncResponse
                 */
                StateSyncResponse.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.StateSyncResponse)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.StateSyncResponse: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.StateSyncResponse();
                    if (object.requestId != null)
                        message.requestId = String(object.requestId);
                    if (object.serverTimestamp != null) {
                        if (!$util.isObject(object.serverTimestamp))
                            throw TypeError(".mythbound.websocket.v1.StateSyncResponse.serverTimestamp: object expected");
                        message.serverTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.fromObject(object.serverTimestamp, long + 1);
                    }
                    if (object.state) {
                        if (!$util.isObject(object.state))
                            throw TypeError(".mythbound.websocket.v1.StateSyncResponse.state: object expected");
                        message.state = {};
                        for (let keys = Object.keys(object.state), i = 0; i < keys.length; ++i) {
                            if (keys[i] === "__proto__")
                                $util.makeProp(message.state, keys[i]);
                            message.state[keys[i]] = String(object.state[keys[i]]);
                        }
                    }
                    if (object.pendingUpdates) {
                        if (!Array.isArray(object.pendingUpdates))
                            throw TypeError(".mythbound.websocket.v1.StateSyncResponse.pendingUpdates: array expected");
                        message.pendingUpdates = [];
                        for (let i = 0; i < object.pendingUpdates.length; ++i) {
                            if (!$util.isObject(object.pendingUpdates[i]))
                                throw TypeError(".mythbound.websocket.v1.StateSyncResponse.pendingUpdates: object expected");
                            message.pendingUpdates[i] = $root.mythbound.websocket.v1.StateUpdate.fromObject(object.pendingUpdates[i], long + 1);
                        }
                    }
                    if (object.complete != null)
                        message.complete = Boolean(object.complete);
                    return message;
                };

                /**
                 * Creates a plain object from a StateSyncResponse message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @static
                 * @param {mythbound.websocket.v1.StateSyncResponse} message StateSyncResponse
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StateSyncResponse.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.pendingUpdates = [];
                    if (options.objects || options.defaults)
                        object.state = {};
                    if (options.defaults) {
                        object.requestId = "";
                        object.serverTimestamp = null;
                        object.complete = false;
                    }
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        object.requestId = message.requestId;
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp"))
                        object.serverTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.toObject(message.serverTimestamp, options, q + 1);
                    let keys2;
                    if (message.state && (keys2 = Object.keys(message.state)).length) {
                        object.state = {};
                        for (let j = 0; j < keys2.length; ++j) {
                            if (keys2[j] === "__proto__")
                                $util.makeProp(object.state, keys2[j]);
                            object.state[keys2[j]] = message.state[keys2[j]];
                        }
                    }
                    if (message.pendingUpdates && message.pendingUpdates.length) {
                        object.pendingUpdates = [];
                        for (let j = 0; j < message.pendingUpdates.length; ++j)
                            object.pendingUpdates[j] = $root.mythbound.websocket.v1.StateUpdate.toObject(message.pendingUpdates[j], options, q + 1);
                    }
                    if (message.complete != null && Object.hasOwnProperty.call(message, "complete"))
                        object.complete = message.complete;
                    return object;
                };

                /**
                 * Converts this StateSyncResponse to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StateSyncResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StateSyncResponse
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.StateSyncResponse
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StateSyncResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.StateSyncResponse";
                };

                return StateSyncResponse;
            })();

            v1.StateConflict = (function() {

                /**
                 * Properties of a StateConflict.
                 * @memberof mythbound.websocket.v1
                 * @interface IStateConflict
                 * @property {string|null} [conflictId] StateConflict conflictId
                 * @property {mythbound.websocket.v1.IStateUpdate|null} [localUpdate] StateConflict localUpdate
                 * @property {mythbound.websocket.v1.IStateUpdate|null} [serverUpdate] StateConflict serverUpdate
                 * @property {mythbound.websocket.v1.IStateUpdate|null} [resolvedUpdate] StateConflict resolvedUpdate
                 * @property {mythbound.websocket.v1.ConflictResolutionStrategy|null} [resolutionUsed] StateConflict resolutionUsed
                 * @property {string|null} [resolutionReason] StateConflict resolutionReason
                 */

                /**
                 * Constructs a new StateConflict.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a StateConflict.
                 * @implements IStateConflict
                 * @constructor
                 * @param {mythbound.websocket.v1.IStateConflict=} [properties] Properties to set
                 */
                function StateConflict(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StateConflict conflictId.
                 * @member {string} conflictId
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @instance
                 */
                StateConflict.prototype.conflictId = "";

                /**
                 * StateConflict localUpdate.
                 * @member {mythbound.websocket.v1.IStateUpdate|null|undefined} localUpdate
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @instance
                 */
                StateConflict.prototype.localUpdate = null;

                /**
                 * StateConflict serverUpdate.
                 * @member {mythbound.websocket.v1.IStateUpdate|null|undefined} serverUpdate
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @instance
                 */
                StateConflict.prototype.serverUpdate = null;

                /**
                 * StateConflict resolvedUpdate.
                 * @member {mythbound.websocket.v1.IStateUpdate|null|undefined} resolvedUpdate
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @instance
                 */
                StateConflict.prototype.resolvedUpdate = null;

                /**
                 * StateConflict resolutionUsed.
                 * @member {mythbound.websocket.v1.ConflictResolutionStrategy} resolutionUsed
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @instance
                 */
                StateConflict.prototype.resolutionUsed = 0;

                /**
                 * StateConflict resolutionReason.
                 * @member {string} resolutionReason
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @instance
                 */
                StateConflict.prototype.resolutionReason = "";

                /**
                 * Creates a new StateConflict instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @static
                 * @param {mythbound.websocket.v1.IStateConflict=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.StateConflict} StateConflict instance
                 */
                StateConflict.create = function create(properties) {
                    return new StateConflict(properties);
                };

                /**
                 * Encodes the specified StateConflict message. Does not implicitly {@link mythbound.websocket.v1.StateConflict.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @static
                 * @param {mythbound.websocket.v1.IStateConflict} message StateConflict message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateConflict.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.conflictId != null && Object.hasOwnProperty.call(message, "conflictId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.conflictId);
                    if (message.localUpdate != null && Object.hasOwnProperty.call(message, "localUpdate"))
                        $root.mythbound.websocket.v1.StateUpdate.encode(message.localUpdate, writer.uint32(/* id 2, wireType 2 =*/18).fork(), q + 1).ldelim();
                    if (message.serverUpdate != null && Object.hasOwnProperty.call(message, "serverUpdate"))
                        $root.mythbound.websocket.v1.StateUpdate.encode(message.serverUpdate, writer.uint32(/* id 3, wireType 2 =*/26).fork(), q + 1).ldelim();
                    if (message.resolvedUpdate != null && Object.hasOwnProperty.call(message, "resolvedUpdate"))
                        $root.mythbound.websocket.v1.StateUpdate.encode(message.resolvedUpdate, writer.uint32(/* id 4, wireType 2 =*/34).fork(), q + 1).ldelim();
                    if (message.resolutionUsed != null && Object.hasOwnProperty.call(message, "resolutionUsed"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.resolutionUsed);
                    if (message.resolutionReason != null && Object.hasOwnProperty.call(message, "resolutionReason"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.resolutionReason);
                    return writer;
                };

                /**
                 * Encodes the specified StateConflict message, length delimited. Does not implicitly {@link mythbound.websocket.v1.StateConflict.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @static
                 * @param {mythbound.websocket.v1.IStateConflict} message StateConflict message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateConflict.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a StateConflict message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.StateConflict} StateConflict
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateConflict.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.StateConflict();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.conflictId = reader.string();
                                break;
                            }
                        case 2: {
                                message.localUpdate = $root.mythbound.websocket.v1.StateUpdate.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 3: {
                                message.serverUpdate = $root.mythbound.websocket.v1.StateUpdate.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 4: {
                                message.resolvedUpdate = $root.mythbound.websocket.v1.StateUpdate.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 5: {
                                message.resolutionUsed = reader.int32();
                                break;
                            }
                        case 6: {
                                message.resolutionReason = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a StateConflict message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.StateConflict} StateConflict
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateConflict.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StateConflict message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StateConflict.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.conflictId != null && Object.hasOwnProperty.call(message, "conflictId"))
                        if (!$util.isString(message.conflictId))
                            return "conflictId: string expected";
                    if (message.localUpdate != null && Object.hasOwnProperty.call(message, "localUpdate")) {
                        let error = $root.mythbound.websocket.v1.StateUpdate.verify(message.localUpdate, long + 1);
                        if (error)
                            return "localUpdate." + error;
                    }
                    if (message.serverUpdate != null && Object.hasOwnProperty.call(message, "serverUpdate")) {
                        let error = $root.mythbound.websocket.v1.StateUpdate.verify(message.serverUpdate, long + 1);
                        if (error)
                            return "serverUpdate." + error;
                    }
                    if (message.resolvedUpdate != null && Object.hasOwnProperty.call(message, "resolvedUpdate")) {
                        let error = $root.mythbound.websocket.v1.StateUpdate.verify(message.resolvedUpdate, long + 1);
                        if (error)
                            return "resolvedUpdate." + error;
                    }
                    if (message.resolutionUsed != null && Object.hasOwnProperty.call(message, "resolutionUsed"))
                        switch (message.resolutionUsed) {
                        default:
                            return "resolutionUsed: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.resolutionReason != null && Object.hasOwnProperty.call(message, "resolutionReason"))
                        if (!$util.isString(message.resolutionReason))
                            return "resolutionReason: string expected";
                    return null;
                };

                /**
                 * Creates a StateConflict message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.StateConflict} StateConflict
                 */
                StateConflict.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.StateConflict)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.StateConflict: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.StateConflict();
                    if (object.conflictId != null)
                        message.conflictId = String(object.conflictId);
                    if (object.localUpdate != null) {
                        if (!$util.isObject(object.localUpdate))
                            throw TypeError(".mythbound.websocket.v1.StateConflict.localUpdate: object expected");
                        message.localUpdate = $root.mythbound.websocket.v1.StateUpdate.fromObject(object.localUpdate, long + 1);
                    }
                    if (object.serverUpdate != null) {
                        if (!$util.isObject(object.serverUpdate))
                            throw TypeError(".mythbound.websocket.v1.StateConflict.serverUpdate: object expected");
                        message.serverUpdate = $root.mythbound.websocket.v1.StateUpdate.fromObject(object.serverUpdate, long + 1);
                    }
                    if (object.resolvedUpdate != null) {
                        if (!$util.isObject(object.resolvedUpdate))
                            throw TypeError(".mythbound.websocket.v1.StateConflict.resolvedUpdate: object expected");
                        message.resolvedUpdate = $root.mythbound.websocket.v1.StateUpdate.fromObject(object.resolvedUpdate, long + 1);
                    }
                    switch (object.resolutionUsed) {
                    default:
                        if (typeof object.resolutionUsed === "number") {
                            message.resolutionUsed = object.resolutionUsed;
                            break;
                        }
                        break;
                    case "CONFLICT_RESOLUTION_UNSPECIFIED":
                    case 0:
                        message.resolutionUsed = 0;
                        break;
                    case "CONFLICT_RESOLUTION_LAST_WRITE_WINS":
                    case 1:
                        message.resolutionUsed = 1;
                        break;
                    case "CONFLICT_RESOLUTION_MERGE_DEEP":
                    case 2:
                        message.resolutionUsed = 2;
                        break;
                    case "CONFLICT_RESOLUTION_MERGE_UNION":
                    case 3:
                        message.resolutionUsed = 3;
                        break;
                    case "CONFLICT_RESOLUTION_CUSTOM":
                    case 4:
                        message.resolutionUsed = 4;
                        break;
                    }
                    if (object.resolutionReason != null)
                        message.resolutionReason = String(object.resolutionReason);
                    return message;
                };

                /**
                 * Creates a plain object from a StateConflict message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @static
                 * @param {mythbound.websocket.v1.StateConflict} message StateConflict
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StateConflict.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.conflictId = "";
                        object.localUpdate = null;
                        object.serverUpdate = null;
                        object.resolvedUpdate = null;
                        object.resolutionUsed = options.enums === String ? "CONFLICT_RESOLUTION_UNSPECIFIED" : 0;
                        object.resolutionReason = "";
                    }
                    if (message.conflictId != null && Object.hasOwnProperty.call(message, "conflictId"))
                        object.conflictId = message.conflictId;
                    if (message.localUpdate != null && Object.hasOwnProperty.call(message, "localUpdate"))
                        object.localUpdate = $root.mythbound.websocket.v1.StateUpdate.toObject(message.localUpdate, options, q + 1);
                    if (message.serverUpdate != null && Object.hasOwnProperty.call(message, "serverUpdate"))
                        object.serverUpdate = $root.mythbound.websocket.v1.StateUpdate.toObject(message.serverUpdate, options, q + 1);
                    if (message.resolvedUpdate != null && Object.hasOwnProperty.call(message, "resolvedUpdate"))
                        object.resolvedUpdate = $root.mythbound.websocket.v1.StateUpdate.toObject(message.resolvedUpdate, options, q + 1);
                    if (message.resolutionUsed != null && Object.hasOwnProperty.call(message, "resolutionUsed"))
                        object.resolutionUsed = options.enums === String ? $root.mythbound.websocket.v1.ConflictResolutionStrategy[message.resolutionUsed] === undefined ? message.resolutionUsed : $root.mythbound.websocket.v1.ConflictResolutionStrategy[message.resolutionUsed] : message.resolutionUsed;
                    if (message.resolutionReason != null && Object.hasOwnProperty.call(message, "resolutionReason"))
                        object.resolutionReason = message.resolutionReason;
                    return object;
                };

                /**
                 * Converts this StateConflict to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StateConflict.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StateConflict
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.StateConflict
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StateConflict.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.StateConflict";
                };

                return StateConflict;
            })();

            v1.VoiceSessionState = (function() {

                /**
                 * Properties of a VoiceSessionState.
                 * @memberof mythbound.websocket.v1
                 * @interface IVoiceSessionState
                 * @property {string|null} [sessionId] VoiceSessionState sessionId
                 * @property {string|null} [campaignId] VoiceSessionState campaignId
                 * @property {number|Long|null} [startedAt] VoiceSessionState startedAt
                 * @property {number|Long|null} [endedAt] VoiceSessionState endedAt
                 * @property {Array.<mythbound.websocket.v1.IVoiceParticipant>|null} [participants] VoiceSessionState participants
                 * @property {number|null} [maxParticipants] VoiceSessionState maxParticipants
                 * @property {string|null} [listeningMode] VoiceSessionState listeningMode
                 * @property {boolean|null} [wakeWordEnabled] VoiceSessionState wakeWordEnabled
                 * @property {string|null} [wakePhrase] VoiceSessionState wakePhrase
                 * @property {mythbound.websocket.v1.IAudioConfig|null} [audioConfig] VoiceSessionState audioConfig
                 * @property {mythbound.websocket.v1.IHLCTimestamp|null} [lastUpdated] VoiceSessionState lastUpdated
                 * @property {string|null} [stateVersion] VoiceSessionState stateVersion
                 */

                /**
                 * Constructs a new VoiceSessionState.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a VoiceSessionState.
                 * @implements IVoiceSessionState
                 * @constructor
                 * @param {mythbound.websocket.v1.IVoiceSessionState=} [properties] Properties to set
                 */
                function VoiceSessionState(properties) {
                    this.participants = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VoiceSessionState sessionId.
                 * @member {string} sessionId
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.sessionId = "";

                /**
                 * VoiceSessionState campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.campaignId = "";

                /**
                 * VoiceSessionState startedAt.
                 * @member {number|Long} startedAt
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.startedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * VoiceSessionState endedAt.
                 * @member {number|Long} endedAt
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.endedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * VoiceSessionState participants.
                 * @member {Array.<mythbound.websocket.v1.IVoiceParticipant>} participants
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.participants = $util.emptyArray;

                /**
                 * VoiceSessionState maxParticipants.
                 * @member {number} maxParticipants
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.maxParticipants = 0;

                /**
                 * VoiceSessionState listeningMode.
                 * @member {string} listeningMode
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.listeningMode = "";

                /**
                 * VoiceSessionState wakeWordEnabled.
                 * @member {boolean} wakeWordEnabled
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.wakeWordEnabled = false;

                /**
                 * VoiceSessionState wakePhrase.
                 * @member {string} wakePhrase
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.wakePhrase = "";

                /**
                 * VoiceSessionState audioConfig.
                 * @member {mythbound.websocket.v1.IAudioConfig|null|undefined} audioConfig
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.audioConfig = null;

                /**
                 * VoiceSessionState lastUpdated.
                 * @member {mythbound.websocket.v1.IHLCTimestamp|null|undefined} lastUpdated
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.lastUpdated = null;

                /**
                 * VoiceSessionState stateVersion.
                 * @member {string} stateVersion
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 */
                VoiceSessionState.prototype.stateVersion = "";

                /**
                 * Creates a new VoiceSessionState instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceSessionState=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.VoiceSessionState} VoiceSessionState instance
                 */
                VoiceSessionState.create = function create(properties) {
                    return new VoiceSessionState(properties);
                };

                /**
                 * Encodes the specified VoiceSessionState message. Does not implicitly {@link mythbound.websocket.v1.VoiceSessionState.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceSessionState} message VoiceSessionState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceSessionState.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.sessionId);
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.campaignId);
                    if (message.startedAt != null && Object.hasOwnProperty.call(message, "startedAt"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.startedAt);
                    if (message.endedAt != null && Object.hasOwnProperty.call(message, "endedAt"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.endedAt);
                    if (message.participants != null && message.participants.length)
                        for (let i = 0; i < message.participants.length; ++i)
                            $root.mythbound.websocket.v1.VoiceParticipant.encode(message.participants[i], writer.uint32(/* id 5, wireType 2 =*/42).fork(), q + 1).ldelim();
                    if (message.maxParticipants != null && Object.hasOwnProperty.call(message, "maxParticipants"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.maxParticipants);
                    if (message.listeningMode != null && Object.hasOwnProperty.call(message, "listeningMode"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.listeningMode);
                    if (message.wakeWordEnabled != null && Object.hasOwnProperty.call(message, "wakeWordEnabled"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.wakeWordEnabled);
                    if (message.wakePhrase != null && Object.hasOwnProperty.call(message, "wakePhrase"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.wakePhrase);
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig"))
                        $root.mythbound.websocket.v1.AudioConfig.encode(message.audioConfig, writer.uint32(/* id 10, wireType 2 =*/82).fork(), q + 1).ldelim();
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
                        $root.mythbound.websocket.v1.HLCTimestamp.encode(message.lastUpdated, writer.uint32(/* id 11, wireType 2 =*/90).fork(), q + 1).ldelim();
                    if (message.stateVersion != null && Object.hasOwnProperty.call(message, "stateVersion"))
                        writer.uint32(/* id 12, wireType 2 =*/98).string(message.stateVersion);
                    return writer;
                };

                /**
                 * Encodes the specified VoiceSessionState message, length delimited. Does not implicitly {@link mythbound.websocket.v1.VoiceSessionState.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceSessionState} message VoiceSessionState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceSessionState.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a VoiceSessionState message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.VoiceSessionState} VoiceSessionState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceSessionState.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.VoiceSessionState();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.sessionId = reader.string();
                                break;
                            }
                        case 2: {
                                message.campaignId = reader.string();
                                break;
                            }
                        case 3: {
                                message.startedAt = reader.int64();
                                break;
                            }
                        case 4: {
                                message.endedAt = reader.int64();
                                break;
                            }
                        case 5: {
                                if (!(message.participants && message.participants.length))
                                    message.participants = [];
                                message.participants.push($root.mythbound.websocket.v1.VoiceParticipant.decode(reader, reader.uint32(), undefined, long + 1));
                                break;
                            }
                        case 6: {
                                message.maxParticipants = reader.int32();
                                break;
                            }
                        case 7: {
                                message.listeningMode = reader.string();
                                break;
                            }
                        case 8: {
                                message.wakeWordEnabled = reader.bool();
                                break;
                            }
                        case 9: {
                                message.wakePhrase = reader.string();
                                break;
                            }
                        case 10: {
                                message.audioConfig = $root.mythbound.websocket.v1.AudioConfig.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 11: {
                                message.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 12: {
                                message.stateVersion = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a VoiceSessionState message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.VoiceSessionState} VoiceSessionState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceSessionState.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VoiceSessionState message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VoiceSessionState.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        if (!$util.isString(message.sessionId))
                            return "sessionId: string expected";
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    if (message.startedAt != null && Object.hasOwnProperty.call(message, "startedAt"))
                        if (!$util.isInteger(message.startedAt) && !(message.startedAt && $util.isInteger(message.startedAt.low) && $util.isInteger(message.startedAt.high)))
                            return "startedAt: integer|Long expected";
                    if (message.endedAt != null && Object.hasOwnProperty.call(message, "endedAt"))
                        if (!$util.isInteger(message.endedAt) && !(message.endedAt && $util.isInteger(message.endedAt.low) && $util.isInteger(message.endedAt.high)))
                            return "endedAt: integer|Long expected";
                    if (message.participants != null && Object.hasOwnProperty.call(message, "participants")) {
                        if (!Array.isArray(message.participants))
                            return "participants: array expected";
                        for (let i = 0; i < message.participants.length; ++i) {
                            let error = $root.mythbound.websocket.v1.VoiceParticipant.verify(message.participants[i], long + 1);
                            if (error)
                                return "participants." + error;
                        }
                    }
                    if (message.maxParticipants != null && Object.hasOwnProperty.call(message, "maxParticipants"))
                        if (!$util.isInteger(message.maxParticipants))
                            return "maxParticipants: integer expected";
                    if (message.listeningMode != null && Object.hasOwnProperty.call(message, "listeningMode"))
                        if (!$util.isString(message.listeningMode))
                            return "listeningMode: string expected";
                    if (message.wakeWordEnabled != null && Object.hasOwnProperty.call(message, "wakeWordEnabled"))
                        if (typeof message.wakeWordEnabled !== "boolean")
                            return "wakeWordEnabled: boolean expected";
                    if (message.wakePhrase != null && Object.hasOwnProperty.call(message, "wakePhrase"))
                        if (!$util.isString(message.wakePhrase))
                            return "wakePhrase: string expected";
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig")) {
                        let error = $root.mythbound.websocket.v1.AudioConfig.verify(message.audioConfig, long + 1);
                        if (error)
                            return "audioConfig." + error;
                    }
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated")) {
                        let error = $root.mythbound.websocket.v1.HLCTimestamp.verify(message.lastUpdated, long + 1);
                        if (error)
                            return "lastUpdated." + error;
                    }
                    if (message.stateVersion != null && Object.hasOwnProperty.call(message, "stateVersion"))
                        if (!$util.isString(message.stateVersion))
                            return "stateVersion: string expected";
                    return null;
                };

                /**
                 * Creates a VoiceSessionState message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.VoiceSessionState} VoiceSessionState
                 */
                VoiceSessionState.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.VoiceSessionState)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.VoiceSessionState: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.VoiceSessionState();
                    if (object.sessionId != null)
                        message.sessionId = String(object.sessionId);
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    if (object.startedAt != null)
                        if ($util.Long)
                            message.startedAt = $util.Long.fromValue(object.startedAt, false);
                        else if (typeof object.startedAt === "string")
                            message.startedAt = parseInt(object.startedAt, 10);
                        else if (typeof object.startedAt === "number")
                            message.startedAt = object.startedAt;
                        else if (typeof object.startedAt === "object")
                            message.startedAt = new $util.LongBits(object.startedAt.low >>> 0, object.startedAt.high >>> 0).toNumber();
                    if (object.endedAt != null)
                        if ($util.Long)
                            message.endedAt = $util.Long.fromValue(object.endedAt, false);
                        else if (typeof object.endedAt === "string")
                            message.endedAt = parseInt(object.endedAt, 10);
                        else if (typeof object.endedAt === "number")
                            message.endedAt = object.endedAt;
                        else if (typeof object.endedAt === "object")
                            message.endedAt = new $util.LongBits(object.endedAt.low >>> 0, object.endedAt.high >>> 0).toNumber();
                    if (object.participants) {
                        if (!Array.isArray(object.participants))
                            throw TypeError(".mythbound.websocket.v1.VoiceSessionState.participants: array expected");
                        message.participants = [];
                        for (let i = 0; i < object.participants.length; ++i) {
                            if (!$util.isObject(object.participants[i]))
                                throw TypeError(".mythbound.websocket.v1.VoiceSessionState.participants: object expected");
                            message.participants[i] = $root.mythbound.websocket.v1.VoiceParticipant.fromObject(object.participants[i], long + 1);
                        }
                    }
                    if (object.maxParticipants != null)
                        message.maxParticipants = object.maxParticipants | 0;
                    if (object.listeningMode != null)
                        message.listeningMode = String(object.listeningMode);
                    if (object.wakeWordEnabled != null)
                        message.wakeWordEnabled = Boolean(object.wakeWordEnabled);
                    if (object.wakePhrase != null)
                        message.wakePhrase = String(object.wakePhrase);
                    if (object.audioConfig != null) {
                        if (!$util.isObject(object.audioConfig))
                            throw TypeError(".mythbound.websocket.v1.VoiceSessionState.audioConfig: object expected");
                        message.audioConfig = $root.mythbound.websocket.v1.AudioConfig.fromObject(object.audioConfig, long + 1);
                    }
                    if (object.lastUpdated != null) {
                        if (!$util.isObject(object.lastUpdated))
                            throw TypeError(".mythbound.websocket.v1.VoiceSessionState.lastUpdated: object expected");
                        message.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.fromObject(object.lastUpdated, long + 1);
                    }
                    if (object.stateVersion != null)
                        message.stateVersion = String(object.stateVersion);
                    return message;
                };

                /**
                 * Creates a plain object from a VoiceSessionState message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @static
                 * @param {mythbound.websocket.v1.VoiceSessionState} message VoiceSessionState
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VoiceSessionState.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.participants = [];
                    if (options.defaults) {
                        object.sessionId = "";
                        object.campaignId = "";
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.startedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                        } else
                            object.startedAt = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.endedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                        } else
                            object.endedAt = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                        object.maxParticipants = 0;
                        object.listeningMode = "";
                        object.wakeWordEnabled = false;
                        object.wakePhrase = "";
                        object.audioConfig = null;
                        object.lastUpdated = null;
                        object.stateVersion = "";
                    }
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        object.sessionId = message.sessionId;
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    if (message.startedAt != null && Object.hasOwnProperty.call(message, "startedAt"))
                        if (typeof BigInt !== "undefined" && options.longs === BigInt)
                            object.startedAt = typeof message.startedAt === "number" ? BigInt(message.startedAt) : $util.Long.fromBits(message.startedAt.low >>> 0, message.startedAt.high >>> 0, false).toBigInt();
                        else if (typeof message.startedAt === "number")
                            object.startedAt = options.longs === String ? String(message.startedAt) : message.startedAt;
                        else
                            object.startedAt = options.longs === String ? $util.Long.prototype.toString.call(message.startedAt) : options.longs === Number ? new $util.LongBits(message.startedAt.low >>> 0, message.startedAt.high >>> 0).toNumber() : message.startedAt;
                    if (message.endedAt != null && Object.hasOwnProperty.call(message, "endedAt"))
                        if (typeof BigInt !== "undefined" && options.longs === BigInt)
                            object.endedAt = typeof message.endedAt === "number" ? BigInt(message.endedAt) : $util.Long.fromBits(message.endedAt.low >>> 0, message.endedAt.high >>> 0, false).toBigInt();
                        else if (typeof message.endedAt === "number")
                            object.endedAt = options.longs === String ? String(message.endedAt) : message.endedAt;
                        else
                            object.endedAt = options.longs === String ? $util.Long.prototype.toString.call(message.endedAt) : options.longs === Number ? new $util.LongBits(message.endedAt.low >>> 0, message.endedAt.high >>> 0).toNumber() : message.endedAt;
                    if (message.participants && message.participants.length) {
                        object.participants = [];
                        for (let j = 0; j < message.participants.length; ++j)
                            object.participants[j] = $root.mythbound.websocket.v1.VoiceParticipant.toObject(message.participants[j], options, q + 1);
                    }
                    if (message.maxParticipants != null && Object.hasOwnProperty.call(message, "maxParticipants"))
                        object.maxParticipants = message.maxParticipants;
                    if (message.listeningMode != null && Object.hasOwnProperty.call(message, "listeningMode"))
                        object.listeningMode = message.listeningMode;
                    if (message.wakeWordEnabled != null && Object.hasOwnProperty.call(message, "wakeWordEnabled"))
                        object.wakeWordEnabled = message.wakeWordEnabled;
                    if (message.wakePhrase != null && Object.hasOwnProperty.call(message, "wakePhrase"))
                        object.wakePhrase = message.wakePhrase;
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig"))
                        object.audioConfig = $root.mythbound.websocket.v1.AudioConfig.toObject(message.audioConfig, options, q + 1);
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
                        object.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.toObject(message.lastUpdated, options, q + 1);
                    if (message.stateVersion != null && Object.hasOwnProperty.call(message, "stateVersion"))
                        object.stateVersion = message.stateVersion;
                    return object;
                };

                /**
                 * Converts this VoiceSessionState to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VoiceSessionState.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VoiceSessionState
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.VoiceSessionState
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VoiceSessionState.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.VoiceSessionState";
                };

                return VoiceSessionState;
            })();

            v1.VoiceParticipant = (function() {

                /**
                 * Properties of a VoiceParticipant.
                 * @memberof mythbound.websocket.v1
                 * @interface IVoiceParticipant
                 * @property {string|null} [participantId] VoiceParticipant participantId
                 * @property {string|null} [userId] VoiceParticipant userId
                 * @property {string|null} [characterId] VoiceParticipant characterId
                 * @property {string|null} [characterName] VoiceParticipant characterName
                 * @property {string|null} [discordUserId] VoiceParticipant discordUserId
                 * @property {string|null} [platform] VoiceParticipant platform
                 * @property {number|Long|null} [joinedAt] VoiceParticipant joinedAt
                 * @property {boolean|null} [isListening] VoiceParticipant isListening
                 * @property {mythbound.websocket.v1.IAudioConfig|null} [audioConfig] VoiceParticipant audioConfig
                 */

                /**
                 * Constructs a new VoiceParticipant.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a VoiceParticipant.
                 * @implements IVoiceParticipant
                 * @constructor
                 * @param {mythbound.websocket.v1.IVoiceParticipant=} [properties] Properties to set
                 */
                function VoiceParticipant(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VoiceParticipant participantId.
                 * @member {string} participantId
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @instance
                 */
                VoiceParticipant.prototype.participantId = "";

                /**
                 * VoiceParticipant userId.
                 * @member {string} userId
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @instance
                 */
                VoiceParticipant.prototype.userId = "";

                /**
                 * VoiceParticipant characterId.
                 * @member {string} characterId
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @instance
                 */
                VoiceParticipant.prototype.characterId = "";

                /**
                 * VoiceParticipant characterName.
                 * @member {string} characterName
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @instance
                 */
                VoiceParticipant.prototype.characterName = "";

                /**
                 * VoiceParticipant discordUserId.
                 * @member {string} discordUserId
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @instance
                 */
                VoiceParticipant.prototype.discordUserId = "";

                /**
                 * VoiceParticipant platform.
                 * @member {string} platform
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @instance
                 */
                VoiceParticipant.prototype.platform = "";

                /**
                 * VoiceParticipant joinedAt.
                 * @member {number|Long} joinedAt
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @instance
                 */
                VoiceParticipant.prototype.joinedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * VoiceParticipant isListening.
                 * @member {boolean} isListening
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @instance
                 */
                VoiceParticipant.prototype.isListening = false;

                /**
                 * VoiceParticipant audioConfig.
                 * @member {mythbound.websocket.v1.IAudioConfig|null|undefined} audioConfig
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @instance
                 */
                VoiceParticipant.prototype.audioConfig = null;

                /**
                 * Creates a new VoiceParticipant instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceParticipant=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.VoiceParticipant} VoiceParticipant instance
                 */
                VoiceParticipant.create = function create(properties) {
                    return new VoiceParticipant(properties);
                };

                /**
                 * Encodes the specified VoiceParticipant message. Does not implicitly {@link mythbound.websocket.v1.VoiceParticipant.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceParticipant} message VoiceParticipant message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceParticipant.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.participantId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.userId);
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.characterId);
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.characterName);
                    if (message.discordUserId != null && Object.hasOwnProperty.call(message, "discordUserId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.discordUserId);
                    if (message.platform != null && Object.hasOwnProperty.call(message, "platform"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.platform);
                    if (message.joinedAt != null && Object.hasOwnProperty.call(message, "joinedAt"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.joinedAt);
                    if (message.isListening != null && Object.hasOwnProperty.call(message, "isListening"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isListening);
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig"))
                        $root.mythbound.websocket.v1.AudioConfig.encode(message.audioConfig, writer.uint32(/* id 9, wireType 2 =*/74).fork(), q + 1).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified VoiceParticipant message, length delimited. Does not implicitly {@link mythbound.websocket.v1.VoiceParticipant.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @static
                 * @param {mythbound.websocket.v1.IVoiceParticipant} message VoiceParticipant message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceParticipant.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a VoiceParticipant message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.VoiceParticipant} VoiceParticipant
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceParticipant.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.VoiceParticipant();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.participantId = reader.string();
                                break;
                            }
                        case 2: {
                                message.userId = reader.string();
                                break;
                            }
                        case 3: {
                                message.characterId = reader.string();
                                break;
                            }
                        case 4: {
                                message.characterName = reader.string();
                                break;
                            }
                        case 5: {
                                message.discordUserId = reader.string();
                                break;
                            }
                        case 6: {
                                message.platform = reader.string();
                                break;
                            }
                        case 7: {
                                message.joinedAt = reader.int64();
                                break;
                            }
                        case 8: {
                                message.isListening = reader.bool();
                                break;
                            }
                        case 9: {
                                message.audioConfig = $root.mythbound.websocket.v1.AudioConfig.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a VoiceParticipant message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.VoiceParticipant} VoiceParticipant
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceParticipant.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VoiceParticipant message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VoiceParticipant.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        if (!$util.isString(message.participantId))
                            return "participantId: string expected";
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        if (!$util.isString(message.characterId))
                            return "characterId: string expected";
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        if (!$util.isString(message.characterName))
                            return "characterName: string expected";
                    if (message.discordUserId != null && Object.hasOwnProperty.call(message, "discordUserId"))
                        if (!$util.isString(message.discordUserId))
                            return "discordUserId: string expected";
                    if (message.platform != null && Object.hasOwnProperty.call(message, "platform"))
                        if (!$util.isString(message.platform))
                            return "platform: string expected";
                    if (message.joinedAt != null && Object.hasOwnProperty.call(message, "joinedAt"))
                        if (!$util.isInteger(message.joinedAt) && !(message.joinedAt && $util.isInteger(message.joinedAt.low) && $util.isInteger(message.joinedAt.high)))
                            return "joinedAt: integer|Long expected";
                    if (message.isListening != null && Object.hasOwnProperty.call(message, "isListening"))
                        if (typeof message.isListening !== "boolean")
                            return "isListening: boolean expected";
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig")) {
                        let error = $root.mythbound.websocket.v1.AudioConfig.verify(message.audioConfig, long + 1);
                        if (error)
                            return "audioConfig." + error;
                    }
                    return null;
                };

                /**
                 * Creates a VoiceParticipant message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.VoiceParticipant} VoiceParticipant
                 */
                VoiceParticipant.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.VoiceParticipant)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.VoiceParticipant: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.VoiceParticipant();
                    if (object.participantId != null)
                        message.participantId = String(object.participantId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.characterId != null)
                        message.characterId = String(object.characterId);
                    if (object.characterName != null)
                        message.characterName = String(object.characterName);
                    if (object.discordUserId != null)
                        message.discordUserId = String(object.discordUserId);
                    if (object.platform != null)
                        message.platform = String(object.platform);
                    if (object.joinedAt != null)
                        if ($util.Long)
                            message.joinedAt = $util.Long.fromValue(object.joinedAt, false);
                        else if (typeof object.joinedAt === "string")
                            message.joinedAt = parseInt(object.joinedAt, 10);
                        else if (typeof object.joinedAt === "number")
                            message.joinedAt = object.joinedAt;
                        else if (typeof object.joinedAt === "object")
                            message.joinedAt = new $util.LongBits(object.joinedAt.low >>> 0, object.joinedAt.high >>> 0).toNumber();
                    if (object.isListening != null)
                        message.isListening = Boolean(object.isListening);
                    if (object.audioConfig != null) {
                        if (!$util.isObject(object.audioConfig))
                            throw TypeError(".mythbound.websocket.v1.VoiceParticipant.audioConfig: object expected");
                        message.audioConfig = $root.mythbound.websocket.v1.AudioConfig.fromObject(object.audioConfig, long + 1);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a VoiceParticipant message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @static
                 * @param {mythbound.websocket.v1.VoiceParticipant} message VoiceParticipant
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VoiceParticipant.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.participantId = "";
                        object.userId = "";
                        object.characterId = "";
                        object.characterName = "";
                        object.discordUserId = "";
                        object.platform = "";
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.joinedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                        } else
                            object.joinedAt = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                        object.isListening = false;
                        object.audioConfig = null;
                    }
                    if (message.participantId != null && Object.hasOwnProperty.call(message, "participantId"))
                        object.participantId = message.participantId;
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        object.userId = message.userId;
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        object.characterId = message.characterId;
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        object.characterName = message.characterName;
                    if (message.discordUserId != null && Object.hasOwnProperty.call(message, "discordUserId"))
                        object.discordUserId = message.discordUserId;
                    if (message.platform != null && Object.hasOwnProperty.call(message, "platform"))
                        object.platform = message.platform;
                    if (message.joinedAt != null && Object.hasOwnProperty.call(message, "joinedAt"))
                        if (typeof BigInt !== "undefined" && options.longs === BigInt)
                            object.joinedAt = typeof message.joinedAt === "number" ? BigInt(message.joinedAt) : $util.Long.fromBits(message.joinedAt.low >>> 0, message.joinedAt.high >>> 0, false).toBigInt();
                        else if (typeof message.joinedAt === "number")
                            object.joinedAt = options.longs === String ? String(message.joinedAt) : message.joinedAt;
                        else
                            object.joinedAt = options.longs === String ? $util.Long.prototype.toString.call(message.joinedAt) : options.longs === Number ? new $util.LongBits(message.joinedAt.low >>> 0, message.joinedAt.high >>> 0).toNumber() : message.joinedAt;
                    if (message.isListening != null && Object.hasOwnProperty.call(message, "isListening"))
                        object.isListening = message.isListening;
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig"))
                        object.audioConfig = $root.mythbound.websocket.v1.AudioConfig.toObject(message.audioConfig, options, q + 1);
                    return object;
                };

                /**
                 * Converts this VoiceParticipant to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VoiceParticipant.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VoiceParticipant
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.VoiceParticipant
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VoiceParticipant.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.VoiceParticipant";
                };

                return VoiceParticipant;
            })();

            v1.AudioConfig = (function() {

                /**
                 * Properties of an AudioConfig.
                 * @memberof mythbound.websocket.v1
                 * @interface IAudioConfig
                 * @property {number|null} [sampleRate] AudioConfig sampleRate
                 * @property {number|null} [channels] AudioConfig channels
                 * @property {number|null} [bitDepth] AudioConfig bitDepth
                 * @property {number|null} [frameSize] AudioConfig frameSize
                 * @property {string|null} [encoding] AudioConfig encoding
                 */

                /**
                 * Constructs a new AudioConfig.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents an AudioConfig.
                 * @implements IAudioConfig
                 * @constructor
                 * @param {mythbound.websocket.v1.IAudioConfig=} [properties] Properties to set
                 */
                function AudioConfig(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AudioConfig sampleRate.
                 * @member {number} sampleRate
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @instance
                 */
                AudioConfig.prototype.sampleRate = 0;

                /**
                 * AudioConfig channels.
                 * @member {number} channels
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @instance
                 */
                AudioConfig.prototype.channels = 0;

                /**
                 * AudioConfig bitDepth.
                 * @member {number} bitDepth
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @instance
                 */
                AudioConfig.prototype.bitDepth = 0;

                /**
                 * AudioConfig frameSize.
                 * @member {number} frameSize
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @instance
                 */
                AudioConfig.prototype.frameSize = 0;

                /**
                 * AudioConfig encoding.
                 * @member {string} encoding
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @instance
                 */
                AudioConfig.prototype.encoding = "";

                /**
                 * Creates a new AudioConfig instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @static
                 * @param {mythbound.websocket.v1.IAudioConfig=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.AudioConfig} AudioConfig instance
                 */
                AudioConfig.create = function create(properties) {
                    return new AudioConfig(properties);
                };

                /**
                 * Encodes the specified AudioConfig message. Does not implicitly {@link mythbound.websocket.v1.AudioConfig.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @static
                 * @param {mythbound.websocket.v1.IAudioConfig} message AudioConfig message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AudioConfig.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.sampleRate != null && Object.hasOwnProperty.call(message, "sampleRate"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.sampleRate);
                    if (message.channels != null && Object.hasOwnProperty.call(message, "channels"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.channels);
                    if (message.bitDepth != null && Object.hasOwnProperty.call(message, "bitDepth"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.bitDepth);
                    if (message.frameSize != null && Object.hasOwnProperty.call(message, "frameSize"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.frameSize);
                    if (message.encoding != null && Object.hasOwnProperty.call(message, "encoding"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.encoding);
                    return writer;
                };

                /**
                 * Encodes the specified AudioConfig message, length delimited. Does not implicitly {@link mythbound.websocket.v1.AudioConfig.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @static
                 * @param {mythbound.websocket.v1.IAudioConfig} message AudioConfig message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AudioConfig.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes an AudioConfig message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.AudioConfig} AudioConfig
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AudioConfig.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.AudioConfig();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.sampleRate = reader.int32();
                                break;
                            }
                        case 2: {
                                message.channels = reader.int32();
                                break;
                            }
                        case 3: {
                                message.bitDepth = reader.int32();
                                break;
                            }
                        case 4: {
                                message.frameSize = reader.int32();
                                break;
                            }
                        case 5: {
                                message.encoding = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes an AudioConfig message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.AudioConfig} AudioConfig
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AudioConfig.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AudioConfig message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AudioConfig.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.sampleRate != null && Object.hasOwnProperty.call(message, "sampleRate"))
                        if (!$util.isInteger(message.sampleRate))
                            return "sampleRate: integer expected";
                    if (message.channels != null && Object.hasOwnProperty.call(message, "channels"))
                        if (!$util.isInteger(message.channels))
                            return "channels: integer expected";
                    if (message.bitDepth != null && Object.hasOwnProperty.call(message, "bitDepth"))
                        if (!$util.isInteger(message.bitDepth))
                            return "bitDepth: integer expected";
                    if (message.frameSize != null && Object.hasOwnProperty.call(message, "frameSize"))
                        if (!$util.isInteger(message.frameSize))
                            return "frameSize: integer expected";
                    if (message.encoding != null && Object.hasOwnProperty.call(message, "encoding"))
                        if (!$util.isString(message.encoding))
                            return "encoding: string expected";
                    return null;
                };

                /**
                 * Creates an AudioConfig message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.AudioConfig} AudioConfig
                 */
                AudioConfig.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.AudioConfig)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.AudioConfig: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.AudioConfig();
                    if (object.sampleRate != null)
                        message.sampleRate = object.sampleRate | 0;
                    if (object.channels != null)
                        message.channels = object.channels | 0;
                    if (object.bitDepth != null)
                        message.bitDepth = object.bitDepth | 0;
                    if (object.frameSize != null)
                        message.frameSize = object.frameSize | 0;
                    if (object.encoding != null)
                        message.encoding = String(object.encoding);
                    return message;
                };

                /**
                 * Creates a plain object from an AudioConfig message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @static
                 * @param {mythbound.websocket.v1.AudioConfig} message AudioConfig
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AudioConfig.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.sampleRate = 0;
                        object.channels = 0;
                        object.bitDepth = 0;
                        object.frameSize = 0;
                        object.encoding = "";
                    }
                    if (message.sampleRate != null && Object.hasOwnProperty.call(message, "sampleRate"))
                        object.sampleRate = message.sampleRate;
                    if (message.channels != null && Object.hasOwnProperty.call(message, "channels"))
                        object.channels = message.channels;
                    if (message.bitDepth != null && Object.hasOwnProperty.call(message, "bitDepth"))
                        object.bitDepth = message.bitDepth;
                    if (message.frameSize != null && Object.hasOwnProperty.call(message, "frameSize"))
                        object.frameSize = message.frameSize;
                    if (message.encoding != null && Object.hasOwnProperty.call(message, "encoding"))
                        object.encoding = message.encoding;
                    return object;
                };

                /**
                 * Converts this AudioConfig to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AudioConfig.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for AudioConfig
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.AudioConfig
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                AudioConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.AudioConfig";
                };

                return AudioConfig;
            })();

            v1.CampaignState = (function() {

                /**
                 * Properties of a CampaignState.
                 * @memberof mythbound.websocket.v1
                 * @interface ICampaignState
                 * @property {string|null} [campaignId] CampaignState campaignId
                 * @property {string|null} [name] CampaignState name
                 * @property {string|null} [ownerUserId] CampaignState ownerUserId
                 * @property {Array.<mythbound.websocket.v1.ICampaignParticipant>|null} [participants] CampaignState participants
                 * @property {number|null} [maxParticipants] CampaignState maxParticipants
                 * @property {string|null} [activeVoiceSessionId] CampaignState activeVoiceSessionId
                 * @property {string|null} [discordGuildId] CampaignState discordGuildId
                 * @property {string|null} [discordVoiceChannelId] CampaignState discordVoiceChannelId
                 * @property {string|null} [discordTextChannelId] CampaignState discordTextChannelId
                 * @property {mythbound.websocket.v1.IHLCTimestamp|null} [lastUpdated] CampaignState lastUpdated
                 * @property {number|Long|null} [createdAt] CampaignState createdAt
                 */

                /**
                 * Constructs a new CampaignState.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a CampaignState.
                 * @implements ICampaignState
                 * @constructor
                 * @param {mythbound.websocket.v1.ICampaignState=} [properties] Properties to set
                 */
                function CampaignState(properties) {
                    this.participants = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CampaignState campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 */
                CampaignState.prototype.campaignId = "";

                /**
                 * CampaignState name.
                 * @member {string} name
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 */
                CampaignState.prototype.name = "";

                /**
                 * CampaignState ownerUserId.
                 * @member {string} ownerUserId
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 */
                CampaignState.prototype.ownerUserId = "";

                /**
                 * CampaignState participants.
                 * @member {Array.<mythbound.websocket.v1.ICampaignParticipant>} participants
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 */
                CampaignState.prototype.participants = $util.emptyArray;

                /**
                 * CampaignState maxParticipants.
                 * @member {number} maxParticipants
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 */
                CampaignState.prototype.maxParticipants = 0;

                /**
                 * CampaignState activeVoiceSessionId.
                 * @member {string} activeVoiceSessionId
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 */
                CampaignState.prototype.activeVoiceSessionId = "";

                /**
                 * CampaignState discordGuildId.
                 * @member {string} discordGuildId
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 */
                CampaignState.prototype.discordGuildId = "";

                /**
                 * CampaignState discordVoiceChannelId.
                 * @member {string} discordVoiceChannelId
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 */
                CampaignState.prototype.discordVoiceChannelId = "";

                /**
                 * CampaignState discordTextChannelId.
                 * @member {string} discordTextChannelId
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 */
                CampaignState.prototype.discordTextChannelId = "";

                /**
                 * CampaignState lastUpdated.
                 * @member {mythbound.websocket.v1.IHLCTimestamp|null|undefined} lastUpdated
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 */
                CampaignState.prototype.lastUpdated = null;

                /**
                 * CampaignState createdAt.
                 * @member {number|Long} createdAt
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 */
                CampaignState.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new CampaignState instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignState=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.CampaignState} CampaignState instance
                 */
                CampaignState.create = function create(properties) {
                    return new CampaignState(properties);
                };

                /**
                 * Encodes the specified CampaignState message. Does not implicitly {@link mythbound.websocket.v1.CampaignState.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignState} message CampaignState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CampaignState.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.campaignId);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.ownerUserId != null && Object.hasOwnProperty.call(message, "ownerUserId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.ownerUserId);
                    if (message.participants != null && message.participants.length)
                        for (let i = 0; i < message.participants.length; ++i)
                            $root.mythbound.websocket.v1.CampaignParticipant.encode(message.participants[i], writer.uint32(/* id 4, wireType 2 =*/34).fork(), q + 1).ldelim();
                    if (message.maxParticipants != null && Object.hasOwnProperty.call(message, "maxParticipants"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.maxParticipants);
                    if (message.activeVoiceSessionId != null && Object.hasOwnProperty.call(message, "activeVoiceSessionId"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.activeVoiceSessionId);
                    if (message.discordGuildId != null && Object.hasOwnProperty.call(message, "discordGuildId"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.discordGuildId);
                    if (message.discordVoiceChannelId != null && Object.hasOwnProperty.call(message, "discordVoiceChannelId"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.discordVoiceChannelId);
                    if (message.discordTextChannelId != null && Object.hasOwnProperty.call(message, "discordTextChannelId"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.discordTextChannelId);
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
                        $root.mythbound.websocket.v1.HLCTimestamp.encode(message.lastUpdated, writer.uint32(/* id 10, wireType 2 =*/82).fork(), q + 1).ldelim();
                    if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                        writer.uint32(/* id 11, wireType 0 =*/88).int64(message.createdAt);
                    return writer;
                };

                /**
                 * Encodes the specified CampaignState message, length delimited. Does not implicitly {@link mythbound.websocket.v1.CampaignState.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignState} message CampaignState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CampaignState.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a CampaignState message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.CampaignState} CampaignState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CampaignState.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.CampaignState();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.campaignId = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.ownerUserId = reader.string();
                                break;
                            }
                        case 4: {
                                if (!(message.participants && message.participants.length))
                                    message.participants = [];
                                message.participants.push($root.mythbound.websocket.v1.CampaignParticipant.decode(reader, reader.uint32(), undefined, long + 1));
                                break;
                            }
                        case 5: {
                                message.maxParticipants = reader.int32();
                                break;
                            }
                        case 6: {
                                message.activeVoiceSessionId = reader.string();
                                break;
                            }
                        case 7: {
                                message.discordGuildId = reader.string();
                                break;
                            }
                        case 8: {
                                message.discordVoiceChannelId = reader.string();
                                break;
                            }
                        case 9: {
                                message.discordTextChannelId = reader.string();
                                break;
                            }
                        case 10: {
                                message.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 11: {
                                message.createdAt = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a CampaignState message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.CampaignState} CampaignState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CampaignState.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CampaignState message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CampaignState.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.ownerUserId != null && Object.hasOwnProperty.call(message, "ownerUserId"))
                        if (!$util.isString(message.ownerUserId))
                            return "ownerUserId: string expected";
                    if (message.participants != null && Object.hasOwnProperty.call(message, "participants")) {
                        if (!Array.isArray(message.participants))
                            return "participants: array expected";
                        for (let i = 0; i < message.participants.length; ++i) {
                            let error = $root.mythbound.websocket.v1.CampaignParticipant.verify(message.participants[i], long + 1);
                            if (error)
                                return "participants." + error;
                        }
                    }
                    if (message.maxParticipants != null && Object.hasOwnProperty.call(message, "maxParticipants"))
                        if (!$util.isInteger(message.maxParticipants))
                            return "maxParticipants: integer expected";
                    if (message.activeVoiceSessionId != null && Object.hasOwnProperty.call(message, "activeVoiceSessionId"))
                        if (!$util.isString(message.activeVoiceSessionId))
                            return "activeVoiceSessionId: string expected";
                    if (message.discordGuildId != null && Object.hasOwnProperty.call(message, "discordGuildId"))
                        if (!$util.isString(message.discordGuildId))
                            return "discordGuildId: string expected";
                    if (message.discordVoiceChannelId != null && Object.hasOwnProperty.call(message, "discordVoiceChannelId"))
                        if (!$util.isString(message.discordVoiceChannelId))
                            return "discordVoiceChannelId: string expected";
                    if (message.discordTextChannelId != null && Object.hasOwnProperty.call(message, "discordTextChannelId"))
                        if (!$util.isString(message.discordTextChannelId))
                            return "discordTextChannelId: string expected";
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated")) {
                        let error = $root.mythbound.websocket.v1.HLCTimestamp.verify(message.lastUpdated, long + 1);
                        if (error)
                            return "lastUpdated." + error;
                    }
                    if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                        if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                            return "createdAt: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a CampaignState message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.CampaignState} CampaignState
                 */
                CampaignState.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.CampaignState)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.CampaignState: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.CampaignState();
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.ownerUserId != null)
                        message.ownerUserId = String(object.ownerUserId);
                    if (object.participants) {
                        if (!Array.isArray(object.participants))
                            throw TypeError(".mythbound.websocket.v1.CampaignState.participants: array expected");
                        message.participants = [];
                        for (let i = 0; i < object.participants.length; ++i) {
                            if (!$util.isObject(object.participants[i]))
                                throw TypeError(".mythbound.websocket.v1.CampaignState.participants: object expected");
                            message.participants[i] = $root.mythbound.websocket.v1.CampaignParticipant.fromObject(object.participants[i], long + 1);
                        }
                    }
                    if (object.maxParticipants != null)
                        message.maxParticipants = object.maxParticipants | 0;
                    if (object.activeVoiceSessionId != null)
                        message.activeVoiceSessionId = String(object.activeVoiceSessionId);
                    if (object.discordGuildId != null)
                        message.discordGuildId = String(object.discordGuildId);
                    if (object.discordVoiceChannelId != null)
                        message.discordVoiceChannelId = String(object.discordVoiceChannelId);
                    if (object.discordTextChannelId != null)
                        message.discordTextChannelId = String(object.discordTextChannelId);
                    if (object.lastUpdated != null) {
                        if (!$util.isObject(object.lastUpdated))
                            throw TypeError(".mythbound.websocket.v1.CampaignState.lastUpdated: object expected");
                        message.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.fromObject(object.lastUpdated, long + 1);
                    }
                    if (object.createdAt != null)
                        if ($util.Long)
                            message.createdAt = $util.Long.fromValue(object.createdAt, false);
                        else if (typeof object.createdAt === "string")
                            message.createdAt = parseInt(object.createdAt, 10);
                        else if (typeof object.createdAt === "number")
                            message.createdAt = object.createdAt;
                        else if (typeof object.createdAt === "object")
                            message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a CampaignState message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @static
                 * @param {mythbound.websocket.v1.CampaignState} message CampaignState
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CampaignState.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.participants = [];
                    if (options.defaults) {
                        object.campaignId = "";
                        object.name = "";
                        object.ownerUserId = "";
                        object.maxParticipants = 0;
                        object.activeVoiceSessionId = "";
                        object.discordGuildId = "";
                        object.discordVoiceChannelId = "";
                        object.discordTextChannelId = "";
                        object.lastUpdated = null;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                        } else
                            object.createdAt = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                    }
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        object.name = message.name;
                    if (message.ownerUserId != null && Object.hasOwnProperty.call(message, "ownerUserId"))
                        object.ownerUserId = message.ownerUserId;
                    if (message.participants && message.participants.length) {
                        object.participants = [];
                        for (let j = 0; j < message.participants.length; ++j)
                            object.participants[j] = $root.mythbound.websocket.v1.CampaignParticipant.toObject(message.participants[j], options, q + 1);
                    }
                    if (message.maxParticipants != null && Object.hasOwnProperty.call(message, "maxParticipants"))
                        object.maxParticipants = message.maxParticipants;
                    if (message.activeVoiceSessionId != null && Object.hasOwnProperty.call(message, "activeVoiceSessionId"))
                        object.activeVoiceSessionId = message.activeVoiceSessionId;
                    if (message.discordGuildId != null && Object.hasOwnProperty.call(message, "discordGuildId"))
                        object.discordGuildId = message.discordGuildId;
                    if (message.discordVoiceChannelId != null && Object.hasOwnProperty.call(message, "discordVoiceChannelId"))
                        object.discordVoiceChannelId = message.discordVoiceChannelId;
                    if (message.discordTextChannelId != null && Object.hasOwnProperty.call(message, "discordTextChannelId"))
                        object.discordTextChannelId = message.discordTextChannelId;
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
                        object.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.toObject(message.lastUpdated, options, q + 1);
                    if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                        if (typeof BigInt !== "undefined" && options.longs === BigInt)
                            object.createdAt = typeof message.createdAt === "number" ? BigInt(message.createdAt) : $util.Long.fromBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0, false).toBigInt();
                        else if (typeof message.createdAt === "number")
                            object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                        else
                            object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
                    return object;
                };

                /**
                 * Converts this CampaignState to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CampaignState.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CampaignState
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.CampaignState
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CampaignState.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.CampaignState";
                };

                return CampaignState;
            })();

            v1.CampaignParticipant = (function() {

                /**
                 * Properties of a CampaignParticipant.
                 * @memberof mythbound.websocket.v1
                 * @interface ICampaignParticipant
                 * @property {string|null} [userId] CampaignParticipant userId
                 * @property {string|null} [characterId] CampaignParticipant characterId
                 * @property {string|null} [role] CampaignParticipant role
                 * @property {number|Long|null} [joinedAt] CampaignParticipant joinedAt
                 */

                /**
                 * Constructs a new CampaignParticipant.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a CampaignParticipant.
                 * @implements ICampaignParticipant
                 * @constructor
                 * @param {mythbound.websocket.v1.ICampaignParticipant=} [properties] Properties to set
                 */
                function CampaignParticipant(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CampaignParticipant userId.
                 * @member {string} userId
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @instance
                 */
                CampaignParticipant.prototype.userId = "";

                /**
                 * CampaignParticipant characterId.
                 * @member {string} characterId
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @instance
                 */
                CampaignParticipant.prototype.characterId = "";

                /**
                 * CampaignParticipant role.
                 * @member {string} role
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @instance
                 */
                CampaignParticipant.prototype.role = "";

                /**
                 * CampaignParticipant joinedAt.
                 * @member {number|Long} joinedAt
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @instance
                 */
                CampaignParticipant.prototype.joinedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new CampaignParticipant instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignParticipant=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.CampaignParticipant} CampaignParticipant instance
                 */
                CampaignParticipant.create = function create(properties) {
                    return new CampaignParticipant(properties);
                };

                /**
                 * Encodes the specified CampaignParticipant message. Does not implicitly {@link mythbound.websocket.v1.CampaignParticipant.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignParticipant} message CampaignParticipant message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CampaignParticipant.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.characterId);
                    if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.role);
                    if (message.joinedAt != null && Object.hasOwnProperty.call(message, "joinedAt"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.joinedAt);
                    return writer;
                };

                /**
                 * Encodes the specified CampaignParticipant message, length delimited. Does not implicitly {@link mythbound.websocket.v1.CampaignParticipant.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @static
                 * @param {mythbound.websocket.v1.ICampaignParticipant} message CampaignParticipant message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CampaignParticipant.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a CampaignParticipant message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.CampaignParticipant} CampaignParticipant
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CampaignParticipant.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.CampaignParticipant();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.userId = reader.string();
                                break;
                            }
                        case 2: {
                                message.characterId = reader.string();
                                break;
                            }
                        case 3: {
                                message.role = reader.string();
                                break;
                            }
                        case 4: {
                                message.joinedAt = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a CampaignParticipant message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.CampaignParticipant} CampaignParticipant
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CampaignParticipant.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CampaignParticipant message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CampaignParticipant.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        if (!$util.isString(message.characterId))
                            return "characterId: string expected";
                    if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                        if (!$util.isString(message.role))
                            return "role: string expected";
                    if (message.joinedAt != null && Object.hasOwnProperty.call(message, "joinedAt"))
                        if (!$util.isInteger(message.joinedAt) && !(message.joinedAt && $util.isInteger(message.joinedAt.low) && $util.isInteger(message.joinedAt.high)))
                            return "joinedAt: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a CampaignParticipant message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.CampaignParticipant} CampaignParticipant
                 */
                CampaignParticipant.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.CampaignParticipant)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.CampaignParticipant: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.CampaignParticipant();
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.characterId != null)
                        message.characterId = String(object.characterId);
                    if (object.role != null)
                        message.role = String(object.role);
                    if (object.joinedAt != null)
                        if ($util.Long)
                            message.joinedAt = $util.Long.fromValue(object.joinedAt, false);
                        else if (typeof object.joinedAt === "string")
                            message.joinedAt = parseInt(object.joinedAt, 10);
                        else if (typeof object.joinedAt === "number")
                            message.joinedAt = object.joinedAt;
                        else if (typeof object.joinedAt === "object")
                            message.joinedAt = new $util.LongBits(object.joinedAt.low >>> 0, object.joinedAt.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a CampaignParticipant message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @static
                 * @param {mythbound.websocket.v1.CampaignParticipant} message CampaignParticipant
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CampaignParticipant.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.userId = "";
                        object.characterId = "";
                        object.role = "";
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.joinedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                        } else
                            object.joinedAt = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                    }
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        object.userId = message.userId;
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        object.characterId = message.characterId;
                    if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                        object.role = message.role;
                    if (message.joinedAt != null && Object.hasOwnProperty.call(message, "joinedAt"))
                        if (typeof BigInt !== "undefined" && options.longs === BigInt)
                            object.joinedAt = typeof message.joinedAt === "number" ? BigInt(message.joinedAt) : $util.Long.fromBits(message.joinedAt.low >>> 0, message.joinedAt.high >>> 0, false).toBigInt();
                        else if (typeof message.joinedAt === "number")
                            object.joinedAt = options.longs === String ? String(message.joinedAt) : message.joinedAt;
                        else
                            object.joinedAt = options.longs === String ? $util.Long.prototype.toString.call(message.joinedAt) : options.longs === Number ? new $util.LongBits(message.joinedAt.low >>> 0, message.joinedAt.high >>> 0).toNumber() : message.joinedAt;
                    return object;
                };

                /**
                 * Converts this CampaignParticipant to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CampaignParticipant.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CampaignParticipant
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.CampaignParticipant
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CampaignParticipant.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.CampaignParticipant";
                };

                return CampaignParticipant;
            })();

            v1.NarrativeState = (function() {

                /**
                 * Properties of a NarrativeState.
                 * @memberof mythbound.websocket.v1
                 * @interface INarrativeState
                 * @property {string|null} [campaignId] NarrativeState campaignId
                 * @property {string|null} [currentScene] NarrativeState currentScene
                 * @property {string|null} [narrativeContext] NarrativeState narrativeContext
                 * @property {Array.<string>|null} [recentEvents] NarrativeState recentEvents
                 * @property {string|null} [activeEngine] NarrativeState activeEngine
                 * @property {string|null} [engineModel] NarrativeState engineModel
                 * @property {boolean|null} [engineHealthy] NarrativeState engineHealthy
                 * @property {string|null} [currentRequestId] NarrativeState currentRequestId
                 * @property {boolean|null} [isProcessing] NarrativeState isProcessing
                 * @property {mythbound.websocket.v1.IHLCTimestamp|null} [lastUpdated] NarrativeState lastUpdated
                 */

                /**
                 * Constructs a new NarrativeState.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a NarrativeState.
                 * @implements INarrativeState
                 * @constructor
                 * @param {mythbound.websocket.v1.INarrativeState=} [properties] Properties to set
                 */
                function NarrativeState(properties) {
                    this.recentEvents = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NarrativeState campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @instance
                 */
                NarrativeState.prototype.campaignId = "";

                /**
                 * NarrativeState currentScene.
                 * @member {string} currentScene
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @instance
                 */
                NarrativeState.prototype.currentScene = "";

                /**
                 * NarrativeState narrativeContext.
                 * @member {string} narrativeContext
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @instance
                 */
                NarrativeState.prototype.narrativeContext = "";

                /**
                 * NarrativeState recentEvents.
                 * @member {Array.<string>} recentEvents
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @instance
                 */
                NarrativeState.prototype.recentEvents = $util.emptyArray;

                /**
                 * NarrativeState activeEngine.
                 * @member {string} activeEngine
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @instance
                 */
                NarrativeState.prototype.activeEngine = "";

                /**
                 * NarrativeState engineModel.
                 * @member {string} engineModel
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @instance
                 */
                NarrativeState.prototype.engineModel = "";

                /**
                 * NarrativeState engineHealthy.
                 * @member {boolean} engineHealthy
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @instance
                 */
                NarrativeState.prototype.engineHealthy = false;

                /**
                 * NarrativeState currentRequestId.
                 * @member {string} currentRequestId
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @instance
                 */
                NarrativeState.prototype.currentRequestId = "";

                /**
                 * NarrativeState isProcessing.
                 * @member {boolean} isProcessing
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @instance
                 */
                NarrativeState.prototype.isProcessing = false;

                /**
                 * NarrativeState lastUpdated.
                 * @member {mythbound.websocket.v1.IHLCTimestamp|null|undefined} lastUpdated
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @instance
                 */
                NarrativeState.prototype.lastUpdated = null;

                /**
                 * Creates a new NarrativeState instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @static
                 * @param {mythbound.websocket.v1.INarrativeState=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.NarrativeState} NarrativeState instance
                 */
                NarrativeState.create = function create(properties) {
                    return new NarrativeState(properties);
                };

                /**
                 * Encodes the specified NarrativeState message. Does not implicitly {@link mythbound.websocket.v1.NarrativeState.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @static
                 * @param {mythbound.websocket.v1.INarrativeState} message NarrativeState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NarrativeState.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.campaignId);
                    if (message.currentScene != null && Object.hasOwnProperty.call(message, "currentScene"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.currentScene);
                    if (message.narrativeContext != null && Object.hasOwnProperty.call(message, "narrativeContext"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.narrativeContext);
                    if (message.recentEvents != null && message.recentEvents.length)
                        for (let i = 0; i < message.recentEvents.length; ++i)
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.recentEvents[i]);
                    if (message.activeEngine != null && Object.hasOwnProperty.call(message, "activeEngine"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.activeEngine);
                    if (message.engineModel != null && Object.hasOwnProperty.call(message, "engineModel"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.engineModel);
                    if (message.engineHealthy != null && Object.hasOwnProperty.call(message, "engineHealthy"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.engineHealthy);
                    if (message.currentRequestId != null && Object.hasOwnProperty.call(message, "currentRequestId"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.currentRequestId);
                    if (message.isProcessing != null && Object.hasOwnProperty.call(message, "isProcessing"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isProcessing);
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
                        $root.mythbound.websocket.v1.HLCTimestamp.encode(message.lastUpdated, writer.uint32(/* id 10, wireType 2 =*/82).fork(), q + 1).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified NarrativeState message, length delimited. Does not implicitly {@link mythbound.websocket.v1.NarrativeState.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @static
                 * @param {mythbound.websocket.v1.INarrativeState} message NarrativeState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NarrativeState.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a NarrativeState message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.NarrativeState} NarrativeState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NarrativeState.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.NarrativeState();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.campaignId = reader.string();
                                break;
                            }
                        case 2: {
                                message.currentScene = reader.string();
                                break;
                            }
                        case 3: {
                                message.narrativeContext = reader.string();
                                break;
                            }
                        case 4: {
                                if (!(message.recentEvents && message.recentEvents.length))
                                    message.recentEvents = [];
                                message.recentEvents.push(reader.string());
                                break;
                            }
                        case 5: {
                                message.activeEngine = reader.string();
                                break;
                            }
                        case 6: {
                                message.engineModel = reader.string();
                                break;
                            }
                        case 7: {
                                message.engineHealthy = reader.bool();
                                break;
                            }
                        case 8: {
                                message.currentRequestId = reader.string();
                                break;
                            }
                        case 9: {
                                message.isProcessing = reader.bool();
                                break;
                            }
                        case 10: {
                                message.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a NarrativeState message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.NarrativeState} NarrativeState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NarrativeState.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NarrativeState message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NarrativeState.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    if (message.currentScene != null && Object.hasOwnProperty.call(message, "currentScene"))
                        if (!$util.isString(message.currentScene))
                            return "currentScene: string expected";
                    if (message.narrativeContext != null && Object.hasOwnProperty.call(message, "narrativeContext"))
                        if (!$util.isString(message.narrativeContext))
                            return "narrativeContext: string expected";
                    if (message.recentEvents != null && Object.hasOwnProperty.call(message, "recentEvents")) {
                        if (!Array.isArray(message.recentEvents))
                            return "recentEvents: array expected";
                        for (let i = 0; i < message.recentEvents.length; ++i)
                            if (!$util.isString(message.recentEvents[i]))
                                return "recentEvents: string[] expected";
                    }
                    if (message.activeEngine != null && Object.hasOwnProperty.call(message, "activeEngine"))
                        if (!$util.isString(message.activeEngine))
                            return "activeEngine: string expected";
                    if (message.engineModel != null && Object.hasOwnProperty.call(message, "engineModel"))
                        if (!$util.isString(message.engineModel))
                            return "engineModel: string expected";
                    if (message.engineHealthy != null && Object.hasOwnProperty.call(message, "engineHealthy"))
                        if (typeof message.engineHealthy !== "boolean")
                            return "engineHealthy: boolean expected";
                    if (message.currentRequestId != null && Object.hasOwnProperty.call(message, "currentRequestId"))
                        if (!$util.isString(message.currentRequestId))
                            return "currentRequestId: string expected";
                    if (message.isProcessing != null && Object.hasOwnProperty.call(message, "isProcessing"))
                        if (typeof message.isProcessing !== "boolean")
                            return "isProcessing: boolean expected";
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated")) {
                        let error = $root.mythbound.websocket.v1.HLCTimestamp.verify(message.lastUpdated, long + 1);
                        if (error)
                            return "lastUpdated." + error;
                    }
                    return null;
                };

                /**
                 * Creates a NarrativeState message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.NarrativeState} NarrativeState
                 */
                NarrativeState.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.NarrativeState)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.NarrativeState: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.NarrativeState();
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    if (object.currentScene != null)
                        message.currentScene = String(object.currentScene);
                    if (object.narrativeContext != null)
                        message.narrativeContext = String(object.narrativeContext);
                    if (object.recentEvents) {
                        if (!Array.isArray(object.recentEvents))
                            throw TypeError(".mythbound.websocket.v1.NarrativeState.recentEvents: array expected");
                        message.recentEvents = [];
                        for (let i = 0; i < object.recentEvents.length; ++i)
                            message.recentEvents[i] = String(object.recentEvents[i]);
                    }
                    if (object.activeEngine != null)
                        message.activeEngine = String(object.activeEngine);
                    if (object.engineModel != null)
                        message.engineModel = String(object.engineModel);
                    if (object.engineHealthy != null)
                        message.engineHealthy = Boolean(object.engineHealthy);
                    if (object.currentRequestId != null)
                        message.currentRequestId = String(object.currentRequestId);
                    if (object.isProcessing != null)
                        message.isProcessing = Boolean(object.isProcessing);
                    if (object.lastUpdated != null) {
                        if (!$util.isObject(object.lastUpdated))
                            throw TypeError(".mythbound.websocket.v1.NarrativeState.lastUpdated: object expected");
                        message.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.fromObject(object.lastUpdated, long + 1);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a NarrativeState message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @static
                 * @param {mythbound.websocket.v1.NarrativeState} message NarrativeState
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NarrativeState.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.recentEvents = [];
                    if (options.defaults) {
                        object.campaignId = "";
                        object.currentScene = "";
                        object.narrativeContext = "";
                        object.activeEngine = "";
                        object.engineModel = "";
                        object.engineHealthy = false;
                        object.currentRequestId = "";
                        object.isProcessing = false;
                        object.lastUpdated = null;
                    }
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    if (message.currentScene != null && Object.hasOwnProperty.call(message, "currentScene"))
                        object.currentScene = message.currentScene;
                    if (message.narrativeContext != null && Object.hasOwnProperty.call(message, "narrativeContext"))
                        object.narrativeContext = message.narrativeContext;
                    if (message.recentEvents && message.recentEvents.length) {
                        object.recentEvents = [];
                        for (let j = 0; j < message.recentEvents.length; ++j)
                            object.recentEvents[j] = message.recentEvents[j];
                    }
                    if (message.activeEngine != null && Object.hasOwnProperty.call(message, "activeEngine"))
                        object.activeEngine = message.activeEngine;
                    if (message.engineModel != null && Object.hasOwnProperty.call(message, "engineModel"))
                        object.engineModel = message.engineModel;
                    if (message.engineHealthy != null && Object.hasOwnProperty.call(message, "engineHealthy"))
                        object.engineHealthy = message.engineHealthy;
                    if (message.currentRequestId != null && Object.hasOwnProperty.call(message, "currentRequestId"))
                        object.currentRequestId = message.currentRequestId;
                    if (message.isProcessing != null && Object.hasOwnProperty.call(message, "isProcessing"))
                        object.isProcessing = message.isProcessing;
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
                        object.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.toObject(message.lastUpdated, options, q + 1);
                    return object;
                };

                /**
                 * Converts this NarrativeState to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NarrativeState.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for NarrativeState
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.NarrativeState
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                NarrativeState.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.NarrativeState";
                };

                return NarrativeState;
            })();

            v1.CharacterState = (function() {

                /**
                 * Properties of a CharacterState.
                 * @memberof mythbound.websocket.v1
                 * @interface ICharacterState
                 * @property {string|null} [characterId] CharacterState characterId
                 * @property {string|null} [characterName] CharacterState characterName
                 * @property {string|null} [userId] CharacterState userId
                 * @property {string|null} [campaignId] CharacterState campaignId
                 * @property {string|null} [attributes] CharacterState attributes
                 * @property {string|null} [statusEffects] CharacterState statusEffects
                 * @property {mythbound.websocket.v1.IHLCTimestamp|null} [lastUpdated] CharacterState lastUpdated
                 * @property {number|Long|null} [createdAt] CharacterState createdAt
                 */

                /**
                 * Constructs a new CharacterState.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a CharacterState.
                 * @implements ICharacterState
                 * @constructor
                 * @param {mythbound.websocket.v1.ICharacterState=} [properties] Properties to set
                 */
                function CharacterState(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CharacterState characterId.
                 * @member {string} characterId
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @instance
                 */
                CharacterState.prototype.characterId = "";

                /**
                 * CharacterState characterName.
                 * @member {string} characterName
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @instance
                 */
                CharacterState.prototype.characterName = "";

                /**
                 * CharacterState userId.
                 * @member {string} userId
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @instance
                 */
                CharacterState.prototype.userId = "";

                /**
                 * CharacterState campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @instance
                 */
                CharacterState.prototype.campaignId = "";

                /**
                 * CharacterState attributes.
                 * @member {string} attributes
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @instance
                 */
                CharacterState.prototype.attributes = "";

                /**
                 * CharacterState statusEffects.
                 * @member {string} statusEffects
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @instance
                 */
                CharacterState.prototype.statusEffects = "";

                /**
                 * CharacterState lastUpdated.
                 * @member {mythbound.websocket.v1.IHLCTimestamp|null|undefined} lastUpdated
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @instance
                 */
                CharacterState.prototype.lastUpdated = null;

                /**
                 * CharacterState createdAt.
                 * @member {number|Long} createdAt
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @instance
                 */
                CharacterState.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new CharacterState instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @static
                 * @param {mythbound.websocket.v1.ICharacterState=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.CharacterState} CharacterState instance
                 */
                CharacterState.create = function create(properties) {
                    return new CharacterState(properties);
                };

                /**
                 * Encodes the specified CharacterState message. Does not implicitly {@link mythbound.websocket.v1.CharacterState.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @static
                 * @param {mythbound.websocket.v1.ICharacterState} message CharacterState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CharacterState.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.characterId);
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.characterName);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.userId);
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.campaignId);
                    if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.attributes);
                    if (message.statusEffects != null && Object.hasOwnProperty.call(message, "statusEffects"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.statusEffects);
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
                        $root.mythbound.websocket.v1.HLCTimestamp.encode(message.lastUpdated, writer.uint32(/* id 7, wireType 2 =*/58).fork(), q + 1).ldelim();
                    if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createdAt);
                    return writer;
                };

                /**
                 * Encodes the specified CharacterState message, length delimited. Does not implicitly {@link mythbound.websocket.v1.CharacterState.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @static
                 * @param {mythbound.websocket.v1.ICharacterState} message CharacterState message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CharacterState.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a CharacterState message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.CharacterState} CharacterState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CharacterState.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.CharacterState();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.characterId = reader.string();
                                break;
                            }
                        case 2: {
                                message.characterName = reader.string();
                                break;
                            }
                        case 3: {
                                message.userId = reader.string();
                                break;
                            }
                        case 4: {
                                message.campaignId = reader.string();
                                break;
                            }
                        case 5: {
                                message.attributes = reader.string();
                                break;
                            }
                        case 6: {
                                message.statusEffects = reader.string();
                                break;
                            }
                        case 7: {
                                message.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 8: {
                                message.createdAt = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a CharacterState message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.CharacterState} CharacterState
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CharacterState.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CharacterState message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CharacterState.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        if (!$util.isString(message.characterId))
                            return "characterId: string expected";
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        if (!$util.isString(message.characterName))
                            return "characterName: string expected";
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
                        if (!$util.isString(message.attributes))
                            return "attributes: string expected";
                    if (message.statusEffects != null && Object.hasOwnProperty.call(message, "statusEffects"))
                        if (!$util.isString(message.statusEffects))
                            return "statusEffects: string expected";
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated")) {
                        let error = $root.mythbound.websocket.v1.HLCTimestamp.verify(message.lastUpdated, long + 1);
                        if (error)
                            return "lastUpdated." + error;
                    }
                    if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                        if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                            return "createdAt: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a CharacterState message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.CharacterState} CharacterState
                 */
                CharacterState.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.CharacterState)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.CharacterState: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.CharacterState();
                    if (object.characterId != null)
                        message.characterId = String(object.characterId);
                    if (object.characterName != null)
                        message.characterName = String(object.characterName);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    if (object.attributes != null)
                        message.attributes = String(object.attributes);
                    if (object.statusEffects != null)
                        message.statusEffects = String(object.statusEffects);
                    if (object.lastUpdated != null) {
                        if (!$util.isObject(object.lastUpdated))
                            throw TypeError(".mythbound.websocket.v1.CharacterState.lastUpdated: object expected");
                        message.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.fromObject(object.lastUpdated, long + 1);
                    }
                    if (object.createdAt != null)
                        if ($util.Long)
                            message.createdAt = $util.Long.fromValue(object.createdAt, false);
                        else if (typeof object.createdAt === "string")
                            message.createdAt = parseInt(object.createdAt, 10);
                        else if (typeof object.createdAt === "number")
                            message.createdAt = object.createdAt;
                        else if (typeof object.createdAt === "object")
                            message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a CharacterState message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @static
                 * @param {mythbound.websocket.v1.CharacterState} message CharacterState
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CharacterState.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.characterId = "";
                        object.characterName = "";
                        object.userId = "";
                        object.campaignId = "";
                        object.attributes = "";
                        object.statusEffects = "";
                        object.lastUpdated = null;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : typeof BigInt !== "undefined" && options.longs === BigInt ? long.toBigInt() : long;
                        } else
                            object.createdAt = options.longs === String ? "0" : typeof BigInt !== "undefined" && options.longs === BigInt ? BigInt("0") : 0;
                    }
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        object.characterId = message.characterId;
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        object.characterName = message.characterName;
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        object.userId = message.userId;
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
                        object.attributes = message.attributes;
                    if (message.statusEffects != null && Object.hasOwnProperty.call(message, "statusEffects"))
                        object.statusEffects = message.statusEffects;
                    if (message.lastUpdated != null && Object.hasOwnProperty.call(message, "lastUpdated"))
                        object.lastUpdated = $root.mythbound.websocket.v1.HLCTimestamp.toObject(message.lastUpdated, options, q + 1);
                    if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                        if (typeof BigInt !== "undefined" && options.longs === BigInt)
                            object.createdAt = typeof message.createdAt === "number" ? BigInt(message.createdAt) : $util.Long.fromBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0, false).toBigInt();
                        else if (typeof message.createdAt === "number")
                            object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                        else
                            object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
                    return object;
                };

                /**
                 * Converts this CharacterState to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CharacterState.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CharacterState
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.CharacterState
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CharacterState.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.CharacterState";
                };

                return CharacterState;
            })();

            v1.StateMessage = (function() {

                /**
                 * Properties of a StateMessage.
                 * @memberof mythbound.websocket.v1
                 * @interface IStateMessage
                 * @property {string|null} [messageId] StateMessage messageId
                 * @property {string|null} [messageType] StateMessage messageType
                 * @property {string|null} [timestamp] StateMessage timestamp
                 * @property {number|null} [sequenceNumber] StateMessage sequenceNumber
                 * @property {string|null} [sourcePlatform] StateMessage sourcePlatform
                 * @property {string|null} [targetPlatform] StateMessage targetPlatform
                 * @property {string|null} [campaignId] StateMessage campaignId
                 * @property {string|null} [userId] StateMessage userId
                 * @property {mythbound.websocket.v1.IStateUpdate|null} [update] StateMessage update
                 * @property {mythbound.websocket.v1.IStateBatch|null} [batch] StateMessage batch
                 * @property {mythbound.websocket.v1.IStateSyncRequest|null} [syncRequest] StateMessage syncRequest
                 * @property {mythbound.websocket.v1.IStateSyncResponse|null} [syncResponse] StateMessage syncResponse
                 * @property {mythbound.websocket.v1.IStateConflict|null} [conflict] StateMessage conflict
                 * @property {mythbound.websocket.v1.IVoiceSessionState|null} [voiceSession] StateMessage voiceSession
                 * @property {mythbound.websocket.v1.ICampaignState|null} [campaign] StateMessage campaign
                 * @property {mythbound.websocket.v1.INarrativeState|null} [narrative] StateMessage narrative
                 * @property {mythbound.websocket.v1.ICharacterState|null} [character] StateMessage character
                 * @property {string|null} [priority] StateMessage priority
                 */

                /**
                 * Constructs a new StateMessage.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a StateMessage.
                 * @implements IStateMessage
                 * @constructor
                 * @param {mythbound.websocket.v1.IStateMessage=} [properties] Properties to set
                 */
                function StateMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StateMessage messageId.
                 * @member {string} messageId
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.messageId = "";

                /**
                 * StateMessage messageType.
                 * @member {string} messageType
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.messageType = "";

                /**
                 * StateMessage timestamp.
                 * @member {string} timestamp
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.timestamp = "";

                /**
                 * StateMessage sequenceNumber.
                 * @member {number} sequenceNumber
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.sequenceNumber = 0;

                /**
                 * StateMessage sourcePlatform.
                 * @member {string} sourcePlatform
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.sourcePlatform = "";

                /**
                 * StateMessage targetPlatform.
                 * @member {string} targetPlatform
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.targetPlatform = "";

                /**
                 * StateMessage campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.campaignId = "";

                /**
                 * StateMessage userId.
                 * @member {string} userId
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.userId = "";

                /**
                 * StateMessage update.
                 * @member {mythbound.websocket.v1.IStateUpdate|null|undefined} update
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.update = null;

                /**
                 * StateMessage batch.
                 * @member {mythbound.websocket.v1.IStateBatch|null|undefined} batch
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.batch = null;

                /**
                 * StateMessage syncRequest.
                 * @member {mythbound.websocket.v1.IStateSyncRequest|null|undefined} syncRequest
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.syncRequest = null;

                /**
                 * StateMessage syncResponse.
                 * @member {mythbound.websocket.v1.IStateSyncResponse|null|undefined} syncResponse
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.syncResponse = null;

                /**
                 * StateMessage conflict.
                 * @member {mythbound.websocket.v1.IStateConflict|null|undefined} conflict
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.conflict = null;

                /**
                 * StateMessage voiceSession.
                 * @member {mythbound.websocket.v1.IVoiceSessionState|null|undefined} voiceSession
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.voiceSession = null;

                /**
                 * StateMessage campaign.
                 * @member {mythbound.websocket.v1.ICampaignState|null|undefined} campaign
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.campaign = null;

                /**
                 * StateMessage narrative.
                 * @member {mythbound.websocket.v1.INarrativeState|null|undefined} narrative
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.narrative = null;

                /**
                 * StateMessage character.
                 * @member {mythbound.websocket.v1.ICharacterState|null|undefined} character
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.character = null;

                /**
                 * StateMessage priority.
                 * @member {string} priority
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 */
                StateMessage.prototype.priority = "";

                /**
                 * Creates a new StateMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @static
                 * @param {mythbound.websocket.v1.IStateMessage=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.StateMessage} StateMessage instance
                 */
                StateMessage.create = function create(properties) {
                    return new StateMessage(properties);
                };

                /**
                 * Encodes the specified StateMessage message. Does not implicitly {@link mythbound.websocket.v1.StateMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @static
                 * @param {mythbound.websocket.v1.IStateMessage} message StateMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.messageId);
                    if (message.messageType != null && Object.hasOwnProperty.call(message, "messageType"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageType);
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.timestamp);
                    if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sequenceNumber);
                    if (message.sourcePlatform != null && Object.hasOwnProperty.call(message, "sourcePlatform"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.sourcePlatform);
                    if (message.targetPlatform != null && Object.hasOwnProperty.call(message, "targetPlatform"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.targetPlatform);
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.campaignId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.userId);
                    if (message.update != null && Object.hasOwnProperty.call(message, "update"))
                        $root.mythbound.websocket.v1.StateUpdate.encode(message.update, writer.uint32(/* id 10, wireType 2 =*/82).fork(), q + 1).ldelim();
                    if (message.batch != null && Object.hasOwnProperty.call(message, "batch"))
                        $root.mythbound.websocket.v1.StateBatch.encode(message.batch, writer.uint32(/* id 11, wireType 2 =*/90).fork(), q + 1).ldelim();
                    if (message.syncRequest != null && Object.hasOwnProperty.call(message, "syncRequest"))
                        $root.mythbound.websocket.v1.StateSyncRequest.encode(message.syncRequest, writer.uint32(/* id 12, wireType 2 =*/98).fork(), q + 1).ldelim();
                    if (message.syncResponse != null && Object.hasOwnProperty.call(message, "syncResponse"))
                        $root.mythbound.websocket.v1.StateSyncResponse.encode(message.syncResponse, writer.uint32(/* id 13, wireType 2 =*/106).fork(), q + 1).ldelim();
                    if (message.conflict != null && Object.hasOwnProperty.call(message, "conflict"))
                        $root.mythbound.websocket.v1.StateConflict.encode(message.conflict, writer.uint32(/* id 14, wireType 2 =*/114).fork(), q + 1).ldelim();
                    if (message.voiceSession != null && Object.hasOwnProperty.call(message, "voiceSession"))
                        $root.mythbound.websocket.v1.VoiceSessionState.encode(message.voiceSession, writer.uint32(/* id 20, wireType 2 =*/162).fork(), q + 1).ldelim();
                    if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign"))
                        $root.mythbound.websocket.v1.CampaignState.encode(message.campaign, writer.uint32(/* id 21, wireType 2 =*/170).fork(), q + 1).ldelim();
                    if (message.narrative != null && Object.hasOwnProperty.call(message, "narrative"))
                        $root.mythbound.websocket.v1.NarrativeState.encode(message.narrative, writer.uint32(/* id 22, wireType 2 =*/178).fork(), q + 1).ldelim();
                    if (message.character != null && Object.hasOwnProperty.call(message, "character"))
                        $root.mythbound.websocket.v1.CharacterState.encode(message.character, writer.uint32(/* id 23, wireType 2 =*/186).fork(), q + 1).ldelim();
                    if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                        writer.uint32(/* id 30, wireType 2 =*/242).string(message.priority);
                    return writer;
                };

                /**
                 * Encodes the specified StateMessage message, length delimited. Does not implicitly {@link mythbound.websocket.v1.StateMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @static
                 * @param {mythbound.websocket.v1.IStateMessage} message StateMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a StateMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.StateMessage} StateMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.StateMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.messageId = reader.string();
                                break;
                            }
                        case 2: {
                                message.messageType = reader.string();
                                break;
                            }
                        case 3: {
                                message.timestamp = reader.string();
                                break;
                            }
                        case 4: {
                                message.sequenceNumber = reader.int32();
                                break;
                            }
                        case 5: {
                                message.sourcePlatform = reader.string();
                                break;
                            }
                        case 6: {
                                message.targetPlatform = reader.string();
                                break;
                            }
                        case 7: {
                                message.campaignId = reader.string();
                                break;
                            }
                        case 8: {
                                message.userId = reader.string();
                                break;
                            }
                        case 10: {
                                message.update = $root.mythbound.websocket.v1.StateUpdate.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 11: {
                                message.batch = $root.mythbound.websocket.v1.StateBatch.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 12: {
                                message.syncRequest = $root.mythbound.websocket.v1.StateSyncRequest.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 13: {
                                message.syncResponse = $root.mythbound.websocket.v1.StateSyncResponse.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 14: {
                                message.conflict = $root.mythbound.websocket.v1.StateConflict.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 20: {
                                message.voiceSession = $root.mythbound.websocket.v1.VoiceSessionState.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 21: {
                                message.campaign = $root.mythbound.websocket.v1.CampaignState.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 22: {
                                message.narrative = $root.mythbound.websocket.v1.NarrativeState.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 23: {
                                message.character = $root.mythbound.websocket.v1.CharacterState.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 30: {
                                message.priority = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a StateMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.StateMessage} StateMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StateMessage message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StateMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                        if (!$util.isString(message.messageId))
                            return "messageId: string expected";
                    if (message.messageType != null && Object.hasOwnProperty.call(message, "messageType"))
                        if (!$util.isString(message.messageType))
                            return "messageType: string expected";
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        if (!$util.isString(message.timestamp))
                            return "timestamp: string expected";
                    if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                        if (!$util.isInteger(message.sequenceNumber))
                            return "sequenceNumber: integer expected";
                    if (message.sourcePlatform != null && Object.hasOwnProperty.call(message, "sourcePlatform"))
                        if (!$util.isString(message.sourcePlatform))
                            return "sourcePlatform: string expected";
                    if (message.targetPlatform != null && Object.hasOwnProperty.call(message, "targetPlatform"))
                        if (!$util.isString(message.targetPlatform))
                            return "targetPlatform: string expected";
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.update != null && Object.hasOwnProperty.call(message, "update")) {
                        let error = $root.mythbound.websocket.v1.StateUpdate.verify(message.update, long + 1);
                        if (error)
                            return "update." + error;
                    }
                    if (message.batch != null && Object.hasOwnProperty.call(message, "batch")) {
                        let error = $root.mythbound.websocket.v1.StateBatch.verify(message.batch, long + 1);
                        if (error)
                            return "batch." + error;
                    }
                    if (message.syncRequest != null && Object.hasOwnProperty.call(message, "syncRequest")) {
                        let error = $root.mythbound.websocket.v1.StateSyncRequest.verify(message.syncRequest, long + 1);
                        if (error)
                            return "syncRequest." + error;
                    }
                    if (message.syncResponse != null && Object.hasOwnProperty.call(message, "syncResponse")) {
                        let error = $root.mythbound.websocket.v1.StateSyncResponse.verify(message.syncResponse, long + 1);
                        if (error)
                            return "syncResponse." + error;
                    }
                    if (message.conflict != null && Object.hasOwnProperty.call(message, "conflict")) {
                        let error = $root.mythbound.websocket.v1.StateConflict.verify(message.conflict, long + 1);
                        if (error)
                            return "conflict." + error;
                    }
                    if (message.voiceSession != null && Object.hasOwnProperty.call(message, "voiceSession")) {
                        let error = $root.mythbound.websocket.v1.VoiceSessionState.verify(message.voiceSession, long + 1);
                        if (error)
                            return "voiceSession." + error;
                    }
                    if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign")) {
                        let error = $root.mythbound.websocket.v1.CampaignState.verify(message.campaign, long + 1);
                        if (error)
                            return "campaign." + error;
                    }
                    if (message.narrative != null && Object.hasOwnProperty.call(message, "narrative")) {
                        let error = $root.mythbound.websocket.v1.NarrativeState.verify(message.narrative, long + 1);
                        if (error)
                            return "narrative." + error;
                    }
                    if (message.character != null && Object.hasOwnProperty.call(message, "character")) {
                        let error = $root.mythbound.websocket.v1.CharacterState.verify(message.character, long + 1);
                        if (error)
                            return "character." + error;
                    }
                    if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                        if (!$util.isString(message.priority))
                            return "priority: string expected";
                    return null;
                };

                /**
                 * Creates a StateMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.StateMessage} StateMessage
                 */
                StateMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.StateMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.StateMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.StateMessage();
                    if (object.messageId != null)
                        message.messageId = String(object.messageId);
                    if (object.messageType != null)
                        message.messageType = String(object.messageType);
                    if (object.timestamp != null)
                        message.timestamp = String(object.timestamp);
                    if (object.sequenceNumber != null)
                        message.sequenceNumber = object.sequenceNumber | 0;
                    if (object.sourcePlatform != null)
                        message.sourcePlatform = String(object.sourcePlatform);
                    if (object.targetPlatform != null)
                        message.targetPlatform = String(object.targetPlatform);
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.update != null) {
                        if (!$util.isObject(object.update))
                            throw TypeError(".mythbound.websocket.v1.StateMessage.update: object expected");
                        message.update = $root.mythbound.websocket.v1.StateUpdate.fromObject(object.update, long + 1);
                    }
                    if (object.batch != null) {
                        if (!$util.isObject(object.batch))
                            throw TypeError(".mythbound.websocket.v1.StateMessage.batch: object expected");
                        message.batch = $root.mythbound.websocket.v1.StateBatch.fromObject(object.batch, long + 1);
                    }
                    if (object.syncRequest != null) {
                        if (!$util.isObject(object.syncRequest))
                            throw TypeError(".mythbound.websocket.v1.StateMessage.syncRequest: object expected");
                        message.syncRequest = $root.mythbound.websocket.v1.StateSyncRequest.fromObject(object.syncRequest, long + 1);
                    }
                    if (object.syncResponse != null) {
                        if (!$util.isObject(object.syncResponse))
                            throw TypeError(".mythbound.websocket.v1.StateMessage.syncResponse: object expected");
                        message.syncResponse = $root.mythbound.websocket.v1.StateSyncResponse.fromObject(object.syncResponse, long + 1);
                    }
                    if (object.conflict != null) {
                        if (!$util.isObject(object.conflict))
                            throw TypeError(".mythbound.websocket.v1.StateMessage.conflict: object expected");
                        message.conflict = $root.mythbound.websocket.v1.StateConflict.fromObject(object.conflict, long + 1);
                    }
                    if (object.voiceSession != null) {
                        if (!$util.isObject(object.voiceSession))
                            throw TypeError(".mythbound.websocket.v1.StateMessage.voiceSession: object expected");
                        message.voiceSession = $root.mythbound.websocket.v1.VoiceSessionState.fromObject(object.voiceSession, long + 1);
                    }
                    if (object.campaign != null) {
                        if (!$util.isObject(object.campaign))
                            throw TypeError(".mythbound.websocket.v1.StateMessage.campaign: object expected");
                        message.campaign = $root.mythbound.websocket.v1.CampaignState.fromObject(object.campaign, long + 1);
                    }
                    if (object.narrative != null) {
                        if (!$util.isObject(object.narrative))
                            throw TypeError(".mythbound.websocket.v1.StateMessage.narrative: object expected");
                        message.narrative = $root.mythbound.websocket.v1.NarrativeState.fromObject(object.narrative, long + 1);
                    }
                    if (object.character != null) {
                        if (!$util.isObject(object.character))
                            throw TypeError(".mythbound.websocket.v1.StateMessage.character: object expected");
                        message.character = $root.mythbound.websocket.v1.CharacterState.fromObject(object.character, long + 1);
                    }
                    if (object.priority != null)
                        message.priority = String(object.priority);
                    return message;
                };

                /**
                 * Creates a plain object from a StateMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @static
                 * @param {mythbound.websocket.v1.StateMessage} message StateMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StateMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.messageId = "";
                        object.messageType = "";
                        object.timestamp = "";
                        object.sequenceNumber = 0;
                        object.sourcePlatform = "";
                        object.targetPlatform = "";
                        object.campaignId = "";
                        object.userId = "";
                        object.update = null;
                        object.batch = null;
                        object.syncRequest = null;
                        object.syncResponse = null;
                        object.conflict = null;
                        object.voiceSession = null;
                        object.campaign = null;
                        object.narrative = null;
                        object.character = null;
                        object.priority = "";
                    }
                    if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                        object.messageId = message.messageId;
                    if (message.messageType != null && Object.hasOwnProperty.call(message, "messageType"))
                        object.messageType = message.messageType;
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        object.timestamp = message.timestamp;
                    if (message.sequenceNumber != null && Object.hasOwnProperty.call(message, "sequenceNumber"))
                        object.sequenceNumber = message.sequenceNumber;
                    if (message.sourcePlatform != null && Object.hasOwnProperty.call(message, "sourcePlatform"))
                        object.sourcePlatform = message.sourcePlatform;
                    if (message.targetPlatform != null && Object.hasOwnProperty.call(message, "targetPlatform"))
                        object.targetPlatform = message.targetPlatform;
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        object.userId = message.userId;
                    if (message.update != null && Object.hasOwnProperty.call(message, "update"))
                        object.update = $root.mythbound.websocket.v1.StateUpdate.toObject(message.update, options, q + 1);
                    if (message.batch != null && Object.hasOwnProperty.call(message, "batch"))
                        object.batch = $root.mythbound.websocket.v1.StateBatch.toObject(message.batch, options, q + 1);
                    if (message.syncRequest != null && Object.hasOwnProperty.call(message, "syncRequest"))
                        object.syncRequest = $root.mythbound.websocket.v1.StateSyncRequest.toObject(message.syncRequest, options, q + 1);
                    if (message.syncResponse != null && Object.hasOwnProperty.call(message, "syncResponse"))
                        object.syncResponse = $root.mythbound.websocket.v1.StateSyncResponse.toObject(message.syncResponse, options, q + 1);
                    if (message.conflict != null && Object.hasOwnProperty.call(message, "conflict"))
                        object.conflict = $root.mythbound.websocket.v1.StateConflict.toObject(message.conflict, options, q + 1);
                    if (message.voiceSession != null && Object.hasOwnProperty.call(message, "voiceSession"))
                        object.voiceSession = $root.mythbound.websocket.v1.VoiceSessionState.toObject(message.voiceSession, options, q + 1);
                    if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign"))
                        object.campaign = $root.mythbound.websocket.v1.CampaignState.toObject(message.campaign, options, q + 1);
                    if (message.narrative != null && Object.hasOwnProperty.call(message, "narrative"))
                        object.narrative = $root.mythbound.websocket.v1.NarrativeState.toObject(message.narrative, options, q + 1);
                    if (message.character != null && Object.hasOwnProperty.call(message, "character"))
                        object.character = $root.mythbound.websocket.v1.CharacterState.toObject(message.character, options, q + 1);
                    if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                        object.priority = message.priority;
                    return object;
                };

                /**
                 * Converts this StateMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StateMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StateMessage
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.StateMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StateMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.StateMessage";
                };

                return StateMessage;
            })();

            v1.StateRecoveryRequest = (function() {

                /**
                 * Properties of a StateRecoveryRequest.
                 * @memberof mythbound.websocket.v1
                 * @interface IStateRecoveryRequest
                 * @property {string|null} [requestId] StateRecoveryRequest requestId
                 * @property {mythbound.websocket.v1.IHLCTimestamp|null} [lastKnownTimestamp] StateRecoveryRequest lastKnownTimestamp
                 * @property {string|null} [sessionId] StateRecoveryRequest sessionId
                 * @property {string|null} [campaignId] StateRecoveryRequest campaignId
                 * @property {Array.<string>|null} [subscribedKeys] StateRecoveryRequest subscribedKeys
                 */

                /**
                 * Constructs a new StateRecoveryRequest.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a StateRecoveryRequest.
                 * @implements IStateRecoveryRequest
                 * @constructor
                 * @param {mythbound.websocket.v1.IStateRecoveryRequest=} [properties] Properties to set
                 */
                function StateRecoveryRequest(properties) {
                    this.subscribedKeys = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StateRecoveryRequest requestId.
                 * @member {string} requestId
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @instance
                 */
                StateRecoveryRequest.prototype.requestId = "";

                /**
                 * StateRecoveryRequest lastKnownTimestamp.
                 * @member {mythbound.websocket.v1.IHLCTimestamp|null|undefined} lastKnownTimestamp
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @instance
                 */
                StateRecoveryRequest.prototype.lastKnownTimestamp = null;

                /**
                 * StateRecoveryRequest sessionId.
                 * @member {string} sessionId
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @instance
                 */
                StateRecoveryRequest.prototype.sessionId = "";

                /**
                 * StateRecoveryRequest campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @instance
                 */
                StateRecoveryRequest.prototype.campaignId = "";

                /**
                 * StateRecoveryRequest subscribedKeys.
                 * @member {Array.<string>} subscribedKeys
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @instance
                 */
                StateRecoveryRequest.prototype.subscribedKeys = $util.emptyArray;

                /**
                 * Creates a new StateRecoveryRequest instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @static
                 * @param {mythbound.websocket.v1.IStateRecoveryRequest=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.StateRecoveryRequest} StateRecoveryRequest instance
                 */
                StateRecoveryRequest.create = function create(properties) {
                    return new StateRecoveryRequest(properties);
                };

                /**
                 * Encodes the specified StateRecoveryRequest message. Does not implicitly {@link mythbound.websocket.v1.StateRecoveryRequest.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @static
                 * @param {mythbound.websocket.v1.IStateRecoveryRequest} message StateRecoveryRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateRecoveryRequest.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
                    if (message.lastKnownTimestamp != null && Object.hasOwnProperty.call(message, "lastKnownTimestamp"))
                        $root.mythbound.websocket.v1.HLCTimestamp.encode(message.lastKnownTimestamp, writer.uint32(/* id 2, wireType 2 =*/18).fork(), q + 1).ldelim();
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.sessionId);
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.campaignId);
                    if (message.subscribedKeys != null && message.subscribedKeys.length)
                        for (let i = 0; i < message.subscribedKeys.length; ++i)
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.subscribedKeys[i]);
                    return writer;
                };

                /**
                 * Encodes the specified StateRecoveryRequest message, length delimited. Does not implicitly {@link mythbound.websocket.v1.StateRecoveryRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @static
                 * @param {mythbound.websocket.v1.IStateRecoveryRequest} message StateRecoveryRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateRecoveryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a StateRecoveryRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.StateRecoveryRequest} StateRecoveryRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateRecoveryRequest.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.StateRecoveryRequest();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.requestId = reader.string();
                                break;
                            }
                        case 2: {
                                message.lastKnownTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 3: {
                                message.sessionId = reader.string();
                                break;
                            }
                        case 4: {
                                message.campaignId = reader.string();
                                break;
                            }
                        case 5: {
                                if (!(message.subscribedKeys && message.subscribedKeys.length))
                                    message.subscribedKeys = [];
                                message.subscribedKeys.push(reader.string());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a StateRecoveryRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.StateRecoveryRequest} StateRecoveryRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateRecoveryRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StateRecoveryRequest message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StateRecoveryRequest.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        if (!$util.isString(message.requestId))
                            return "requestId: string expected";
                    if (message.lastKnownTimestamp != null && Object.hasOwnProperty.call(message, "lastKnownTimestamp")) {
                        let error = $root.mythbound.websocket.v1.HLCTimestamp.verify(message.lastKnownTimestamp, long + 1);
                        if (error)
                            return "lastKnownTimestamp." + error;
                    }
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        if (!$util.isString(message.sessionId))
                            return "sessionId: string expected";
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    if (message.subscribedKeys != null && Object.hasOwnProperty.call(message, "subscribedKeys")) {
                        if (!Array.isArray(message.subscribedKeys))
                            return "subscribedKeys: array expected";
                        for (let i = 0; i < message.subscribedKeys.length; ++i)
                            if (!$util.isString(message.subscribedKeys[i]))
                                return "subscribedKeys: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a StateRecoveryRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.StateRecoveryRequest} StateRecoveryRequest
                 */
                StateRecoveryRequest.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.StateRecoveryRequest)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.StateRecoveryRequest: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.StateRecoveryRequest();
                    if (object.requestId != null)
                        message.requestId = String(object.requestId);
                    if (object.lastKnownTimestamp != null) {
                        if (!$util.isObject(object.lastKnownTimestamp))
                            throw TypeError(".mythbound.websocket.v1.StateRecoveryRequest.lastKnownTimestamp: object expected");
                        message.lastKnownTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.fromObject(object.lastKnownTimestamp, long + 1);
                    }
                    if (object.sessionId != null)
                        message.sessionId = String(object.sessionId);
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    if (object.subscribedKeys) {
                        if (!Array.isArray(object.subscribedKeys))
                            throw TypeError(".mythbound.websocket.v1.StateRecoveryRequest.subscribedKeys: array expected");
                        message.subscribedKeys = [];
                        for (let i = 0; i < object.subscribedKeys.length; ++i)
                            message.subscribedKeys[i] = String(object.subscribedKeys[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StateRecoveryRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @static
                 * @param {mythbound.websocket.v1.StateRecoveryRequest} message StateRecoveryRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StateRecoveryRequest.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.subscribedKeys = [];
                    if (options.defaults) {
                        object.requestId = "";
                        object.lastKnownTimestamp = null;
                        object.sessionId = "";
                        object.campaignId = "";
                    }
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        object.requestId = message.requestId;
                    if (message.lastKnownTimestamp != null && Object.hasOwnProperty.call(message, "lastKnownTimestamp"))
                        object.lastKnownTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.toObject(message.lastKnownTimestamp, options, q + 1);
                    if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
                        object.sessionId = message.sessionId;
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    if (message.subscribedKeys && message.subscribedKeys.length) {
                        object.subscribedKeys = [];
                        for (let j = 0; j < message.subscribedKeys.length; ++j)
                            object.subscribedKeys[j] = message.subscribedKeys[j];
                    }
                    return object;
                };

                /**
                 * Converts this StateRecoveryRequest to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StateRecoveryRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StateRecoveryRequest
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.StateRecoveryRequest
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StateRecoveryRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.StateRecoveryRequest";
                };

                return StateRecoveryRequest;
            })();

            v1.StateRecoveryResponse = (function() {

                /**
                 * Properties of a StateRecoveryResponse.
                 * @memberof mythbound.websocket.v1
                 * @interface IStateRecoveryResponse
                 * @property {string|null} [requestId] StateRecoveryResponse requestId
                 * @property {mythbound.websocket.v1.IHLCTimestamp|null} [serverTimestamp] StateRecoveryResponse serverTimestamp
                 * @property {Array.<mythbound.websocket.v1.IStateUpdate>|null} [missedUpdates] StateRecoveryResponse missedUpdates
                 * @property {Object.<string,string>|null} [currentState] StateRecoveryResponse currentState
                 * @property {boolean|null} [recoveryComplete] StateRecoveryResponse recoveryComplete
                 * @property {number|null} [updatesApplied] StateRecoveryResponse updatesApplied
                 */

                /**
                 * Constructs a new StateRecoveryResponse.
                 * @memberof mythbound.websocket.v1
                 * @classdesc Represents a StateRecoveryResponse.
                 * @implements IStateRecoveryResponse
                 * @constructor
                 * @param {mythbound.websocket.v1.IStateRecoveryResponse=} [properties] Properties to set
                 */
                function StateRecoveryResponse(properties) {
                    this.missedUpdates = [];
                    this.currentState = {};
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StateRecoveryResponse requestId.
                 * @member {string} requestId
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @instance
                 */
                StateRecoveryResponse.prototype.requestId = "";

                /**
                 * StateRecoveryResponse serverTimestamp.
                 * @member {mythbound.websocket.v1.IHLCTimestamp|null|undefined} serverTimestamp
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @instance
                 */
                StateRecoveryResponse.prototype.serverTimestamp = null;

                /**
                 * StateRecoveryResponse missedUpdates.
                 * @member {Array.<mythbound.websocket.v1.IStateUpdate>} missedUpdates
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @instance
                 */
                StateRecoveryResponse.prototype.missedUpdates = $util.emptyArray;

                /**
                 * StateRecoveryResponse currentState.
                 * @member {Object.<string,string>} currentState
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @instance
                 */
                StateRecoveryResponse.prototype.currentState = $util.emptyObject;

                /**
                 * StateRecoveryResponse recoveryComplete.
                 * @member {boolean} recoveryComplete
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @instance
                 */
                StateRecoveryResponse.prototype.recoveryComplete = false;

                /**
                 * StateRecoveryResponse updatesApplied.
                 * @member {number} updatesApplied
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @instance
                 */
                StateRecoveryResponse.prototype.updatesApplied = 0;

                /**
                 * Creates a new StateRecoveryResponse instance using the specified properties.
                 * @function create
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @static
                 * @param {mythbound.websocket.v1.IStateRecoveryResponse=} [properties] Properties to set
                 * @returns {mythbound.websocket.v1.StateRecoveryResponse} StateRecoveryResponse instance
                 */
                StateRecoveryResponse.create = function create(properties) {
                    return new StateRecoveryResponse(properties);
                };

                /**
                 * Encodes the specified StateRecoveryResponse message. Does not implicitly {@link mythbound.websocket.v1.StateRecoveryResponse.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @static
                 * @param {mythbound.websocket.v1.IStateRecoveryResponse} message StateRecoveryResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateRecoveryResponse.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.requestId);
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp"))
                        $root.mythbound.websocket.v1.HLCTimestamp.encode(message.serverTimestamp, writer.uint32(/* id 2, wireType 2 =*/18).fork(), q + 1).ldelim();
                    if (message.missedUpdates != null && message.missedUpdates.length)
                        for (let i = 0; i < message.missedUpdates.length; ++i)
                            $root.mythbound.websocket.v1.StateUpdate.encode(message.missedUpdates[i], writer.uint32(/* id 3, wireType 2 =*/26).fork(), q + 1).ldelim();
                    if (message.currentState != null && Object.hasOwnProperty.call(message, "currentState"))
                        for (let keys = Object.keys(message.currentState), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 4, wireType 2 =*/34).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.currentState[keys[i]]).ldelim();
                    if (message.recoveryComplete != null && Object.hasOwnProperty.call(message, "recoveryComplete"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.recoveryComplete);
                    if (message.updatesApplied != null && Object.hasOwnProperty.call(message, "updatesApplied"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.updatesApplied);
                    return writer;
                };

                /**
                 * Encodes the specified StateRecoveryResponse message, length delimited. Does not implicitly {@link mythbound.websocket.v1.StateRecoveryResponse.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @static
                 * @param {mythbound.websocket.v1.IStateRecoveryResponse} message StateRecoveryResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StateRecoveryResponse.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a StateRecoveryResponse message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.websocket.v1.StateRecoveryResponse} StateRecoveryResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateRecoveryResponse.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message, key, value;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.websocket.v1.StateRecoveryResponse();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.requestId = reader.string();
                                break;
                            }
                        case 2: {
                                message.serverTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        case 3: {
                                if (!(message.missedUpdates && message.missedUpdates.length))
                                    message.missedUpdates = [];
                                message.missedUpdates.push($root.mythbound.websocket.v1.StateUpdate.decode(reader, reader.uint32(), undefined, long + 1));
                                break;
                            }
                        case 4: {
                                if (message.currentState === $util.emptyObject)
                                    message.currentState = {};
                                let end2 = reader.uint32() + reader.pos;
                                if (end2 > reader.len)
                                    throw RangeError("index out of range");
                                reader.len = end2;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    let tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7, long);
                                        break;
                                    }
                                }
                                if (reader.pos !== end2)
                                    throw RangeError("index out of range");
                                reader.len = end;
                                if (key === "__proto__")
                                    $util.makeProp(message.currentState, key);
                                message.currentState[key] = value;
                                break;
                            }
                        case 5: {
                                message.recoveryComplete = reader.bool();
                                break;
                            }
                        case 6: {
                                message.updatesApplied = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a StateRecoveryResponse message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.websocket.v1.StateRecoveryResponse} StateRecoveryResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StateRecoveryResponse.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StateRecoveryResponse message.
                 * @function verify
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StateRecoveryResponse.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        if (!$util.isString(message.requestId))
                            return "requestId: string expected";
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp")) {
                        let error = $root.mythbound.websocket.v1.HLCTimestamp.verify(message.serverTimestamp, long + 1);
                        if (error)
                            return "serverTimestamp." + error;
                    }
                    if (message.missedUpdates != null && Object.hasOwnProperty.call(message, "missedUpdates")) {
                        if (!Array.isArray(message.missedUpdates))
                            return "missedUpdates: array expected";
                        for (let i = 0; i < message.missedUpdates.length; ++i) {
                            let error = $root.mythbound.websocket.v1.StateUpdate.verify(message.missedUpdates[i], long + 1);
                            if (error)
                                return "missedUpdates." + error;
                        }
                    }
                    if (message.currentState != null && Object.hasOwnProperty.call(message, "currentState")) {
                        if (!$util.isObject(message.currentState))
                            return "currentState: object expected";
                        let key = Object.keys(message.currentState);
                        for (let i = 0; i < key.length; ++i)
                            if (!$util.isString(message.currentState[key[i]]))
                                return "currentState: string{k:string} expected";
                    }
                    if (message.recoveryComplete != null && Object.hasOwnProperty.call(message, "recoveryComplete"))
                        if (typeof message.recoveryComplete !== "boolean")
                            return "recoveryComplete: boolean expected";
                    if (message.updatesApplied != null && Object.hasOwnProperty.call(message, "updatesApplied"))
                        if (!$util.isInteger(message.updatesApplied))
                            return "updatesApplied: integer expected";
                    return null;
                };

                /**
                 * Creates a StateRecoveryResponse message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.websocket.v1.StateRecoveryResponse} StateRecoveryResponse
                 */
                StateRecoveryResponse.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.websocket.v1.StateRecoveryResponse)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.websocket.v1.StateRecoveryResponse: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.websocket.v1.StateRecoveryResponse();
                    if (object.requestId != null)
                        message.requestId = String(object.requestId);
                    if (object.serverTimestamp != null) {
                        if (!$util.isObject(object.serverTimestamp))
                            throw TypeError(".mythbound.websocket.v1.StateRecoveryResponse.serverTimestamp: object expected");
                        message.serverTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.fromObject(object.serverTimestamp, long + 1);
                    }
                    if (object.missedUpdates) {
                        if (!Array.isArray(object.missedUpdates))
                            throw TypeError(".mythbound.websocket.v1.StateRecoveryResponse.missedUpdates: array expected");
                        message.missedUpdates = [];
                        for (let i = 0; i < object.missedUpdates.length; ++i) {
                            if (!$util.isObject(object.missedUpdates[i]))
                                throw TypeError(".mythbound.websocket.v1.StateRecoveryResponse.missedUpdates: object expected");
                            message.missedUpdates[i] = $root.mythbound.websocket.v1.StateUpdate.fromObject(object.missedUpdates[i], long + 1);
                        }
                    }
                    if (object.currentState) {
                        if (!$util.isObject(object.currentState))
                            throw TypeError(".mythbound.websocket.v1.StateRecoveryResponse.currentState: object expected");
                        message.currentState = {};
                        for (let keys = Object.keys(object.currentState), i = 0; i < keys.length; ++i) {
                            if (keys[i] === "__proto__")
                                $util.makeProp(message.currentState, keys[i]);
                            message.currentState[keys[i]] = String(object.currentState[keys[i]]);
                        }
                    }
                    if (object.recoveryComplete != null)
                        message.recoveryComplete = Boolean(object.recoveryComplete);
                    if (object.updatesApplied != null)
                        message.updatesApplied = object.updatesApplied | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a StateRecoveryResponse message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @static
                 * @param {mythbound.websocket.v1.StateRecoveryResponse} message StateRecoveryResponse
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StateRecoveryResponse.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.missedUpdates = [];
                    if (options.objects || options.defaults)
                        object.currentState = {};
                    if (options.defaults) {
                        object.requestId = "";
                        object.serverTimestamp = null;
                        object.recoveryComplete = false;
                        object.updatesApplied = 0;
                    }
                    if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                        object.requestId = message.requestId;
                    if (message.serverTimestamp != null && Object.hasOwnProperty.call(message, "serverTimestamp"))
                        object.serverTimestamp = $root.mythbound.websocket.v1.HLCTimestamp.toObject(message.serverTimestamp, options, q + 1);
                    if (message.missedUpdates && message.missedUpdates.length) {
                        object.missedUpdates = [];
                        for (let j = 0; j < message.missedUpdates.length; ++j)
                            object.missedUpdates[j] = $root.mythbound.websocket.v1.StateUpdate.toObject(message.missedUpdates[j], options, q + 1);
                    }
                    let keys2;
                    if (message.currentState && (keys2 = Object.keys(message.currentState)).length) {
                        object.currentState = {};
                        for (let j = 0; j < keys2.length; ++j) {
                            if (keys2[j] === "__proto__")
                                $util.makeProp(object.currentState, keys2[j]);
                            object.currentState[keys2[j]] = message.currentState[keys2[j]];
                        }
                    }
                    if (message.recoveryComplete != null && Object.hasOwnProperty.call(message, "recoveryComplete"))
                        object.recoveryComplete = message.recoveryComplete;
                    if (message.updatesApplied != null && Object.hasOwnProperty.call(message, "updatesApplied"))
                        object.updatesApplied = message.updatesApplied;
                    return object;
                };

                /**
                 * Converts this StateRecoveryResponse to JSON.
                 * @function toJSON
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StateRecoveryResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StateRecoveryResponse
                 * @function getTypeUrl
                 * @memberof mythbound.websocket.v1.StateRecoveryResponse
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StateRecoveryResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.websocket.v1.StateRecoveryResponse";
                };

                return StateRecoveryResponse;
            })();

            return v1;
        })();

        return websocket;
    })();

    mythbound.ws = (function() {

        /**
         * Namespace ws.
         * @memberof mythbound
         * @namespace
         */
        const ws = {};

        ws.v1 = (function() {

            /**
             * Namespace v1.
             * @memberof mythbound.ws
             * @namespace
             */
            const v1 = {};

            /**
             * WebSocketEventType enum.
             * @name mythbound.ws.v1.WebSocketEventType
             * @enum {number}
             * @property {number} STATE_UPDATE=0 STATE_UPDATE value
             * @property {number} STATE_CONFLICT_RESOLVED=1 STATE_CONFLICT_RESOLVED value
             * @property {number} VOICE_JOIN=2 VOICE_JOIN value
             * @property {number} VOICE_LEAVE=3 VOICE_LEAVE value
             * @property {number} VOICE_SPEAKING_INDICATOR=4 VOICE_SPEAKING_INDICATOR value
             * @property {number} TRANSCRIPTION_STATE_CHANGED=5 TRANSCRIPTION_STATE_CHANGED value
             * @property {number} UI_STATE_CHANGED=6 UI_STATE_CHANGED value
             * @property {number} CONNECTION_ACK=7 CONNECTION_ACK value
             * @property {number} HEARTBEAT=8 HEARTBEAT value
             * @property {number} ERROR=9 ERROR value
             */
            v1.WebSocketEventType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "STATE_UPDATE"] = 0;
                values[valuesById[1] = "STATE_CONFLICT_RESOLVED"] = 1;
                values[valuesById[2] = "VOICE_JOIN"] = 2;
                values[valuesById[3] = "VOICE_LEAVE"] = 3;
                values[valuesById[4] = "VOICE_SPEAKING_INDICATOR"] = 4;
                values[valuesById[5] = "TRANSCRIPTION_STATE_CHANGED"] = 5;
                values[valuesById[6] = "UI_STATE_CHANGED"] = 6;
                values[valuesById[7] = "CONNECTION_ACK"] = 7;
                values[valuesById[8] = "HEARTBEAT"] = 8;
                values[valuesById[9] = "ERROR"] = 9;
                return values;
            })();

            v1.AudioConfig = (function() {

                /**
                 * Properties of an AudioConfig.
                 * @memberof mythbound.ws.v1
                 * @interface IAudioConfig
                 * @property {number|null} [sampleRateHz] AudioConfig sampleRateHz
                 * @property {string|null} [channelLayout] AudioConfig channelLayout
                 * @property {number|null} [frameSize] AudioConfig frameSize
                 * @property {string|null} [encoding] AudioConfig encoding
                 */

                /**
                 * Constructs a new AudioConfig.
                 * @memberof mythbound.ws.v1
                 * @classdesc Represents an AudioConfig.
                 * @implements IAudioConfig
                 * @constructor
                 * @param {mythbound.ws.v1.IAudioConfig=} [properties] Properties to set
                 */
                function AudioConfig(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AudioConfig sampleRateHz.
                 * @member {number} sampleRateHz
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @instance
                 */
                AudioConfig.prototype.sampleRateHz = 0;

                /**
                 * AudioConfig channelLayout.
                 * @member {string} channelLayout
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @instance
                 */
                AudioConfig.prototype.channelLayout = "";

                /**
                 * AudioConfig frameSize.
                 * @member {number} frameSize
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @instance
                 */
                AudioConfig.prototype.frameSize = 0;

                /**
                 * AudioConfig encoding.
                 * @member {string} encoding
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @instance
                 */
                AudioConfig.prototype.encoding = "";

                /**
                 * Creates a new AudioConfig instance using the specified properties.
                 * @function create
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @static
                 * @param {mythbound.ws.v1.IAudioConfig=} [properties] Properties to set
                 * @returns {mythbound.ws.v1.AudioConfig} AudioConfig instance
                 */
                AudioConfig.create = function create(properties) {
                    return new AudioConfig(properties);
                };

                /**
                 * Encodes the specified AudioConfig message. Does not implicitly {@link mythbound.ws.v1.AudioConfig.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @static
                 * @param {mythbound.ws.v1.IAudioConfig} message AudioConfig message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AudioConfig.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.sampleRateHz != null && Object.hasOwnProperty.call(message, "sampleRateHz"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.sampleRateHz);
                    if (message.channelLayout != null && Object.hasOwnProperty.call(message, "channelLayout"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.channelLayout);
                    if (message.frameSize != null && Object.hasOwnProperty.call(message, "frameSize"))
                        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.frameSize);
                    if (message.encoding != null && Object.hasOwnProperty.call(message, "encoding"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.encoding);
                    return writer;
                };

                /**
                 * Encodes the specified AudioConfig message, length delimited. Does not implicitly {@link mythbound.ws.v1.AudioConfig.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @static
                 * @param {mythbound.ws.v1.IAudioConfig} message AudioConfig message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AudioConfig.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes an AudioConfig message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.ws.v1.AudioConfig} AudioConfig
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AudioConfig.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.ws.v1.AudioConfig();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.sampleRateHz = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.channelLayout = reader.string();
                                break;
                            }
                        case 3: {
                                message.frameSize = reader.uint32();
                                break;
                            }
                        case 4: {
                                message.encoding = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes an AudioConfig message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.ws.v1.AudioConfig} AudioConfig
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AudioConfig.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AudioConfig message.
                 * @function verify
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AudioConfig.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.sampleRateHz != null && Object.hasOwnProperty.call(message, "sampleRateHz"))
                        if (!$util.isInteger(message.sampleRateHz))
                            return "sampleRateHz: integer expected";
                    if (message.channelLayout != null && Object.hasOwnProperty.call(message, "channelLayout"))
                        if (!$util.isString(message.channelLayout))
                            return "channelLayout: string expected";
                    if (message.frameSize != null && Object.hasOwnProperty.call(message, "frameSize"))
                        if (!$util.isInteger(message.frameSize))
                            return "frameSize: integer expected";
                    if (message.encoding != null && Object.hasOwnProperty.call(message, "encoding"))
                        if (!$util.isString(message.encoding))
                            return "encoding: string expected";
                    return null;
                };

                /**
                 * Creates an AudioConfig message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.ws.v1.AudioConfig} AudioConfig
                 */
                AudioConfig.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.ws.v1.AudioConfig)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.ws.v1.AudioConfig: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.ws.v1.AudioConfig();
                    if (object.sampleRateHz != null)
                        message.sampleRateHz = object.sampleRateHz >>> 0;
                    if (object.channelLayout != null)
                        message.channelLayout = String(object.channelLayout);
                    if (object.frameSize != null)
                        message.frameSize = object.frameSize >>> 0;
                    if (object.encoding != null)
                        message.encoding = String(object.encoding);
                    return message;
                };

                /**
                 * Creates a plain object from an AudioConfig message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @static
                 * @param {mythbound.ws.v1.AudioConfig} message AudioConfig
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AudioConfig.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.sampleRateHz = 0;
                        object.channelLayout = "";
                        object.frameSize = 0;
                        object.encoding = "";
                    }
                    if (message.sampleRateHz != null && Object.hasOwnProperty.call(message, "sampleRateHz"))
                        object.sampleRateHz = message.sampleRateHz;
                    if (message.channelLayout != null && Object.hasOwnProperty.call(message, "channelLayout"))
                        object.channelLayout = message.channelLayout;
                    if (message.frameSize != null && Object.hasOwnProperty.call(message, "frameSize"))
                        object.frameSize = message.frameSize;
                    if (message.encoding != null && Object.hasOwnProperty.call(message, "encoding"))
                        object.encoding = message.encoding;
                    return object;
                };

                /**
                 * Converts this AudioConfig to JSON.
                 * @function toJSON
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AudioConfig.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for AudioConfig
                 * @function getTypeUrl
                 * @memberof mythbound.ws.v1.AudioConfig
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                AudioConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.ws.v1.AudioConfig";
                };

                return AudioConfig;
            })();

            v1.VoiceJoinMessage = (function() {

                /**
                 * Properties of a VoiceJoinMessage.
                 * @memberof mythbound.ws.v1
                 * @interface IVoiceJoinMessage
                 * @property {string|null} [campaignId] VoiceJoinMessage campaignId
                 * @property {string|null} [characterId] VoiceJoinMessage characterId
                 * @property {string|null} [characterName] VoiceJoinMessage characterName
                 * @property {mythbound.ws.v1.IAudioConfig|null} [audioConfig] VoiceJoinMessage audioConfig
                 */

                /**
                 * Constructs a new VoiceJoinMessage.
                 * @memberof mythbound.ws.v1
                 * @classdesc Represents a VoiceJoinMessage.
                 * @implements IVoiceJoinMessage
                 * @constructor
                 * @param {mythbound.ws.v1.IVoiceJoinMessage=} [properties] Properties to set
                 */
                function VoiceJoinMessage(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VoiceJoinMessage campaignId.
                 * @member {string} campaignId
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @instance
                 */
                VoiceJoinMessage.prototype.campaignId = "";

                /**
                 * VoiceJoinMessage characterId.
                 * @member {string} characterId
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @instance
                 */
                VoiceJoinMessage.prototype.characterId = "";

                /**
                 * VoiceJoinMessage characterName.
                 * @member {string} characterName
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @instance
                 */
                VoiceJoinMessage.prototype.characterName = "";

                /**
                 * VoiceJoinMessage audioConfig.
                 * @member {mythbound.ws.v1.IAudioConfig|null|undefined} audioConfig
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @instance
                 */
                VoiceJoinMessage.prototype.audioConfig = null;

                /**
                 * Creates a new VoiceJoinMessage instance using the specified properties.
                 * @function create
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @static
                 * @param {mythbound.ws.v1.IVoiceJoinMessage=} [properties] Properties to set
                 * @returns {mythbound.ws.v1.VoiceJoinMessage} VoiceJoinMessage instance
                 */
                VoiceJoinMessage.create = function create(properties) {
                    return new VoiceJoinMessage(properties);
                };

                /**
                 * Encodes the specified VoiceJoinMessage message. Does not implicitly {@link mythbound.ws.v1.VoiceJoinMessage.verify|verify} messages.
                 * @function encode
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @static
                 * @param {mythbound.ws.v1.IVoiceJoinMessage} message VoiceJoinMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceJoinMessage.encode = function encode(message, writer, q) {
                    if (!writer)
                        writer = $Writer.create();
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.campaignId);
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.characterId);
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.characterName);
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig"))
                        $root.mythbound.ws.v1.AudioConfig.encode(message.audioConfig, writer.uint32(/* id 4, wireType 2 =*/34).fork(), q + 1).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified VoiceJoinMessage message, length delimited. Does not implicitly {@link mythbound.ws.v1.VoiceJoinMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @static
                 * @param {mythbound.ws.v1.IVoiceJoinMessage} message VoiceJoinMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VoiceJoinMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer && writer.len ? writer.fork() : writer).ldelim();
                };

                /**
                 * Decodes a VoiceJoinMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {mythbound.ws.v1.VoiceJoinMessage} VoiceJoinMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceJoinMessage.decode = function decode(reader, length, error, long) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    if (long === undefined)
                        long = 0;
                    if (long > $Reader.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let end, message;
                    if (length === undefined)
                        end = reader.len;
                    else {
                        end = reader.pos + length;
                        if (end > reader.len)
                            throw RangeError("index out of range");
                        length = reader.len;
                        reader.len = end;
                    }
                    message = new $root.mythbound.ws.v1.VoiceJoinMessage();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        if (tag === error)
                            break;
                        switch (tag >>> 3) {
                        case 1: {
                                message.campaignId = reader.string();
                                break;
                            }
                        case 2: {
                                message.characterId = reader.string();
                                break;
                            }
                        case 3: {
                                message.characterName = reader.string();
                                break;
                            }
                        case 4: {
                                message.audioConfig = $root.mythbound.ws.v1.AudioConfig.decode(reader, reader.uint32(), undefined, long + 1);
                                break;
                            }
                        default:
                            reader.skipType(tag & 7, long);
                            break;
                        }
                    }
                    if (length !== undefined) {
                        if (reader.pos !== end)
                            throw RangeError("index out of range");
                        reader.len = length;
                    }
                    return message;
                };

                /**
                 * Decodes a VoiceJoinMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {mythbound.ws.v1.VoiceJoinMessage} VoiceJoinMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VoiceJoinMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VoiceJoinMessage message.
                 * @function verify
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VoiceJoinMessage.verify = function verify(message, long) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        return "maximum nesting depth exceeded";
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        if (!$util.isString(message.campaignId))
                            return "campaignId: string expected";
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        if (!$util.isString(message.characterId))
                            return "characterId: string expected";
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        if (!$util.isString(message.characterName))
                            return "characterName: string expected";
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig")) {
                        let error = $root.mythbound.ws.v1.AudioConfig.verify(message.audioConfig, long + 1);
                        if (error)
                            return "audioConfig." + error;
                    }
                    return null;
                };

                /**
                 * Creates a VoiceJoinMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {mythbound.ws.v1.VoiceJoinMessage} VoiceJoinMessage
                 */
                VoiceJoinMessage.fromObject = function fromObject(object, long) {
                    if (object instanceof $root.mythbound.ws.v1.VoiceJoinMessage)
                        return object;
                    if (!$util.isObject(object))
                        throw TypeError(".mythbound.ws.v1.VoiceJoinMessage: object expected");
                    if (long === undefined)
                        long = 0;
                    if (long > $util.recursionLimit)
                        throw Error("maximum nesting depth exceeded");
                    let message = new $root.mythbound.ws.v1.VoiceJoinMessage();
                    if (object.campaignId != null)
                        message.campaignId = String(object.campaignId);
                    if (object.characterId != null)
                        message.characterId = String(object.characterId);
                    if (object.characterName != null)
                        message.characterName = String(object.characterName);
                    if (object.audioConfig != null) {
                        if (!$util.isObject(object.audioConfig))
                            throw TypeError(".mythbound.ws.v1.VoiceJoinMessage.audioConfig: object expected");
                        message.audioConfig = $root.mythbound.ws.v1.AudioConfig.fromObject(object.audioConfig, long + 1);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a VoiceJoinMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @static
                 * @param {mythbound.ws.v1.VoiceJoinMessage} message VoiceJoinMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VoiceJoinMessage.toObject = function toObject(message, options, q) {
                    if (!options)
                        options = {};
                    if (q === undefined)
                        q = 0;
                    if (q > $util.recursionLimit)
                        throw Error("max depth exceeded");
                    let object = {};
                    if (options.defaults) {
                        object.campaignId = "";
                        object.characterId = "";
                        object.characterName = "";
                        object.audioConfig = null;
                    }
                    if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                        object.campaignId = message.campaignId;
                    if (message.characterId != null && Object.hasOwnProperty.call(message, "characterId"))
                        object.characterId = message.characterId;
                    if (message.characterName != null && Object.hasOwnProperty.call(message, "characterName"))
                        object.characterName = message.characterName;
                    if (message.audioConfig != null && Object.hasOwnProperty.call(message, "audioConfig"))
                        object.audioConfig = $root.mythbound.ws.v1.AudioConfig.toObject(message.audioConfig, options, q + 1);
                    return object;
                };

                /**
                 * Converts this VoiceJoinMessage to JSON.
                 * @function toJSON
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VoiceJoinMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VoiceJoinMessage
                 * @function getTypeUrl
                 * @memberof mythbound.ws.v1.VoiceJoinMessage
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VoiceJoinMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/mythbound.ws.v1.VoiceJoinMessage";
                };

                return VoiceJoinMessage;
            })();

            return v1;
        })();

        return ws;
    })();

    return mythbound;
})();

export { $root as default };
